/*!
  * Bootstrap v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e(require("@popperjs/core")):"function"==typeof define&&define.amd?define(["@popperjs/core"],e):(t="undefined"!=typeof globalThis?globalThis:t||self).bootstrap=e(t.Popper)}(this,(function(t){"use strict";function e(t){if(t&&t.__esModule)return t;const e=Object.create(null);if(t)for(const i in t)if("default"!==i){const s=Object.getOwnPropertyDescriptor(t,i);Object.defineProperty(e,i,s.get?s:{enumerable:!0,get:()=>t[i]})}return e.default=t,Object.freeze(e)}const i=e(t),s="transitionend",n=t=>{let e=t.getAttribute("data-bs-target");if(!e||"#"===e){let i=t.getAttribute("href");if(!i||!i.includes("#")&&!i.startsWith("."))return null;i.includes("#")&&!i.startsWith("#")&&(i=`#${i.split("#")[1]}`),e=i&&"#"!==i?i.trim():null}return e},o=t=>{const e=n(t);return e&&document.querySelector(e)?e:null},r=t=>{const e=n(t);return e?document.querySelector(e):null},a=t=>{t.dispatchEvent(new Event(s))},l=t=>!(!t||"object"!=typeof t)&&(void 0!==t.jquery&&(t=t[0]),void 0!==t.nodeType),c=t=>l(t)?t.jquery?t[0]:t:"string"==typeof t&&t.length>0?document.querySelector(t):null,h=(t,e,i)=>{Object.keys(i).forEach((s=>{const n=i[s],o=e[s],r=o&&l(o)?"element":null==(a=o)?`${a}`:{}.toString.call(a).match(/\s([a-z]+)/i)[1].toLowerCase();var a;if(!new RegExp(n).test(r))throw new TypeError(`${t.toUpperCase()}: Option "${s}" provided type "${r}" but expected type "${n}".`)}))},d=t=>!(!l(t)||0===t.getClientRects().length)&&"visible"===getComputedStyle(t).getPropertyValue("visibility"),u=t=>!t||t.nodeType!==Node.ELEMENT_NODE||!!t.classList.contains("disabled")||(void 0!==t.disabled?t.disabled:t.hasAttribute("disabled")&&"false"!==t.getAttribute("disabled")),g=t=>{if(!document.documentElement.attachShadow)return null;if("function"==typeof t.getRootNode){const e=t.getRootNode();return e instanceof ShadowRoot?e:null}return t instanceof ShadowRoot?t:t.parentNode?g(t.parentNode):null},_=()=>{},f=t=>{t.offsetHeight},p=()=>{const{jQuery:t}=window;return t&&!document.body.hasAttribute("data-bs-no-jquery")?t:null},m=[],b=()=>"rtl"===document.documentElement.dir,v=t=>{var e;e=()=>{const e=p();if(e){const i=t.NAME,s=e.fn[i];e.fn[i]=t.jQueryInterface,e.fn[i].Constructor=t,e.fn[i].noConflict=()=>(e.fn[i]=s,t.jQueryInterface)}},"loading"===document.readyState?(m.length||document.addEventListener("DOMContentLoaded",(()=>{m.forEach((t=>t()))})),m.push(e)):e()},y=t=>{"function"==typeof t&&t()},E=(t,e,i=!0)=>{if(!i)return void y(t);const n=(t=>{if(!t)return 0;let{transitionDuration:e,transitionDelay:i}=window.getComputedStyle(t);const s=Number.parseFloat(e),n=Number.parseFloat(i);return s||n?(e=e.split(",")[0],i=i.split(",")[0],1e3*(Number.parseFloat(e)+Number.parseFloat(i))):0})(e)+5;let o=!1;const r=({target:i})=>{i===e&&(o=!0,e.removeEventListener(s,r),y(t))};e.addEventListener(s,r),setTimeout((()=>{o||a(e)}),n)},w=(t,e,i,s)=>{let n=t.indexOf(e);if(-1===n)return t[!i&&s?t.length-1:0];const o=t.length;return n+=i?1:-1,s&&(n=(n+o)%o),t[Math.max(0,Math.min(n,o-1))]},A=/[^.]*(?=\..*)\.|.*/,T=/\..*/,C=/::\d+$/,k={};let L=1;const S={mouseenter:"mouseover",mouseleave:"mouseout"},O=/^(mouseenter|mouseleave)/i,N=new Set(["click","dblclick","mouseup","mousedown","contextmenu","mousewheel","DOMMouseScroll","mouseover","mouseout","mousemove","selectstart","selectend","keydown","keypress","keyup","orientationchange","touchstart","touchmove","touchend","touchcancel","pointerdown","pointermove","pointerup","pointerleave","pointercancel","gesturestart","gesturechange","gestureend","focus","blur","change","reset","select","submit","focusin","focusout","load","unload","beforeunload","resize","move","DOMContentLoaded","readystatechange","error","abort","scroll"]);function D(t,e){return e&&`${e}::${L++}`||t.uidEvent||L++}function I(t){const e=D(t);return t.uidEvent=e,k[e]=k[e]||{},k[e]}function P(t,e,i=null){const s=Object.keys(t);for(let n=0,o=s.length;n<o;n++){const o=t[s[n]];if(o.originalHandler===e&&o.delegationSelector===i)return o}return null}function x(t,e,i){const s="string"==typeof e,n=s?i:e;let o=H(t);return N.has(o)||(o=t),[s,n,o]}function M(t,e,i,s,n){if("string"!=typeof e||!t)return;if(i||(i=s,s=null),O.test(e)){const t=t=>function(e){if(!e.relatedTarget||e.relatedTarget!==e.delegateTarget&&!e.delegateTarget.contains(e.relatedTarget))return t.call(this,e)};s?s=t(s):i=t(i)}const[o,r,a]=x(e,i,s),l=I(t),c=l[a]||(l[a]={}),h=P(c,r,o?i:null);if(h)return void(h.oneOff=h.oneOff&&n);const d=D(r,e.replace(A,"")),u=o?function(t,e,i){return function s(n){const o=t.querySelectorAll(e);for(let{target:r}=n;r&&r!==this;r=r.parentNode)for(let a=o.length;a--;)if(o[a]===r)return n.delegateTarget=r,s.oneOff&&$.off(t,n.type,e,i),i.apply(r,[n]);return null}}(t,i,s):function(t,e){return function i(s){return s.delegateTarget=t,i.oneOff&&$.off(t,s.type,e),e.apply(t,[s])}}(t,i);u.delegationSelector=o?i:null,u.originalHandler=r,u.oneOff=n,u.uidEvent=d,c[d]=u,t.addEventListener(a,u,o)}function j(t,e,i,s,n){const o=P(e[i],s,n);o&&(t.removeEventListener(i,o,Boolean(n)),delete e[i][o.uidEvent])}function H(t){return t=t.replace(T,""),S[t]||t}const $={on(t,e,i,s){M(t,e,i,s,!1)},one(t,e,i,s){M(t,e,i,s,!0)},off(t,e,i,s){if("string"!=typeof e||!t)return;const[n,o,r]=x(e,i,s),a=r!==e,l=I(t),c=e.startsWith(".");if(void 0!==o){if(!l||!l[r])return;return void j(t,l,r,o,n?i:null)}c&&Object.keys(l).forEach((i=>{!function(t,e,i,s){const n=e[i]||{};Object.keys(n).forEach((o=>{if(o.includes(s)){const s=n[o];j(t,e,i,s.originalHandler,s.delegationSelector)}}))}(t,l,i,e.slice(1))}));const h=l[r]||{};Object.keys(h).forEach((i=>{const s=i.replace(C,"");if(!a||e.includes(s)){const e=h[i];j(t,l,r,e.originalHandler,e.delegationSelector)}}))},trigger(t,e,i){if("string"!=typeof e||!t)return null;const s=p(),n=H(e),o=e!==n,r=N.has(n);let a,l=!0,c=!0,h=!1,d=null;return o&&s&&(a=s.Event(e,i),s(t).trigger(a),l=!a.isPropagationStopped(),c=!a.isImmediatePropagationStopped(),h=a.isDefaultPrevented()),r?(d=document.createEvent("HTMLEvents"),d.initEvent(n,l,!0)):d=new CustomEvent(e,{bubbles:l,cancelable:!0}),void 0!==i&&Object.keys(i).forEach((t=>{Object.defineProperty(d,t,{get:()=>i[t]})})),h&&d.preventDefault(),c&&t.dispatchEvent(d),d.defaultPrevented&&void 0!==a&&a.preventDefault(),d}},B=new Map,z={set(t,e,i){B.has(t)||B.set(t,new Map);const s=B.get(t);s.has(e)||0===s.size?s.set(e,i):console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(s.keys())[0]}.`)},get:(t,e)=>B.has(t)&&B.get(t).get(e)||null,remove(t,e){if(!B.has(t))return;const i=B.get(t);i.delete(e),0===i.size&&B.delete(t)}};class R{constructor(t){(t=c(t))&&(this._element=t,z.set(this._element,this.constructor.DATA_KEY,this))}dispose(){z.remove(this._element,this.constructor.DATA_KEY),$.off(this._element,this.constructor.EVENT_KEY),Object.getOwnPropertyNames(this).forEach((t=>{this[t]=null}))}_queueCallback(t,e,i=!0){E(t,e,i)}static getInstance(t){return z.get(c(t),this.DATA_KEY)}static getOrCreateInstance(t,e={}){return this.getInstance(t)||new this(t,"object"==typeof e?e:null)}static get VERSION(){return"5.1.3"}static get NAME(){throw new Error('You have to implement the static method "NAME", for each component!')}static get DATA_KEY(){return`bs.${this.NAME}`}static get EVENT_KEY(){return`.${this.DATA_KEY}`}}const F=(t,e="hide")=>{const i=`click.dismiss${t.EVENT_KEY}`,s=t.NAME;$.on(document,i,`[data-bs-dismiss="${s}"]`,(function(i){if(["A","AREA"].includes(this.tagName)&&i.preventDefault(),u(this))return;const n=r(this)||this.closest(`.${s}`);t.getOrCreateInstance(n)[e]()}))};class q extends R{static get NAME(){return"alert"}close(){if($.trigger(this._element,"close.bs.alert").defaultPrevented)return;this._element.classList.remove("show");const t=this._element.classList.contains("fade");this._queueCallback((()=>this._destroyElement()),this._element,t)}_destroyElement(){this._element.remove(),$.trigger(this._element,"closed.bs.alert"),this.dispose()}static jQueryInterface(t){return this.each((function(){const e=q.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}F(q,"close"),v(q);const W='[data-bs-toggle="button"]';class U extends R{static get NAME(){return"button"}toggle(){this._element.setAttribute("aria-pressed",this._element.classList.toggle("active"))}static jQueryInterface(t){return this.each((function(){const e=U.getOrCreateInstance(this);"toggle"===t&&e[t]()}))}}function K(t){return"true"===t||"false"!==t&&(t===Number(t).toString()?Number(t):""===t||"null"===t?null:t)}function V(t){return t.replace(/[A-Z]/g,(t=>`-${t.toLowerCase()}`))}$.on(document,"click.bs.button.data-api",W,(t=>{t.preventDefault();const e=t.target.closest(W);U.getOrCreateInstance(e).toggle()})),v(U);const X={setDataAttribute(t,e,i){t.setAttribute(`data-bs-${V(e)}`,i)},removeDataAttribute(t,e){t.removeAttribute(`data-bs-${V(e)}`)},getDataAttributes(t){if(!t)return{};const e={};return Object.keys(t.dataset).filter((t=>t.startsWith("bs"))).forEach((i=>{let s=i.replace(/^bs/,"");s=s.charAt(0).toLowerCase()+s.slice(1,s.length),e[s]=K(t.dataset[i])})),e},getDataAttribute:(t,e)=>K(t.getAttribute(`data-bs-${V(e)}`)),offset(t){const e=t.getBoundingClientRect();return{top:e.top+window.pageYOffset,left:e.left+window.pageXOffset}},position:t=>({top:t.offsetTop,left:t.offsetLeft})},Y={find:(t,e=document.documentElement)=>[].concat(...Element.prototype.querySelectorAll.call(e,t)),findOne:(t,e=document.documentElement)=>Element.prototype.querySelector.call(e,t),children:(t,e)=>[].concat(...t.children).filter((t=>t.matches(e))),parents(t,e){const i=[];let s=t.parentNode;for(;s&&s.nodeType===Node.ELEMENT_NODE&&3!==s.nodeType;)s.matches(e)&&i.push(s),s=s.parentNode;return i},prev(t,e){let i=t.previousElementSibling;for(;i;){if(i.matches(e))return[i];i=i.previousElementSibling}return[]},next(t,e){let i=t.nextElementSibling;for(;i;){if(i.matches(e))return[i];i=i.nextElementSibling}return[]},focusableChildren(t){const e=["a","button","input","textarea","select","details","[tabindex]",'[contenteditable="true"]'].map((t=>`${t}:not([tabindex^="-"])`)).join(", ");return this.find(e,t).filter((t=>!u(t)&&d(t)))}},Q="carousel",G={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0,touch:!0},Z={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean",touch:"boolean"},J="next",tt="prev",et="left",it="right",st={ArrowLeft:it,ArrowRight:et},nt="slid.bs.carousel",ot="active",rt=".active.carousel-item";class at extends R{constructor(t,e){super(t),this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this.touchTimeout=null,this.touchStartX=0,this.touchDeltaX=0,this._config=this._getConfig(e),this._indicatorsElement=Y.findOne(".carousel-indicators",this._element),this._touchSupported="ontouchstart"in document.documentElement||navigator.maxTouchPoints>0,this._pointerEvent=Boolean(window.PointerEvent),this._addEventListeners()}static get Default(){return G}static get NAME(){return Q}next(){this._slide(J)}nextWhenVisible(){!document.hidden&&d(this._element)&&this.next()}prev(){this._slide(tt)}pause(t){t||(this._isPaused=!0),Y.findOne(".carousel-item-next, .carousel-item-prev",this._element)&&(a(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null}cycle(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config&&this._config.interval&&!this._isPaused&&(this._updateInterval(),this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))}to(t){this._activeElement=Y.findOne(rt,this._element);const e=this._getItemIndex(this._activeElement);if(t>this._items.length-1||t<0)return;if(this._isSliding)return void $.one(this._element,nt,(()=>this.to(t)));if(e===t)return this.pause(),void this.cycle();const i=t>e?J:tt;this._slide(i,this._items[t])}_getConfig(t){return t={...G,...X.getDataAttributes(this._element),..."object"==typeof t?t:{}},h(Q,t,Z),t}_handleSwipe(){const t=Math.abs(this.touchDeltaX);if(t<=40)return;const e=t/this.touchDeltaX;this.touchDeltaX=0,e&&this._slide(e>0?it:et)}_addEventListeners(){this._config.keyboard&&$.on(this._element,"keydown.bs.carousel",(t=>this._keydown(t))),"hover"===this._config.pause&&($.on(this._element,"mouseenter.bs.carousel",(t=>this.pause(t))),$.on(this._element,"mouseleave.bs.carousel",(t=>this.cycle(t)))),this._config.touch&&this._touchSupported&&this._addTouchEventListeners()}_addTouchEventListeners(){const t=t=>this._pointerEvent&&("pen"===t.pointerType||"touch"===t.pointerType),e=e=>{t(e)?this.touchStartX=e.clientX:this._pointerEvent||(this.touchStartX=e.touches[0].clientX)},i=t=>{this.touchDeltaX=t.touches&&t.touches.length>1?0:t.touches[0].clientX-this.touchStartX},s=e=>{t(e)&&(this.touchDeltaX=e.clientX-this.touchStartX),this._handleSwipe(),"hover"===this._config.pause&&(this.pause(),this.touchTimeout&&clearTimeout(this.touchTimeout),this.touchTimeout=setTimeout((t=>this.cycle(t)),500+this._config.interval))};Y.find(".carousel-item img",this._element).forEach((t=>{$.on(t,"dragstart.bs.carousel",(t=>t.preventDefault()))})),this._pointerEvent?($.on(this._element,"pointerdown.bs.carousel",(t=>e(t))),$.on(this._element,"pointerup.bs.carousel",(t=>s(t))),this._element.classList.add("pointer-event")):($.on(this._element,"touchstart.bs.carousel",(t=>e(t))),$.on(this._element,"touchmove.bs.carousel",(t=>i(t))),$.on(this._element,"touchend.bs.carousel",(t=>s(t))))}_keydown(t){if(/input|textarea/i.test(t.target.tagName))return;const e=st[t.key];e&&(t.preventDefault(),this._slide(e))}_getItemIndex(t){return this._items=t&&t.parentNode?Y.find(".carousel-item",t.parentNode):[],this._items.indexOf(t)}_getItemByOrder(t,e){const i=t===J;return w(this._items,e,i,this._config.wrap)}_triggerSlideEvent(t,e){const i=this._getItemIndex(t),s=this._getItemIndex(Y.findOne(rt,this._element));return $.trigger(this._element,"slide.bs.carousel",{relatedTarget:t,direction:e,from:s,to:i})}_setActiveIndicatorElement(t){if(this._indicatorsElement){const e=Y.findOne(".active",this._indicatorsElement);e.classList.remove(ot),e.removeAttribute("aria-current");const i=Y.find("[data-bs-target]",this._indicatorsElement);for(let e=0;e<i.length;e++)if(Number.parseInt(i[e].getAttribute("data-bs-slide-to"),10)===this._getItemIndex(t)){i[e].classList.add(ot),i[e].setAttribute("aria-current","true");break}}}_updateInterval(){const t=this._activeElement||Y.findOne(rt,this._element);if(!t)return;const e=Number.parseInt(t.getAttribute("data-bs-interval"),10);e?(this._config.defaultInterval=this._config.defaultInterval||this._config.interval,this._config.interval=e):this._config.interval=this._config.defaultInterval||this._config.interval}_slide(t,e){const i=this._directionToOrder(t),s=Y.findOne(rt,this._element),n=this._getItemIndex(s),o=e||this._getItemByOrder(i,s),r=this._getItemIndex(o),a=Boolean(this._interval),l=i===J,c=l?"carousel-item-start":"carousel-item-end",h=l?"carousel-item-next":"carousel-item-prev",d=this._orderToDirection(i);if(o&&o.classList.contains(ot))return void(this._isSliding=!1);if(this._isSliding)return;if(this._triggerSlideEvent(o,d).defaultPrevented)return;if(!s||!o)return;this._isSliding=!0,a&&this.pause(),this._setActiveIndicatorElement(o),this._activeElement=o;const u=()=>{$.trigger(this._element,nt,{relatedTarget:o,direction:d,from:n,to:r})};if(this._element.classList.contains("slide")){o.classList.add(h),f(o),s.classList.add(c),o.classList.add(c);const t=()=>{o.classList.remove(c,h),o.classList.add(ot),s.classList.remove(ot,h,c),this._isSliding=!1,setTimeout(u,0)};this._queueCallback(t,s,!0)}else s.classList.remove(ot),o.classList.add(ot),this._isSliding=!1,u();a&&this.cycle()}_directionToOrder(t){return[it,et].includes(t)?b()?t===et?tt:J:t===et?J:tt:t}_orderToDirection(t){return[J,tt].includes(t)?b()?t===tt?et:it:t===tt?it:et:t}static carouselInterface(t,e){const i=at.getOrCreateInstance(t,e);let{_config:s}=i;"object"==typeof e&&(s={...s,...e});const n="string"==typeof e?e:s.slide;if("number"==typeof e)i.to(e);else if("string"==typeof n){if(void 0===i[n])throw new TypeError(`No method named "${n}"`);i[n]()}else s.interval&&s.ride&&(i.pause(),i.cycle())}static jQueryInterface(t){return this.each((function(){at.carouselInterface(this,t)}))}static dataApiClickHandler(t){const e=r(this);if(!e||!e.classList.contains("carousel"))return;const i={...X.getDataAttributes(e),...X.getDataAttributes(this)},s=this.getAttribute("data-bs-slide-to");s&&(i.interval=!1),at.carouselInterface(e,i),s&&at.getInstance(e).to(s),t.preventDefault()}}$.on(document,"click.bs.carousel.data-api","[data-bs-slide], [data-bs-slide-to]",at.dataApiClickHandler),$.on(window,"load.bs.carousel.data-api",(()=>{const t=Y.find('[data-bs-ride="carousel"]');for(let e=0,i=t.length;e<i;e++)at.carouselInterface(t[e],at.getInstance(t[e]))})),v(at);const lt="collapse",ct={toggle:!0,parent:null},ht={toggle:"boolean",parent:"(null|element)"},dt="show",ut="collapse",gt="collapsing",_t="collapsed",ft=":scope .collapse .collapse",pt='[data-bs-toggle="collapse"]';class mt extends R{constructor(t,e){super(t),this._isTransitioning=!1,this._config=this._getConfig(e),this._triggerArray=[];const i=Y.find(pt);for(let t=0,e=i.length;t<e;t++){const e=i[t],s=o(e),n=Y.find(s).filter((t=>t===this._element));null!==s&&n.length&&(this._selector=s,this._triggerArray.push(e))}this._initializeChildren(),this._config.parent||this._addAriaAndCollapsedClass(this._triggerArray,this._isShown()),this._config.toggle&&this.toggle()}static get Default(){return ct}static get NAME(){return lt}toggle(){this._isShown()?this.hide():this.show()}show(){if(this._isTransitioning||this._isShown())return;let t,e=[];if(this._config.parent){const t=Y.find(ft,this._config.parent);e=Y.find(".collapse.show, .collapse.collapsing",this._config.parent).filter((e=>!t.includes(e)))}const i=Y.findOne(this._selector);if(e.length){const s=e.find((t=>i!==t));if(t=s?mt.getInstance(s):null,t&&t._isTransitioning)return}if($.trigger(this._element,"show.bs.collapse").defaultPrevented)return;e.forEach((e=>{i!==e&&mt.getOrCreateInstance(e,{toggle:!1}).hide(),t||z.set(e,"bs.collapse",null)}));const s=this._getDimension();this._element.classList.remove(ut),this._element.classList.add(gt),this._element.style[s]=0,this._addAriaAndCollapsedClass(this._triggerArray,!0),this._isTransitioning=!0;const n=`scroll${s[0].toUpperCase()+s.slice(1)}`;this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(gt),this._element.classList.add(ut,dt),this._element.style[s]="",$.trigger(this._element,"shown.bs.collapse")}),this._element,!0),this._element.style[s]=`${this._element[n]}px`}hide(){if(this._isTransitioning||!this._isShown())return;if($.trigger(this._element,"hide.bs.collapse").defaultPrevented)return;const t=this._getDimension();this._element.style[t]=`${this._element.getBoundingClientRect()[t]}px`,f(this._element),this._element.classList.add(gt),this._element.classList.remove(ut,dt);const e=this._triggerArray.length;for(let t=0;t<e;t++){const e=this._triggerArray[t],i=r(e);i&&!this._isShown(i)&&this._addAriaAndCollapsedClass([e],!1)}this._isTransitioning=!0,this._element.style[t]="",this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(gt),this._element.classList.add(ut),$.trigger(this._element,"hidden.bs.collapse")}),this._element,!0)}_isShown(t=this._element){return t.classList.contains(dt)}_getConfig(t){return(t={...ct,...X.getDataAttributes(this._element),...t}).toggle=Boolean(t.toggle),t.parent=c(t.parent),h(lt,t,ht),t}_getDimension(){return this._element.classList.contains("collapse-horizontal")?"width":"height"}_initializeChildren(){if(!this._config.parent)return;const t=Y.find(ft,this._config.parent);Y.find(pt,this._config.parent).filter((e=>!t.includes(e))).forEach((t=>{const e=r(t);e&&this._addAriaAndCollapsedClass([t],this._isShown(e))}))}_addAriaAndCollapsedClass(t,e){t.length&&t.forEach((t=>{e?t.classList.remove(_t):t.classList.add(_t),t.setAttribute("aria-expanded",e)}))}static jQueryInterface(t){return this.each((function(){const e={};"string"==typeof t&&/show|hide/.test(t)&&(e.toggle=!1);const i=mt.getOrCreateInstance(this,e);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t]()}}))}}$.on(document,"click.bs.collapse.data-api",pt,(function(t){("A"===t.target.tagName||t.delegateTarget&&"A"===t.delegateTarget.tagName)&&t.preventDefault();const e=o(this);Y.find(e).forEach((t=>{mt.getOrCreateInstance(t,{toggle:!1}).toggle()}))})),v(mt);const bt="dropdown",vt="Escape",yt="Space",Et="ArrowUp",wt="ArrowDown",At=new RegExp("ArrowUp|ArrowDown|Escape"),Tt="click.bs.dropdown.data-api",Ct="keydown.bs.dropdown.data-api",kt="show",Lt='[data-bs-toggle="dropdown"]',St=".dropdown-menu",Ot=b()?"top-end":"top-start",Nt=b()?"top-start":"top-end",Dt=b()?"bottom-end":"bottom-start",It=b()?"bottom-start":"bottom-end",Pt=b()?"left-start":"right-start",xt=b()?"right-start":"left-start",Mt={offset:[0,2],boundary:"clippingParents",reference:"toggle",display:"dynamic",popperConfig:null,autoClose:!0},jt={offset:"(array|string|function)",boundary:"(string|element)",reference:"(string|element|object)",display:"string",popperConfig:"(null|object|function)",autoClose:"(boolean|string)"};class Ht extends R{constructor(t,e){super(t),this._popper=null,this._config=this._getConfig(e),this._menu=this._getMenuElement(),this._inNavbar=this._detectNavbar()}static get Default(){return Mt}static get DefaultType(){return jt}static get NAME(){return bt}toggle(){return this._isShown()?this.hide():this.show()}show(){if(u(this._element)||this._isShown(this._menu))return;const t={relatedTarget:this._element};if($.trigger(this._element,"show.bs.dropdown",t).defaultPrevented)return;const e=Ht.getParentFromElement(this._element);this._inNavbar?X.setDataAttribute(this._menu,"popper","none"):this._createPopper(e),"ontouchstart"in document.documentElement&&!e.closest(".navbar-nav")&&[].concat(...document.body.children).forEach((t=>$.on(t,"mouseover",_))),this._element.focus(),this._element.setAttribute("aria-expanded",!0),this._menu.classList.add(kt),this._element.classList.add(kt),$.trigger(this._element,"shown.bs.dropdown",t)}hide(){if(u(this._element)||!this._isShown(this._menu))return;const t={relatedTarget:this._element};this._completeHide(t)}dispose(){this._popper&&this._popper.destroy(),super.dispose()}update(){this._inNavbar=this._detectNavbar(),this._popper&&this._popper.update()}_completeHide(t){$.trigger(this._element,"hide.bs.dropdown",t).defaultPrevented||("ontouchstart"in document.documentElement&&[].concat(...document.body.children).forEach((t=>$.off(t,"mouseover",_))),this._popper&&this._popper.destroy(),this._menu.classList.remove(kt),this._element.classList.remove(kt),this._element.setAttribute("aria-expanded","false"),X.removeDataAttribute(this._menu,"popper"),$.trigger(this._element,"hidden.bs.dropdown",t))}_getConfig(t){if(t={...this.constructor.Default,...X.getDataAttributes(this._element),...t},h(bt,t,this.constructor.DefaultType),"object"==typeof t.reference&&!l(t.reference)&&"function"!=typeof t.reference.getBoundingClientRect)throw new TypeError(`${bt.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);return t}_createPopper(t){if(void 0===i)throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");let e=this._element;"parent"===this._config.reference?e=t:l(this._config.reference)?e=c(this._config.reference):"object"==typeof this._config.reference&&(e=this._config.reference);const s=this._getPopperConfig(),n=s.modifiers.find((t=>"applyStyles"===t.name&&!1===t.enabled));this._popper=i.createPopper(e,this._menu,s),n&&X.setDataAttribute(this._menu,"popper","static")}_isShown(t=this._element){return t.classList.contains(kt)}_getMenuElement(){return Y.next(this._element,St)[0]}_getPlacement(){const t=this._element.parentNode;if(t.classList.contains("dropend"))return Pt;if(t.classList.contains("dropstart"))return xt;const e="end"===getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();return t.classList.contains("dropup")?e?Nt:Ot:e?It:Dt}_detectNavbar(){return null!==this._element.closest(".navbar")}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_getPopperConfig(){const t={placement:this._getPlacement(),modifiers:[{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"offset",options:{offset:this._getOffset()}}]};return"static"===this._config.display&&(t.modifiers=[{name:"applyStyles",enabled:!1}]),{...t,..."function"==typeof this._config.popperConfig?this._config.popperConfig(t):this._config.popperConfig}}_selectMenuItem({key:t,target:e}){const i=Y.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",this._menu).filter(d);i.length&&w(i,e,t===wt,!i.includes(e)).focus()}static jQueryInterface(t){return this.each((function(){const e=Ht.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}static clearMenus(t){if(t&&(2===t.button||"keyup"===t.type&&"Tab"!==t.key))return;const e=Y.find(Lt);for(let i=0,s=e.length;i<s;i++){const s=Ht.getInstance(e[i]);if(!s||!1===s._config.autoClose)continue;if(!s._isShown())continue;const n={relatedTarget:s._element};if(t){const e=t.composedPath(),i=e.includes(s._menu);if(e.includes(s._element)||"inside"===s._config.autoClose&&!i||"outside"===s._config.autoClose&&i)continue;if(s._menu.contains(t.target)&&("keyup"===t.type&&"Tab"===t.key||/input|select|option|textarea|form/i.test(t.target.tagName)))continue;"click"===t.type&&(n.clickEvent=t)}s._completeHide(n)}}static getParentFromElement(t){return r(t)||t.parentNode}static dataApiKeydownHandler(t){if(/input|textarea/i.test(t.target.tagName)?t.key===yt||t.key!==vt&&(t.key!==wt&&t.key!==Et||t.target.closest(St)):!At.test(t.key))return;const e=this.classList.contains(kt);if(!e&&t.key===vt)return;if(t.preventDefault(),t.stopPropagation(),u(this))return;const i=this.matches(Lt)?this:Y.prev(this,Lt)[0],s=Ht.getOrCreateInstance(i);if(t.key!==vt)return t.key===Et||t.key===wt?(e||s.show(),void s._selectMenuItem(t)):void(e&&t.key!==yt||Ht.clearMenus());s.hide()}}$.on(document,Ct,Lt,Ht.dataApiKeydownHandler),$.on(document,Ct,St,Ht.dataApiKeydownHandler),$.on(document,Tt,Ht.clearMenus),$.on(document,"keyup.bs.dropdown.data-api",Ht.clearMenus),$.on(document,Tt,Lt,(function(t){t.preventDefault(),Ht.getOrCreateInstance(this).toggle()})),v(Ht);const $t=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",Bt=".sticky-top";class zt{constructor(){this._element=document.body}getWidth(){const t=document.documentElement.clientWidth;return Math.abs(window.innerWidth-t)}hide(){const t=this.getWidth();this._disableOverFlow(),this._setElementAttributes(this._element,"paddingRight",(e=>e+t)),this._setElementAttributes($t,"paddingRight",(e=>e+t)),this._setElementAttributes(Bt,"marginRight",(e=>e-t))}_disableOverFlow(){this._saveInitialAttribute(this._element,"overflow"),this._element.style.overflow="hidden"}_setElementAttributes(t,e,i){const s=this.getWidth();this._applyManipulationCallback(t,(t=>{if(t!==this._element&&window.innerWidth>t.clientWidth+s)return;this._saveInitialAttribute(t,e);const n=window.getComputedStyle(t)[e];t.style[e]=`${i(Number.parseFloat(n))}px`}))}reset(){this._resetElementAttributes(this._element,"overflow"),this._resetElementAttributes(this._element,"paddingRight"),this._resetElementAttributes($t,"paddingRight"),this._resetElementAttributes(Bt,"marginRight")}_saveInitialAttribute(t,e){const i=t.style[e];i&&X.setDataAttribute(t,e,i)}_resetElementAttributes(t,e){this._applyManipulationCallback(t,(t=>{const i=X.getDataAttribute(t,e);void 0===i?t.style.removeProperty(e):(X.removeDataAttribute(t,e),t.style[e]=i)}))}_applyManipulationCallback(t,e){l(t)?e(t):Y.find(t,this._element).forEach(e)}isOverflowing(){return this.getWidth()>0}}const Rt={className:"modal-backdrop",isVisible:!0,isAnimated:!1,rootElement:"body",clickCallback:null},Ft={className:"string",isVisible:"boolean",isAnimated:"boolean",rootElement:"(element|string)",clickCallback:"(function|null)"},qt="show",Wt="mousedown.bs.backdrop";class Ut{constructor(t){this._config=this._getConfig(t),this._isAppended=!1,this._element=null}show(t){this._config.isVisible?(this._append(),this._config.isAnimated&&f(this._getElement()),this._getElement().classList.add(qt),this._emulateAnimation((()=>{y(t)}))):y(t)}hide(t){this._config.isVisible?(this._getElement().classList.remove(qt),this._emulateAnimation((()=>{this.dispose(),y(t)}))):y(t)}_getElement(){if(!this._element){const t=document.createElement("div");t.className=this._config.className,this._config.isAnimated&&t.classList.add("fade"),this._element=t}return this._element}_getConfig(t){return(t={...Rt,..."object"==typeof t?t:{}}).rootElement=c(t.rootElement),h("backdrop",t,Ft),t}_append(){this._isAppended||(this._config.rootElement.append(this._getElement()),$.on(this._getElement(),Wt,(()=>{y(this._config.clickCallback)})),this._isAppended=!0)}dispose(){this._isAppended&&($.off(this._element,Wt),this._element.remove(),this._isAppended=!1)}_emulateAnimation(t){E(t,this._getElement(),this._config.isAnimated)}}const Kt={trapElement:null,autofocus:!0},Vt={trapElement:"element",autofocus:"boolean"},Xt=".bs.focustrap",Yt="backward";class Qt{constructor(t){this._config=this._getConfig(t),this._isActive=!1,this._lastTabNavDirection=null}activate(){const{trapElement:t,autofocus:e}=this._config;this._isActive||(e&&t.focus(),$.off(document,Xt),$.on(document,"focusin.bs.focustrap",(t=>this._handleFocusin(t))),$.on(document,"keydown.tab.bs.focustrap",(t=>this._handleKeydown(t))),this._isActive=!0)}deactivate(){this._isActive&&(this._isActive=!1,$.off(document,Xt))}_handleFocusin(t){const{target:e}=t,{trapElement:i}=this._config;if(e===document||e===i||i.contains(e))return;const s=Y.focusableChildren(i);0===s.length?i.focus():this._lastTabNavDirection===Yt?s[s.length-1].focus():s[0].focus()}_handleKeydown(t){"Tab"===t.key&&(this._lastTabNavDirection=t.shiftKey?Yt:"forward")}_getConfig(t){return t={...Kt,..."object"==typeof t?t:{}},h("focustrap",t,Vt),t}}const Gt="modal",Zt="Escape",Jt={backdrop:!0,keyboard:!0,focus:!0},te={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean"},ee="hidden.bs.modal",ie="show.bs.modal",se="resize.bs.modal",ne="click.dismiss.bs.modal",oe="keydown.dismiss.bs.modal",re="mousedown.dismiss.bs.modal",ae="modal-open",le="show",ce="modal-static";class he extends R{constructor(t,e){super(t),this._config=this._getConfig(e),this._dialog=Y.findOne(".modal-dialog",this._element),this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._isShown=!1,this._ignoreBackdropClick=!1,this._isTransitioning=!1,this._scrollBar=new zt}static get Default(){return Jt}static get NAME(){return Gt}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||this._isTransitioning||$.trigger(this._element,ie,{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._isAnimated()&&(this._isTransitioning=!0),this._scrollBar.hide(),document.body.classList.add(ae),this._adjustDialog(),this._setEscapeEvent(),this._setResizeEvent(),$.on(this._dialog,re,(()=>{$.one(this._element,"mouseup.dismiss.bs.modal",(t=>{t.target===this._element&&(this._ignoreBackdropClick=!0)}))})),this._showBackdrop((()=>this._showElement(t))))}hide(){if(!this._isShown||this._isTransitioning)return;if($.trigger(this._element,"hide.bs.modal").defaultPrevented)return;this._isShown=!1;const t=this._isAnimated();t&&(this._isTransitioning=!0),this._setEscapeEvent(),this._setResizeEvent(),this._focustrap.deactivate(),this._element.classList.remove(le),$.off(this._element,ne),$.off(this._dialog,re),this._queueCallback((()=>this._hideModal()),this._element,t)}dispose(){[window,this._dialog].forEach((t=>$.off(t,".bs.modal"))),this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}handleUpdate(){this._adjustDialog()}_initializeBackDrop(){return new Ut({isVisible:Boolean(this._config.backdrop),isAnimated:this._isAnimated()})}_initializeFocusTrap(){return new Qt({trapElement:this._element})}_getConfig(t){return t={...Jt,...X.getDataAttributes(this._element),..."object"==typeof t?t:{}},h(Gt,t,te),t}_showElement(t){const e=this._isAnimated(),i=Y.findOne(".modal-body",this._dialog);this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.append(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.scrollTop=0,i&&(i.scrollTop=0),e&&f(this._element),this._element.classList.add(le),this._queueCallback((()=>{this._config.focus&&this._focustrap.activate(),this._isTransitioning=!1,$.trigger(this._element,"shown.bs.modal",{relatedTarget:t})}),this._dialog,e)}_setEscapeEvent(){this._isShown?$.on(this._element,oe,(t=>{this._config.keyboard&&t.key===Zt?(t.preventDefault(),this.hide()):this._config.keyboard||t.key!==Zt||this._triggerBackdropTransition()})):$.off(this._element,oe)}_setResizeEvent(){this._isShown?$.on(window,se,(()=>this._adjustDialog())):$.off(window,se)}_hideModal(){this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._isTransitioning=!1,this._backdrop.hide((()=>{document.body.classList.remove(ae),this._resetAdjustments(),this._scrollBar.reset(),$.trigger(this._element,ee)}))}_showBackdrop(t){$.on(this._element,ne,(t=>{this._ignoreBackdropClick?this._ignoreBackdropClick=!1:t.target===t.currentTarget&&(!0===this._config.backdrop?this.hide():"static"===this._config.backdrop&&this._triggerBackdropTransition())})),this._backdrop.show(t)}_isAnimated(){return this._element.classList.contains("fade")}_triggerBackdropTransition(){if($.trigger(this._element,"hidePrevented.bs.modal").defaultPrevented)return;const{classList:t,scrollHeight:e,style:i}=this._element,s=e>document.documentElement.clientHeight;!s&&"hidden"===i.overflowY||t.contains(ce)||(s||(i.overflowY="hidden"),t.add(ce),this._queueCallback((()=>{t.remove(ce),s||this._queueCallback((()=>{i.overflowY=""}),this._dialog)}),this._dialog),this._element.focus())}_adjustDialog(){const t=this._element.scrollHeight>document.documentElement.clientHeight,e=this._scrollBar.getWidth(),i=e>0;(!i&&t&&!b()||i&&!t&&b())&&(this._element.style.paddingLeft=`${e}px`),(i&&!t&&!b()||!i&&t&&b())&&(this._element.style.paddingRight=`${e}px`)}_resetAdjustments(){this._element.style.paddingLeft="",this._element.style.paddingRight=""}static jQueryInterface(t,e){return this.each((function(){const i=he.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t](e)}}))}}$.on(document,"click.bs.modal.data-api",'[data-bs-toggle="modal"]',(function(t){const e=r(this);["A","AREA"].includes(this.tagName)&&t.preventDefault(),$.one(e,ie,(t=>{t.defaultPrevented||$.one(e,ee,(()=>{d(this)&&this.focus()}))}));const i=Y.findOne(".modal.show");i&&he.getInstance(i).hide(),he.getOrCreateInstance(e).toggle(this)})),F(he),v(he);const de="offcanvas",ue={backdrop:!0,keyboard:!0,scroll:!1},ge={backdrop:"boolean",keyboard:"boolean",scroll:"boolean"},_e="show",fe=".offcanvas.show",pe="hidden.bs.offcanvas";class me extends R{constructor(t,e){super(t),this._config=this._getConfig(e),this._isShown=!1,this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._addEventListeners()}static get NAME(){return de}static get Default(){return ue}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||$.trigger(this._element,"show.bs.offcanvas",{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._element.style.visibility="visible",this._backdrop.show(),this._config.scroll||(new zt).hide(),this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.classList.add(_e),this._queueCallback((()=>{this._config.scroll||this._focustrap.activate(),$.trigger(this._element,"shown.bs.offcanvas",{relatedTarget:t})}),this._element,!0))}hide(){this._isShown&&($.trigger(this._element,"hide.bs.offcanvas").defaultPrevented||(this._focustrap.deactivate(),this._element.blur(),this._isShown=!1,this._element.classList.remove(_e),this._backdrop.hide(),this._queueCallback((()=>{this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._element.style.visibility="hidden",this._config.scroll||(new zt).reset(),$.trigger(this._element,pe)}),this._element,!0)))}dispose(){this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}_getConfig(t){return t={...ue,...X.getDataAttributes(this._element),..."object"==typeof t?t:{}},h(de,t,ge),t}_initializeBackDrop(){return new Ut({className:"offcanvas-backdrop",isVisible:this._config.backdrop,isAnimated:!0,rootElement:this._element.parentNode,clickCallback:()=>this.hide()})}_initializeFocusTrap(){return new Qt({trapElement:this._element})}_addEventListeners(){$.on(this._element,"keydown.dismiss.bs.offcanvas",(t=>{this._config.keyboard&&"Escape"===t.key&&this.hide()}))}static jQueryInterface(t){return this.each((function(){const e=me.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}$.on(document,"click.bs.offcanvas.data-api",'[data-bs-toggle="offcanvas"]',(function(t){const e=r(this);if(["A","AREA"].includes(this.tagName)&&t.preventDefault(),u(this))return;$.one(e,pe,(()=>{d(this)&&this.focus()}));const i=Y.findOne(fe);i&&i!==e&&me.getInstance(i).hide(),me.getOrCreateInstance(e).toggle(this)})),$.on(window,"load.bs.offcanvas.data-api",(()=>Y.find(fe).forEach((t=>me.getOrCreateInstance(t).show())))),F(me),v(me);const be=new Set(["background","cite","href","itemtype","longdesc","poster","src","xlink:href"]),ve=/^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i,ye=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i,Ee=(t,e)=>{const i=t.nodeName.toLowerCase();if(e.includes(i))return!be.has(i)||Boolean(ve.test(t.nodeValue)||ye.test(t.nodeValue));const s=e.filter((t=>t instanceof RegExp));for(let t=0,e=s.length;t<e;t++)if(s[t].test(i))return!0;return!1};function we(t,e,i){if(!t.length)return t;if(i&&"function"==typeof i)return i(t);const s=(new window.DOMParser).parseFromString(t,"text/html"),n=[].concat(...s.body.querySelectorAll("*"));for(let t=0,i=n.length;t<i;t++){const i=n[t],s=i.nodeName.toLowerCase();if(!Object.keys(e).includes(s)){i.remove();continue}const o=[].concat(...i.attributes),r=[].concat(e["*"]||[],e[s]||[]);o.forEach((t=>{Ee(t,r)||i.removeAttribute(t.nodeName)}))}return s.body.innerHTML}const Ae="tooltip",Te=new Set(["sanitize","allowList","sanitizeFn"]),Ce={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"(array|string|function)",container:"(string|element|boolean)",fallbackPlacements:"array",boundary:"(string|element)",customClass:"(string|function)",sanitize:"boolean",sanitizeFn:"(null|function)",allowList:"object",popperConfig:"(null|object|function)"},ke={AUTO:"auto",TOP:"top",RIGHT:b()?"left":"right",BOTTOM:"bottom",LEFT:b()?"right":"left"},Le={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,selector:!1,placement:"top",offset:[0,0],container:!1,fallbackPlacements:["top","right","bottom","left"],boundary:"clippingParents",customClass:"",sanitize:!0,sanitizeFn:null,allowList:{"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","srcset","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},popperConfig:null},Se={HIDE:"hide.bs.tooltip",HIDDEN:"hidden.bs.tooltip",SHOW:"show.bs.tooltip",SHOWN:"shown.bs.tooltip",INSERTED:"inserted.bs.tooltip",CLICK:"click.bs.tooltip",FOCUSIN:"focusin.bs.tooltip",FOCUSOUT:"focusout.bs.tooltip",MOUSEENTER:"mouseenter.bs.tooltip",MOUSELEAVE:"mouseleave.bs.tooltip"},Oe="fade",Ne="show",De="show",Ie="out",Pe=".tooltip-inner",xe=".modal",Me="hide.bs.modal",je="hover",He="focus";class $e extends R{constructor(t,e){if(void 0===i)throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");super(t),this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._popper=null,this._config=this._getConfig(e),this.tip=null,this._setListeners()}static get Default(){return Le}static get NAME(){return Ae}static get Event(){return Se}static get DefaultType(){return Ce}enable(){this._isEnabled=!0}disable(){this._isEnabled=!1}toggleEnabled(){this._isEnabled=!this._isEnabled}toggle(t){if(this._isEnabled)if(t){const e=this._initializeOnDelegatedTarget(t);e._activeTrigger.click=!e._activeTrigger.click,e._isWithActiveTrigger()?e._enter(null,e):e._leave(null,e)}else{if(this.getTipElement().classList.contains(Ne))return void this._leave(null,this);this._enter(null,this)}}dispose(){clearTimeout(this._timeout),$.off(this._element.closest(xe),Me,this._hideModalHandler),this.tip&&this.tip.remove(),this._disposePopper(),super.dispose()}show(){if("none"===this._element.style.display)throw new Error("Please use show on visible elements");if(!this.isWithContent()||!this._isEnabled)return;const t=$.trigger(this._element,this.constructor.Event.SHOW),e=g(this._element),s=null===e?this._element.ownerDocument.documentElement.contains(this._element):e.contains(this._element);if(t.defaultPrevented||!s)return;"tooltip"===this.constructor.NAME&&this.tip&&this.getTitle()!==this.tip.querySelector(Pe).innerHTML&&(this._disposePopper(),this.tip.remove(),this.tip=null);const n=this.getTipElement(),o=(t=>{do{t+=Math.floor(1e6*Math.random())}while(document.getElementById(t));return t})(this.constructor.NAME);n.setAttribute("id",o),this._element.setAttribute("aria-describedby",o),this._config.animation&&n.classList.add(Oe);const r="function"==typeof this._config.placement?this._config.placement.call(this,n,this._element):this._config.placement,a=this._getAttachment(r);this._addAttachmentClass(a);const{container:l}=this._config;z.set(n,this.constructor.DATA_KEY,this),this._element.ownerDocument.documentElement.contains(this.tip)||(l.append(n),$.trigger(this._element,this.constructor.Event.INSERTED)),this._popper?this._popper.update():this._popper=i.createPopper(this._element,n,this._getPopperConfig(a)),n.classList.add(Ne);const c=this._resolvePossibleFunction(this._config.customClass);c&&n.classList.add(...c.split(" ")),"ontouchstart"in document.documentElement&&[].concat(...document.body.children).forEach((t=>{$.on(t,"mouseover",_)}));const h=this.tip.classList.contains(Oe);this._queueCallback((()=>{const t=this._hoverState;this._hoverState=null,$.trigger(this._element,this.constructor.Event.SHOWN),t===Ie&&this._leave(null,this)}),this.tip,h)}hide(){if(!this._popper)return;const t=this.getTipElement();if($.trigger(this._element,this.constructor.Event.HIDE).defaultPrevented)return;t.classList.remove(Ne),"ontouchstart"in document.documentElement&&[].concat(...document.body.children).forEach((t=>$.off(t,"mouseover",_))),this._activeTrigger.click=!1,this._activeTrigger.focus=!1,this._activeTrigger.hover=!1;const e=this.tip.classList.contains(Oe);this._queueCallback((()=>{this._isWithActiveTrigger()||(this._hoverState!==De&&t.remove(),this._cleanTipClass(),this._element.removeAttribute("aria-describedby"),$.trigger(this._element,this.constructor.Event.HIDDEN),this._disposePopper())}),this.tip,e),this._hoverState=""}update(){null!==this._popper&&this._popper.update()}isWithContent(){return Boolean(this.getTitle())}getTipElement(){if(this.tip)return this.tip;const t=document.createElement("div");t.innerHTML=this._config.template;const e=t.children[0];return this.setContent(e),e.classList.remove(Oe,Ne),this.tip=e,this.tip}setContent(t){this._sanitizeAndSetContent(t,this.getTitle(),Pe)}_sanitizeAndSetContent(t,e,i){const s=Y.findOne(i,t);e||!s?this.setElementContent(s,e):s.remove()}setElementContent(t,e){if(null!==t)return l(e)?(e=c(e),void(this._config.html?e.parentNode!==t&&(t.innerHTML="",t.append(e)):t.textContent=e.textContent)):void(this._config.html?(this._config.sanitize&&(e=we(e,this._config.allowList,this._config.sanitizeFn)),t.innerHTML=e):t.textContent=e)}getTitle(){const t=this._element.getAttribute("data-bs-original-title")||this._config.title;return this._resolvePossibleFunction(t)}updateAttachment(t){return"right"===t?"end":"left"===t?"start":t}_initializeOnDelegatedTarget(t,e){return e||this.constructor.getOrCreateInstance(t.delegateTarget,this._getDelegateConfig())}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_resolvePossibleFunction(t){return"function"==typeof t?t.call(this._element):t}_getPopperConfig(t){const e={placement:t,modifiers:[{name:"flip",options:{fallbackPlacements:this._config.fallbackPlacements}},{name:"offset",options:{offset:this._getOffset()}},{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"arrow",options:{element:`.${this.constructor.NAME}-arrow`}},{name:"onChange",enabled:!0,phase:"afterWrite",fn:t=>this._handlePopperPlacementChange(t)}],onFirstUpdate:t=>{t.options.placement!==t.placement&&this._handlePopperPlacementChange(t)}};return{...e,..."function"==typeof this._config.popperConfig?this._config.popperConfig(e):this._config.popperConfig}}_addAttachmentClass(t){this.getTipElement().classList.add(`${this._getBasicClassPrefix()}-${this.updateAttachment(t)}`)}_getAttachment(t){return ke[t.toUpperCase()]}_setListeners(){this._config.trigger.split(" ").forEach((t=>{if("click"===t)$.on(this._element,this.constructor.Event.CLICK,this._config.selector,(t=>this.toggle(t)));else if("manual"!==t){const e=t===je?this.constructor.Event.MOUSEENTER:this.constructor.Event.FOCUSIN,i=t===je?this.constructor.Event.MOUSELEAVE:this.constructor.Event.FOCUSOUT;$.on(this._element,e,this._config.selector,(t=>this._enter(t))),$.on(this._element,i,this._config.selector,(t=>this._leave(t)))}})),this._hideModalHandler=()=>{this._element&&this.hide()},$.on(this._element.closest(xe),Me,this._hideModalHandler),this._config.selector?this._config={...this._config,trigger:"manual",selector:""}:this._fixTitle()}_fixTitle(){const t=this._element.getAttribute("title"),e=typeof this._element.getAttribute("data-bs-original-title");(t||"string"!==e)&&(this._element.setAttribute("data-bs-original-title",t||""),!t||this._element.getAttribute("aria-label")||this._element.textContent||this._element.setAttribute("aria-label",t),this._element.setAttribute("title",""))}_enter(t,e){e=this._initializeOnDelegatedTarget(t,e),t&&(e._activeTrigger["focusin"===t.type?He:je]=!0),e.getTipElement().classList.contains(Ne)||e._hoverState===De?e._hoverState=De:(clearTimeout(e._timeout),e._hoverState=De,e._config.delay&&e._config.delay.show?e._timeout=setTimeout((()=>{e._hoverState===De&&e.show()}),e._config.delay.show):e.show())}_leave(t,e){e=this._initializeOnDelegatedTarget(t,e),t&&(e._activeTrigger["focusout"===t.type?He:je]=e._element.contains(t.relatedTarget)),e._isWithActiveTrigger()||(clearTimeout(e._timeout),e._hoverState=Ie,e._config.delay&&e._config.delay.hide?e._timeout=setTimeout((()=>{e._hoverState===Ie&&e.hide()}),e._config.delay.hide):e.hide())}_isWithActiveTrigger(){for(const t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1}_getConfig(t){const e=X.getDataAttributes(this._element);return Object.keys(e).forEach((t=>{Te.has(t)&&delete e[t]})),(t={...this.constructor.Default,...e,..."object"==typeof t&&t?t:{}}).container=!1===t.container?document.body:c(t.container),"number"==typeof t.delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),h(Ae,t,this.constructor.DefaultType),t.sanitize&&(t.template=we(t.template,t.allowList,t.sanitizeFn)),t}_getDelegateConfig(){const t={};for(const e in this._config)this.constructor.Default[e]!==this._config[e]&&(t[e]=this._config[e]);return t}_cleanTipClass(){const t=this.getTipElement(),e=new RegExp(`(^|\\s)${this._getBasicClassPrefix()}\\S+`,"g"),i=t.getAttribute("class").match(e);null!==i&&i.length>0&&i.map((t=>t.trim())).forEach((e=>t.classList.remove(e)))}_getBasicClassPrefix(){return"bs-tooltip"}_handlePopperPlacementChange(t){const{state:e}=t;e&&(this.tip=e.elements.popper,this._cleanTipClass(),this._addAttachmentClass(this._getAttachment(e.placement)))}_disposePopper(){this._popper&&(this._popper.destroy(),this._popper=null)}static jQueryInterface(t){return this.each((function(){const e=$e.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}v($e);const Be={...$e.Default,placement:"right",offset:[0,8],trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'},ze={...$e.DefaultType,content:"(string|element|function)"},Re={HIDE:"hide.bs.popover",HIDDEN:"hidden.bs.popover",SHOW:"show.bs.popover",SHOWN:"shown.bs.popover",INSERTED:"inserted.bs.popover",CLICK:"click.bs.popover",FOCUSIN:"focusin.bs.popover",FOCUSOUT:"focusout.bs.popover",MOUSEENTER:"mouseenter.bs.popover",MOUSELEAVE:"mouseleave.bs.popover"};class Fe extends $e{static get Default(){return Be}static get NAME(){return"popover"}static get Event(){return Re}static get DefaultType(){return ze}isWithContent(){return this.getTitle()||this._getContent()}setContent(t){this._sanitizeAndSetContent(t,this.getTitle(),".popover-header"),this._sanitizeAndSetContent(t,this._getContent(),".popover-body")}_getContent(){return this._resolvePossibleFunction(this._config.content)}_getBasicClassPrefix(){return"bs-popover"}static jQueryInterface(t){return this.each((function(){const e=Fe.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}v(Fe);const qe="scrollspy",We={offset:10,method:"auto",target:""},Ue={offset:"number",method:"string",target:"(string|element)"},Ke="active",Ve=".nav-link, .list-group-item, .dropdown-item",Xe="position";class Ye extends R{constructor(t,e){super(t),this._scrollElement="BODY"===this._element.tagName?window:this._element,this._config=this._getConfig(e),this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,$.on(this._scrollElement,"scroll.bs.scrollspy",(()=>this._process())),this.refresh(),this._process()}static get Default(){return We}static get NAME(){return qe}refresh(){const t=this._scrollElement===this._scrollElement.window?"offset":Xe,e="auto"===this._config.method?t:this._config.method,i=e===Xe?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),Y.find(Ve,this._config.target).map((t=>{const s=o(t),n=s?Y.findOne(s):null;if(n){const t=n.getBoundingClientRect();if(t.width||t.height)return[X[e](n).top+i,s]}return null})).filter((t=>t)).sort(((t,e)=>t[0]-e[0])).forEach((t=>{this._offsets.push(t[0]),this._targets.push(t[1])}))}dispose(){$.off(this._scrollElement,".bs.scrollspy"),super.dispose()}_getConfig(t){return(t={...We,...X.getDataAttributes(this._element),..."object"==typeof t&&t?t:{}}).target=c(t.target)||document.documentElement,h(qe,t,Ue),t}_getScrollTop(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop}_getScrollHeight(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)}_getOffsetHeight(){return this._scrollElement===window?window.innerHeight:this._scrollElement.getBoundingClientRect().height}_process(){const t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),i=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),t>=i){const t=this._targets[this._targets.length-1];this._activeTarget!==t&&this._activate(t)}else{if(this._activeTarget&&t<this._offsets[0]&&this._offsets[0]>0)return this._activeTarget=null,void this._clear();for(let e=this._offsets.length;e--;)this._activeTarget!==this._targets[e]&&t>=this._offsets[e]&&(void 0===this._offsets[e+1]||t<this._offsets[e+1])&&this._activate(this._targets[e])}}_activate(t){this._activeTarget=t,this._clear();const e=Ve.split(",").map((e=>`${e}[data-bs-target="${t}"],${e}[href="${t}"]`)),i=Y.findOne(e.join(","),this._config.target);i.classList.add(Ke),i.classList.contains("dropdown-item")?Y.findOne(".dropdown-toggle",i.closest(".dropdown")).classList.add(Ke):Y.parents(i,".nav, .list-group").forEach((t=>{Y.prev(t,".nav-link, .list-group-item").forEach((t=>t.classList.add(Ke))),Y.prev(t,".nav-item").forEach((t=>{Y.children(t,".nav-link").forEach((t=>t.classList.add(Ke)))}))})),$.trigger(this._scrollElement,"activate.bs.scrollspy",{relatedTarget:t})}_clear(){Y.find(Ve,this._config.target).filter((t=>t.classList.contains(Ke))).forEach((t=>t.classList.remove(Ke)))}static jQueryInterface(t){return this.each((function(){const e=Ye.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}$.on(window,"load.bs.scrollspy.data-api",(()=>{Y.find('[data-bs-spy="scroll"]').forEach((t=>new Ye(t)))})),v(Ye);const Qe="active",Ge="fade",Ze="show",Je=".active",ti=":scope > li > .active";class ei extends R{static get NAME(){return"tab"}show(){if(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&this._element.classList.contains(Qe))return;let t;const e=r(this._element),i=this._element.closest(".nav, .list-group");if(i){const e="UL"===i.nodeName||"OL"===i.nodeName?ti:Je;t=Y.find(e,i),t=t[t.length-1]}const s=t?$.trigger(t,"hide.bs.tab",{relatedTarget:this._element}):null;if($.trigger(this._element,"show.bs.tab",{relatedTarget:t}).defaultPrevented||null!==s&&s.defaultPrevented)return;this._activate(this._element,i);const n=()=>{$.trigger(t,"hidden.bs.tab",{relatedTarget:this._element}),$.trigger(this._element,"shown.bs.tab",{relatedTarget:t})};e?this._activate(e,e.parentNode,n):n()}_activate(t,e,i){const s=(!e||"UL"!==e.nodeName&&"OL"!==e.nodeName?Y.children(e,Je):Y.find(ti,e))[0],n=i&&s&&s.classList.contains(Ge),o=()=>this._transitionComplete(t,s,i);s&&n?(s.classList.remove(Ze),this._queueCallback(o,t,!0)):o()}_transitionComplete(t,e,i){if(e){e.classList.remove(Qe);const t=Y.findOne(":scope > .dropdown-menu .active",e.parentNode);t&&t.classList.remove(Qe),"tab"===e.getAttribute("role")&&e.setAttribute("aria-selected",!1)}t.classList.add(Qe),"tab"===t.getAttribute("role")&&t.setAttribute("aria-selected",!0),f(t),t.classList.contains(Ge)&&t.classList.add(Ze);let s=t.parentNode;if(s&&"LI"===s.nodeName&&(s=s.parentNode),s&&s.classList.contains("dropdown-menu")){const e=t.closest(".dropdown");e&&Y.find(".dropdown-toggle",e).forEach((t=>t.classList.add(Qe))),t.setAttribute("aria-expanded",!0)}i&&i()}static jQueryInterface(t){return this.each((function(){const e=ei.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}$.on(document,"click.bs.tab.data-api",'[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]',(function(t){["A","AREA"].includes(this.tagName)&&t.preventDefault(),u(this)||ei.getOrCreateInstance(this).show()})),v(ei);const ii="toast",si="hide",ni="show",oi="showing",ri={animation:"boolean",autohide:"boolean",delay:"number"},ai={animation:!0,autohide:!0,delay:5e3};class li extends R{constructor(t,e){super(t),this._config=this._getConfig(e),this._timeout=null,this._hasMouseInteraction=!1,this._hasKeyboardInteraction=!1,this._setListeners()}static get DefaultType(){return ri}static get Default(){return ai}static get NAME(){return ii}show(){$.trigger(this._element,"show.bs.toast").defaultPrevented||(this._clearTimeout(),this._config.animation&&this._element.classList.add("fade"),this._element.classList.remove(si),f(this._element),this._element.classList.add(ni),this._element.classList.add(oi),this._queueCallback((()=>{this._element.classList.remove(oi),$.trigger(this._element,"shown.bs.toast"),this._maybeScheduleHide()}),this._element,this._config.animation))}hide(){this._element.classList.contains(ni)&&($.trigger(this._element,"hide.bs.toast").defaultPrevented||(this._element.classList.add(oi),this._queueCallback((()=>{this._element.classList.add(si),this._element.classList.remove(oi),this._element.classList.remove(ni),$.trigger(this._element,"hidden.bs.toast")}),this._element,this._config.animation)))}dispose(){this._clearTimeout(),this._element.classList.contains(ni)&&this._element.classList.remove(ni),super.dispose()}_getConfig(t){return t={...ai,...X.getDataAttributes(this._element),..."object"==typeof t&&t?t:{}},h(ii,t,this.constructor.DefaultType),t}_maybeScheduleHide(){this._config.autohide&&(this._hasMouseInteraction||this._hasKeyboardInteraction||(this._timeout=setTimeout((()=>{this.hide()}),this._config.delay)))}_onInteraction(t,e){switch(t.type){case"mouseover":case"mouseout":this._hasMouseInteraction=e;break;case"focusin":case"focusout":this._hasKeyboardInteraction=e}if(e)return void this._clearTimeout();const i=t.relatedTarget;this._element===i||this._element.contains(i)||this._maybeScheduleHide()}_setListeners(){$.on(this._element,"mouseover.bs.toast",(t=>this._onInteraction(t,!0))),$.on(this._element,"mouseout.bs.toast",(t=>this._onInteraction(t,!1))),$.on(this._element,"focusin.bs.toast",(t=>this._onInteraction(t,!0))),$.on(this._element,"focusout.bs.toast",(t=>this._onInteraction(t,!1)))}_clearTimeout(){clearTimeout(this._timeout),this._timeout=null}static jQueryInterface(t){return this.each((function(){const e=li.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}return F(li),v(li),{Alert:q,Button:U,Carousel:at,Collapse:mt,Dropdown:Ht,Modal:he,Offcanvas:me,Popover:Fe,ScrollSpy:Ye,Tab:ei,Toast:li,Tooltip:$e}}));
//# sourceMappingURL=bootstrap.min.js.map
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/*! js-cookie v3.0.5 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  })());
})(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));

/*!
 * hoverIntent v1.10.2 // 2020.04.28 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2019 Brian Cherne
 */

/**
 * hoverIntent is similar to jQuery's built-in "hover" method except that
 * instead of firing the handlerIn function immediately, hoverIntent checks
 * to see if the user's mouse has slowed down (beneath the sensitivity
 * threshold) before firing the event. The handlerOut function is only
 * called after a matching handlerIn.
 *
 * // basic usage ... just like .hover()
 * .hoverIntent( handlerIn, handlerOut )
 * .hoverIntent( handlerInOut )
 *
 * // basic usage ... with event delegation!
 * .hoverIntent( handlerIn, handlerOut, selector )
 * .hoverIntent( handlerInOut, selector )
 *
 * // using a basic configuration object
 * .hoverIntent( config )
 *
 * @param  handlerIn   function OR configuration object
 * @param  handlerOut  function OR selector for delegation OR undefined
 * @param  selector    selector OR undefined
 * @author Brian Cherne <brian(at)cherne(dot)net>
 */

;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('jquery'));
    } else if (jQuery && !jQuery.fn.hoverIntent) {
        factory(jQuery);
    }
})(function($) {
    'use strict';

    // default configuration values
    var _cfg = {
        interval: 100,
        sensitivity: 6,
        timeout: 0
    };

    // counter used to generate an ID for each instance
    var INSTANCE_COUNT = 0;

    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    var cX, cY;

    // saves the current pointer position coordinates based on the given mousemove event
    var track = function(ev) {
        cX = ev.pageX;
        cY = ev.pageY;
    };

    // compares current and previous mouse positions
    var compare = function(ev,$el,s,cfg) {
        // compare mouse positions to see if pointer has slowed enough to trigger `over` function
        if ( Math.sqrt( (s.pX-cX)*(s.pX-cX) + (s.pY-cY)*(s.pY-cY) ) < cfg.sensitivity ) {
            $el.off(s.event,track);
            delete s.timeoutId;
            // set hoverIntent state as active for this element (permits `out` handler to trigger)
            s.isActive = true;
            // overwrite old mouseenter event coordinates with most recent pointer position
            ev.pageX = cX; ev.pageY = cY;
            // clear coordinate data from state object
            delete s.pX; delete s.pY;
            return cfg.over.apply($el[0],[ev]);
        } else {
            // set previous coordinates for next comparison
            s.pX = cX; s.pY = cY;
            // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
            s.timeoutId = setTimeout( function(){compare(ev, $el, s, cfg);} , cfg.interval );
        }
    };

    // triggers given `out` function at configured `timeout` after a mouseleave and clears state
    var delay = function(ev,$el,s,out) {
        var data = $el.data('hoverIntent');
        if (data) {
            delete data[s.id];
        }
        return out.apply($el[0],[ev]);
    };

    // checks if `value` is a function
    var isFunction = function(value) {
        return typeof value === 'function';
    };

    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {
        // instance ID, used as a key to store and retrieve state information on an element
        var instanceId = INSTANCE_COUNT++;

        // extend the default configuration and parse parameters
        var cfg = $.extend({}, _cfg);
        if ( $.isPlainObject(handlerIn) ) {
            cfg = $.extend(cfg, handlerIn);
            if ( !isFunction(cfg.out) ) {
                cfg.out = cfg.over;
            }
        } else if ( isFunction(handlerOut) ) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // cloned event to pass to handlers (copy required for event object to be passed in IE)
            var ev = $.extend({},e);

            // the current target of the mouse event, wrapped in a jQuery object
            var $el = $(this);

            // read hoverIntent data from element (or initialize if not present)
            var hoverIntentData = $el.data('hoverIntent');
            if (!hoverIntentData) { $el.data('hoverIntent', (hoverIntentData = {})); }

            // read per-instance state from element (or initialize if not present)
            var state = hoverIntentData[instanceId];
            if (!state) { hoverIntentData[instanceId] = state = { id: instanceId }; }

            // state properties:
            // id = instance ID, used to clean up data
            // timeoutId = timeout ID, reused for tracking mouse position and delaying "out" handler
            // isActive = plugin state, true after `over` is called just until `out` is called
            // pX, pY = previously-measured pointer coordinates, updated at each polling interval
            // event = string representing the namespaced event used for mouse tracking

            // clear any existing timeout
            if (state.timeoutId) { state.timeoutId = clearTimeout(state.timeoutId); }

            // namespaced event used to register and unregister mousemove tracking
            var mousemove = state.event = 'mousemove.hoverIntent.hoverIntent'+instanceId;

            // handle the event, based on its type
            if (e.type === 'mouseenter') {
                // do nothing if already active
                if (state.isActive) { return; }
                // set "previous" X and Y position based on initial entry point
                state.pX = ev.pageX; state.pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $el.off(mousemove,track).on(mousemove,track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                state.timeoutId = setTimeout( function(){compare(ev,$el,state,cfg);} , cfg.interval );
            } else { // "mouseleave"
                // do nothing if not already active
                if (!state.isActive) { return; }
                // unbind expensive mousemove event
                $el.off(mousemove,track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                state.timeoutId = setTimeout( function(){delay(ev,$el,state,cfg.out);} , cfg.timeout );
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
});

/**
 * Swiper 11.2.10
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 28, 2025
 */

var Swiper=function(){"use strict";function e(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function t(s,a){void 0===s&&(s={}),void 0===a&&(a={});const i=["__proto__","constructor","prototype"];Object.keys(a).filter((e=>i.indexOf(e)<0)).forEach((i=>{void 0===s[i]?s[i]=a[i]:e(a[i])&&e(s[i])&&Object.keys(a[i]).length>0&&t(s[i],a[i])}))}const s={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector:()=>null,querySelectorAll:()=>[],getElementById:()=>null,createEvent:()=>({initEvent(){}}),createElement:()=>({children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName:()=>[]}),createElementNS:()=>({}),importNode:()=>null,location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function a(){const e="undefined"!=typeof document?document:{};return t(e,s),e}const i={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle:()=>({getPropertyValue:()=>""}),Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia:()=>({}),requestAnimationFrame:e=>"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0),cancelAnimationFrame(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function r(){const e="undefined"!=typeof window?window:{};return t(e,i),e}function n(e){return void 0===e&&(e=""),e.trim().split(" ").filter((e=>!!e.trim()))}function l(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function o(){return Date.now()}function d(e,t){void 0===t&&(t="x");const s=r();let a,i,n;const l=function(e){const t=r();let s;return t.getComputedStyle&&(s=t.getComputedStyle(e,null)),!s&&e.currentStyle&&(s=e.currentStyle),s||(s=e.style),s}(e);return s.WebKitCSSMatrix?(i=l.transform||l.webkitTransform,i.split(",").length>6&&(i=i.split(", ").map((e=>e.replace(",","."))).join(", ")),n=new s.WebKitCSSMatrix("none"===i?"":i)):(n=l.MozTransform||l.OTransform||l.MsTransform||l.msTransform||l.transform||l.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),a=n.toString().split(",")),"x"===t&&(i=s.WebKitCSSMatrix?n.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=s.WebKitCSSMatrix?n.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function c(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function p(){const e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"];for(let a=1;a<arguments.length;a+=1){const i=a<0||arguments.length<=a?void 0:arguments[a];if(null!=i&&(s=i,!("undefined"!=typeof window&&void 0!==window.HTMLElement?s instanceof HTMLElement:s&&(1===s.nodeType||11===s.nodeType)))){const s=Object.keys(Object(i)).filter((e=>t.indexOf(e)<0));for(let t=0,a=s.length;t<a;t+=1){const a=s[t],r=Object.getOwnPropertyDescriptor(i,a);void 0!==r&&r.enumerable&&(c(e[a])&&c(i[a])?i[a].__swiper__?e[a]=i[a]:p(e[a],i[a]):!c(e[a])&&c(i[a])?(e[a]={},i[a].__swiper__?e[a]=i[a]:p(e[a],i[a])):e[a]=i[a])}}}var s;return e}function u(e,t,s){e.style.setProperty(t,s)}function m(e){let{swiper:t,targetPosition:s,side:a}=e;const i=r(),n=-t.translate;let l,o=null;const d=t.params.speed;t.wrapperEl.style.scrollSnapType="none",i.cancelAnimationFrame(t.cssModeFrameID);const c=s>n?"next":"prev",p=(e,t)=>"next"===c&&e>=t||"prev"===c&&e<=t,u=()=>{l=(new Date).getTime(),null===o&&(o=l);const e=Math.max(Math.min((l-o)/d,1),0),r=.5-Math.cos(e*Math.PI)/2;let c=n+r*(s-n);if(p(c,s)&&(c=s),t.wrapperEl.scrollTo({[a]:c}),p(c,s))return t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.scrollSnapType="",setTimeout((()=>{t.wrapperEl.style.overflow="",t.wrapperEl.scrollTo({[a]:c})})),void i.cancelAnimationFrame(t.cssModeFrameID);t.cssModeFrameID=i.requestAnimationFrame(u)};u()}function h(e){return e.querySelector(".swiper-slide-transform")||e.shadowRoot&&e.shadowRoot.querySelector(".swiper-slide-transform")||e}function f(e,t){void 0===t&&(t="");const s=r(),a=[...e.children];return s.HTMLSlotElement&&e instanceof HTMLSlotElement&&a.push(...e.assignedElements()),t?a.filter((e=>e.matches(t))):a}function g(e){try{return void console.warn(e)}catch(e){}}function v(e,t){void 0===t&&(t=[]);const s=document.createElement(e);return s.classList.add(...Array.isArray(t)?t:n(t)),s}function w(e){const t=r(),s=a(),i=e.getBoundingClientRect(),n=s.body,l=e.clientTop||n.clientTop||0,o=e.clientLeft||n.clientLeft||0,d=e===t?t.scrollY:e.scrollTop,c=e===t?t.scrollX:e.scrollLeft;return{top:i.top+d-l,left:i.left+c-o}}function b(e,t){return r().getComputedStyle(e,null).getPropertyValue(t)}function y(e){let t,s=e;if(s){for(t=0;null!==(s=s.previousSibling);)1===s.nodeType&&(t+=1);return t}}function E(e,t){const s=[];let a=e.parentElement;for(;a;)t?a.matches(t)&&s.push(a):s.push(a),a=a.parentElement;return s}function x(e,t){t&&e.addEventListener("transitionend",(function s(a){a.target===e&&(t.call(e,a),e.removeEventListener("transitionend",s))}))}function S(e,t,s){const a=r();return s?e["width"===t?"offsetWidth":"offsetHeight"]+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-right":"margin-top"))+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-left":"margin-bottom")):e.offsetWidth}function T(e){return(Array.isArray(e)?e:[e]).filter((e=>!!e))}function M(e){return t=>Math.abs(t)>0&&e.browser&&e.browser.need3dFix&&Math.abs(t)%90==0?t+.001:t}function C(e,t){void 0===t&&(t=""),"undefined"!=typeof trustedTypes?e.innerHTML=trustedTypes.createPolicy("html",{createHTML:e=>e}).createHTML(t):e.innerHTML=t}let P,L,I;function z(){return P||(P=function(){const e=r(),t=a();return{smoothScroll:t.documentElement&&t.documentElement.style&&"scrollBehavior"in t.documentElement.style,touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch)}}()),P}function A(e){return void 0===e&&(e={}),L||(L=function(e){let{userAgent:t}=void 0===e?{}:e;const s=z(),a=r(),i=a.navigator.platform,n=t||a.navigator.userAgent,l={ios:!1,android:!1},o=a.screen.width,d=a.screen.height,c=n.match(/(Android);?[\s\/]+([\d.]+)?/);let p=n.match(/(iPad).*OS\s([\d_]+)/);const u=n.match(/(iPod)(.*OS\s([\d_]+))?/),m=!p&&n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),h="Win32"===i;let f="MacIntel"===i;return!p&&f&&s.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(`${o}x${d}`)>=0&&(p=n.match(/(Version)\/([\d.]+)/),p||(p=[0,1,"13_0_0"]),f=!1),c&&!h&&(l.os="android",l.android=!0),(p||m||u)&&(l.os="ios",l.ios=!0),l}(e)),L}function $(){return I||(I=function(){const e=r(),t=A();let s=!1;function a(){const t=e.navigator.userAgent.toLowerCase();return t.indexOf("safari")>=0&&t.indexOf("chrome")<0&&t.indexOf("android")<0}if(a()){const t=String(e.navigator.userAgent);if(t.includes("Version/")){const[e,a]=t.split("Version/")[1].split(" ")[0].split(".").map((e=>Number(e)));s=e<16||16===e&&a<2}}const i=/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),n=a();return{isSafari:s||n,needPerspectiveFix:s,need3dFix:n||i&&t.ios,isWebView:i}}()),I}var k={on(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;const i=s?"unshift":"push";return e.split(" ").forEach((e=>{a.eventsListeners[e]||(a.eventsListeners[e]=[]),a.eventsListeners[e][i](t)})),a},once(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;function i(){a.off(e,i),i.__emitterProxy&&delete i.__emitterProxy;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];t.apply(a,r)}return i.__emitterProxy=t,a.on(e,i,s)},onAny(e,t){const s=this;if(!s.eventsListeners||s.destroyed)return s;if("function"!=typeof e)return s;const a=t?"unshift":"push";return s.eventsAnyListeners.indexOf(e)<0&&s.eventsAnyListeners[a](e),s},offAny(e){const t=this;if(!t.eventsListeners||t.destroyed)return t;if(!t.eventsAnyListeners)return t;const s=t.eventsAnyListeners.indexOf(e);return s>=0&&t.eventsAnyListeners.splice(s,1),t},off(e,t){const s=this;return!s.eventsListeners||s.destroyed?s:s.eventsListeners?(e.split(" ").forEach((e=>{void 0===t?s.eventsListeners[e]=[]:s.eventsListeners[e]&&s.eventsListeners[e].forEach(((a,i)=>{(a===t||a.__emitterProxy&&a.__emitterProxy===t)&&s.eventsListeners[e].splice(i,1)}))})),s):s},emit(){const e=this;if(!e.eventsListeners||e.destroyed)return e;if(!e.eventsListeners)return e;let t,s,a;for(var i=arguments.length,r=new Array(i),n=0;n<i;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(t=r[0],s=r.slice(1,r.length),a=e):(t=r[0].events,s=r[0].data,a=r[0].context||e),s.unshift(a);return(Array.isArray(t)?t:t.split(" ")).forEach((t=>{e.eventsAnyListeners&&e.eventsAnyListeners.length&&e.eventsAnyListeners.forEach((e=>{e.apply(a,[t,...s])})),e.eventsListeners&&e.eventsListeners[t]&&e.eventsListeners[t].forEach((e=>{e.apply(a,s)}))})),e}};const O=(e,t,s)=>{t&&!e.classList.contains(s)?e.classList.add(s):!t&&e.classList.contains(s)&&e.classList.remove(s)};const D=(e,t,s)=>{t&&!e.classList.contains(s)?e.classList.add(s):!t&&e.classList.contains(s)&&e.classList.remove(s)};const G=(e,t)=>{if(!e||e.destroyed||!e.params)return;const s=t.closest(e.isElement?"swiper-slide":`.${e.params.slideClass}`);if(s){let t=s.querySelector(`.${e.params.lazyPreloaderClass}`);!t&&e.isElement&&(s.shadowRoot?t=s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`):requestAnimationFrame((()=>{s.shadowRoot&&(t=s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`),t&&t.remove())}))),t&&t.remove()}},X=(e,t)=>{if(!e.slides[t])return;const s=e.slides[t].querySelector('[loading="lazy"]');s&&s.removeAttribute("loading")},Y=e=>{if(!e||e.destroyed||!e.params)return;let t=e.params.lazyPreloadPrevNext;const s=e.slides.length;if(!s||!t||t<0)return;t=Math.min(t,s);const a="auto"===e.params.slidesPerView?e.slidesPerViewDynamic():Math.ceil(e.params.slidesPerView),i=e.activeIndex;if(e.params.grid&&e.params.grid.rows>1){const s=i,r=[s-t];return r.push(...Array.from({length:t}).map(((e,t)=>s+a+t))),void e.slides.forEach(((t,s)=>{r.includes(t.column)&&X(e,s)}))}const r=i+a-1;if(e.params.rewind||e.params.loop)for(let a=i-t;a<=r+t;a+=1){const t=(a%s+s)%s;(t<i||t>r)&&X(e,t)}else for(let a=Math.max(i-t,0);a<=Math.min(r+t,s-1);a+=1)a!==i&&(a>r||a<i)&&X(e,a)};var B={updateSize:function(){const e=this;let t,s;const a=e.el;t=void 0!==e.params.width&&null!==e.params.width?e.params.width:a.clientWidth,s=void 0!==e.params.height&&null!==e.params.height?e.params.height:a.clientHeight,0===t&&e.isHorizontal()||0===s&&e.isVertical()||(t=t-parseInt(b(a,"padding-left")||0,10)-parseInt(b(a,"padding-right")||0,10),s=s-parseInt(b(a,"padding-top")||0,10)-parseInt(b(a,"padding-bottom")||0,10),Number.isNaN(t)&&(t=0),Number.isNaN(s)&&(s=0),Object.assign(e,{width:t,height:s,size:e.isHorizontal()?t:s}))},updateSlides:function(){const e=this;function t(t,s){return parseFloat(t.getPropertyValue(e.getDirectionLabel(s))||0)}const s=e.params,{wrapperEl:a,slidesEl:i,size:r,rtlTranslate:n,wrongRTL:l}=e,o=e.virtual&&s.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,c=f(i,`.${e.params.slideClass}, swiper-slide`),p=o?e.virtual.slides.length:c.length;let m=[];const h=[],g=[];let v=s.slidesOffsetBefore;"function"==typeof v&&(v=s.slidesOffsetBefore.call(e));let w=s.slidesOffsetAfter;"function"==typeof w&&(w=s.slidesOffsetAfter.call(e));const y=e.snapGrid.length,E=e.slidesGrid.length;let x=s.spaceBetween,T=-v,M=0,C=0;if(void 0===r)return;"string"==typeof x&&x.indexOf("%")>=0?x=parseFloat(x.replace("%",""))/100*r:"string"==typeof x&&(x=parseFloat(x)),e.virtualSize=-x,c.forEach((e=>{n?e.style.marginLeft="":e.style.marginRight="",e.style.marginBottom="",e.style.marginTop=""})),s.centeredSlides&&s.cssMode&&(u(a,"--swiper-centered-offset-before",""),u(a,"--swiper-centered-offset-after",""));const P=s.grid&&s.grid.rows>1&&e.grid;let L;P?e.grid.initSlides(c):e.grid&&e.grid.unsetSlides();const I="auto"===s.slidesPerView&&s.breakpoints&&Object.keys(s.breakpoints).filter((e=>void 0!==s.breakpoints[e].slidesPerView)).length>0;for(let a=0;a<p;a+=1){let i;if(L=0,c[a]&&(i=c[a]),P&&e.grid.updateSlide(a,i,c),!c[a]||"none"!==b(i,"display")){if("auto"===s.slidesPerView){I&&(c[a].style[e.getDirectionLabel("width")]="");const r=getComputedStyle(i),n=i.style.transform,l=i.style.webkitTransform;if(n&&(i.style.transform="none"),l&&(i.style.webkitTransform="none"),s.roundLengths)L=e.isHorizontal()?S(i,"width",!0):S(i,"height",!0);else{const e=t(r,"width"),s=t(r,"padding-left"),a=t(r,"padding-right"),n=t(r,"margin-left"),l=t(r,"margin-right"),o=r.getPropertyValue("box-sizing");if(o&&"border-box"===o)L=e+n+l;else{const{clientWidth:t,offsetWidth:r}=i;L=e+s+a+n+l+(r-t)}}n&&(i.style.transform=n),l&&(i.style.webkitTransform=l),s.roundLengths&&(L=Math.floor(L))}else L=(r-(s.slidesPerView-1)*x)/s.slidesPerView,s.roundLengths&&(L=Math.floor(L)),c[a]&&(c[a].style[e.getDirectionLabel("width")]=`${L}px`);c[a]&&(c[a].swiperSlideSize=L),g.push(L),s.centeredSlides?(T=T+L/2+M/2+x,0===M&&0!==a&&(T=T-r/2-x),0===a&&(T=T-r/2-x),Math.abs(T)<.001&&(T=0),s.roundLengths&&(T=Math.floor(T)),C%s.slidesPerGroup==0&&m.push(T),h.push(T)):(s.roundLengths&&(T=Math.floor(T)),(C-Math.min(e.params.slidesPerGroupSkip,C))%e.params.slidesPerGroup==0&&m.push(T),h.push(T),T=T+L+x),e.virtualSize+=L+x,M=L,C+=1}}if(e.virtualSize=Math.max(e.virtualSize,r)+w,n&&l&&("slide"===s.effect||"coverflow"===s.effect)&&(a.style.width=`${e.virtualSize+x}px`),s.setWrapperSize&&(a.style[e.getDirectionLabel("width")]=`${e.virtualSize+x}px`),P&&e.grid.updateWrapperSize(L,m),!s.centeredSlides){const t=[];for(let a=0;a<m.length;a+=1){let i=m[a];s.roundLengths&&(i=Math.floor(i)),m[a]<=e.virtualSize-r&&t.push(i)}m=t,Math.floor(e.virtualSize-r)-Math.floor(m[m.length-1])>1&&m.push(e.virtualSize-r)}if(o&&s.loop){const t=g[0]+x;if(s.slidesPerGroup>1){const a=Math.ceil((e.virtual.slidesBefore+e.virtual.slidesAfter)/s.slidesPerGroup),i=t*s.slidesPerGroup;for(let e=0;e<a;e+=1)m.push(m[m.length-1]+i)}for(let a=0;a<e.virtual.slidesBefore+e.virtual.slidesAfter;a+=1)1===s.slidesPerGroup&&m.push(m[m.length-1]+t),h.push(h[h.length-1]+t),e.virtualSize+=t}if(0===m.length&&(m=[0]),0!==x){const t=e.isHorizontal()&&n?"marginLeft":e.getDirectionLabel("marginRight");c.filter(((e,t)=>!(s.cssMode&&!s.loop)||t!==c.length-1)).forEach((e=>{e.style[t]=`${x}px`}))}if(s.centeredSlides&&s.centeredSlidesBounds){let e=0;g.forEach((t=>{e+=t+(x||0)})),e-=x;const t=e>r?e-r:0;m=m.map((e=>e<=0?-v:e>t?t+w:e))}if(s.centerInsufficientSlides){let e=0;g.forEach((t=>{e+=t+(x||0)})),e-=x;const t=(s.slidesOffsetBefore||0)+(s.slidesOffsetAfter||0);if(e+t<r){const s=(r-e-t)/2;m.forEach(((e,t)=>{m[t]=e-s})),h.forEach(((e,t)=>{h[t]=e+s}))}}if(Object.assign(e,{slides:c,snapGrid:m,slidesGrid:h,slidesSizesGrid:g}),s.centeredSlides&&s.cssMode&&!s.centeredSlidesBounds){u(a,"--swiper-centered-offset-before",-m[0]+"px"),u(a,"--swiper-centered-offset-after",e.size/2-g[g.length-1]/2+"px");const t=-e.snapGrid[0],s=-e.slidesGrid[0];e.snapGrid=e.snapGrid.map((e=>e+t)),e.slidesGrid=e.slidesGrid.map((e=>e+s))}if(p!==d&&e.emit("slidesLengthChange"),m.length!==y&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==E&&e.emit("slidesGridLengthChange"),s.watchSlidesProgress&&e.updateSlidesOffset(),e.emit("slidesUpdated"),!(o||s.cssMode||"slide"!==s.effect&&"fade"!==s.effect)){const t=`${s.containerModifierClass}backface-hidden`,a=e.el.classList.contains(t);p<=s.maxBackfaceHiddenSlides?a||e.el.classList.add(t):a&&e.el.classList.remove(t)}},updateAutoHeight:function(e){const t=this,s=[],a=t.virtual&&t.params.virtual.enabled;let i,r=0;"number"==typeof e?t.setTransition(e):!0===e&&t.setTransition(t.params.speed);const n=e=>a?t.slides[t.getSlideIndexByData(e)]:t.slides[e];if("auto"!==t.params.slidesPerView&&t.params.slidesPerView>1)if(t.params.centeredSlides)(t.visibleSlides||[]).forEach((e=>{s.push(e)}));else for(i=0;i<Math.ceil(t.params.slidesPerView);i+=1){const e=t.activeIndex+i;if(e>t.slides.length&&!a)break;s.push(n(e))}else s.push(n(t.activeIndex));for(i=0;i<s.length;i+=1)if(void 0!==s[i]){const e=s[i].offsetHeight;r=e>r?e:r}(r||0===r)&&(t.wrapperEl.style.height=`${r}px`)},updateSlidesOffset:function(){const e=this,t=e.slides,s=e.isElement?e.isHorizontal()?e.wrapperEl.offsetLeft:e.wrapperEl.offsetTop:0;for(let a=0;a<t.length;a+=1)t[a].swiperSlideOffset=(e.isHorizontal()?t[a].offsetLeft:t[a].offsetTop)-s-e.cssOverflowAdjustment()},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);const t=this,s=t.params,{slides:a,rtlTranslate:i,snapGrid:r}=t;if(0===a.length)return;void 0===a[0].swiperSlideOffset&&t.updateSlidesOffset();let n=-e;i&&(n=e),t.visibleSlidesIndexes=[],t.visibleSlides=[];let l=s.spaceBetween;"string"==typeof l&&l.indexOf("%")>=0?l=parseFloat(l.replace("%",""))/100*t.size:"string"==typeof l&&(l=parseFloat(l));for(let e=0;e<a.length;e+=1){const o=a[e];let d=o.swiperSlideOffset;s.cssMode&&s.centeredSlides&&(d-=a[0].swiperSlideOffset);const c=(n+(s.centeredSlides?t.minTranslate():0)-d)/(o.swiperSlideSize+l),p=(n-r[0]+(s.centeredSlides?t.minTranslate():0)-d)/(o.swiperSlideSize+l),u=-(n-d),m=u+t.slidesSizesGrid[e],h=u>=0&&u<=t.size-t.slidesSizesGrid[e],f=u>=0&&u<t.size-1||m>1&&m<=t.size||u<=0&&m>=t.size;f&&(t.visibleSlides.push(o),t.visibleSlidesIndexes.push(e)),O(o,f,s.slideVisibleClass),O(o,h,s.slideFullyVisibleClass),o.progress=i?-c:c,o.originalProgress=i?-p:p}},updateProgress:function(e){const t=this;if(void 0===e){const s=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*s||0}const s=t.params,a=t.maxTranslate()-t.minTranslate();let{progress:i,isBeginning:r,isEnd:n,progressLoop:l}=t;const o=r,d=n;if(0===a)i=0,r=!0,n=!0;else{i=(e-t.minTranslate())/a;const s=Math.abs(e-t.minTranslate())<1,l=Math.abs(e-t.maxTranslate())<1;r=s||i<=0,n=l||i>=1,s&&(i=0),l&&(i=1)}if(s.loop){const s=t.getSlideIndexByData(0),a=t.getSlideIndexByData(t.slides.length-1),i=t.slidesGrid[s],r=t.slidesGrid[a],n=t.slidesGrid[t.slidesGrid.length-1],o=Math.abs(e);l=o>=i?(o-i)/n:(o+n-r)/n,l>1&&(l-=1)}Object.assign(t,{progress:i,progressLoop:l,isBeginning:r,isEnd:n}),(s.watchSlidesProgress||s.centeredSlides&&s.autoHeight)&&t.updateSlidesProgress(e),r&&!o&&t.emit("reachBeginning toEdge"),n&&!d&&t.emit("reachEnd toEdge"),(o&&!r||d&&!n)&&t.emit("fromEdge"),t.emit("progress",i)},updateSlidesClasses:function(){const e=this,{slides:t,params:s,slidesEl:a,activeIndex:i}=e,r=e.virtual&&s.virtual.enabled,n=e.grid&&s.grid&&s.grid.rows>1,l=e=>f(a,`.${s.slideClass}${e}, swiper-slide${e}`)[0];let o,d,c;if(r)if(s.loop){let t=i-e.virtual.slidesBefore;t<0&&(t=e.virtual.slides.length+t),t>=e.virtual.slides.length&&(t-=e.virtual.slides.length),o=l(`[data-swiper-slide-index="${t}"]`)}else o=l(`[data-swiper-slide-index="${i}"]`);else n?(o=t.find((e=>e.column===i)),c=t.find((e=>e.column===i+1)),d=t.find((e=>e.column===i-1))):o=t[i];o&&(n||(c=function(e,t){const s=[];for(;e.nextElementSibling;){const a=e.nextElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(o,`.${s.slideClass}, swiper-slide`)[0],s.loop&&!c&&(c=t[0]),d=function(e,t){const s=[];for(;e.previousElementSibling;){const a=e.previousElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(o,`.${s.slideClass}, swiper-slide`)[0],s.loop&&0===!d&&(d=t[t.length-1]))),t.forEach((e=>{D(e,e===o,s.slideActiveClass),D(e,e===c,s.slideNextClass),D(e,e===d,s.slidePrevClass)})),e.emitSlidesClasses()},updateActiveIndex:function(e){const t=this,s=t.rtlTranslate?t.translate:-t.translate,{snapGrid:a,params:i,activeIndex:r,realIndex:n,snapIndex:l}=t;let o,d=e;const c=e=>{let s=e-t.virtual.slidesBefore;return s<0&&(s=t.virtual.slides.length+s),s>=t.virtual.slides.length&&(s-=t.virtual.slides.length),s};if(void 0===d&&(d=function(e){const{slidesGrid:t,params:s}=e,a=e.rtlTranslate?e.translate:-e.translate;let i;for(let e=0;e<t.length;e+=1)void 0!==t[e+1]?a>=t[e]&&a<t[e+1]-(t[e+1]-t[e])/2?i=e:a>=t[e]&&a<t[e+1]&&(i=e+1):a>=t[e]&&(i=e);return s.normalizeSlideIndex&&(i<0||void 0===i)&&(i=0),i}(t)),a.indexOf(s)>=0)o=a.indexOf(s);else{const e=Math.min(i.slidesPerGroupSkip,d);o=e+Math.floor((d-e)/i.slidesPerGroup)}if(o>=a.length&&(o=a.length-1),d===r&&!t.params.loop)return void(o!==l&&(t.snapIndex=o,t.emit("snapIndexChange")));if(d===r&&t.params.loop&&t.virtual&&t.params.virtual.enabled)return void(t.realIndex=c(d));const p=t.grid&&i.grid&&i.grid.rows>1;let u;if(t.virtual&&i.virtual.enabled&&i.loop)u=c(d);else if(p){const e=t.slides.find((e=>e.column===d));let s=parseInt(e.getAttribute("data-swiper-slide-index"),10);Number.isNaN(s)&&(s=Math.max(t.slides.indexOf(e),0)),u=Math.floor(s/i.grid.rows)}else if(t.slides[d]){const e=t.slides[d].getAttribute("data-swiper-slide-index");u=e?parseInt(e,10):d}else u=d;Object.assign(t,{previousSnapIndex:l,snapIndex:o,previousRealIndex:n,realIndex:u,previousIndex:r,activeIndex:d}),t.initialized&&Y(t),t.emit("activeIndexChange"),t.emit("snapIndexChange"),(t.initialized||t.params.runCallbacksOnInit)&&(n!==u&&t.emit("realIndexChange"),t.emit("slideChange"))},updateClickedSlide:function(e,t){const s=this,a=s.params;let i=e.closest(`.${a.slideClass}, swiper-slide`);!i&&s.isElement&&t&&t.length>1&&t.includes(e)&&[...t.slice(t.indexOf(e)+1,t.length)].forEach((e=>{!i&&e.matches&&e.matches(`.${a.slideClass}, swiper-slide`)&&(i=e)}));let r,n=!1;if(i)for(let e=0;e<s.slides.length;e+=1)if(s.slides[e]===i){n=!0,r=e;break}if(!i||!n)return s.clickedSlide=void 0,void(s.clickedIndex=void 0);s.clickedSlide=i,s.virtual&&s.params.virtual.enabled?s.clickedIndex=parseInt(i.getAttribute("data-swiper-slide-index"),10):s.clickedIndex=r,a.slideToClickedSlide&&void 0!==s.clickedIndex&&s.clickedIndex!==s.activeIndex&&s.slideToClickedSlide()}};var H={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");const{params:t,rtlTranslate:s,translate:a,wrapperEl:i}=this;if(t.virtualTranslate)return s?-a:a;if(t.cssMode)return a;let r=d(i,e);return r+=this.cssOverflowAdjustment(),s&&(r=-r),r||0},setTranslate:function(e,t){const s=this,{rtlTranslate:a,params:i,wrapperEl:r,progress:n}=s;let l,o=0,d=0;s.isHorizontal()?o=a?-e:e:d=e,i.roundLengths&&(o=Math.floor(o),d=Math.floor(d)),s.previousTranslate=s.translate,s.translate=s.isHorizontal()?o:d,i.cssMode?r[s.isHorizontal()?"scrollLeft":"scrollTop"]=s.isHorizontal()?-o:-d:i.virtualTranslate||(s.isHorizontal()?o-=s.cssOverflowAdjustment():d-=s.cssOverflowAdjustment(),r.style.transform=`translate3d(${o}px, ${d}px, 0px)`);const c=s.maxTranslate()-s.minTranslate();l=0===c?0:(e-s.minTranslate())/c,l!==n&&s.updateProgress(e),s.emit("setTranslate",s.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),void 0===a&&(a=!0);const r=this,{params:n,wrapperEl:l}=r;if(r.animating&&n.preventInteractionOnTransition)return!1;const o=r.minTranslate(),d=r.maxTranslate();let c;if(c=a&&e>o?o:a&&e<d?d:e,r.updateProgress(c),n.cssMode){const e=r.isHorizontal();if(0===t)l[e?"scrollLeft":"scrollTop"]=-c;else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:-c,side:e?"left":"top"}),!0;l.scrollTo({[e?"left":"top"]:-c,behavior:"smooth"})}return!0}return 0===t?(r.setTransition(0),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,r.animating=!1,s&&r.emit("transitionEnd"))}),r.wrapperEl.addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd))),!0}};function N(e){let{swiper:t,runCallbacks:s,direction:a,step:i}=e;const{activeIndex:r,previousIndex:n}=t;let l=a;l||(l=r>n?"next":r<n?"prev":"reset"),t.emit(`transition${i}`),s&&"reset"===l?t.emit(`slideResetTransition${i}`):s&&r!==n&&(t.emit(`slideChangeTransition${i}`),"next"===l?t.emit(`slideNextTransition${i}`):t.emit(`slidePrevTransition${i}`))}var R={slideTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===s&&(s=!0),"string"==typeof e&&(e=parseInt(e,10));const r=this;let n=e;n<0&&(n=0);const{params:l,snapGrid:o,slidesGrid:d,previousIndex:c,activeIndex:p,rtlTranslate:u,wrapperEl:h,enabled:f}=r;if(!f&&!a&&!i||r.destroyed||r.animating&&l.preventInteractionOnTransition)return!1;void 0===t&&(t=r.params.speed);const g=Math.min(r.params.slidesPerGroupSkip,n);let v=g+Math.floor((n-g)/r.params.slidesPerGroup);v>=o.length&&(v=o.length-1);const w=-o[v];if(l.normalizeSlideIndex)for(let e=0;e<d.length;e+=1){const t=-Math.floor(100*w),s=Math.floor(100*d[e]),a=Math.floor(100*d[e+1]);void 0!==d[e+1]?t>=s&&t<a-(a-s)/2?n=e:t>=s&&t<a&&(n=e+1):t>=s&&(n=e)}if(r.initialized&&n!==p){if(!r.allowSlideNext&&(u?w>r.translate&&w>r.minTranslate():w<r.translate&&w<r.minTranslate()))return!1;if(!r.allowSlidePrev&&w>r.translate&&w>r.maxTranslate()&&(p||0)!==n)return!1}let b;n!==(c||0)&&s&&r.emit("beforeSlideChangeStart"),r.updateProgress(w),b=n>p?"next":n<p?"prev":"reset";const y=r.virtual&&r.params.virtual.enabled;if(!(y&&i)&&(u&&-w===r.translate||!u&&w===r.translate))return r.updateActiveIndex(n),l.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==l.effect&&r.setTranslate(w),"reset"!==b&&(r.transitionStart(s,b),r.transitionEnd(s,b)),!1;if(l.cssMode){const e=r.isHorizontal(),s=u?w:-w;if(0===t)y&&(r.wrapperEl.style.scrollSnapType="none",r._immediateVirtual=!0),y&&!r._cssModeVirtualInitialSet&&r.params.initialSlide>0?(r._cssModeVirtualInitialSet=!0,requestAnimationFrame((()=>{h[e?"scrollLeft":"scrollTop"]=s}))):h[e?"scrollLeft":"scrollTop"]=s,y&&requestAnimationFrame((()=>{r.wrapperEl.style.scrollSnapType="",r._immediateVirtual=!1}));else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:s,side:e?"left":"top"}),!0;h.scrollTo({[e?"left":"top"]:s,behavior:"smooth"})}return!0}const E=$().isSafari;return y&&!i&&E&&r.isElement&&r.virtual.update(!1,!1,n),r.setTransition(t),r.setTranslate(w),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,a),r.transitionStart(s,b),0===t?r.transitionEnd(s,b):r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(s,b))}),r.wrapperEl.addEventListener("transitionend",r.onSlideToWrapperTransitionEnd)),!0},slideToLoop:function(e,t,s,a){if(void 0===e&&(e=0),void 0===s&&(s=!0),"string"==typeof e){e=parseInt(e,10)}const i=this;if(i.destroyed)return;void 0===t&&(t=i.params.speed);const r=i.grid&&i.params.grid&&i.params.grid.rows>1;let n=e;if(i.params.loop)if(i.virtual&&i.params.virtual.enabled)n+=i.virtual.slidesBefore;else{let e;if(r){const t=n*i.params.grid.rows;e=i.slides.find((e=>1*e.getAttribute("data-swiper-slide-index")===t)).column}else e=i.getSlideIndexByData(n);const t=r?Math.ceil(i.slides.length/i.params.grid.rows):i.slides.length,{centeredSlides:s}=i.params;let l=i.params.slidesPerView;"auto"===l?l=i.slidesPerViewDynamic():(l=Math.ceil(parseFloat(i.params.slidesPerView,10)),s&&l%2==0&&(l+=1));let o=t-e<l;if(s&&(o=o||e<Math.ceil(l/2)),a&&s&&"auto"!==i.params.slidesPerView&&!r&&(o=!1),o){const a=s?e<i.activeIndex?"prev":"next":e-i.activeIndex-1<i.params.slidesPerView?"next":"prev";i.loopFix({direction:a,slideTo:!0,activeSlideIndex:"next"===a?e+1:e-t+1,slideRealIndex:"next"===a?i.realIndex:void 0})}if(r){const e=n*i.params.grid.rows;n=i.slides.find((t=>1*t.getAttribute("data-swiper-slide-index")===e)).column}else n=i.getSlideIndexByData(n)}return requestAnimationFrame((()=>{i.slideTo(n,t,s,a)})),i},slideNext:function(e,t,s){void 0===t&&(t=!0);const a=this,{enabled:i,params:r,animating:n}=a;if(!i||a.destroyed)return a;void 0===e&&(e=a.params.speed);let l=r.slidesPerGroup;"auto"===r.slidesPerView&&1===r.slidesPerGroup&&r.slidesPerGroupAuto&&(l=Math.max(a.slidesPerViewDynamic("current",!0),1));const o=a.activeIndex<r.slidesPerGroupSkip?1:l,d=a.virtual&&r.virtual.enabled;if(r.loop){if(n&&!d&&r.loopPreventsSliding)return!1;if(a.loopFix({direction:"next"}),a._clientLeft=a.wrapperEl.clientLeft,a.activeIndex===a.slides.length-1&&r.cssMode)return requestAnimationFrame((()=>{a.slideTo(a.activeIndex+o,e,t,s)})),!0}return r.rewind&&a.isEnd?a.slideTo(0,e,t,s):a.slideTo(a.activeIndex+o,e,t,s)},slidePrev:function(e,t,s){void 0===t&&(t=!0);const a=this,{params:i,snapGrid:r,slidesGrid:n,rtlTranslate:l,enabled:o,animating:d}=a;if(!o||a.destroyed)return a;void 0===e&&(e=a.params.speed);const c=a.virtual&&i.virtual.enabled;if(i.loop){if(d&&!c&&i.loopPreventsSliding)return!1;a.loopFix({direction:"prev"}),a._clientLeft=a.wrapperEl.clientLeft}function p(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}const u=p(l?a.translate:-a.translate),m=r.map((e=>p(e))),h=i.freeMode&&i.freeMode.enabled;let f=r[m.indexOf(u)-1];if(void 0===f&&(i.cssMode||h)){let e;r.forEach(((t,s)=>{u>=t&&(e=s)})),void 0!==e&&(f=h?r[e]:r[e>0?e-1:e])}let g=0;if(void 0!==f&&(g=n.indexOf(f),g<0&&(g=a.activeIndex-1),"auto"===i.slidesPerView&&1===i.slidesPerGroup&&i.slidesPerGroupAuto&&(g=g-a.slidesPerViewDynamic("previous",!0)+1,g=Math.max(g,0))),i.rewind&&a.isBeginning){const i=a.params.virtual&&a.params.virtual.enabled&&a.virtual?a.virtual.slides.length-1:a.slides.length-1;return a.slideTo(i,e,t,s)}return i.loop&&0===a.activeIndex&&i.cssMode?(requestAnimationFrame((()=>{a.slideTo(g,e,t,s)})),!0):a.slideTo(g,e,t,s)},slideReset:function(e,t,s){void 0===t&&(t=!0);const a=this;if(!a.destroyed)return void 0===e&&(e=a.params.speed),a.slideTo(a.activeIndex,e,t,s)},slideToClosest:function(e,t,s,a){void 0===t&&(t=!0),void 0===a&&(a=.5);const i=this;if(i.destroyed)return;void 0===e&&(e=i.params.speed);let r=i.activeIndex;const n=Math.min(i.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/i.params.slidesPerGroup),o=i.rtlTranslate?i.translate:-i.translate;if(o>=i.snapGrid[l]){const e=i.snapGrid[l];o-e>(i.snapGrid[l+1]-e)*a&&(r+=i.params.slidesPerGroup)}else{const e=i.snapGrid[l-1];o-e<=(i.snapGrid[l]-e)*a&&(r-=i.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,i.slidesGrid.length-1),i.slideTo(r,e,t,s)},slideToClickedSlide:function(){const e=this;if(e.destroyed)return;const{params:t,slidesEl:s}=e,a="auto"===t.slidesPerView?e.slidesPerViewDynamic():t.slidesPerView;let i,r=e.getSlideIndexWhenGrid(e.clickedIndex);const n=e.isElement?"swiper-slide":`.${t.slideClass}`,o=e.grid&&e.params.grid&&e.params.grid.rows>1;if(t.loop){if(e.animating)return;i=parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10),t.centeredSlides?e.slideToLoop(i):r>(o?(e.slides.length-a)/2-(e.params.grid.rows-1):e.slides.length-a)?(e.loopFix(),r=e.getSlideIndex(f(s,`${n}[data-swiper-slide-index="${i}"]`)[0]),l((()=>{e.slideTo(r)}))):e.slideTo(r)}else e.slideTo(r)}};var _={loopCreate:function(e,t){const s=this,{params:a,slidesEl:i}=s;if(!a.loop||s.virtual&&s.params.virtual.enabled)return;const r=()=>{f(i,`.${a.slideClass}, swiper-slide`).forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t)}))},n=s.grid&&a.grid&&a.grid.rows>1;a.loopAddBlankSlides&&(a.slidesPerGroup>1||n)&&(()=>{const e=f(i,`.${a.slideBlankClass}`);e.forEach((e=>{e.remove()})),e.length>0&&(s.recalcSlides(),s.updateSlides())})();const l=a.slidesPerGroup*(n?a.grid.rows:1),o=s.slides.length%l!=0,d=n&&s.slides.length%a.grid.rows!=0,c=e=>{for(let t=0;t<e;t+=1){const e=s.isElement?v("swiper-slide",[a.slideBlankClass]):v("div",[a.slideClass,a.slideBlankClass]);s.slidesEl.append(e)}};if(o){if(a.loopAddBlankSlides){c(l-s.slides.length%l),s.recalcSlides(),s.updateSlides()}else g("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");r()}else if(d){if(a.loopAddBlankSlides){c(a.grid.rows-s.slides.length%a.grid.rows),s.recalcSlides(),s.updateSlides()}else g("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");r()}else r();s.loopFix({slideRealIndex:e,direction:a.centeredSlides?void 0:"next",initial:t})},loopFix:function(e){let{slideRealIndex:t,slideTo:s=!0,direction:a,setTranslate:i,activeSlideIndex:r,initial:n,byController:l,byMousewheel:o}=void 0===e?{}:e;const d=this;if(!d.params.loop)return;d.emit("beforeLoopFix");const{slides:c,allowSlidePrev:p,allowSlideNext:u,slidesEl:m,params:h}=d,{centeredSlides:f,initialSlide:v}=h;if(d.allowSlidePrev=!0,d.allowSlideNext=!0,d.virtual&&h.virtual.enabled)return s&&(h.centeredSlides||0!==d.snapIndex?h.centeredSlides&&d.snapIndex<h.slidesPerView?d.slideTo(d.virtual.slides.length+d.snapIndex,0,!1,!0):d.snapIndex===d.snapGrid.length-1&&d.slideTo(d.virtual.slidesBefore,0,!1,!0):d.slideTo(d.virtual.slides.length,0,!1,!0)),d.allowSlidePrev=p,d.allowSlideNext=u,void d.emit("loopFix");let w=h.slidesPerView;"auto"===w?w=d.slidesPerViewDynamic():(w=Math.ceil(parseFloat(h.slidesPerView,10)),f&&w%2==0&&(w+=1));const b=h.slidesPerGroupAuto?w:h.slidesPerGroup;let y=f?Math.max(b,Math.ceil(w/2)):b;y%b!=0&&(y+=b-y%b),y+=h.loopAdditionalSlides,d.loopedSlides=y;const E=d.grid&&h.grid&&h.grid.rows>1;c.length<w+y||"cards"===d.params.effect&&c.length<w+2*y?g("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"):E&&"row"===h.grid.fill&&g("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");const x=[],S=[],T=E?Math.ceil(c.length/h.grid.rows):c.length,M=n&&T-v<w&&!f;let C=M?v:d.activeIndex;void 0===r?r=d.getSlideIndex(c.find((e=>e.classList.contains(h.slideActiveClass)))):C=r;const P="next"===a||!a,L="prev"===a||!a;let I=0,z=0;const A=(E?c[r].column:r)+(f&&void 0===i?-w/2+.5:0);if(A<y){I=Math.max(y-A,b);for(let e=0;e<y-A;e+=1){const t=e-Math.floor(e/T)*T;if(E){const e=T-t-1;for(let t=c.length-1;t>=0;t-=1)c[t].column===e&&x.push(t)}else x.push(T-t-1)}}else if(A+w>T-y){z=Math.max(A-(T-2*y),b),M&&(z=Math.max(z,w-T+v+1));for(let e=0;e<z;e+=1){const t=e-Math.floor(e/T)*T;E?c.forEach(((e,s)=>{e.column===t&&S.push(s)})):S.push(t)}}if(d.__preventObserver__=!0,requestAnimationFrame((()=>{d.__preventObserver__=!1})),"cards"===d.params.effect&&c.length<w+2*y&&(S.includes(r)&&S.splice(S.indexOf(r),1),x.includes(r)&&x.splice(x.indexOf(r),1)),L&&x.forEach((e=>{c[e].swiperLoopMoveDOM=!0,m.prepend(c[e]),c[e].swiperLoopMoveDOM=!1})),P&&S.forEach((e=>{c[e].swiperLoopMoveDOM=!0,m.append(c[e]),c[e].swiperLoopMoveDOM=!1})),d.recalcSlides(),"auto"===h.slidesPerView?d.updateSlides():E&&(x.length>0&&L||S.length>0&&P)&&d.slides.forEach(((e,t)=>{d.grid.updateSlide(t,e,d.slides)})),h.watchSlidesProgress&&d.updateSlidesOffset(),s)if(x.length>0&&L){if(void 0===t){const e=d.slidesGrid[C],t=d.slidesGrid[C+I]-e;o?d.setTranslate(d.translate-t):(d.slideTo(C+Math.ceil(I),0,!1,!0),i&&(d.touchEventsData.startTranslate=d.touchEventsData.startTranslate-t,d.touchEventsData.currentTranslate=d.touchEventsData.currentTranslate-t))}else if(i){const e=E?x.length/h.grid.rows:x.length;d.slideTo(d.activeIndex+e,0,!1,!0),d.touchEventsData.currentTranslate=d.translate}}else if(S.length>0&&P)if(void 0===t){const e=d.slidesGrid[C],t=d.slidesGrid[C-z]-e;o?d.setTranslate(d.translate-t):(d.slideTo(C-z,0,!1,!0),i&&(d.touchEventsData.startTranslate=d.touchEventsData.startTranslate-t,d.touchEventsData.currentTranslate=d.touchEventsData.currentTranslate-t))}else{const e=E?S.length/h.grid.rows:S.length;d.slideTo(d.activeIndex-e,0,!1,!0)}if(d.allowSlidePrev=p,d.allowSlideNext=u,d.controller&&d.controller.control&&!l){const e={slideRealIndex:t,direction:a,setTranslate:i,activeSlideIndex:r,byController:!0};Array.isArray(d.controller.control)?d.controller.control.forEach((t=>{!t.destroyed&&t.params.loop&&t.loopFix({...e,slideTo:t.params.slidesPerView===h.slidesPerView&&s})})):d.controller.control instanceof d.constructor&&d.controller.control.params.loop&&d.controller.control.loopFix({...e,slideTo:d.controller.control.params.slidesPerView===h.slidesPerView&&s})}d.emit("loopFix")},loopDestroy:function(){const e=this,{params:t,slidesEl:s}=e;if(!t.loop||!s||e.virtual&&e.params.virtual.enabled)return;e.recalcSlides();const a=[];e.slides.forEach((e=>{const t=void 0===e.swiperSlideIndex?1*e.getAttribute("data-swiper-slide-index"):e.swiperSlideIndex;a[t]=e})),e.slides.forEach((e=>{e.removeAttribute("data-swiper-slide-index")})),a.forEach((e=>{s.append(e)})),e.recalcSlides(),e.slideTo(e.realIndex,0)}};function q(e,t,s){const a=r(),{params:i}=e,n=i.edgeSwipeDetection,l=i.edgeSwipeThreshold;return!n||!(s<=l||s>=a.innerWidth-l)||"prevent"===n&&(t.preventDefault(),!0)}function V(e){const t=this,s=a();let i=e;i.originalEvent&&(i=i.originalEvent);const n=t.touchEventsData;if("pointerdown"===i.type){if(null!==n.pointerId&&n.pointerId!==i.pointerId)return;n.pointerId=i.pointerId}else"touchstart"===i.type&&1===i.targetTouches.length&&(n.touchId=i.targetTouches[0].identifier);if("touchstart"===i.type)return void q(t,i,i.targetTouches[0].pageX);const{params:l,touches:d,enabled:c}=t;if(!c)return;if(!l.simulateTouch&&"mouse"===i.pointerType)return;if(t.animating&&l.preventInteractionOnTransition)return;!t.animating&&l.cssMode&&l.loop&&t.loopFix();let p=i.target;if("wrapper"===l.touchEventsTarget&&!function(e,t){const s=r();let a=t.contains(e);!a&&s.HTMLSlotElement&&t instanceof HTMLSlotElement&&(a=[...t.assignedElements()].includes(e),a||(a=function(e,t){const s=[t];for(;s.length>0;){const t=s.shift();if(e===t)return!0;s.push(...t.children,...t.shadowRoot?t.shadowRoot.children:[],...t.assignedElements?t.assignedElements():[])}}(e,t)));return a}(p,t.wrapperEl))return;if("which"in i&&3===i.which)return;if("button"in i&&i.button>0)return;if(n.isTouched&&n.isMoved)return;const u=!!l.noSwipingClass&&""!==l.noSwipingClass,m=i.composedPath?i.composedPath():i.path;u&&i.target&&i.target.shadowRoot&&m&&(p=m[0]);const h=l.noSwipingSelector?l.noSwipingSelector:`.${l.noSwipingClass}`,f=!(!i.target||!i.target.shadowRoot);if(l.noSwiping&&(f?function(e,t){return void 0===t&&(t=this),function t(s){if(!s||s===a()||s===r())return null;s.assignedSlot&&(s=s.assignedSlot);const i=s.closest(e);return i||s.getRootNode?i||t(s.getRootNode().host):null}(t)}(h,p):p.closest(h)))return void(t.allowClick=!0);if(l.swipeHandler&&!p.closest(l.swipeHandler))return;d.currentX=i.pageX,d.currentY=i.pageY;const g=d.currentX,v=d.currentY;if(!q(t,i,g))return;Object.assign(n,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),d.startX=g,d.startY=v,n.touchStartTime=o(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,l.threshold>0&&(n.allowThresholdMove=!1);let w=!0;p.matches(n.focusableElements)&&(w=!1,"SELECT"===p.nodeName&&(n.isTouched=!1)),s.activeElement&&s.activeElement.matches(n.focusableElements)&&s.activeElement!==p&&("mouse"===i.pointerType||"mouse"!==i.pointerType&&!p.matches(n.focusableElements))&&s.activeElement.blur();const b=w&&t.allowTouchMove&&l.touchStartPreventDefault;!l.touchStartForcePreventDefault&&!b||p.isContentEditable||i.preventDefault(),l.freeMode&&l.freeMode.enabled&&t.freeMode&&t.animating&&!l.cssMode&&t.freeMode.onTouchStart(),t.emit("touchStart",i)}function F(e){const t=a(),s=this,i=s.touchEventsData,{params:r,touches:n,rtlTranslate:l,enabled:d}=s;if(!d)return;if(!r.simulateTouch&&"mouse"===e.pointerType)return;let c,p=e;if(p.originalEvent&&(p=p.originalEvent),"pointermove"===p.type){if(null!==i.touchId)return;if(p.pointerId!==i.pointerId)return}if("touchmove"===p.type){if(c=[...p.changedTouches].find((e=>e.identifier===i.touchId)),!c||c.identifier!==i.touchId)return}else c=p;if(!i.isTouched)return void(i.startMoving&&i.isScrolling&&s.emit("touchMoveOpposite",p));const u=c.pageX,m=c.pageY;if(p.preventedByNestedSwiper)return n.startX=u,void(n.startY=m);if(!s.allowTouchMove)return p.target.matches(i.focusableElements)||(s.allowClick=!1),void(i.isTouched&&(Object.assign(n,{startX:u,startY:m,currentX:u,currentY:m}),i.touchStartTime=o()));if(r.touchReleaseOnEdges&&!r.loop)if(s.isVertical()){if(m<n.startY&&s.translate<=s.maxTranslate()||m>n.startY&&s.translate>=s.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else{if(l&&(u>n.startX&&-s.translate<=s.maxTranslate()||u<n.startX&&-s.translate>=s.minTranslate()))return;if(!l&&(u<n.startX&&s.translate<=s.maxTranslate()||u>n.startX&&s.translate>=s.minTranslate()))return}if(t.activeElement&&t.activeElement.matches(i.focusableElements)&&t.activeElement!==p.target&&"mouse"!==p.pointerType&&t.activeElement.blur(),t.activeElement&&p.target===t.activeElement&&p.target.matches(i.focusableElements))return i.isMoved=!0,void(s.allowClick=!1);i.allowTouchCallbacks&&s.emit("touchMove",p),n.previousX=n.currentX,n.previousY=n.currentY,n.currentX=u,n.currentY=m;const h=n.currentX-n.startX,f=n.currentY-n.startY;if(s.params.threshold&&Math.sqrt(h**2+f**2)<s.params.threshold)return;if(void 0===i.isScrolling){let e;s.isHorizontal()&&n.currentY===n.startY||s.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:h*h+f*f>=25&&(e=180*Math.atan2(Math.abs(f),Math.abs(h))/Math.PI,i.isScrolling=s.isHorizontal()?e>r.touchAngle:90-e>r.touchAngle)}if(i.isScrolling&&s.emit("touchMoveOpposite",p),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling||"touchmove"===p.type&&i.preventTouchMoveFromPointerMove)return void(i.isTouched=!1);if(!i.startMoving)return;s.allowClick=!1,!r.cssMode&&p.cancelable&&p.preventDefault(),r.touchMoveStopPropagation&&!r.nested&&p.stopPropagation();let g=s.isHorizontal()?h:f,v=s.isHorizontal()?n.currentX-n.previousX:n.currentY-n.previousY;r.oneWayMovement&&(g=Math.abs(g)*(l?1:-1),v=Math.abs(v)*(l?1:-1)),n.diff=g,g*=r.touchRatio,l&&(g=-g,v=-v);const w=s.touchesDirection;s.swipeDirection=g>0?"prev":"next",s.touchesDirection=v>0?"prev":"next";const b=s.params.loop&&!r.cssMode,y="next"===s.touchesDirection&&s.allowSlideNext||"prev"===s.touchesDirection&&s.allowSlidePrev;if(!i.isMoved){if(b&&y&&s.loopFix({direction:s.swipeDirection}),i.startTranslate=s.getTranslate(),s.setTransition(0),s.animating){const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0,detail:{bySwiperTouchMove:!0}});s.wrapperEl.dispatchEvent(e)}i.allowMomentumBounce=!1,!r.grabCursor||!0!==s.allowSlideNext&&!0!==s.allowSlidePrev||s.setGrabCursor(!0),s.emit("sliderFirstMove",p)}if((new Date).getTime(),!1!==r._loopSwapReset&&i.isMoved&&i.allowThresholdMove&&w!==s.touchesDirection&&b&&y&&Math.abs(g)>=1)return Object.assign(n,{startX:u,startY:m,currentX:u,currentY:m,startTranslate:i.currentTranslate}),i.loopSwapReset=!0,void(i.startTranslate=i.currentTranslate);s.emit("sliderMove",p),i.isMoved=!0,i.currentTranslate=g+i.startTranslate;let E=!0,x=r.resistanceRatio;if(r.touchReleaseOnEdges&&(x=0),g>0?(b&&y&&i.allowThresholdMove&&i.currentTranslate>(r.centeredSlides?s.minTranslate()-s.slidesSizesGrid[s.activeIndex+1]-("auto"!==r.slidesPerView&&s.slides.length-r.slidesPerView>=2?s.slidesSizesGrid[s.activeIndex+1]+s.params.spaceBetween:0)-s.params.spaceBetween:s.minTranslate())&&s.loopFix({direction:"prev",setTranslate:!0,activeSlideIndex:0}),i.currentTranslate>s.minTranslate()&&(E=!1,r.resistance&&(i.currentTranslate=s.minTranslate()-1+(-s.minTranslate()+i.startTranslate+g)**x))):g<0&&(b&&y&&i.allowThresholdMove&&i.currentTranslate<(r.centeredSlides?s.maxTranslate()+s.slidesSizesGrid[s.slidesSizesGrid.length-1]+s.params.spaceBetween+("auto"!==r.slidesPerView&&s.slides.length-r.slidesPerView>=2?s.slidesSizesGrid[s.slidesSizesGrid.length-1]+s.params.spaceBetween:0):s.maxTranslate())&&s.loopFix({direction:"next",setTranslate:!0,activeSlideIndex:s.slides.length-("auto"===r.slidesPerView?s.slidesPerViewDynamic():Math.ceil(parseFloat(r.slidesPerView,10)))}),i.currentTranslate<s.maxTranslate()&&(E=!1,r.resistance&&(i.currentTranslate=s.maxTranslate()+1-(s.maxTranslate()-i.startTranslate-g)**x))),E&&(p.preventedByNestedSwiper=!0),!s.allowSlideNext&&"next"===s.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!s.allowSlidePrev&&"prev"===s.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),s.allowSlidePrev||s.allowSlideNext||(i.currentTranslate=i.startTranslate),r.threshold>0){if(!(Math.abs(g)>r.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=s.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}r.followFinger&&!r.cssMode&&((r.freeMode&&r.freeMode.enabled&&s.freeMode||r.watchSlidesProgress)&&(s.updateActiveIndex(),s.updateSlidesClasses()),r.freeMode&&r.freeMode.enabled&&s.freeMode&&s.freeMode.onTouchMove(),s.updateProgress(i.currentTranslate),s.setTranslate(i.currentTranslate))}function W(e){const t=this,s=t.touchEventsData;let a,i=e;i.originalEvent&&(i=i.originalEvent);if("touchend"===i.type||"touchcancel"===i.type){if(a=[...i.changedTouches].find((e=>e.identifier===s.touchId)),!a||a.identifier!==s.touchId)return}else{if(null!==s.touchId)return;if(i.pointerId!==s.pointerId)return;a=i}if(["pointercancel","pointerout","pointerleave","contextmenu"].includes(i.type)){if(!(["pointercancel","contextmenu"].includes(i.type)&&(t.browser.isSafari||t.browser.isWebView)))return}s.pointerId=null,s.touchId=null;const{params:r,touches:n,rtlTranslate:d,slidesGrid:c,enabled:p}=t;if(!p)return;if(!r.simulateTouch&&"mouse"===i.pointerType)return;if(s.allowTouchCallbacks&&t.emit("touchEnd",i),s.allowTouchCallbacks=!1,!s.isTouched)return s.isMoved&&r.grabCursor&&t.setGrabCursor(!1),s.isMoved=!1,void(s.startMoving=!1);r.grabCursor&&s.isMoved&&s.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);const u=o(),m=u-s.touchStartTime;if(t.allowClick){const e=i.path||i.composedPath&&i.composedPath();t.updateClickedSlide(e&&e[0]||i.target,e),t.emit("tap click",i),m<300&&u-s.lastClickTime<300&&t.emit("doubleTap doubleClick",i)}if(s.lastClickTime=o(),l((()=>{t.destroyed||(t.allowClick=!0)})),!s.isTouched||!s.isMoved||!t.swipeDirection||0===n.diff&&!s.loopSwapReset||s.currentTranslate===s.startTranslate&&!s.loopSwapReset)return s.isTouched=!1,s.isMoved=!1,void(s.startMoving=!1);let h;if(s.isTouched=!1,s.isMoved=!1,s.startMoving=!1,h=r.followFinger?d?t.translate:-t.translate:-s.currentTranslate,r.cssMode)return;if(r.freeMode&&r.freeMode.enabled)return void t.freeMode.onTouchEnd({currentPos:h});const f=h>=-t.maxTranslate()&&!t.params.loop;let g=0,v=t.slidesSizesGrid[0];for(let e=0;e<c.length;e+=e<r.slidesPerGroupSkip?1:r.slidesPerGroup){const t=e<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;void 0!==c[e+t]?(f||h>=c[e]&&h<c[e+t])&&(g=e,v=c[e+t]-c[e]):(f||h>=c[e])&&(g=e,v=c[c.length-1]-c[c.length-2])}let w=null,b=null;r.rewind&&(t.isBeginning?b=r.virtual&&r.virtual.enabled&&t.virtual?t.virtual.slides.length-1:t.slides.length-1:t.isEnd&&(w=0));const y=(h-c[g])/v,E=g<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;if(m>r.longSwipesMs){if(!r.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(y>=r.longSwipesRatio?t.slideTo(r.rewind&&t.isEnd?w:g+E):t.slideTo(g)),"prev"===t.swipeDirection&&(y>1-r.longSwipesRatio?t.slideTo(g+E):null!==b&&y<0&&Math.abs(y)>r.longSwipesRatio?t.slideTo(b):t.slideTo(g))}else{if(!r.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(i.target===t.navigation.nextEl||i.target===t.navigation.prevEl)?i.target===t.navigation.nextEl?t.slideTo(g+E):t.slideTo(g):("next"===t.swipeDirection&&t.slideTo(null!==w?w:g+E),"prev"===t.swipeDirection&&t.slideTo(null!==b?b:g))}}function j(){const e=this,{params:t,el:s}=e;if(s&&0===s.offsetWidth)return;t.breakpoints&&e.setBreakpoint();const{allowSlideNext:a,allowSlidePrev:i,snapGrid:r}=e,n=e.virtual&&e.params.virtual.enabled;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses();const l=n&&t.loop;!("auto"===t.slidesPerView||t.slidesPerView>1)||!e.isEnd||e.isBeginning||e.params.centeredSlides||l?e.params.loop&&!n?e.slideToLoop(e.realIndex,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0):e.slideTo(e.slides.length-1,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&(clearTimeout(e.autoplay.resizeTimeout),e.autoplay.resizeTimeout=setTimeout((()=>{e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.resume()}),500)),e.allowSlidePrev=i,e.allowSlideNext=a,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}function U(e){const t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function K(){const e=this,{wrapperEl:t,rtlTranslate:s,enabled:a}=e;if(!a)return;let i;e.previousTranslate=e.translate,e.isHorizontal()?e.translate=-t.scrollLeft:e.translate=-t.scrollTop,0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();const r=e.maxTranslate()-e.minTranslate();i=0===r?0:(e.translate-e.minTranslate())/r,i!==e.progress&&e.updateProgress(s?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}function Z(e){const t=this;G(t,e.target),t.params.cssMode||"auto"!==t.params.slidesPerView&&!t.params.autoHeight||t.update()}function Q(){const e=this;e.documentTouchHandlerProceeded||(e.documentTouchHandlerProceeded=!0,e.params.touchReleaseOnEdges&&(e.el.style.touchAction="auto"))}const J=(e,t)=>{const s=a(),{params:i,el:r,wrapperEl:n,device:l}=e,o=!!i.nested,d="on"===t?"addEventListener":"removeEventListener",c=t;r&&"string"!=typeof r&&(s[d]("touchstart",e.onDocumentTouchStart,{passive:!1,capture:o}),r[d]("touchstart",e.onTouchStart,{passive:!1}),r[d]("pointerdown",e.onTouchStart,{passive:!1}),s[d]("touchmove",e.onTouchMove,{passive:!1,capture:o}),s[d]("pointermove",e.onTouchMove,{passive:!1,capture:o}),s[d]("touchend",e.onTouchEnd,{passive:!0}),s[d]("pointerup",e.onTouchEnd,{passive:!0}),s[d]("pointercancel",e.onTouchEnd,{passive:!0}),s[d]("touchcancel",e.onTouchEnd,{passive:!0}),s[d]("pointerout",e.onTouchEnd,{passive:!0}),s[d]("pointerleave",e.onTouchEnd,{passive:!0}),s[d]("contextmenu",e.onTouchEnd,{passive:!0}),(i.preventClicks||i.preventClicksPropagation)&&r[d]("click",e.onClick,!0),i.cssMode&&n[d]("scroll",e.onScroll),i.updateOnWindowResize?e[c](l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",j,!0):e[c]("observerUpdate",j,!0),r[d]("load",e.onLoad,{capture:!0}))};const ee=(e,t)=>e.grid&&t.grid&&t.grid.rows>1;var te={init:!0,direction:"horizontal",oneWayMovement:!1,swiperElementNodeName:"SWIPER-CONTAINER",touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,eventsPrefix:"swiper",enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:5,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,loop:!1,loopAddBlankSlides:!0,loopAdditionalSlides:0,loopPreventsSliding:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-blank",slideActiveClass:"swiper-slide-active",slideVisibleClass:"swiper-slide-visible",slideFullyVisibleClass:"swiper-slide-fully-visible",slideNextClass:"swiper-slide-next",slidePrevClass:"swiper-slide-prev",wrapperClass:"swiper-wrapper",lazyPreloaderClass:"swiper-lazy-preloader",lazyPreloadPrevNext:0,runCallbacksOnInit:!0,_emitClasses:!1};function se(e,t){return function(s){void 0===s&&(s={});const a=Object.keys(s)[0],i=s[a];"object"==typeof i&&null!==i?(!0===e[a]&&(e[a]={enabled:!0}),"navigation"===a&&e[a]&&e[a].enabled&&!e[a].prevEl&&!e[a].nextEl&&(e[a].auto=!0),["pagination","scrollbar"].indexOf(a)>=0&&e[a]&&e[a].enabled&&!e[a].el&&(e[a].auto=!0),a in e&&"enabled"in i?("object"!=typeof e[a]||"enabled"in e[a]||(e[a].enabled=!0),e[a]||(e[a]={enabled:!1}),p(t,s)):p(t,s)):p(t,s)}}const ae={eventsEmitter:k,update:B,translate:H,transition:{setTransition:function(e,t){const s=this;s.params.cssMode||(s.wrapperEl.style.transitionDuration=`${e}ms`,s.wrapperEl.style.transitionDelay=0===e?"0ms":""),s.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;a.cssMode||(a.autoHeight&&s.updateAutoHeight(),N({swiper:s,runCallbacks:e,direction:t,step:"Start"}))},transitionEnd:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;s.animating=!1,a.cssMode||(s.setTransition(0),N({swiper:s,runCallbacks:e,direction:t,step:"End"}))}},slide:R,loop:_,grabCursor:{setGrabCursor:function(e){const t=this;if(!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)return;const s="container"===t.params.touchEventsTarget?t.el:t.wrapperEl;t.isElement&&(t.__preventObserver__=!0),s.style.cursor="move",s.style.cursor=e?"grabbing":"grab",t.isElement&&requestAnimationFrame((()=>{t.__preventObserver__=!1}))},unsetGrabCursor:function(){const e=this;e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e.isElement&&(e.__preventObserver__=!0),e["container"===e.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="",e.isElement&&requestAnimationFrame((()=>{e.__preventObserver__=!1})))}},events:{attachEvents:function(){const e=this,{params:t}=e;e.onTouchStart=V.bind(e),e.onTouchMove=F.bind(e),e.onTouchEnd=W.bind(e),e.onDocumentTouchStart=Q.bind(e),t.cssMode&&(e.onScroll=K.bind(e)),e.onClick=U.bind(e),e.onLoad=Z.bind(e),J(e,"on")},detachEvents:function(){J(this,"off")}},breakpoints:{setBreakpoint:function(){const e=this,{realIndex:t,initialized:s,params:i,el:r}=e,n=i.breakpoints;if(!n||n&&0===Object.keys(n).length)return;const l=a(),o="window"!==i.breakpointsBase&&i.breakpointsBase?"container":i.breakpointsBase,d=["window","container"].includes(i.breakpointsBase)||!i.breakpointsBase?e.el:l.querySelector(i.breakpointsBase),c=e.getBreakpoint(n,o,d);if(!c||e.currentBreakpoint===c)return;const u=(c in n?n[c]:void 0)||e.originalParams,m=ee(e,i),h=ee(e,u),f=e.params.grabCursor,g=u.grabCursor,v=i.enabled;m&&!h?(r.classList.remove(`${i.containerModifierClass}grid`,`${i.containerModifierClass}grid-column`),e.emitContainerClasses()):!m&&h&&(r.classList.add(`${i.containerModifierClass}grid`),(u.grid.fill&&"column"===u.grid.fill||!u.grid.fill&&"column"===i.grid.fill)&&r.classList.add(`${i.containerModifierClass}grid-column`),e.emitContainerClasses()),f&&!g?e.unsetGrabCursor():!f&&g&&e.setGrabCursor(),["navigation","pagination","scrollbar"].forEach((t=>{if(void 0===u[t])return;const s=i[t]&&i[t].enabled,a=u[t]&&u[t].enabled;s&&!a&&e[t].disable(),!s&&a&&e[t].enable()}));const w=u.direction&&u.direction!==i.direction,b=i.loop&&(u.slidesPerView!==i.slidesPerView||w),y=i.loop;w&&s&&e.changeDirection(),p(e.params,u);const E=e.params.enabled,x=e.params.loop;Object.assign(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),v&&!E?e.disable():!v&&E&&e.enable(),e.currentBreakpoint=c,e.emit("_beforeBreakpoint",u),s&&(b?(e.loopDestroy(),e.loopCreate(t),e.updateSlides()):!y&&x?(e.loopCreate(t),e.updateSlides()):y&&!x&&e.loopDestroy()),e.emit("breakpoint",u)},getBreakpoint:function(e,t,s){if(void 0===t&&(t="window"),!e||"container"===t&&!s)return;let a=!1;const i=r(),n="window"===t?i.innerHeight:s.clientHeight,l=Object.keys(e).map((e=>{if("string"==typeof e&&0===e.indexOf("@")){const t=parseFloat(e.substr(1));return{value:n*t,point:e}}return{value:e,point:e}}));l.sort(((e,t)=>parseInt(e.value,10)-parseInt(t.value,10)));for(let e=0;e<l.length;e+=1){const{point:r,value:n}=l[e];"window"===t?i.matchMedia(`(min-width: ${n}px)`).matches&&(a=r):n<=s.clientWidth&&(a=r)}return a||"max"}},checkOverflow:{checkOverflow:function(){const e=this,{isLocked:t,params:s}=e,{slidesOffsetBefore:a}=s;if(a){const t=e.slides.length-1,s=e.slidesGrid[t]+e.slidesSizesGrid[t]+2*a;e.isLocked=e.size>s}else e.isLocked=1===e.snapGrid.length;!0===s.allowSlideNext&&(e.allowSlideNext=!e.isLocked),!0===s.allowSlidePrev&&(e.allowSlidePrev=!e.isLocked),t&&t!==e.isLocked&&(e.isEnd=!1),t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock")}},classes:{addClasses:function(){const e=this,{classNames:t,params:s,rtl:a,el:i,device:r}=e,n=function(e,t){const s=[];return e.forEach((e=>{"object"==typeof e?Object.keys(e).forEach((a=>{e[a]&&s.push(t+a)})):"string"==typeof e&&s.push(t+e)})),s}(["initialized",s.direction,{"free-mode":e.params.freeMode&&s.freeMode.enabled},{autoheight:s.autoHeight},{rtl:a},{grid:s.grid&&s.grid.rows>1},{"grid-column":s.grid&&s.grid.rows>1&&"column"===s.grid.fill},{android:r.android},{ios:r.ios},{"css-mode":s.cssMode},{centered:s.cssMode&&s.centeredSlides},{"watch-progress":s.watchSlidesProgress}],s.containerModifierClass);t.push(...n),i.classList.add(...t),e.emitContainerClasses()},removeClasses:function(){const{el:e,classNames:t}=this;e&&"string"!=typeof e&&(e.classList.remove(...t),this.emitContainerClasses())}}},ie={};class re{constructor(){let e,t;for(var s=arguments.length,i=new Array(s),r=0;r<s;r++)i[r]=arguments[r];1===i.length&&i[0].constructor&&"Object"===Object.prototype.toString.call(i[0]).slice(8,-1)?t=i[0]:[e,t]=i,t||(t={}),t=p({},t),e&&!t.el&&(t.el=e);const n=a();if(t.el&&"string"==typeof t.el&&n.querySelectorAll(t.el).length>1){const e=[];return n.querySelectorAll(t.el).forEach((s=>{const a=p({},t,{el:s});e.push(new re(a))})),e}const l=this;l.__swiper__=!0,l.support=z(),l.device=A({userAgent:t.userAgent}),l.browser=$(),l.eventsListeners={},l.eventsAnyListeners=[],l.modules=[...l.__modules__],t.modules&&Array.isArray(t.modules)&&l.modules.push(...t.modules);const o={};l.modules.forEach((e=>{e({params:t,swiper:l,extendParams:se(t,o),on:l.on.bind(l),once:l.once.bind(l),off:l.off.bind(l),emit:l.emit.bind(l)})}));const d=p({},te,o);return l.params=p({},d,ie,t),l.originalParams=p({},l.params),l.passedParams=p({},t),l.params&&l.params.on&&Object.keys(l.params.on).forEach((e=>{l.on(e,l.params.on[e])})),l.params&&l.params.onAny&&l.onAny(l.params.onAny),Object.assign(l,{enabled:l.params.enabled,el:e,classNames:[],slides:[],slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:()=>"horizontal"===l.params.direction,isVertical:()=>"vertical"===l.params.direction,activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,cssOverflowAdjustment(){return Math.trunc(this.translate/2**23)*2**23},allowSlideNext:l.params.allowSlideNext,allowSlidePrev:l.params.allowSlidePrev,touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:l.params.focusableElements,lastClickTime:0,clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,startMoving:void 0,pointerId:null,touchId:null},allowClick:!0,allowTouchMove:l.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),l.emit("_swiper"),l.params.init&&l.init(),l}getDirectionLabel(e){return this.isHorizontal()?e:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[e]}getSlideIndex(e){const{slidesEl:t,params:s}=this,a=y(f(t,`.${s.slideClass}, swiper-slide`)[0]);return y(e)-a}getSlideIndexByData(e){return this.getSlideIndex(this.slides.find((t=>1*t.getAttribute("data-swiper-slide-index")===e)))}getSlideIndexWhenGrid(e){return this.grid&&this.params.grid&&this.params.grid.rows>1&&("column"===this.params.grid.fill?e=Math.floor(e/this.params.grid.rows):"row"===this.params.grid.fill&&(e%=Math.ceil(this.slides.length/this.params.grid.rows))),e}recalcSlides(){const{slidesEl:e,params:t}=this;this.slides=f(e,`.${t.slideClass}, swiper-slide`)}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const s=this;e=Math.min(Math.max(e,0),1);const a=s.minTranslate(),i=(s.maxTranslate()-a)*e+a;s.translateTo(i,void 0===t?0:t),s.updateActiveIndex(),s.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter((t=>0===t.indexOf("swiper")||0===t.indexOf(e.params.containerModifierClass)));e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return t.destroyed?"":e.className.split(" ").filter((e=>0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass))).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.forEach((s=>{const a=e.getSlideClasses(s);t.push({slideEl:s,classNames:a}),e.emit("_slideClass",s,a)})),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){void 0===e&&(e="current"),void 0===t&&(t=!1);const{params:s,slides:a,slidesGrid:i,slidesSizesGrid:r,size:n,activeIndex:l}=this;let o=1;if("number"==typeof s.slidesPerView)return s.slidesPerView;if(s.centeredSlides){let e,t=a[l]?Math.ceil(a[l].swiperSlideSize):0;for(let s=l+1;s<a.length;s+=1)a[s]&&!e&&(t+=Math.ceil(a[s].swiperSlideSize),o+=1,t>n&&(e=!0));for(let s=l-1;s>=0;s-=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0))}else if("current"===e)for(let e=l+1;e<a.length;e+=1){(t?i[e]+r[e]-i[l]<n:i[e]-i[l]<n)&&(o+=1)}else for(let e=l-1;e>=0;e-=1){i[l]-i[e]<n&&(o+=1)}return o}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:s}=e;function a(){const t=e.rtlTranslate?-1*e.translate:e.translate,s=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(s),e.updateActiveIndex(),e.updateSlidesClasses()}let i;if(s.breakpoints&&e.setBreakpoint(),[...e.el.querySelectorAll('[loading="lazy"]')].forEach((t=>{t.complete&&G(e,t)})),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),s.freeMode&&s.freeMode.enabled&&!s.cssMode)a(),s.autoHeight&&e.updateAutoHeight();else{if(("auto"===s.slidesPerView||s.slidesPerView>1)&&e.isEnd&&!s.centeredSlides){const t=e.virtual&&s.virtual.enabled?e.virtual.slides:e.slides;i=e.slideTo(t.length-1,0,!1,!0)}else i=e.slideTo(e.activeIndex,0,!1,!0);i||a()}s.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){void 0===t&&(t=!0);const s=this,a=s.params.direction;return e||(e="horizontal"===a?"vertical":"horizontal"),e===a||"horizontal"!==e&&"vertical"!==e||(s.el.classList.remove(`${s.params.containerModifierClass}${a}`),s.el.classList.add(`${s.params.containerModifierClass}${e}`),s.emitContainerClasses(),s.params.direction=e,s.slides.forEach((t=>{"vertical"===e?t.style.width="":t.style.height=""})),s.emit("changeDirection"),t&&s.update()),s}changeLanguageDirection(e){const t=this;t.rtl&&"rtl"===e||!t.rtl&&"ltr"===e||(t.rtl="rtl"===e,t.rtlTranslate="horizontal"===t.params.direction&&t.rtl,t.rtl?(t.el.classList.add(`${t.params.containerModifierClass}rtl`),t.el.dir="rtl"):(t.el.classList.remove(`${t.params.containerModifierClass}rtl`),t.el.dir="ltr"),t.update())}mount(e){const t=this;if(t.mounted)return!0;let s=e||t.params.el;if("string"==typeof s&&(s=document.querySelector(s)),!s)return!1;s.swiper=t,s.parentNode&&s.parentNode.host&&s.parentNode.host.nodeName===t.params.swiperElementNodeName.toUpperCase()&&(t.isElement=!0);const a=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let i=(()=>{if(s&&s.shadowRoot&&s.shadowRoot.querySelector){return s.shadowRoot.querySelector(a())}return f(s,a())[0]})();return!i&&t.params.createElements&&(i=v("div",t.params.wrapperClass),s.append(i),f(s,`.${t.params.slideClass}`).forEach((e=>{i.append(e)}))),Object.assign(t,{el:s,wrapperEl:i,slidesEl:t.isElement&&!s.parentNode.host.slideSlots?s.parentNode.host:i,hostEl:t.isElement?s.parentNode.host:s,mounted:!0,rtl:"rtl"===s.dir.toLowerCase()||"rtl"===b(s,"direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===s.dir.toLowerCase()||"rtl"===b(s,"direction")),wrongRTL:"-webkit-box"===b(i,"display")}),!0}init(e){const t=this;if(t.initialized)return t;if(!1===t.mount(e))return t;t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.loop&&t.virtual&&t.params.virtual.enabled?t.slideTo(t.params.initialSlide+t.virtual.slidesBefore,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.params.loop&&t.loopCreate(void 0,!0),t.attachEvents();const s=[...t.el.querySelectorAll('[loading="lazy"]')];return t.isElement&&s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),s.forEach((e=>{e.complete?G(t,e):e.addEventListener("load",(e=>{G(t,e.target)}))})),Y(t),t.initialized=!0,Y(t),t.emit("init"),t.emit("afterInit"),t}destroy(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);const s=this,{params:a,el:i,wrapperEl:r,slides:n}=s;return void 0===s.params||s.destroyed||(s.emit("beforeDestroy"),s.initialized=!1,s.detachEvents(),a.loop&&s.loopDestroy(),t&&(s.removeClasses(),i&&"string"!=typeof i&&i.removeAttribute("style"),r&&r.removeAttribute("style"),n&&n.length&&n.forEach((e=>{e.classList.remove(a.slideVisibleClass,a.slideFullyVisibleClass,a.slideActiveClass,a.slideNextClass,a.slidePrevClass),e.removeAttribute("style"),e.removeAttribute("data-swiper-slide-index")}))),s.emit("destroy"),Object.keys(s.eventsListeners).forEach((e=>{s.off(e)})),!1!==e&&(s.el&&"string"!=typeof s.el&&(s.el.swiper=null),function(e){const t=e;Object.keys(t).forEach((e=>{try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))}(s)),s.destroyed=!0),null}static extendDefaults(e){p(ie,e)}static get extendedDefaults(){return ie}static get defaults(){return te}static installModule(e){re.prototype.__modules__||(re.prototype.__modules__=[]);const t=re.prototype.__modules__;"function"==typeof e&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach((e=>re.installModule(e))),re):(re.installModule(e),re)}}function ne(e,t,s,a){return e.params.createElements&&Object.keys(a).forEach((i=>{if(!s[i]&&!0===s.auto){let r=f(e.el,`.${a[i]}`)[0];r||(r=v("div",a[i]),r.className=a[i],e.el.append(r)),s[i]=r,t[i]=r}})),s}function le(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!+\/()[\]])/g,"\\$1").replace(/ /g,".")}`}function oe(e){const t=this,{params:s,slidesEl:a}=t;s.loop&&t.loopDestroy();const i=e=>{if("string"==typeof e){const t=document.createElement("div");C(t,e),a.append(t.children[0]),C(t,"")}else a.append(e)};if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&i(e[t]);else i(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update()}function de(e){const t=this,{params:s,activeIndex:a,slidesEl:i}=t;s.loop&&t.loopDestroy();let r=a+1;const n=e=>{if("string"==typeof e){const t=document.createElement("div");C(t,e),i.prepend(t.children[0]),C(t,"")}else i.prepend(e)};if("object"==typeof e&&"length"in e){for(let t=0;t<e.length;t+=1)e[t]&&n(e[t]);r=a+e.length}else n(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),t.slideTo(r,0,!1)}function ce(e,t){const s=this,{params:a,activeIndex:i,slidesEl:r}=s;let n=i;a.loop&&(n-=s.loopedSlides,s.loopDestroy(),s.recalcSlides());const l=s.slides.length;if(e<=0)return void s.prependSlide(t);if(e>=l)return void s.appendSlide(t);let o=n>e?n+1:n;const d=[];for(let t=l-1;t>=e;t-=1){const e=s.slides[t];e.remove(),d.unshift(e)}if("object"==typeof t&&"length"in t){for(let e=0;e<t.length;e+=1)t[e]&&r.append(t[e]);o=n>e?n+t.length:n}else r.append(t);for(let e=0;e<d.length;e+=1)r.append(d[e]);s.recalcSlides(),a.loop&&s.loopCreate(),a.observer&&!s.isElement||s.update(),a.loop?s.slideTo(o+s.loopedSlides,0,!1):s.slideTo(o,0,!1)}function pe(e){const t=this,{params:s,activeIndex:a}=t;let i=a;s.loop&&(i-=t.loopedSlides,t.loopDestroy());let r,n=i;if("object"==typeof e&&"length"in e){for(let s=0;s<e.length;s+=1)r=e[s],t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1),n=Math.max(n,0);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),s.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)}function ue(){const e=this,t=[];for(let s=0;s<e.slides.length;s+=1)t.push(s);e.removeSlide(t)}function me(e){const{effect:t,swiper:s,on:a,setTranslate:i,setTransition:r,overwriteParams:n,perspective:l,recreateShadows:o,getEffectParams:d}=e;let c;a("beforeInit",(()=>{if(s.params.effect!==t)return;s.classNames.push(`${s.params.containerModifierClass}${t}`),l&&l()&&s.classNames.push(`${s.params.containerModifierClass}3d`);const e=n?n():{};Object.assign(s.params,e),Object.assign(s.originalParams,e)})),a("setTranslate _virtualUpdated",(()=>{s.params.effect===t&&i()})),a("setTransition",((e,a)=>{s.params.effect===t&&r(a)})),a("transitionEnd",(()=>{if(s.params.effect===t&&o){if(!d||!d().slideShadows)return;s.slides.forEach((e=>{e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e=>e.remove()))})),o()}})),a("virtualUpdate",(()=>{s.params.effect===t&&(s.slides.length||(c=!0),requestAnimationFrame((()=>{c&&s.slides&&s.slides.length&&(i(),c=!1)})))}))}function he(e,t){const s=h(t);return s!==t&&(s.style.backfaceVisibility="hidden",s.style["-webkit-backface-visibility"]="hidden"),s}function fe(e){let{swiper:t,duration:s,transformElements:a,allSlides:i}=e;const{activeIndex:r}=t;if(t.params.virtualTranslate&&0!==s){let e,s=!1;e=i?a:a.filter((e=>{const s=e.classList.contains("swiper-slide-transform")?(e=>{if(!e.parentElement)return t.slides.find((t=>t.shadowRoot&&t.shadowRoot===e.parentNode));return e.parentElement})(e):e;return t.getSlideIndex(s)===r})),e.forEach((e=>{x(e,(()=>{if(s)return;if(!t||t.destroyed)return;s=!0,t.animating=!1;const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});t.wrapperEl.dispatchEvent(e)}))}))}}function ge(e,t,s){const a=`swiper-slide-shadow${s?`-${s}`:""}${e?` swiper-slide-shadow-${e}`:""}`,i=h(t);let r=i.querySelector(`.${a.split(" ").join(".")}`);return r||(r=v("div",a.split(" ")),i.append(r)),r}Object.keys(ae).forEach((e=>{Object.keys(ae[e]).forEach((t=>{re.prototype[t]=ae[e][t]}))})),re.use([function(e){let{swiper:t,on:s,emit:a}=e;const i=r();let n=null,l=null;const o=()=>{t&&!t.destroyed&&t.initialized&&(a("beforeResize"),a("resize"))},d=()=>{t&&!t.destroyed&&t.initialized&&a("orientationchange")};s("init",(()=>{t.params.resizeObserver&&void 0!==i.ResizeObserver?t&&!t.destroyed&&t.initialized&&(n=new ResizeObserver((e=>{l=i.requestAnimationFrame((()=>{const{width:s,height:a}=t;let i=s,r=a;e.forEach((e=>{let{contentBoxSize:s,contentRect:a,target:n}=e;n&&n!==t.el||(i=a?a.width:(s[0]||s).inlineSize,r=a?a.height:(s[0]||s).blockSize)})),i===s&&r===a||o()}))})),n.observe(t.el)):(i.addEventListener("resize",o),i.addEventListener("orientationchange",d))})),s("destroy",(()=>{l&&i.cancelAnimationFrame(l),n&&n.unobserve&&t.el&&(n.unobserve(t.el),n=null),i.removeEventListener("resize",o),i.removeEventListener("orientationchange",d)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=[],l=r(),o=function(e,s){void 0===s&&(s={});const a=new(l.MutationObserver||l.WebkitMutationObserver)((e=>{if(t.__preventObserver__)return;if(1===e.length)return void i("observerUpdate",e[0]);const s=function(){i("observerUpdate",e[0])};l.requestAnimationFrame?l.requestAnimationFrame(s):l.setTimeout(s,0)}));a.observe(e,{attributes:void 0===s.attributes||s.attributes,childList:t.isElement||(void 0===s.childList||s).childList,characterData:void 0===s.characterData||s.characterData}),n.push(a)};s({observer:!1,observeParents:!1,observeSlideChildren:!1}),a("init",(()=>{if(t.params.observer){if(t.params.observeParents){const e=E(t.hostEl);for(let t=0;t<e.length;t+=1)o(e[t])}o(t.hostEl,{childList:t.params.observeSlideChildren}),o(t.wrapperEl,{attributes:!1})}})),a("destroy",(()=>{n.forEach((e=>{e.disconnect()})),n.splice(0,n.length)}))}]);const ve=[function(e){let t,{swiper:s,extendParams:i,on:r,emit:n}=e;i({virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}});const l=a();s.virtual={cache:{},from:void 0,to:void 0,slides:[],offset:0,slidesGrid:[]};const o=l.createElement("div");function d(e,t){const a=s.params.virtual;if(a.cache&&s.virtual.cache[t])return s.virtual.cache[t];let i;return a.renderSlide?(i=a.renderSlide.call(s,e,t),"string"==typeof i&&(C(o,i),i=o.children[0])):i=s.isElement?v("swiper-slide"):v("div",s.params.slideClass),i.setAttribute("data-swiper-slide-index",t),a.renderSlide||C(i,e),a.cache&&(s.virtual.cache[t]=i),i}function c(e,t,a){const{slidesPerView:i,slidesPerGroup:r,centeredSlides:l,loop:o,initialSlide:c}=s.params;if(t&&!o&&c>0)return;const{addSlidesBefore:p,addSlidesAfter:u}=s.params.virtual,{from:m,to:h,slides:g,slidesGrid:v,offset:w}=s.virtual;s.params.cssMode||s.updateActiveIndex();const b=void 0===a?s.activeIndex||0:a;let y,E,x;y=s.rtlTranslate?"right":s.isHorizontal()?"left":"top",l?(E=Math.floor(i/2)+r+u,x=Math.floor(i/2)+r+p):(E=i+(r-1)+u,x=(o?i:r)+p);let S=b-x,T=b+E;o||(S=Math.max(S,0),T=Math.min(T,g.length-1));let M=(s.slidesGrid[S]||0)-(s.slidesGrid[0]||0);function C(){s.updateSlides(),s.updateProgress(),s.updateSlidesClasses(),n("virtualUpdate")}if(o&&b>=x?(S-=x,l||(M+=s.slidesGrid[0])):o&&b<x&&(S=-x,l&&(M+=s.slidesGrid[0])),Object.assign(s.virtual,{from:S,to:T,offset:M,slidesGrid:s.slidesGrid,slidesBefore:x,slidesAfter:E}),m===S&&h===T&&!e)return s.slidesGrid!==v&&M!==w&&s.slides.forEach((e=>{e.style[y]=M-Math.abs(s.cssOverflowAdjustment())+"px"})),s.updateProgress(),void n("virtualUpdate");if(s.params.virtual.renderExternal)return s.params.virtual.renderExternal.call(s,{offset:M,from:S,to:T,slides:function(){const e=[];for(let t=S;t<=T;t+=1)e.push(g[t]);return e}()}),void(s.params.virtual.renderExternalUpdate?C():n("virtualUpdate"));const P=[],L=[],I=e=>{let t=e;return e<0?t=g.length+e:t>=g.length&&(t-=g.length),t};if(e)s.slides.filter((e=>e.matches(`.${s.params.slideClass}, swiper-slide`))).forEach((e=>{e.remove()}));else for(let e=m;e<=h;e+=1)if(e<S||e>T){const t=I(e);s.slides.filter((e=>e.matches(`.${s.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`))).forEach((e=>{e.remove()}))}const z=o?-g.length:0,A=o?2*g.length:g.length;for(let t=z;t<A;t+=1)if(t>=S&&t<=T){const s=I(t);void 0===h||e?L.push(s):(t>h&&L.push(s),t<m&&P.push(s))}if(L.forEach((e=>{s.slidesEl.append(d(g[e],e))})),o)for(let e=P.length-1;e>=0;e-=1){const t=P[e];s.slidesEl.prepend(d(g[t],t))}else P.sort(((e,t)=>t-e)),P.forEach((e=>{s.slidesEl.prepend(d(g[e],e))}));f(s.slidesEl,".swiper-slide, swiper-slide").forEach((e=>{e.style[y]=M-Math.abs(s.cssOverflowAdjustment())+"px"})),C()}r("beforeInit",(()=>{if(!s.params.virtual.enabled)return;let e;if(void 0===s.passedParams.virtual.slides){const t=[...s.slidesEl.children].filter((e=>e.matches(`.${s.params.slideClass}, swiper-slide`)));t&&t.length&&(s.virtual.slides=[...t],e=!0,t.forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t),s.virtual.cache[t]=e,e.remove()})))}e||(s.virtual.slides=s.params.virtual.slides),s.classNames.push(`${s.params.containerModifierClass}virtual`),s.params.watchSlidesProgress=!0,s.originalParams.watchSlidesProgress=!0,c(!1,!0)})),r("setTranslate",(()=>{s.params.virtual.enabled&&(s.params.cssMode&&!s._immediateVirtual?(clearTimeout(t),t=setTimeout((()=>{c()}),100)):c())})),r("init update resize",(()=>{s.params.virtual.enabled&&s.params.cssMode&&u(s.wrapperEl,"--swiper-virtual-size",`${s.virtualSize}px`)})),Object.assign(s.virtual,{appendSlide:function(e){if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.push(e[t]);else s.virtual.slides.push(e);c(!0)},prependSlide:function(e){const t=s.activeIndex;let a=t+1,i=1;if(Array.isArray(e)){for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.unshift(e[t]);a=t+e.length,i=e.length}else s.virtual.slides.unshift(e);if(s.params.virtual.cache){const e=s.virtual.cache,t={};Object.keys(e).forEach((s=>{const a=e[s],r=a.getAttribute("data-swiper-slide-index");r&&a.setAttribute("data-swiper-slide-index",parseInt(r,10)+i),t[parseInt(s,10)+i]=a})),s.virtual.cache=t}c(!0),s.slideTo(a,0)},removeSlide:function(e){if(null==e)return;let t=s.activeIndex;if(Array.isArray(e))for(let a=e.length-1;a>=0;a-=1)s.params.virtual.cache&&(delete s.virtual.cache[e[a]],Object.keys(s.virtual.cache).forEach((t=>{t>e&&(s.virtual.cache[t-1]=s.virtual.cache[t],s.virtual.cache[t-1].setAttribute("data-swiper-slide-index",t-1),delete s.virtual.cache[t])}))),s.virtual.slides.splice(e[a],1),e[a]<t&&(t-=1),t=Math.max(t,0);else s.params.virtual.cache&&(delete s.virtual.cache[e],Object.keys(s.virtual.cache).forEach((t=>{t>e&&(s.virtual.cache[t-1]=s.virtual.cache[t],s.virtual.cache[t-1].setAttribute("data-swiper-slide-index",t-1),delete s.virtual.cache[t])}))),s.virtual.slides.splice(e,1),e<t&&(t-=1),t=Math.max(t,0);c(!0),s.slideTo(t,0)},removeAllSlides:function(){s.virtual.slides=[],s.params.virtual.cache&&(s.virtual.cache={}),c(!0),s.slideTo(0,0)},update:c})},function(e){let{swiper:t,extendParams:s,on:i,emit:n}=e;const l=a(),o=r();function d(e){if(!t.enabled)return;const{rtlTranslate:s}=t;let a=e;a.originalEvent&&(a=a.originalEvent);const i=a.keyCode||a.charCode,r=t.params.keyboard.pageUpDown,d=r&&33===i,c=r&&34===i,p=37===i,u=39===i,m=38===i,h=40===i;if(!t.allowSlideNext&&(t.isHorizontal()&&u||t.isVertical()&&h||c))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&p||t.isVertical()&&m||d))return!1;if(!(a.shiftKey||a.altKey||a.ctrlKey||a.metaKey||l.activeElement&&(l.activeElement.isContentEditable||l.activeElement.nodeName&&("input"===l.activeElement.nodeName.toLowerCase()||"textarea"===l.activeElement.nodeName.toLowerCase())))){if(t.params.keyboard.onlyInViewport&&(d||c||p||u||m||h)){let e=!1;if(E(t.el,`.${t.params.slideClass}, swiper-slide`).length>0&&0===E(t.el,`.${t.params.slideActiveClass}`).length)return;const a=t.el,i=a.clientWidth,r=a.clientHeight,n=o.innerWidth,l=o.innerHeight,d=w(a);s&&(d.left-=a.scrollLeft);const c=[[d.left,d.top],[d.left+i,d.top],[d.left,d.top+r],[d.left+i,d.top+r]];for(let t=0;t<c.length;t+=1){const s=c[t];if(s[0]>=0&&s[0]<=n&&s[1]>=0&&s[1]<=l){if(0===s[0]&&0===s[1])continue;e=!0}}if(!e)return}t.isHorizontal()?((d||c||p||u)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),((c||u)&&!s||(d||p)&&s)&&t.slideNext(),((d||p)&&!s||(c||u)&&s)&&t.slidePrev()):((d||c||m||h)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),(c||h)&&t.slideNext(),(d||m)&&t.slidePrev()),n("keyPress",i)}}function c(){t.keyboard.enabled||(l.addEventListener("keydown",d),t.keyboard.enabled=!0)}function p(){t.keyboard.enabled&&(l.removeEventListener("keydown",d),t.keyboard.enabled=!1)}t.keyboard={enabled:!1},s({keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}}),i("init",(()=>{t.params.keyboard.enabled&&c()})),i("destroy",(()=>{t.keyboard.enabled&&p()})),Object.assign(t.keyboard,{enable:c,disable:p})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();let d;s({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null,noMousewheelClass:"swiper-no-mousewheel"}}),t.mousewheel={enabled:!1};let c,p=o();const u=[];function m(){t.enabled&&(t.mouseEntered=!0)}function h(){t.enabled&&(t.mouseEntered=!1)}function f(e){return!(t.params.mousewheel.thresholdDelta&&e.delta<t.params.mousewheel.thresholdDelta)&&(!(t.params.mousewheel.thresholdTime&&o()-p<t.params.mousewheel.thresholdTime)&&(e.delta>=6&&o()-p<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),i("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),i("scroll",e.raw)),p=(new n.Date).getTime(),!1)))}function g(e){let s=e,a=!0;if(!t.enabled)return;if(e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`))return;const r=t.params.mousewheel;t.params.cssMode&&s.preventDefault();let n=t.el;"container"!==t.params.mousewheel.eventsTarget&&(n=document.querySelector(t.params.mousewheel.eventsTarget));const p=n&&n.contains(s.target);if(!t.mouseEntered&&!p&&!r.releaseOnEdges)return!0;s.originalEvent&&(s=s.originalEvent);let m=0;const h=t.rtlTranslate?-1:1,g=function(e){let t=0,s=0,a=0,i=0;return"detail"in e&&(s=e.detail),"wheelDelta"in e&&(s=-e.wheelDelta/120),"wheelDeltaY"in e&&(s=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=s,s=0),a=10*t,i=10*s,"deltaY"in e&&(i=e.deltaY),"deltaX"in e&&(a=e.deltaX),e.shiftKey&&!a&&(a=i,i=0),(a||i)&&e.deltaMode&&(1===e.deltaMode?(a*=40,i*=40):(a*=800,i*=800)),a&&!t&&(t=a<1?-1:1),i&&!s&&(s=i<1?-1:1),{spinX:t,spinY:s,pixelX:a,pixelY:i}}(s);if(r.forceToAxis)if(t.isHorizontal()){if(!(Math.abs(g.pixelX)>Math.abs(g.pixelY)))return!0;m=-g.pixelX*h}else{if(!(Math.abs(g.pixelY)>Math.abs(g.pixelX)))return!0;m=-g.pixelY}else m=Math.abs(g.pixelX)>Math.abs(g.pixelY)?-g.pixelX*h:-g.pixelY;if(0===m)return!0;r.invert&&(m=-m);let v=t.getTranslate()+m*r.sensitivity;if(v>=t.minTranslate()&&(v=t.minTranslate()),v<=t.maxTranslate()&&(v=t.maxTranslate()),a=!!t.params.loop||!(v===t.minTranslate()||v===t.maxTranslate()),a&&t.params.nested&&s.stopPropagation(),t.params.freeMode&&t.params.freeMode.enabled){const e={time:o(),delta:Math.abs(m),direction:Math.sign(m)},a=c&&e.time<c.time+500&&e.delta<=c.delta&&e.direction===c.direction;if(!a){c=void 0;let n=t.getTranslate()+m*r.sensitivity;const o=t.isBeginning,p=t.isEnd;if(n>=t.minTranslate()&&(n=t.minTranslate()),n<=t.maxTranslate()&&(n=t.maxTranslate()),t.setTransition(0),t.setTranslate(n),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses(),(!o&&t.isBeginning||!p&&t.isEnd)&&t.updateSlidesClasses(),t.params.loop&&t.loopFix({direction:e.direction<0?"next":"prev",byMousewheel:!0}),t.params.freeMode.sticky){clearTimeout(d),d=void 0,u.length>=15&&u.shift();const s=u.length?u[u.length-1]:void 0,a=u[0];if(u.push(e),s&&(e.delta>s.delta||e.direction!==s.direction))u.splice(0);else if(u.length>=15&&e.time-a.time<500&&a.delta-e.delta>=1&&e.delta<=6){const s=m>0?.8:.2;c=e,u.splice(0),d=l((()=>{!t.destroyed&&t.params&&t.slideToClosest(t.params.speed,!0,void 0,s)}),0)}d||(d=l((()=>{if(t.destroyed||!t.params)return;c=e,u.splice(0),t.slideToClosest(t.params.speed,!0,void 0,.5)}),500))}if(a||i("scroll",s),t.params.autoplay&&t.params.autoplay.disableOnInteraction&&t.autoplay.stop(),r.releaseOnEdges&&(n===t.minTranslate()||n===t.maxTranslate()))return!0}}else{const s={time:o(),delta:Math.abs(m),direction:Math.sign(m),raw:e};u.length>=2&&u.shift();const a=u.length?u[u.length-1]:void 0;if(u.push(s),a?(s.direction!==a.direction||s.delta>a.delta||s.time>a.time+150)&&f(s):f(s),function(e){const s=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&s.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&s.releaseOnEdges)return!0;return!1}(s))return!0}return s.preventDefault?s.preventDefault():s.returnValue=!1,!1}function v(e){let s=t.el;"container"!==t.params.mousewheel.eventsTarget&&(s=document.querySelector(t.params.mousewheel.eventsTarget)),s[e]("mouseenter",m),s[e]("mouseleave",h),s[e]("wheel",g)}function w(){return t.params.cssMode?(t.wrapperEl.removeEventListener("wheel",g),!0):!t.mousewheel.enabled&&(v("addEventListener"),t.mousewheel.enabled=!0,!0)}function b(){return t.params.cssMode?(t.wrapperEl.addEventListener(event,g),!0):!!t.mousewheel.enabled&&(v("removeEventListener"),t.mousewheel.enabled=!1,!0)}a("init",(()=>{!t.params.mousewheel.enabled&&t.params.cssMode&&b(),t.params.mousewheel.enabled&&w()})),a("destroy",(()=>{t.params.cssMode&&w(),t.mousewheel.enabled&&b()})),Object.assign(t.mousewheel,{enable:w,disable:b})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;function r(e){let s;return e&&"string"==typeof e&&t.isElement&&(s=t.el.querySelector(e)||t.hostEl.querySelector(e),s)?s:(e&&("string"==typeof e&&(s=[...document.querySelectorAll(e)]),t.params.uniqueNavElements&&"string"==typeof e&&s&&s.length>1&&1===t.el.querySelectorAll(e).length?s=t.el.querySelector(e):s&&1===s.length&&(s=s[0])),e&&!s?e:s)}function n(e,s){const a=t.params.navigation;(e=T(e)).forEach((e=>{e&&(e.classList[s?"add":"remove"](...a.disabledClass.split(" ")),"BUTTON"===e.tagName&&(e.disabled=s),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](a.lockClass))}))}function l(){const{nextEl:e,prevEl:s}=t.navigation;if(t.params.loop)return n(s,!1),void n(e,!1);n(s,t.isBeginning&&!t.params.rewind),n(e,t.isEnd&&!t.params.rewind)}function o(e){e.preventDefault(),(!t.isBeginning||t.params.loop||t.params.rewind)&&(t.slidePrev(),i("navigationPrev"))}function d(e){e.preventDefault(),(!t.isEnd||t.params.loop||t.params.rewind)&&(t.slideNext(),i("navigationNext"))}function c(){const e=t.params.navigation;if(t.params.navigation=ne(t,t.originalParams.navigation,t.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!e.nextEl&&!e.prevEl)return;let s=r(e.nextEl),a=r(e.prevEl);Object.assign(t.navigation,{nextEl:s,prevEl:a}),s=T(s),a=T(a);const i=(s,a)=>{s&&s.addEventListener("click","next"===a?d:o),!t.enabled&&s&&s.classList.add(...e.lockClass.split(" "))};s.forEach((e=>i(e,"next"))),a.forEach((e=>i(e,"prev")))}function p(){let{nextEl:e,prevEl:s}=t.navigation;e=T(e),s=T(s);const a=(e,s)=>{e.removeEventListener("click","next"===s?d:o),e.classList.remove(...t.params.navigation.disabledClass.split(" "))};e.forEach((e=>a(e,"next"))),s.forEach((e=>a(e,"prev")))}s({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock",navigationDisabledClass:"swiper-navigation-disabled"}}),t.navigation={nextEl:null,prevEl:null},a("init",(()=>{!1===t.params.navigation.enabled?u():(c(),l())})),a("toEdge fromEdge lock unlock",(()=>{l()})),a("destroy",(()=>{p()})),a("enable disable",(()=>{let{nextEl:e,prevEl:s}=t.navigation;e=T(e),s=T(s),t.enabled?l():[...e,...s].filter((e=>!!e)).forEach((e=>e.classList.add(t.params.navigation.lockClass)))})),a("click",((e,s)=>{let{nextEl:a,prevEl:r}=t.navigation;a=T(a),r=T(r);const n=s.target;let l=r.includes(n)||a.includes(n);if(t.isElement&&!l){const e=s.path||s.composedPath&&s.composedPath();e&&(l=e.find((e=>a.includes(e)||r.includes(e))))}if(t.params.navigation.hideOnClick&&!l){if(t.pagination&&t.params.pagination&&t.params.pagination.clickable&&(t.pagination.el===n||t.pagination.el.contains(n)))return;let e;a.length?e=a[0].classList.contains(t.params.navigation.hiddenClass):r.length&&(e=r[0].classList.contains(t.params.navigation.hiddenClass)),i(!0===e?"navigationShow":"navigationHide"),[...a,...r].filter((e=>!!e)).forEach((e=>e.classList.toggle(t.params.navigation.hiddenClass)))}}));const u=()=>{t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")),p()};Object.assign(t.navigation,{enable:()=>{t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")),c(),l()},disable:u,update:l,init:c,destroy:p})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const r="swiper-pagination";let n;s({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:e=>e,formatFractionTotal:e=>e,bulletClass:`${r}-bullet`,bulletActiveClass:`${r}-bullet-active`,modifierClass:`${r}-`,currentClass:`${r}-current`,totalClass:`${r}-total`,hiddenClass:`${r}-hidden`,progressbarFillClass:`${r}-progressbar-fill`,progressbarOppositeClass:`${r}-progressbar-opposite`,clickableClass:`${r}-clickable`,lockClass:`${r}-lock`,horizontalClass:`${r}-horizontal`,verticalClass:`${r}-vertical`,paginationDisabledClass:`${r}-disabled`}}),t.pagination={el:null,bullets:[]};let l=0;function o(){return!t.params.pagination.el||!t.pagination.el||Array.isArray(t.pagination.el)&&0===t.pagination.el.length}function d(e,s){const{bulletActiveClass:a}=t.params.pagination;e&&(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&(e.classList.add(`${a}-${s}`),(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&e.classList.add(`${a}-${s}-${s}`))}function c(e){const s=e.target.closest(le(t.params.pagination.bulletClass));if(!s)return;e.preventDefault();const a=y(s)*t.params.slidesPerGroup;if(t.params.loop){if(t.realIndex===a)return;const e=(i=t.realIndex,r=a,n=t.slides.length,(r%=n)==1+(i%=n)?"next":r===i-1?"previous":void 0);"next"===e?t.slideNext():"previous"===e?t.slidePrev():t.slideToLoop(a)}else t.slideTo(a);var i,r,n}function p(){const e=t.rtl,s=t.params.pagination;if(o())return;let a,r,c=t.pagination.el;c=T(c);const p=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,u=t.params.loop?Math.ceil(p/t.params.slidesPerGroup):t.snapGrid.length;if(t.params.loop?(r=t.previousRealIndex||0,a=t.params.slidesPerGroup>1?Math.floor(t.realIndex/t.params.slidesPerGroup):t.realIndex):void 0!==t.snapIndex?(a=t.snapIndex,r=t.previousSnapIndex):(r=t.previousIndex||0,a=t.activeIndex||0),"bullets"===s.type&&t.pagination.bullets&&t.pagination.bullets.length>0){const i=t.pagination.bullets;let o,p,u;if(s.dynamicBullets&&(n=S(i[0],t.isHorizontal()?"width":"height",!0),c.forEach((e=>{e.style[t.isHorizontal()?"width":"height"]=n*(s.dynamicMainBullets+4)+"px"})),s.dynamicMainBullets>1&&void 0!==r&&(l+=a-(r||0),l>s.dynamicMainBullets-1?l=s.dynamicMainBullets-1:l<0&&(l=0)),o=Math.max(a-l,0),p=o+(Math.min(i.length,s.dynamicMainBullets)-1),u=(p+o)/2),i.forEach((e=>{const t=[...["","-next","-next-next","-prev","-prev-prev","-main"].map((e=>`${s.bulletActiveClass}${e}`))].map((e=>"string"==typeof e&&e.includes(" ")?e.split(" "):e)).flat();e.classList.remove(...t)})),c.length>1)i.forEach((e=>{const i=y(e);i===a?e.classList.add(...s.bulletActiveClass.split(" ")):t.isElement&&e.setAttribute("part","bullet"),s.dynamicBullets&&(i>=o&&i<=p&&e.classList.add(...`${s.bulletActiveClass}-main`.split(" ")),i===o&&d(e,"prev"),i===p&&d(e,"next"))}));else{const e=i[a];if(e&&e.classList.add(...s.bulletActiveClass.split(" ")),t.isElement&&i.forEach(((e,t)=>{e.setAttribute("part",t===a?"bullet-active":"bullet")})),s.dynamicBullets){const e=i[o],t=i[p];for(let e=o;e<=p;e+=1)i[e]&&i[e].classList.add(...`${s.bulletActiveClass}-main`.split(" "));d(e,"prev"),d(t,"next")}}if(s.dynamicBullets){const a=Math.min(i.length,s.dynamicMainBullets+4),r=(n*a-n)/2-u*n,l=e?"right":"left";i.forEach((e=>{e.style[t.isHorizontal()?l:"top"]=`${r}px`}))}}c.forEach(((e,r)=>{if("fraction"===s.type&&(e.querySelectorAll(le(s.currentClass)).forEach((e=>{e.textContent=s.formatFractionCurrent(a+1)})),e.querySelectorAll(le(s.totalClass)).forEach((e=>{e.textContent=s.formatFractionTotal(u)}))),"progressbar"===s.type){let i;i=s.progressbarOpposite?t.isHorizontal()?"vertical":"horizontal":t.isHorizontal()?"horizontal":"vertical";const r=(a+1)/u;let n=1,l=1;"horizontal"===i?n=r:l=r,e.querySelectorAll(le(s.progressbarFillClass)).forEach((e=>{e.style.transform=`translate3d(0,0,0) scaleX(${n}) scaleY(${l})`,e.style.transitionDuration=`${t.params.speed}ms`}))}"custom"===s.type&&s.renderCustom?(C(e,s.renderCustom(t,a+1,u)),0===r&&i("paginationRender",e)):(0===r&&i("paginationRender",e),i("paginationUpdate",e)),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](s.lockClass)}))}function u(){const e=t.params.pagination;if(o())return;const s=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.grid&&t.params.grid.rows>1?t.slides.length/Math.ceil(t.params.grid.rows):t.slides.length;let a=t.pagination.el;a=T(a);let r="";if("bullets"===e.type){let a=t.params.loop?Math.ceil(s/t.params.slidesPerGroup):t.snapGrid.length;t.params.freeMode&&t.params.freeMode.enabled&&a>s&&(a=s);for(let s=0;s<a;s+=1)e.renderBullet?r+=e.renderBullet.call(t,s,e.bulletClass):r+=`<${e.bulletElement} ${t.isElement?'part="bullet"':""} class="${e.bulletClass}"></${e.bulletElement}>`}"fraction"===e.type&&(r=e.renderFraction?e.renderFraction.call(t,e.currentClass,e.totalClass):`<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),"progressbar"===e.type&&(r=e.renderProgressbar?e.renderProgressbar.call(t,e.progressbarFillClass):`<span class="${e.progressbarFillClass}"></span>`),t.pagination.bullets=[],a.forEach((s=>{"custom"!==e.type&&C(s,r||""),"bullets"===e.type&&t.pagination.bullets.push(...s.querySelectorAll(le(e.bulletClass)))})),"custom"!==e.type&&i("paginationRender",a[0])}function m(){t.params.pagination=ne(t,t.originalParams.pagination,t.params.pagination,{el:"swiper-pagination"});const e=t.params.pagination;if(!e.el)return;let s;"string"==typeof e.el&&t.isElement&&(s=t.el.querySelector(e.el)),s||"string"!=typeof e.el||(s=[...document.querySelectorAll(e.el)]),s||(s=e.el),s&&0!==s.length&&(t.params.uniqueNavElements&&"string"==typeof e.el&&Array.isArray(s)&&s.length>1&&(s=[...t.el.querySelectorAll(e.el)],s.length>1&&(s=s.find((e=>E(e,".swiper")[0]===t.el)))),Array.isArray(s)&&1===s.length&&(s=s[0]),Object.assign(t.pagination,{el:s}),s=T(s),s.forEach((s=>{"bullets"===e.type&&e.clickable&&s.classList.add(...(e.clickableClass||"").split(" ")),s.classList.add(e.modifierClass+e.type),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass),"bullets"===e.type&&e.dynamicBullets&&(s.classList.add(`${e.modifierClass}${e.type}-dynamic`),l=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&s.classList.add(e.progressbarOppositeClass),e.clickable&&s.addEventListener("click",c),t.enabled||s.classList.add(e.lockClass)})))}function h(){const e=t.params.pagination;if(o())return;let s=t.pagination.el;s&&(s=T(s),s.forEach((s=>{s.classList.remove(e.hiddenClass),s.classList.remove(e.modifierClass+e.type),s.classList.remove(t.isHorizontal()?e.horizontalClass:e.verticalClass),e.clickable&&(s.classList.remove(...(e.clickableClass||"").split(" ")),s.removeEventListener("click",c))}))),t.pagination.bullets&&t.pagination.bullets.forEach((t=>t.classList.remove(...e.bulletActiveClass.split(" "))))}a("changeDirection",(()=>{if(!t.pagination||!t.pagination.el)return;const e=t.params.pagination;let{el:s}=t.pagination;s=T(s),s.forEach((s=>{s.classList.remove(e.horizontalClass,e.verticalClass),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass)}))})),a("init",(()=>{!1===t.params.pagination.enabled?f():(m(),u(),p())})),a("activeIndexChange",(()=>{void 0===t.snapIndex&&p()})),a("snapIndexChange",(()=>{p()})),a("snapGridLengthChange",(()=>{u(),p()})),a("destroy",(()=>{h()})),a("enable disable",(()=>{let{el:e}=t.pagination;e&&(e=T(e),e.forEach((e=>e.classList[t.enabled?"remove":"add"](t.params.pagination.lockClass))))})),a("lock unlock",(()=>{p()})),a("click",((e,s)=>{const a=s.target,r=T(t.pagination.el);if(t.params.pagination.el&&t.params.pagination.hideOnClick&&r&&r.length>0&&!a.classList.contains(t.params.pagination.bulletClass)){if(t.navigation&&(t.navigation.nextEl&&a===t.navigation.nextEl||t.navigation.prevEl&&a===t.navigation.prevEl))return;const e=r[0].classList.contains(t.params.pagination.hiddenClass);i(!0===e?"paginationShow":"paginationHide"),r.forEach((e=>e.classList.toggle(t.params.pagination.hiddenClass)))}}));const f=()=>{t.el.classList.add(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=T(e),e.forEach((e=>e.classList.add(t.params.pagination.paginationDisabledClass)))),h()};Object.assign(t.pagination,{enable:()=>{t.el.classList.remove(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=T(e),e.forEach((e=>e.classList.remove(t.params.pagination.paginationDisabledClass)))),m(),u(),p()},disable:f,render:u,update:p,init:m,destroy:h})},function(e){let{swiper:t,extendParams:s,on:i,emit:r}=e;const o=a();let d,c,p,u,m=!1,h=null,f=null;function g(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e,rtlTranslate:s}=t,{dragEl:a,el:i}=e,r=t.params.scrollbar,n=t.params.loop?t.progressLoop:t.progress;let l=c,o=(p-c)*n;s?(o=-o,o>0?(l=c-o,o=0):-o+c>p&&(l=p+o)):o<0?(l=c+o,o=0):o+c>p&&(l=p-o),t.isHorizontal()?(a.style.transform=`translate3d(${o}px, 0, 0)`,a.style.width=`${l}px`):(a.style.transform=`translate3d(0px, ${o}px, 0)`,a.style.height=`${l}px`),r.hide&&(clearTimeout(h),i.style.opacity=1,h=setTimeout((()=>{i.style.opacity=0,i.style.transitionDuration="400ms"}),1e3))}function b(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e}=t,{dragEl:s,el:a}=e;s.style.width="",s.style.height="",p=t.isHorizontal()?a.offsetWidth:a.offsetHeight,u=t.size/(t.virtualSize+t.params.slidesOffsetBefore-(t.params.centeredSlides?t.snapGrid[0]:0)),c="auto"===t.params.scrollbar.dragSize?p*u:parseInt(t.params.scrollbar.dragSize,10),t.isHorizontal()?s.style.width=`${c}px`:s.style.height=`${c}px`,a.style.display=u>=1?"none":"",t.params.scrollbar.hide&&(a.style.opacity=0),t.params.watchOverflow&&t.enabled&&e.el.classList[t.isLocked?"add":"remove"](t.params.scrollbar.lockClass)}function y(e){return t.isHorizontal()?e.clientX:e.clientY}function E(e){const{scrollbar:s,rtlTranslate:a}=t,{el:i}=s;let r;r=(y(e)-w(i)[t.isHorizontal()?"left":"top"]-(null!==d?d:c/2))/(p-c),r=Math.max(Math.min(r,1),0),a&&(r=1-r);const n=t.minTranslate()+(t.maxTranslate()-t.minTranslate())*r;t.updateProgress(n),t.setTranslate(n),t.updateActiveIndex(),t.updateSlidesClasses()}function x(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:n,dragEl:l}=a;m=!0,d=e.target===l?y(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),i.style.transitionDuration="100ms",l.style.transitionDuration="100ms",E(e),clearTimeout(f),n.style.transitionDuration="0ms",s.hide&&(n.style.opacity=1),t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="none"),r("scrollbarDragStart",e)}function S(e){const{scrollbar:s,wrapperEl:a}=t,{el:i,dragEl:n}=s;m&&(e.preventDefault&&e.cancelable?e.preventDefault():e.returnValue=!1,E(e),a.style.transitionDuration="0ms",i.style.transitionDuration="0ms",n.style.transitionDuration="0ms",r("scrollbarDragMove",e))}function M(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:n}=a;m&&(m=!1,t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="",i.style.transitionDuration=""),s.hide&&(clearTimeout(f),f=l((()=>{n.style.opacity=0,n.style.transitionDuration="400ms"}),1e3)),r("scrollbarDragEnd",e),s.snapOnRelease&&t.slideToClosest())}function C(e){const{scrollbar:s,params:a}=t,i=s.el;if(!i)return;const r=i,n=!!a.passiveListeners&&{passive:!1,capture:!1},l=!!a.passiveListeners&&{passive:!0,capture:!1};if(!r)return;const d="on"===e?"addEventListener":"removeEventListener";r[d]("pointerdown",x,n),o[d]("pointermove",S,n),o[d]("pointerup",M,l)}function P(){const{scrollbar:e,el:s}=t;t.params.scrollbar=ne(t,t.originalParams.scrollbar,t.params.scrollbar,{el:"swiper-scrollbar"});const a=t.params.scrollbar;if(!a.el)return;let i,r;if("string"==typeof a.el&&t.isElement&&(i=t.el.querySelector(a.el)),i||"string"!=typeof a.el)i||(i=a.el);else if(i=o.querySelectorAll(a.el),!i.length)return;t.params.uniqueNavElements&&"string"==typeof a.el&&i.length>1&&1===s.querySelectorAll(a.el).length&&(i=s.querySelector(a.el)),i.length>0&&(i=i[0]),i.classList.add(t.isHorizontal()?a.horizontalClass:a.verticalClass),i&&(r=i.querySelector(le(t.params.scrollbar.dragClass)),r||(r=v("div",t.params.scrollbar.dragClass),i.append(r))),Object.assign(e,{el:i,dragEl:r}),a.draggable&&t.params.scrollbar.el&&t.scrollbar.el&&C("on"),i&&i.classList[t.enabled?"remove":"add"](...n(t.params.scrollbar.lockClass))}function L(){const e=t.params.scrollbar,s=t.scrollbar.el;s&&s.classList.remove(...n(t.isHorizontal()?e.horizontalClass:e.verticalClass)),t.params.scrollbar.el&&t.scrollbar.el&&C("off")}s({scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag",scrollbarDisabledClass:"swiper-scrollbar-disabled",horizontalClass:"swiper-scrollbar-horizontal",verticalClass:"swiper-scrollbar-vertical"}}),t.scrollbar={el:null,dragEl:null},i("changeDirection",(()=>{if(!t.scrollbar||!t.scrollbar.el)return;const e=t.params.scrollbar;let{el:s}=t.scrollbar;s=T(s),s.forEach((s=>{s.classList.remove(e.horizontalClass,e.verticalClass),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass)}))})),i("init",(()=>{!1===t.params.scrollbar.enabled?I():(P(),b(),g())})),i("update resize observerUpdate lock unlock changeDirection",(()=>{b()})),i("setTranslate",(()=>{g()})),i("setTransition",((e,s)=>{!function(e){t.params.scrollbar.el&&t.scrollbar.el&&(t.scrollbar.dragEl.style.transitionDuration=`${e}ms`)}(s)})),i("enable disable",(()=>{const{el:e}=t.scrollbar;e&&e.classList[t.enabled?"remove":"add"](...n(t.params.scrollbar.lockClass))})),i("destroy",(()=>{L()}));const I=()=>{t.el.classList.add(...n(t.params.scrollbar.scrollbarDisabledClass)),t.scrollbar.el&&t.scrollbar.el.classList.add(...n(t.params.scrollbar.scrollbarDisabledClass)),L()};Object.assign(t.scrollbar,{enable:()=>{t.el.classList.remove(...n(t.params.scrollbar.scrollbarDisabledClass)),t.scrollbar.el&&t.scrollbar.el.classList.remove(...n(t.params.scrollbar.scrollbarDisabledClass)),P(),b(),g()},disable:I,updateSize:b,setTranslate:g,init:P,destroy:L})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({parallax:{enabled:!1}});const i="[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",r=(e,s)=>{const{rtl:a}=t,i=a?-1:1,r=e.getAttribute("data-swiper-parallax")||"0";let n=e.getAttribute("data-swiper-parallax-x"),l=e.getAttribute("data-swiper-parallax-y");const o=e.getAttribute("data-swiper-parallax-scale"),d=e.getAttribute("data-swiper-parallax-opacity"),c=e.getAttribute("data-swiper-parallax-rotate");if(n||l?(n=n||"0",l=l||"0"):t.isHorizontal()?(n=r,l="0"):(l=r,n="0"),n=n.indexOf("%")>=0?parseInt(n,10)*s*i+"%":n*s*i+"px",l=l.indexOf("%")>=0?parseInt(l,10)*s+"%":l*s+"px",null!=d){const t=d-(d-1)*(1-Math.abs(s));e.style.opacity=t}let p=`translate3d(${n}, ${l}, 0px)`;if(null!=o){p+=` scale(${o-(o-1)*(1-Math.abs(s))})`}if(c&&null!=c){p+=` rotate(${c*s*-1}deg)`}e.style.transform=p},n=()=>{const{el:e,slides:s,progress:a,snapGrid:n,isElement:l}=t,o=f(e,i);t.isElement&&o.push(...f(t.hostEl,i)),o.forEach((e=>{r(e,a)})),s.forEach(((e,s)=>{let l=e.progress;t.params.slidesPerGroup>1&&"auto"!==t.params.slidesPerView&&(l+=Math.ceil(s/2)-a*(n.length-1)),l=Math.min(Math.max(l,-1),1),e.querySelectorAll(`${i}, [data-swiper-parallax-rotate]`).forEach((e=>{r(e,l)}))}))};a("beforeInit",(()=>{t.params.parallax.enabled&&(t.params.watchSlidesProgress=!0,t.originalParams.watchSlidesProgress=!0)})),a("init",(()=>{t.params.parallax.enabled&&n()})),a("setTranslate",(()=>{t.params.parallax.enabled&&n()})),a("setTransition",((e,s)=>{t.params.parallax.enabled&&function(e){void 0===e&&(e=t.params.speed);const{el:s,hostEl:a}=t,r=[...s.querySelectorAll(i)];t.isElement&&r.push(...a.querySelectorAll(i)),r.forEach((t=>{let s=parseInt(t.getAttribute("data-swiper-parallax-duration"),10)||e;0===e&&(s=0),t.style.transitionDuration=`${s}ms`}))}(s)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();s({zoom:{enabled:!1,limitToOriginalSize:!1,maxRatio:3,minRatio:1,panOnMouseMove:!1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}}),t.zoom={enabled:!1};let l=1,o=!1,c=!1,p={x:0,y:0};const u=-3;let m,h;const g=[],v={originX:0,originY:0,slideEl:void 0,slideWidth:void 0,slideHeight:void 0,imageEl:void 0,imageWrapEl:void 0,maxRatio:3},b={isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},y={x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0};let x,S=1;function T(){if(g.length<2)return 1;const e=g[0].pageX,t=g[0].pageY,s=g[1].pageX,a=g[1].pageY;return Math.sqrt((s-e)**2+(a-t)**2)}function M(){const e=t.params.zoom,s=v.imageWrapEl.getAttribute("data-swiper-zoom")||e.maxRatio;if(e.limitToOriginalSize&&v.imageEl&&v.imageEl.naturalWidth){const e=v.imageEl.naturalWidth/v.imageEl.offsetWidth;return Math.min(e,s)}return s}function C(e){const s=t.isElement?"swiper-slide":`.${t.params.slideClass}`;return!!e.target.matches(s)||t.slides.filter((t=>t.contains(e.target))).length>0}function P(e){const s=`.${t.params.zoom.containerClass}`;return!!e.target.matches(s)||[...t.hostEl.querySelectorAll(s)].filter((t=>t.contains(e.target))).length>0}function L(e){if("mouse"===e.pointerType&&g.splice(0,g.length),!C(e))return;const s=t.params.zoom;if(m=!1,h=!1,g.push(e),!(g.length<2)){if(m=!0,v.scaleStart=T(),!v.slideEl){v.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`),v.slideEl||(v.slideEl=t.slides[t.activeIndex]);let a=v.slideEl.querySelector(`.${s.containerClass}`);if(a&&(a=a.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),v.imageEl=a,v.imageWrapEl=a?E(v.imageEl,`.${s.containerClass}`)[0]:void 0,!v.imageWrapEl)return void(v.imageEl=void 0);v.maxRatio=M()}if(v.imageEl){const[e,t]=function(){if(g.length<2)return{x:null,y:null};const e=v.imageEl.getBoundingClientRect();return[(g[0].pageX+(g[1].pageX-g[0].pageX)/2-e.x-n.scrollX)/l,(g[0].pageY+(g[1].pageY-g[0].pageY)/2-e.y-n.scrollY)/l]}();v.originX=e,v.originY=t,v.imageEl.style.transitionDuration="0ms"}o=!0}}function I(e){if(!C(e))return;const s=t.params.zoom,a=t.zoom,i=g.findIndex((t=>t.pointerId===e.pointerId));i>=0&&(g[i]=e),g.length<2||(h=!0,v.scaleMove=T(),v.imageEl&&(a.scale=v.scaleMove/v.scaleStart*l,a.scale>v.maxRatio&&(a.scale=v.maxRatio-1+(a.scale-v.maxRatio+1)**.5),a.scale<s.minRatio&&(a.scale=s.minRatio+1-(s.minRatio-a.scale+1)**.5),v.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`))}function z(e){if(!C(e))return;if("mouse"===e.pointerType&&"pointerout"===e.type)return;const s=t.params.zoom,a=t.zoom,i=g.findIndex((t=>t.pointerId===e.pointerId));i>=0&&g.splice(i,1),m&&h&&(m=!1,h=!1,v.imageEl&&(a.scale=Math.max(Math.min(a.scale,v.maxRatio),s.minRatio),v.imageEl.style.transitionDuration=`${t.params.speed}ms`,v.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`,l=a.scale,o=!1,a.scale>1&&v.slideEl?v.slideEl.classList.add(`${s.zoomedSlideClass}`):a.scale<=1&&v.slideEl&&v.slideEl.classList.remove(`${s.zoomedSlideClass}`),1===a.scale&&(v.originX=0,v.originY=0,v.slideEl=void 0)))}function A(){t.touchEventsData.preventTouchMoveFromPointerMove=!1}function $(e){const s="mouse"===e.pointerType&&t.params.zoom.panOnMouseMove;if(!C(e)||!P(e))return;const a=t.zoom;if(!v.imageEl)return;if(!b.isTouched||!v.slideEl)return void(s&&O(e));if(s)return void O(e);b.isMoved||(b.width=v.imageEl.offsetWidth||v.imageEl.clientWidth,b.height=v.imageEl.offsetHeight||v.imageEl.clientHeight,b.startX=d(v.imageWrapEl,"x")||0,b.startY=d(v.imageWrapEl,"y")||0,v.slideWidth=v.slideEl.offsetWidth,v.slideHeight=v.slideEl.offsetHeight,v.imageWrapEl.style.transitionDuration="0ms");const i=b.width*a.scale,r=b.height*a.scale;b.minX=Math.min(v.slideWidth/2-i/2,0),b.maxX=-b.minX,b.minY=Math.min(v.slideHeight/2-r/2,0),b.maxY=-b.minY,b.touchesCurrent.x=g.length>0?g[0].pageX:e.pageX,b.touchesCurrent.y=g.length>0?g[0].pageY:e.pageY;if(Math.max(Math.abs(b.touchesCurrent.x-b.touchesStart.x),Math.abs(b.touchesCurrent.y-b.touchesStart.y))>5&&(t.allowClick=!1),!b.isMoved&&!o){if(t.isHorizontal()&&(Math.floor(b.minX)===Math.floor(b.startX)&&b.touchesCurrent.x<b.touchesStart.x||Math.floor(b.maxX)===Math.floor(b.startX)&&b.touchesCurrent.x>b.touchesStart.x))return b.isTouched=!1,void A();if(!t.isHorizontal()&&(Math.floor(b.minY)===Math.floor(b.startY)&&b.touchesCurrent.y<b.touchesStart.y||Math.floor(b.maxY)===Math.floor(b.startY)&&b.touchesCurrent.y>b.touchesStart.y))return b.isTouched=!1,void A()}e.cancelable&&e.preventDefault(),e.stopPropagation(),clearTimeout(x),t.touchEventsData.preventTouchMoveFromPointerMove=!0,x=setTimeout((()=>{t.destroyed||A()})),b.isMoved=!0;const n=(a.scale-l)/(v.maxRatio-t.params.zoom.minRatio),{originX:c,originY:p}=v;b.currentX=b.touchesCurrent.x-b.touchesStart.x+b.startX+n*(b.width-2*c),b.currentY=b.touchesCurrent.y-b.touchesStart.y+b.startY+n*(b.height-2*p),b.currentX<b.minX&&(b.currentX=b.minX+1-(b.minX-b.currentX+1)**.8),b.currentX>b.maxX&&(b.currentX=b.maxX-1+(b.currentX-b.maxX+1)**.8),b.currentY<b.minY&&(b.currentY=b.minY+1-(b.minY-b.currentY+1)**.8),b.currentY>b.maxY&&(b.currentY=b.maxY-1+(b.currentY-b.maxY+1)**.8),y.prevPositionX||(y.prevPositionX=b.touchesCurrent.x),y.prevPositionY||(y.prevPositionY=b.touchesCurrent.y),y.prevTime||(y.prevTime=Date.now()),y.x=(b.touchesCurrent.x-y.prevPositionX)/(Date.now()-y.prevTime)/2,y.y=(b.touchesCurrent.y-y.prevPositionY)/(Date.now()-y.prevTime)/2,Math.abs(b.touchesCurrent.x-y.prevPositionX)<2&&(y.x=0),Math.abs(b.touchesCurrent.y-y.prevPositionY)<2&&(y.y=0),y.prevPositionX=b.touchesCurrent.x,y.prevPositionY=b.touchesCurrent.y,y.prevTime=Date.now(),v.imageWrapEl.style.transform=`translate3d(${b.currentX}px, ${b.currentY}px,0)`}function k(){const e=t.zoom;v.slideEl&&t.activeIndex!==t.slides.indexOf(v.slideEl)&&(v.imageEl&&(v.imageEl.style.transform="translate3d(0,0,0) scale(1)"),v.imageWrapEl&&(v.imageWrapEl.style.transform="translate3d(0,0,0)"),v.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),e.scale=1,l=1,v.slideEl=void 0,v.imageEl=void 0,v.imageWrapEl=void 0,v.originX=0,v.originY=0)}function O(e){if(l<=1||!v.imageWrapEl)return;if(!C(e)||!P(e))return;const t=n.getComputedStyle(v.imageWrapEl).transform,s=new n.DOMMatrix(t);if(!c)return c=!0,p.x=e.clientX,p.y=e.clientY,b.startX=s.e,b.startY=s.f,b.width=v.imageEl.offsetWidth||v.imageEl.clientWidth,b.height=v.imageEl.offsetHeight||v.imageEl.clientHeight,v.slideWidth=v.slideEl.offsetWidth,void(v.slideHeight=v.slideEl.offsetHeight);const a=(e.clientX-p.x)*u,i=(e.clientY-p.y)*u,r=b.width*l,o=b.height*l,d=v.slideWidth,m=v.slideHeight,h=Math.min(d/2-r/2,0),f=-h,g=Math.min(m/2-o/2,0),w=-g,y=Math.max(Math.min(b.startX+a,f),h),E=Math.max(Math.min(b.startY+i,w),g);v.imageWrapEl.style.transitionDuration="0ms",v.imageWrapEl.style.transform=`translate3d(${y}px, ${E}px, 0)`,p.x=e.clientX,p.y=e.clientY,b.startX=y,b.startY=E,b.currentX=y,b.currentY=E}function D(e){const s=t.zoom,a=t.params.zoom;if(!v.slideEl){e&&e.target&&(v.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`)),v.slideEl||(t.params.virtual&&t.params.virtual.enabled&&t.virtual?v.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:v.slideEl=t.slides[t.activeIndex]);let s=v.slideEl.querySelector(`.${a.containerClass}`);s&&(s=s.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),v.imageEl=s,v.imageWrapEl=s?E(v.imageEl,`.${a.containerClass}`)[0]:void 0}if(!v.imageEl||!v.imageWrapEl)return;let i,r,o,d,c,p,u,m,h,g,y,x,S,T,C,P,L,I;t.params.cssMode&&(t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.touchAction="none"),v.slideEl.classList.add(`${a.zoomedSlideClass}`),void 0===b.touchesStart.x&&e?(i=e.pageX,r=e.pageY):(i=b.touchesStart.x,r=b.touchesStart.y);const z=l,A="number"==typeof e?e:null;1===l&&A&&(i=void 0,r=void 0,b.touchesStart.x=void 0,b.touchesStart.y=void 0);const $=M();s.scale=A||$,l=A||$,!e||1===l&&A?(u=0,m=0):(L=v.slideEl.offsetWidth,I=v.slideEl.offsetHeight,o=w(v.slideEl).left+n.scrollX,d=w(v.slideEl).top+n.scrollY,c=o+L/2-i,p=d+I/2-r,h=v.imageEl.offsetWidth||v.imageEl.clientWidth,g=v.imageEl.offsetHeight||v.imageEl.clientHeight,y=h*s.scale,x=g*s.scale,S=Math.min(L/2-y/2,0),T=Math.min(I/2-x/2,0),C=-S,P=-T,z>0&&A&&"number"==typeof b.currentX&&"number"==typeof b.currentY?(u=b.currentX*s.scale/z,m=b.currentY*s.scale/z):(u=c*s.scale,m=p*s.scale),u<S&&(u=S),u>C&&(u=C),m<T&&(m=T),m>P&&(m=P)),A&&1===s.scale&&(v.originX=0,v.originY=0),b.currentX=u,b.currentY=m,v.imageWrapEl.style.transitionDuration="300ms",v.imageWrapEl.style.transform=`translate3d(${u}px, ${m}px,0)`,v.imageEl.style.transitionDuration="300ms",v.imageEl.style.transform=`translate3d(0,0,0) scale(${s.scale})`}function G(){const e=t.zoom,s=t.params.zoom;if(!v.slideEl){t.params.virtual&&t.params.virtual.enabled&&t.virtual?v.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:v.slideEl=t.slides[t.activeIndex];let e=v.slideEl.querySelector(`.${s.containerClass}`);e&&(e=e.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),v.imageEl=e,v.imageWrapEl=e?E(v.imageEl,`.${s.containerClass}`)[0]:void 0}v.imageEl&&v.imageWrapEl&&(t.params.cssMode&&(t.wrapperEl.style.overflow="",t.wrapperEl.style.touchAction=""),e.scale=1,l=1,b.currentX=void 0,b.currentY=void 0,b.touchesStart.x=void 0,b.touchesStart.y=void 0,v.imageWrapEl.style.transitionDuration="300ms",v.imageWrapEl.style.transform="translate3d(0,0,0)",v.imageEl.style.transitionDuration="300ms",v.imageEl.style.transform="translate3d(0,0,0) scale(1)",v.slideEl.classList.remove(`${s.zoomedSlideClass}`),v.slideEl=void 0,v.originX=0,v.originY=0,t.params.zoom.panOnMouseMove&&(p={x:0,y:0},c&&(c=!1,b.startX=0,b.startY=0)))}function X(e){const s=t.zoom;s.scale&&1!==s.scale?G():D(e)}function Y(){return{passiveListener:!!t.params.passiveListeners&&{passive:!0,capture:!1},activeListenerWithCapture:!t.params.passiveListeners||{passive:!1,capture:!0}}}function B(){const e=t.zoom;if(e.enabled)return;e.enabled=!0;const{passiveListener:s,activeListenerWithCapture:a}=Y();t.wrapperEl.addEventListener("pointerdown",L,s),t.wrapperEl.addEventListener("pointermove",I,a),["pointerup","pointercancel","pointerout"].forEach((e=>{t.wrapperEl.addEventListener(e,z,s)})),t.wrapperEl.addEventListener("pointermove",$,a)}function H(){const e=t.zoom;if(!e.enabled)return;e.enabled=!1;const{passiveListener:s,activeListenerWithCapture:a}=Y();t.wrapperEl.removeEventListener("pointerdown",L,s),t.wrapperEl.removeEventListener("pointermove",I,a),["pointerup","pointercancel","pointerout"].forEach((e=>{t.wrapperEl.removeEventListener(e,z,s)})),t.wrapperEl.removeEventListener("pointermove",$,a)}Object.defineProperty(t.zoom,"scale",{get:()=>S,set(e){if(S!==e){const t=v.imageEl,s=v.slideEl;i("zoomChange",e,t,s)}S=e}}),a("init",(()=>{t.params.zoom.enabled&&B()})),a("destroy",(()=>{H()})),a("touchStart",((e,s)=>{t.zoom.enabled&&function(e){const s=t.device;if(!v.imageEl)return;if(b.isTouched)return;s.android&&e.cancelable&&e.preventDefault(),b.isTouched=!0;const a=g.length>0?g[0]:e;b.touchesStart.x=a.pageX,b.touchesStart.y=a.pageY}(s)})),a("touchEnd",((e,s)=>{t.zoom.enabled&&function(){const e=t.zoom;if(g.length=0,!v.imageEl)return;if(!b.isTouched||!b.isMoved)return b.isTouched=!1,void(b.isMoved=!1);b.isTouched=!1,b.isMoved=!1;let s=300,a=300;const i=y.x*s,r=b.currentX+i,n=y.y*a,l=b.currentY+n;0!==y.x&&(s=Math.abs((r-b.currentX)/y.x)),0!==y.y&&(a=Math.abs((l-b.currentY)/y.y));const o=Math.max(s,a);b.currentX=r,b.currentY=l;const d=b.width*e.scale,c=b.height*e.scale;b.minX=Math.min(v.slideWidth/2-d/2,0),b.maxX=-b.minX,b.minY=Math.min(v.slideHeight/2-c/2,0),b.maxY=-b.minY,b.currentX=Math.max(Math.min(b.currentX,b.maxX),b.minX),b.currentY=Math.max(Math.min(b.currentY,b.maxY),b.minY),v.imageWrapEl.style.transitionDuration=`${o}ms`,v.imageWrapEl.style.transform=`translate3d(${b.currentX}px, ${b.currentY}px,0)`}()})),a("doubleTap",((e,s)=>{!t.animating&&t.params.zoom.enabled&&t.zoom.enabled&&t.params.zoom.toggle&&X(s)})),a("transitionEnd",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&k()})),a("slideChange",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&t.params.cssMode&&k()})),Object.assign(t.zoom,{enable:B,disable:H,in:D,out:G,toggle:X})},function(e){let{swiper:t,extendParams:s,on:a}=e;function i(e,t){const s=function(){let e,t,s;return(a,i)=>{for(t=-1,e=a.length;e-t>1;)s=e+t>>1,a[s]<=i?t=s:e=s;return e}}();let a,i;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(i=s(this.x,e),a=i-1,(e-this.x[a])*(this.y[i]-this.y[a])/(this.x[i]-this.x[a])+this.y[a]):0},this}function r(){t.controller.control&&t.controller.spline&&(t.controller.spline=void 0,delete t.controller.spline)}s({controller:{control:void 0,inverse:!1,by:"slide"}}),t.controller={control:void 0},a("beforeInit",(()=>{if("undefined"!=typeof window&&("string"==typeof t.params.controller.control||t.params.controller.control instanceof HTMLElement)){("string"==typeof t.params.controller.control?[...document.querySelectorAll(t.params.controller.control)]:[t.params.controller.control]).forEach((e=>{if(t.controller.control||(t.controller.control=[]),e&&e.swiper)t.controller.control.push(e.swiper);else if(e){const s=`${t.params.eventsPrefix}init`,a=i=>{t.controller.control.push(i.detail[0]),t.update(),e.removeEventListener(s,a)};e.addEventListener(s,a)}}))}else t.controller.control=t.params.controller.control})),a("update",(()=>{r()})),a("resize",(()=>{r()})),a("observerUpdate",(()=>{r()})),a("setTranslate",((e,s,a)=>{t.controller.control&&!t.controller.control.destroyed&&t.controller.setTranslate(s,a)})),a("setTransition",((e,s,a)=>{t.controller.control&&!t.controller.control.destroyed&&t.controller.setTransition(s,a)})),Object.assign(t.controller,{setTranslate:function(e,s){const a=t.controller.control;let r,n;const l=t.constructor;function o(e){if(e.destroyed)return;const s=t.rtlTranslate?-t.translate:t.translate;"slide"===t.params.controller.by&&(!function(e){t.controller.spline=t.params.loop?new i(t.slidesGrid,e.slidesGrid):new i(t.snapGrid,e.snapGrid)}(e),n=-t.controller.spline.interpolate(-s)),n&&"container"!==t.params.controller.by||(r=(e.maxTranslate()-e.minTranslate())/(t.maxTranslate()-t.minTranslate()),!Number.isNaN(r)&&Number.isFinite(r)||(r=1),n=(s-t.minTranslate())*r+e.minTranslate()),t.params.controller.inverse&&(n=e.maxTranslate()-n),e.updateProgress(n),e.setTranslate(n,t),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(a))for(let e=0;e<a.length;e+=1)a[e]!==s&&a[e]instanceof l&&o(a[e]);else a instanceof l&&s!==a&&o(a)},setTransition:function(e,s){const a=t.constructor,i=t.controller.control;let r;function n(s){s.destroyed||(s.setTransition(e,t),0!==e&&(s.transitionStart(),s.params.autoHeight&&l((()=>{s.updateAutoHeight()})),x(s.wrapperEl,(()=>{i&&s.transitionEnd()}))))}if(Array.isArray(i))for(r=0;r<i.length;r+=1)i[r]!==s&&i[r]instanceof a&&n(i[r]);else i instanceof a&&s!==i&&n(i)}})},function(e){let{swiper:t,extendParams:s,on:i}=e;s({a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,containerRole:null,itemRoleDescriptionMessage:null,slideRole:"group",id:null,scrollOnFocus:!0}}),t.a11y={clicked:!1};let r,n,l=null,o=(new Date).getTime();function d(e){const t=l;0!==t.length&&C(t,e)}function c(e){(e=T(e)).forEach((e=>{e.setAttribute("tabIndex","0")}))}function p(e){(e=T(e)).forEach((e=>{e.setAttribute("tabIndex","-1")}))}function u(e,t){(e=T(e)).forEach((e=>{e.setAttribute("role",t)}))}function m(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-roledescription",t)}))}function h(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-label",t)}))}function f(e){(e=T(e)).forEach((e=>{e.setAttribute("aria-disabled",!0)}))}function g(e){(e=T(e)).forEach((e=>{e.setAttribute("aria-disabled",!1)}))}function w(e){if(13!==e.keyCode&&32!==e.keyCode)return;const s=t.params.a11y,a=e.target;if(!t.pagination||!t.pagination.el||a!==t.pagination.el&&!t.pagination.el.contains(e.target)||e.target.matches(le(t.params.pagination.bulletClass))){if(t.navigation&&t.navigation.prevEl&&t.navigation.nextEl){const e=T(t.navigation.prevEl);T(t.navigation.nextEl).includes(a)&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?d(s.lastSlideMessage):d(s.nextSlideMessage)),e.includes(a)&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?d(s.firstSlideMessage):d(s.prevSlideMessage))}t.pagination&&a.matches(le(t.params.pagination.bulletClass))&&a.click()}}function b(){return t.pagination&&t.pagination.bullets&&t.pagination.bullets.length}function E(){return b()&&t.params.pagination.clickable}const x=(e,t,s)=>{c(e),"BUTTON"!==e.tagName&&(u(e,"button"),e.addEventListener("keydown",w)),h(e,s),function(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-controls",t)}))}(e,t)},S=e=>{n&&n!==e.target&&!n.contains(e.target)&&(r=!0),t.a11y.clicked=!0},M=()=>{r=!1,requestAnimationFrame((()=>{requestAnimationFrame((()=>{t.destroyed||(t.a11y.clicked=!1)}))}))},P=e=>{o=(new Date).getTime()},L=e=>{if(t.a11y.clicked||!t.params.a11y.scrollOnFocus)return;if((new Date).getTime()-o<100)return;const s=e.target.closest(`.${t.params.slideClass}, swiper-slide`);if(!s||!t.slides.includes(s))return;n=s;const a=t.slides.indexOf(s)===t.activeIndex,i=t.params.watchSlidesProgress&&t.visibleSlides&&t.visibleSlides.includes(s);a||i||e.sourceCapabilities&&e.sourceCapabilities.firesTouchEvents||(t.isHorizontal()?t.el.scrollLeft=0:t.el.scrollTop=0,requestAnimationFrame((()=>{r||(t.params.loop?t.slideToLoop(t.getSlideIndexWhenGrid(parseInt(s.getAttribute("data-swiper-slide-index"))),0):t.slideTo(t.getSlideIndexWhenGrid(t.slides.indexOf(s)),0),r=!1)})))},I=()=>{const e=t.params.a11y;e.itemRoleDescriptionMessage&&m(t.slides,e.itemRoleDescriptionMessage),e.slideRole&&u(t.slides,e.slideRole);const s=t.slides.length;e.slideLabelMessage&&t.slides.forEach(((a,i)=>{const r=t.params.loop?parseInt(a.getAttribute("data-swiper-slide-index"),10):i;h(a,e.slideLabelMessage.replace(/\{\{index\}\}/,r+1).replace(/\{\{slidesLength\}\}/,s))}))},z=()=>{const e=t.params.a11y;t.el.append(l);const s=t.el;e.containerRoleDescriptionMessage&&m(s,e.containerRoleDescriptionMessage),e.containerMessage&&h(s,e.containerMessage),e.containerRole&&u(s,e.containerRole);const i=t.wrapperEl,r=e.id||i.getAttribute("id")||`swiper-wrapper-${n=16,void 0===n&&(n=16),"x".repeat(n).replace(/x/g,(()=>Math.round(16*Math.random()).toString(16)))}`;var n;const o=t.params.autoplay&&t.params.autoplay.enabled?"off":"polite";var d;d=r,T(i).forEach((e=>{e.setAttribute("id",d)})),function(e,t){(e=T(e)).forEach((e=>{e.setAttribute("aria-live",t)}))}(i,o),I();let{nextEl:c,prevEl:p}=t.navigation?t.navigation:{};if(c=T(c),p=T(p),c&&c.forEach((t=>x(t,r,e.nextSlideMessage))),p&&p.forEach((t=>x(t,r,e.prevSlideMessage))),E()){T(t.pagination.el).forEach((e=>{e.addEventListener("keydown",w)}))}a().addEventListener("visibilitychange",P),t.el.addEventListener("focus",L,!0),t.el.addEventListener("focus",L,!0),t.el.addEventListener("pointerdown",S,!0),t.el.addEventListener("pointerup",M,!0)};i("beforeInit",(()=>{l=v("span",t.params.a11y.notificationClass),l.setAttribute("aria-live","assertive"),l.setAttribute("aria-atomic","true")})),i("afterInit",(()=>{t.params.a11y.enabled&&z()})),i("slidesLengthChange snapGridLengthChange slidesGridLengthChange",(()=>{t.params.a11y.enabled&&I()})),i("fromEdge toEdge afterInit lock unlock",(()=>{t.params.a11y.enabled&&function(){if(t.params.loop||t.params.rewind||!t.navigation)return;const{nextEl:e,prevEl:s}=t.navigation;s&&(t.isBeginning?(f(s),p(s)):(g(s),c(s))),e&&(t.isEnd?(f(e),p(e)):(g(e),c(e)))}()})),i("paginationUpdate",(()=>{t.params.a11y.enabled&&function(){const e=t.params.a11y;b()&&t.pagination.bullets.forEach((s=>{t.params.pagination.clickable&&(c(s),t.params.pagination.renderBullet||(u(s,"button"),h(s,e.paginationBulletMessage.replace(/\{\{index\}\}/,y(s)+1)))),s.matches(le(t.params.pagination.bulletActiveClass))?s.setAttribute("aria-current","true"):s.removeAttribute("aria-current")}))}()})),i("destroy",(()=>{t.params.a11y.enabled&&function(){l&&l.remove();let{nextEl:e,prevEl:s}=t.navigation?t.navigation:{};e=T(e),s=T(s),e&&e.forEach((e=>e.removeEventListener("keydown",w))),s&&s.forEach((e=>e.removeEventListener("keydown",w))),E()&&T(t.pagination.el).forEach((e=>{e.removeEventListener("keydown",w)}));a().removeEventListener("visibilitychange",P),t.el&&"string"!=typeof t.el&&(t.el.removeEventListener("focus",L,!0),t.el.removeEventListener("pointerdown",S,!0),t.el.removeEventListener("pointerup",M,!0))}()}))},function(e){let{swiper:t,extendParams:s,on:a}=e;s({history:{enabled:!1,root:"",replaceState:!1,key:"slides",keepQuery:!1}});let i=!1,n={};const l=e=>e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,""),o=e=>{const t=r();let s;s=e?new URL(e):t.location;const a=s.pathname.slice(1).split("/").filter((e=>""!==e)),i=a.length;return{key:a[i-2],value:a[i-1]}},d=(e,s)=>{const a=r();if(!i||!t.params.history.enabled)return;let n;n=t.params.url?new URL(t.params.url):a.location;const o=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${s}"]`):t.slides[s];let d=l(o.getAttribute("data-history"));if(t.params.history.root.length>0){let s=t.params.history.root;"/"===s[s.length-1]&&(s=s.slice(0,s.length-1)),d=`${s}/${e?`${e}/`:""}${d}`}else n.pathname.includes(e)||(d=`${e?`${e}/`:""}${d}`);t.params.history.keepQuery&&(d+=n.search);const c=a.history.state;c&&c.value===d||(t.params.history.replaceState?a.history.replaceState({value:d},null,d):a.history.pushState({value:d},null,d))},c=(e,s,a)=>{if(s)for(let i=0,r=t.slides.length;i<r;i+=1){const r=t.slides[i];if(l(r.getAttribute("data-history"))===s){const s=t.getSlideIndex(r);t.slideTo(s,e,a)}}else t.slideTo(0,e,a)},p=()=>{n=o(t.params.url),c(t.params.speed,n.value,!1)};a("init",(()=>{t.params.history.enabled&&(()=>{const e=r();if(t.params.history){if(!e.history||!e.history.pushState)return t.params.history.enabled=!1,void(t.params.hashNavigation.enabled=!0);i=!0,n=o(t.params.url),n.key||n.value?(c(0,n.value,t.params.runCallbacksOnInit),t.params.history.replaceState||e.addEventListener("popstate",p)):t.params.history.replaceState||e.addEventListener("popstate",p)}})()})),a("destroy",(()=>{t.params.history.enabled&&(()=>{const e=r();t.params.history.replaceState||e.removeEventListener("popstate",p)})()})),a("transitionEnd _freeModeNoMomentumRelease",(()=>{i&&d(t.params.history.key,t.activeIndex)})),a("slideChange",(()=>{i&&t.params.cssMode&&d(t.params.history.key,t.activeIndex)}))},function(e){let{swiper:t,extendParams:s,emit:i,on:n}=e,l=!1;const o=a(),d=r();s({hashNavigation:{enabled:!1,replaceState:!1,watchState:!1,getSlideIndex(e,s){if(t.virtual&&t.params.virtual.enabled){const e=t.slides.find((e=>e.getAttribute("data-hash")===s));if(!e)return 0;return parseInt(e.getAttribute("data-swiper-slide-index"),10)}return t.getSlideIndex(f(t.slidesEl,`.${t.params.slideClass}[data-hash="${s}"], swiper-slide[data-hash="${s}"]`)[0])}}});const c=()=>{i("hashChange");const e=o.location.hash.replace("#",""),s=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`):t.slides[t.activeIndex];if(e!==(s?s.getAttribute("data-hash"):"")){const s=t.params.hashNavigation.getSlideIndex(t,e);if(void 0===s||Number.isNaN(s))return;t.slideTo(s)}},p=()=>{if(!l||!t.params.hashNavigation.enabled)return;const e=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`):t.slides[t.activeIndex],s=e?e.getAttribute("data-hash")||e.getAttribute("data-history"):"";t.params.hashNavigation.replaceState&&d.history&&d.history.replaceState?(d.history.replaceState(null,null,`#${s}`||""),i("hashSet")):(o.location.hash=s||"",i("hashSet"))};n("init",(()=>{t.params.hashNavigation.enabled&&(()=>{if(!t.params.hashNavigation.enabled||t.params.history&&t.params.history.enabled)return;l=!0;const e=o.location.hash.replace("#","");if(e){const s=0,a=t.params.hashNavigation.getSlideIndex(t,e);t.slideTo(a||0,s,t.params.runCallbacksOnInit,!0)}t.params.hashNavigation.watchState&&d.addEventListener("hashchange",c)})()})),n("destroy",(()=>{t.params.hashNavigation.enabled&&t.params.hashNavigation.watchState&&d.removeEventListener("hashchange",c)})),n("transitionEnd _freeModeNoMomentumRelease",(()=>{l&&p()})),n("slideChange",(()=>{l&&t.params.cssMode&&p()}))},function(e){let t,s,{swiper:i,extendParams:r,on:n,emit:l,params:o}=e;i.autoplay={running:!1,paused:!1,timeLeft:0},r({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!1,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}});let d,c,p,u,m,h,f,g,v=o&&o.autoplay?o.autoplay.delay:3e3,w=o&&o.autoplay?o.autoplay.delay:3e3,b=(new Date).getTime();function y(e){i&&!i.destroyed&&i.wrapperEl&&e.target===i.wrapperEl&&(i.wrapperEl.removeEventListener("transitionend",y),g||e.detail&&e.detail.bySwiperTouchMove||C())}const E=()=>{if(i.destroyed||!i.autoplay.running)return;i.autoplay.paused?c=!0:c&&(w=d,c=!1);const e=i.autoplay.paused?d:b+w-(new Date).getTime();i.autoplay.timeLeft=e,l("autoplayTimeLeft",e,e/v),s=requestAnimationFrame((()=>{E()}))},x=e=>{if(i.destroyed||!i.autoplay.running)return;cancelAnimationFrame(s),E();let a=void 0===e?i.params.autoplay.delay:e;v=i.params.autoplay.delay,w=i.params.autoplay.delay;const r=(()=>{let e;if(e=i.virtual&&i.params.virtual.enabled?i.slides.find((e=>e.classList.contains("swiper-slide-active"))):i.slides[i.activeIndex],!e)return;return parseInt(e.getAttribute("data-swiper-autoplay"),10)})();!Number.isNaN(r)&&r>0&&void 0===e&&(a=r,v=r,w=r),d=a;const n=i.params.speed,o=()=>{i&&!i.destroyed&&(i.params.autoplay.reverseDirection?!i.isBeginning||i.params.loop||i.params.rewind?(i.slidePrev(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(i.slides.length-1,n,!0,!0),l("autoplay")):!i.isEnd||i.params.loop||i.params.rewind?(i.slideNext(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(0,n,!0,!0),l("autoplay")),i.params.cssMode&&(b=(new Date).getTime(),requestAnimationFrame((()=>{x()}))))};return a>0?(clearTimeout(t),t=setTimeout((()=>{o()}),a)):requestAnimationFrame((()=>{o()})),a},S=()=>{b=(new Date).getTime(),i.autoplay.running=!0,x(),l("autoplayStart")},T=()=>{i.autoplay.running=!1,clearTimeout(t),cancelAnimationFrame(s),l("autoplayStop")},M=(e,s)=>{if(i.destroyed||!i.autoplay.running)return;clearTimeout(t),e||(f=!0);const a=()=>{l("autoplayPause"),i.params.autoplay.waitForTransition?i.wrapperEl.addEventListener("transitionend",y):C()};if(i.autoplay.paused=!0,s)return h&&(d=i.params.autoplay.delay),h=!1,void a();const r=d||i.params.autoplay.delay;d=r-((new Date).getTime()-b),i.isEnd&&d<0&&!i.params.loop||(d<0&&(d=0),a())},C=()=>{i.isEnd&&d<0&&!i.params.loop||i.destroyed||!i.autoplay.running||(b=(new Date).getTime(),f?(f=!1,x(d)):x(),i.autoplay.paused=!1,l("autoplayResume"))},P=()=>{if(i.destroyed||!i.autoplay.running)return;const e=a();"hidden"===e.visibilityState&&(f=!0,M(!0)),"visible"===e.visibilityState&&C()},L=e=>{"mouse"===e.pointerType&&(f=!0,g=!0,i.animating||i.autoplay.paused||M(!0))},I=e=>{"mouse"===e.pointerType&&(g=!1,i.autoplay.paused&&C())};n("init",(()=>{i.params.autoplay.enabled&&(i.params.autoplay.pauseOnMouseEnter&&(i.el.addEventListener("pointerenter",L),i.el.addEventListener("pointerleave",I)),a().addEventListener("visibilitychange",P),S())})),n("destroy",(()=>{i.el&&"string"!=typeof i.el&&(i.el.removeEventListener("pointerenter",L),i.el.removeEventListener("pointerleave",I)),a().removeEventListener("visibilitychange",P),i.autoplay.running&&T()})),n("_freeModeStaticRelease",(()=>{(u||f)&&C()})),n("_freeModeNoMomentumRelease",(()=>{i.params.autoplay.disableOnInteraction?T():M(!0,!0)})),n("beforeTransitionStart",((e,t,s)=>{!i.destroyed&&i.autoplay.running&&(s||!i.params.autoplay.disableOnInteraction?M(!0,!0):T())})),n("sliderFirstMove",(()=>{!i.destroyed&&i.autoplay.running&&(i.params.autoplay.disableOnInteraction?T():(p=!0,u=!1,f=!1,m=setTimeout((()=>{f=!0,u=!0,M(!0)}),200)))})),n("touchEnd",(()=>{if(!i.destroyed&&i.autoplay.running&&p){if(clearTimeout(m),clearTimeout(t),i.params.autoplay.disableOnInteraction)return u=!1,void(p=!1);u&&i.params.cssMode&&C(),u=!1,p=!1}})),n("slideChange",(()=>{!i.destroyed&&i.autoplay.running&&(h=!0)})),Object.assign(i.autoplay,{start:S,stop:T,pause:M,resume:C})},function(e){let{swiper:t,extendParams:s,on:i}=e;s({thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-thumbs"}});let r=!1,n=!1;function l(){const e=t.thumbs.swiper;if(!e||e.destroyed)return;const s=e.clickedIndex,a=e.clickedSlide;if(a&&a.classList.contains(t.params.thumbs.slideThumbActiveClass))return;if(null==s)return;let i;i=e.params.loop?parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10):s,t.params.loop?t.slideToLoop(i):t.slideTo(i)}function o(){const{thumbs:e}=t.params;if(r)return!1;r=!0;const s=t.constructor;if(e.swiper instanceof s){if(e.swiper.destroyed)return r=!1,!1;t.thumbs.swiper=e.swiper,Object.assign(t.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),Object.assign(t.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper.update()}else if(c(e.swiper)){const a=Object.assign({},e.swiper);Object.assign(a,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper=new s(a),n=!0}return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass),t.thumbs.swiper.on("tap",l),!0}function d(e){const s=t.thumbs.swiper;if(!s||s.destroyed)return;const a="auto"===s.params.slidesPerView?s.slidesPerViewDynamic():s.params.slidesPerView;let i=1;const r=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(i=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(i=1),i=Math.floor(i),s.slides.forEach((e=>e.classList.remove(r))),s.params.loop||s.params.virtual&&s.params.virtual.enabled)for(let e=0;e<i;e+=1)f(s.slidesEl,`[data-swiper-slide-index="${t.realIndex+e}"]`).forEach((e=>{e.classList.add(r)}));else for(let e=0;e<i;e+=1)s.slides[t.realIndex+e]&&s.slides[t.realIndex+e].classList.add(r);const n=t.params.thumbs.autoScrollOffset,l=n&&!s.params.loop;if(t.realIndex!==s.realIndex||l){const i=s.activeIndex;let r,o;if(s.params.loop){const e=s.slides.find((e=>e.getAttribute("data-swiper-slide-index")===`${t.realIndex}`));r=s.slides.indexOf(e),o=t.activeIndex>t.previousIndex?"next":"prev"}else r=t.realIndex,o=r>t.previousIndex?"next":"prev";l&&(r+="next"===o?n:-1*n),s.visibleSlidesIndexes&&s.visibleSlidesIndexes.indexOf(r)<0&&(s.params.centeredSlides?r=r>i?r-Math.floor(a/2)+1:r+Math.floor(a/2)-1:r>i&&s.params.slidesPerGroup,s.slideTo(r,e?0:void 0))}}t.thumbs={swiper:null},i("beforeInit",(()=>{const{thumbs:e}=t.params;if(e&&e.swiper)if("string"==typeof e.swiper||e.swiper instanceof HTMLElement){const s=a(),i=()=>{const a="string"==typeof e.swiper?s.querySelector(e.swiper):e.swiper;if(a&&a.swiper)e.swiper=a.swiper,o(),d(!0);else if(a){const s=`${t.params.eventsPrefix}init`,i=r=>{e.swiper=r.detail[0],a.removeEventListener(s,i),o(),d(!0),e.swiper.update(),t.update()};a.addEventListener(s,i)}return a},r=()=>{if(t.destroyed)return;i()||requestAnimationFrame(r)};requestAnimationFrame(r)}else o(),d(!0)})),i("slideChange update resize observerUpdate",(()=>{d()})),i("setTransition",((e,s)=>{const a=t.thumbs.swiper;a&&!a.destroyed&&a.setTransition(s)})),i("beforeDestroy",(()=>{const e=t.thumbs.swiper;e&&!e.destroyed&&n&&e.destroy()})),Object.assign(t.thumbs,{init:o,update:d})},function(e){let{swiper:t,extendParams:s,emit:a,once:i}=e;s({freeMode:{enabled:!1,momentum:!0,momentumRatio:1,momentumBounce:!0,momentumBounceRatio:1,momentumVelocityRatio:1,sticky:!1,minimumVelocity:.02}}),Object.assign(t,{freeMode:{onTouchStart:function(){if(t.params.cssMode)return;const e=t.getTranslate();t.setTranslate(e),t.setTransition(0),t.touchEventsData.velocities.length=0,t.freeMode.onTouchEnd({currentPos:t.rtl?t.translate:-t.translate})},onTouchMove:function(){if(t.params.cssMode)return;const{touchEventsData:e,touches:s}=t;0===e.velocities.length&&e.velocities.push({position:s[t.isHorizontal()?"startX":"startY"],time:e.touchStartTime}),e.velocities.push({position:s[t.isHorizontal()?"currentX":"currentY"],time:o()})},onTouchEnd:function(e){let{currentPos:s}=e;if(t.params.cssMode)return;const{params:r,wrapperEl:n,rtlTranslate:l,snapGrid:d,touchEventsData:c}=t,p=o()-c.touchStartTime;if(s<-t.minTranslate())t.slideTo(t.activeIndex);else if(s>-t.maxTranslate())t.slides.length<d.length?t.slideTo(d.length-1):t.slideTo(t.slides.length-1);else{if(r.freeMode.momentum){if(c.velocities.length>1){const e=c.velocities.pop(),s=c.velocities.pop(),a=e.position-s.position,i=e.time-s.time;t.velocity=a/i,t.velocity/=2,Math.abs(t.velocity)<r.freeMode.minimumVelocity&&(t.velocity=0),(i>150||o()-e.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=r.freeMode.momentumVelocityRatio,c.velocities.length=0;let e=1e3*r.freeMode.momentumRatio;const s=t.velocity*e;let p=t.translate+s;l&&(p=-p);let u,m=!1;const h=20*Math.abs(t.velocity)*r.freeMode.momentumBounceRatio;let f;if(p<t.maxTranslate())r.freeMode.momentumBounce?(p+t.maxTranslate()<-h&&(p=t.maxTranslate()-h),u=t.maxTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.maxTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(p>t.minTranslate())r.freeMode.momentumBounce?(p-t.minTranslate()>h&&(p=t.minTranslate()+h),u=t.minTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.minTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(r.freeMode.sticky){let e;for(let t=0;t<d.length;t+=1)if(d[t]>-p){e=t;break}p=Math.abs(d[e]-p)<Math.abs(d[e-1]-p)||"next"===t.swipeDirection?d[e]:d[e-1],p=-p}if(f&&i("transitionEnd",(()=>{t.loopFix()})),0!==t.velocity){if(e=l?Math.abs((-p-t.translate)/t.velocity):Math.abs((p-t.translate)/t.velocity),r.freeMode.sticky){const s=Math.abs((l?-p:p)-t.translate),a=t.slidesSizesGrid[t.activeIndex];e=s<a?r.speed:s<2*a?1.5*r.speed:2.5*r.speed}}else if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode.momentumBounce&&m?(t.updateProgress(u),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating=!0,x(n,(()=>{t&&!t.destroyed&&c.allowMomentumBounce&&(a("momentumBounce"),t.setTransition(r.speed),setTimeout((()=>{t.setTranslate(u),x(n,(()=>{t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(a("_freeModeNoMomentumRelease"),t.updateProgress(p),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,x(n,(()=>{t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(p),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode&&a("_freeModeNoMomentumRelease")}(!r.freeMode.momentum||p>=r.longSwipesMs)&&(a("_freeModeStaticRelease"),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}}}})},function(e){let t,s,a,i,{swiper:r,extendParams:n,on:l}=e;n({grid:{rows:1,fill:"column"}});const o=()=>{let e=r.params.spaceBetween;return"string"==typeof e&&e.indexOf("%")>=0?e=parseFloat(e.replace("%",""))/100*r.size:"string"==typeof e&&(e=parseFloat(e)),e};l("init",(()=>{i=r.params.grid&&r.params.grid.rows>1})),l("update",(()=>{const{params:e,el:t}=r,s=e.grid&&e.grid.rows>1;i&&!s?(t.classList.remove(`${e.containerModifierClass}grid`,`${e.containerModifierClass}grid-column`),a=1,r.emitContainerClasses()):!i&&s&&(t.classList.add(`${e.containerModifierClass}grid`),"column"===e.grid.fill&&t.classList.add(`${e.containerModifierClass}grid-column`),r.emitContainerClasses()),i=s})),r.grid={initSlides:e=>{const{slidesPerView:i}=r.params,{rows:n,fill:l}=r.params.grid,o=r.virtual&&r.params.virtual.enabled?r.virtual.slides.length:e.length;a=Math.floor(o/n),t=Math.floor(o/n)===o/n?o:Math.ceil(o/n)*n,"auto"!==i&&"row"===l&&(t=Math.max(t,i*n)),s=t/n},unsetSlides:()=>{r.slides&&r.slides.forEach((e=>{e.swiperSlideGridSet&&(e.style.height="",e.style[r.getDirectionLabel("margin-top")]="")}))},updateSlide:(e,i,n)=>{const{slidesPerGroup:l}=r.params,d=o(),{rows:c,fill:p}=r.params.grid,u=r.virtual&&r.params.virtual.enabled?r.virtual.slides.length:n.length;let m,h,f;if("row"===p&&l>1){const s=Math.floor(e/(l*c)),a=e-c*l*s,r=0===s?l:Math.min(Math.ceil((u-s*c*l)/c),l);f=Math.floor(a/r),h=a-f*r+s*l,m=h+f*t/c,i.style.order=m}else"column"===p?(h=Math.floor(e/c),f=e-h*c,(h>a||h===a&&f===c-1)&&(f+=1,f>=c&&(f=0,h+=1))):(f=Math.floor(e/s),h=e-f*s);i.row=f,i.column=h,i.style.height=`calc((100% - ${(c-1)*d}px) / ${c})`,i.style[r.getDirectionLabel("margin-top")]=0!==f?d&&`${d}px`:"",i.swiperSlideGridSet=!0},updateWrapperSize:(e,s)=>{const{centeredSlides:a,roundLengths:i}=r.params,n=o(),{rows:l}=r.params.grid;if(r.virtualSize=(e+n)*t,r.virtualSize=Math.ceil(r.virtualSize/l)-n,r.params.cssMode||(r.wrapperEl.style[r.getDirectionLabel("width")]=`${r.virtualSize+n}px`),a){const e=[];for(let t=0;t<s.length;t+=1){let a=s[t];i&&(a=Math.floor(a)),s[t]<r.virtualSize+s[0]&&e.push(a)}s.splice(0,s.length),s.push(...e)}}}},function(e){let{swiper:t}=e;Object.assign(t,{appendSlide:oe.bind(t),prependSlide:de.bind(t),addSlide:ce.bind(t),removeSlide:pe.bind(t),removeAllSlides:ue.bind(t)})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({fadeEffect:{crossFade:!1}}),me({effect:"fade",swiper:t,on:a,setTranslate:()=>{const{slides:e}=t;t.params.fadeEffect;for(let s=0;s<e.length;s+=1){const e=t.slides[s];let a=-e.swiperSlideOffset;t.params.virtualTranslate||(a-=t.translate);let i=0;t.isHorizontal()||(i=a,a=0);const r=t.params.fadeEffect.crossFade?Math.max(1-Math.abs(e.progress),0):1+Math.min(Math.max(e.progress,-1),0),n=he(0,e);n.style.opacity=r,n.style.transform=`translate3d(${a}px, ${i}px, 0px)`}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`})),fe({swiper:t,duration:e,transformElements:s,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}});const i=(e,t,s)=>{let a=s?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),i=s?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");a||(a=v("div",("swiper-slide-shadow-cube swiper-slide-shadow-"+(s?"left":"top")).split(" ")),e.append(a)),i||(i=v("div",("swiper-slide-shadow-cube swiper-slide-shadow-"+(s?"right":"bottom")).split(" ")),e.append(i)),a&&(a.style.opacity=Math.max(-t,0)),i&&(i.style.opacity=Math.max(t,0))};me({effect:"cube",swiper:t,on:a,setTranslate:()=>{const{el:e,wrapperEl:s,slides:a,width:r,height:n,rtlTranslate:l,size:o,browser:d}=t,c=M(t),p=t.params.cubeEffect,u=t.isHorizontal(),m=t.virtual&&t.params.virtual.enabled;let h,f=0;p.shadow&&(u?(h=t.wrapperEl.querySelector(".swiper-cube-shadow"),h||(h=v("div","swiper-cube-shadow"),t.wrapperEl.append(h)),h.style.height=`${r}px`):(h=e.querySelector(".swiper-cube-shadow"),h||(h=v("div","swiper-cube-shadow"),e.append(h))));for(let e=0;e<a.length;e+=1){const t=a[e];let s=e;m&&(s=parseInt(t.getAttribute("data-swiper-slide-index"),10));let r=90*s,n=Math.floor(r/360);l&&(r=-r,n=Math.floor(-r/360));const d=Math.max(Math.min(t.progress,1),-1);let h=0,g=0,v=0;s%4==0?(h=4*-n*o,v=0):(s-1)%4==0?(h=0,v=4*-n*o):(s-2)%4==0?(h=o+4*n*o,v=o):(s-3)%4==0&&(h=-o,v=3*o+4*o*n),l&&(h=-h),u||(g=h,h=0);const w=`rotateX(${c(u?0:-r)}deg) rotateY(${c(u?r:0)}deg) translate3d(${h}px, ${g}px, ${v}px)`;d<=1&&d>-1&&(f=90*s+90*d,l&&(f=90*-s-90*d)),t.style.transform=w,p.slideShadows&&i(t,d,u)}if(s.style.transformOrigin=`50% 50% -${o/2}px`,s.style["-webkit-transform-origin"]=`50% 50% -${o/2}px`,p.shadow)if(u)h.style.transform=`translate3d(0px, ${r/2+p.shadowOffset}px, ${-r/2}px) rotateX(89.99deg) rotateZ(0deg) scale(${p.shadowScale})`;else{const e=Math.abs(f)-90*Math.floor(Math.abs(f)/90),t=1.5-(Math.sin(2*e*Math.PI/360)/2+Math.cos(2*e*Math.PI/360)/2),s=p.shadowScale,a=p.shadowScale/t,i=p.shadowOffset;h.style.transform=`scale3d(${s}, 1, ${a}) translate3d(0px, ${n/2+i}px, ${-n/2/a}px) rotateX(-89.99deg)`}const g=(d.isSafari||d.isWebView)&&d.needPerspectiveFix?-o/2:0;s.style.transform=`translate3d(0px,0,${g}px) rotateX(${c(t.isHorizontal()?0:f)}deg) rotateY(${c(t.isHorizontal()?-f:0)}deg)`,s.style.setProperty("--swiper-cube-translate-z",`${g}px`)},setTransition:e=>{const{el:s,slides:a}=t;if(a.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),t.params.cubeEffect.shadow&&!t.isHorizontal()){const t=s.querySelector(".swiper-cube-shadow");t&&(t.style.transitionDuration=`${e}ms`)}},recreateShadows:()=>{const e=t.isHorizontal();t.slides.forEach((t=>{const s=Math.max(Math.min(t.progress,1),-1);i(t,s,e)}))},getEffectParams:()=>t.params.cubeEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({flipEffect:{slideShadows:!0,limitRotation:!0}});const i=(e,s)=>{let a=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),i=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");a||(a=ge("flip",e,t.isHorizontal()?"left":"top")),i||(i=ge("flip",e,t.isHorizontal()?"right":"bottom")),a&&(a.style.opacity=Math.max(-s,0)),i&&(i.style.opacity=Math.max(s,0))};me({effect:"flip",swiper:t,on:a,setTranslate:()=>{const{slides:e,rtlTranslate:s}=t,a=t.params.flipEffect,r=M(t);for(let n=0;n<e.length;n+=1){const l=e[n];let o=l.progress;t.params.flipEffect.limitRotation&&(o=Math.max(Math.min(l.progress,1),-1));const d=l.swiperSlideOffset;let c=-180*o,p=0,u=t.params.cssMode?-d-t.translate:-d,m=0;t.isHorizontal()?s&&(c=-c):(m=u,u=0,p=-c,c=0),l.style.zIndex=-Math.abs(Math.round(o))+e.length,a.slideShadows&&i(l,o);const h=`translate3d(${u}px, ${m}px, 0px) rotateX(${r(p)}deg) rotateY(${r(c)}deg)`;he(0,l).style.transform=h}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),fe({swiper:t,duration:e,transformElements:s})},recreateShadows:()=>{t.params.flipEffect,t.slides.forEach((e=>{let s=e.progress;t.params.flipEffect.limitRotation&&(s=Math.max(Math.min(e.progress,1),-1)),i(e,s)}))},getEffectParams:()=>t.params.flipEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}}),me({effect:"coverflow",swiper:t,on:a,setTranslate:()=>{const{width:e,height:s,slides:a,slidesSizesGrid:i}=t,r=t.params.coverflowEffect,n=t.isHorizontal(),l=t.translate,o=n?e/2-l:s/2-l,d=n?r.rotate:-r.rotate,c=r.depth,p=M(t);for(let e=0,t=a.length;e<t;e+=1){const t=a[e],s=i[e],l=(o-t.swiperSlideOffset-s/2)/s,u="function"==typeof r.modifier?r.modifier(l):l*r.modifier;let m=n?d*u:0,h=n?0:d*u,f=-c*Math.abs(u),g=r.stretch;"string"==typeof g&&-1!==g.indexOf("%")&&(g=parseFloat(r.stretch)/100*s);let v=n?0:g*u,w=n?g*u:0,b=1-(1-r.scale)*Math.abs(u);Math.abs(w)<.001&&(w=0),Math.abs(v)<.001&&(v=0),Math.abs(f)<.001&&(f=0),Math.abs(m)<.001&&(m=0),Math.abs(h)<.001&&(h=0),Math.abs(b)<.001&&(b=0);const y=`translate3d(${w}px,${v}px,${f}px)  rotateX(${p(h)}deg) rotateY(${p(m)}deg) scale(${b})`;if(he(0,t).style.transform=y,t.style.zIndex=1-Math.abs(Math.round(u)),r.slideShadows){let e=n?t.querySelector(".swiper-slide-shadow-left"):t.querySelector(".swiper-slide-shadow-top"),s=n?t.querySelector(".swiper-slide-shadow-right"):t.querySelector(".swiper-slide-shadow-bottom");e||(e=ge("coverflow",t,n?"left":"top")),s||(s=ge("coverflow",t,n?"right":"bottom")),e&&(e.style.opacity=u>0?u:0),s&&(s.style.opacity=-u>0?-u:0)}}},setTransition:e=>{t.slides.map((e=>h(e))).forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))}))},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({creativeEffect:{limitProgress:1,shadowPerProgress:!1,progressMultiplier:1,perspective:!0,prev:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1},next:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1}}});const i=e=>"string"==typeof e?e:`${e}px`;me({effect:"creative",swiper:t,on:a,setTranslate:()=>{const{slides:e,wrapperEl:s,slidesSizesGrid:a}=t,r=t.params.creativeEffect,{progressMultiplier:n}=r,l=t.params.centeredSlides,o=M(t);if(l){const e=a[0]/2-t.params.slidesOffsetBefore||0;s.style.transform=`translateX(calc(50% - ${e}px))`}for(let s=0;s<e.length;s+=1){const a=e[s],d=a.progress,c=Math.min(Math.max(a.progress,-r.limitProgress),r.limitProgress);let p=c;l||(p=Math.min(Math.max(a.originalProgress,-r.limitProgress),r.limitProgress));const u=a.swiperSlideOffset,m=[t.params.cssMode?-u-t.translate:-u,0,0],h=[0,0,0];let f=!1;t.isHorizontal()||(m[1]=m[0],m[0]=0);let g={translate:[0,0,0],rotate:[0,0,0],scale:1,opacity:1};c<0?(g=r.next,f=!0):c>0&&(g=r.prev,f=!0),m.forEach(((e,t)=>{m[t]=`calc(${e}px + (${i(g.translate[t])} * ${Math.abs(c*n)}))`})),h.forEach(((e,t)=>{let s=g.rotate[t]*Math.abs(c*n);h[t]=s})),a.style.zIndex=-Math.abs(Math.round(d))+e.length;const v=m.join(", "),w=`rotateX(${o(h[0])}deg) rotateY(${o(h[1])}deg) rotateZ(${o(h[2])}deg)`,b=p<0?`scale(${1+(1-g.scale)*p*n})`:`scale(${1-(1-g.scale)*p*n})`,y=p<0?1+(1-g.opacity)*p*n:1-(1-g.opacity)*p*n,E=`translate3d(${v}) ${w} ${b}`;if(f&&g.shadow||!f){let e=a.querySelector(".swiper-slide-shadow");if(!e&&g.shadow&&(e=ge("creative",a)),e){const t=r.shadowPerProgress?c*(1/r.limitProgress):c;e.style.opacity=Math.min(Math.max(Math.abs(t),0),1)}}const x=he(0,a);x.style.transform=E,x.style.opacity=y,g.origin&&(x.style.transformOrigin=g.origin)}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),fe({swiper:t,duration:e,transformElements:s,allSlides:!0})},perspective:()=>t.params.creativeEffect.perspective,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cardsEffect:{slideShadows:!0,rotate:!0,perSlideRotate:2,perSlideOffset:8}}),me({effect:"cards",swiper:t,on:a,setTranslate:()=>{const{slides:e,activeIndex:s,rtlTranslate:a}=t,i=t.params.cardsEffect,{startTranslate:r,isTouched:n}=t.touchEventsData,l=a?-t.translate:t.translate;for(let o=0;o<e.length;o+=1){const d=e[o],c=d.progress,p=Math.min(Math.max(c,-4),4);let u=d.swiperSlideOffset;t.params.centeredSlides&&!t.params.cssMode&&(t.wrapperEl.style.transform=`translateX(${t.minTranslate()}px)`),t.params.centeredSlides&&t.params.cssMode&&(u-=e[0].swiperSlideOffset);let m=t.params.cssMode?-u-t.translate:-u,h=0;const f=-100*Math.abs(p);let g=1,v=-i.perSlideRotate*p,w=i.perSlideOffset-.75*Math.abs(p);const b=t.virtual&&t.params.virtual.enabled?t.virtual.from+o:o,y=(b===s||b===s-1)&&p>0&&p<1&&(n||t.params.cssMode)&&l<r,E=(b===s||b===s+1)&&p<0&&p>-1&&(n||t.params.cssMode)&&l>r;if(y||E){const e=(1-Math.abs((Math.abs(p)-.5)/.5))**.5;v+=-28*p*e,g+=-.5*e,w+=96*e,h=-25*e*Math.abs(p)+"%"}if(m=p<0?`calc(${m}px ${a?"-":"+"} (${w*Math.abs(p)}%))`:p>0?`calc(${m}px ${a?"-":"+"} (-${w*Math.abs(p)}%))`:`${m}px`,!t.isHorizontal()){const e=h;h=m,m=e}const x=p<0?""+(1+(1-g)*p):""+(1-(1-g)*p),S=`\n        translate3d(${m}, ${h}, ${f}px)\n        rotateZ(${i.rotate?a?-v:v:0}deg)\n        scale(${x})\n      `;if(i.slideShadows){let e=d.querySelector(".swiper-slide-shadow");e||(e=ge("cards",d)),e&&(e.style.opacity=Math.min(Math.max((Math.abs(p)-.5)/.5,0),1))}d.style.zIndex=-Math.abs(Math.round(c))+e.length;he(0,d).style.transform=S}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),fe({swiper:t,duration:e,transformElements:s})},perspective:()=>!0,overwriteParams:()=>({_loopSwapReset:!1,watchSlidesProgress:!0,loopAdditionalSlides:t.params.cardsEffect.rotate?3:2,centeredSlides:!0,virtualTranslate:!t.params.cssMode})})}];return re.use(ve),re}();
//# sourceMappingURL=swiper-bundle.min.js.map
(function($){

	$(document).ready(function(){

	 	$(document).on('click','.accordion-trigger',function(e){
	 		e.preventDefault();
	 		$trigger = $(this);
	 		$(this).toggleClass('open');
	 		$(this).parent().siblings('.accordion-group').find('.accordion-trigger').removeClass('open');
	 		$(this).parent().siblings('.accordion-group').find('.accordion-content').slideUp();
	 		$(this).siblings('.accordion-content').slideToggle(function(){
	 			if(!$trigger.hasClass('ss-membership-faq__question') && !$trigger.hasClass('pdp-faq__question')) {
	 				$('html,body').animate({ scrollTop: $(this).offset().top - 200 }, 500);
	 			}
	 		});
	 	});
		
	});

})(jQuery);
(function($){

	$(document).ready(function(){

	 	$(document).on('click', '.btn.anchor-link', function(e){
	 		e.preventDefault();
	 		$target = $(this).data('target');

	 		if($('#' + $target).length) {
	 			$('html, body').animate({ scrollTop: $('#' + $target).offset().top - 120 }, 500);
	 		}

	 	});
		
	});

})(jQuery);
(function($){

	$bucket = new Array();
	$bucket_max = 3;
	$bucket_actual_price = 0;
	$bucket_discounted_price = 0;
	$product_label = 'Product';

	$is_mini = $('#build-a-set__section.build-mini-set').length;
	$is_two_pack = $('#build-a-set__section.2-pack').length;

	if($is_mini) {
		$bucket_max = 4;
		$product_label = 'Mini';
	}

	if($is_two_pack) {
		$bucket_max = 2;
	}

	$(document).ready(function(){

		if($('#build-a-set__grid-right').length) {
			$('#build-a-set__grid-right').attr('data-height', $('#build-a-set__grid-right').outerHeight(true) + 50);
		}

	 	$(document).on('click','#build-a-set__nav .menu li',function(e){
	 		e.preventDefault();
	 		$(this).addClass('active').siblings().removeClass('active');
	 		$filter_class = $(this).data('filter');

	 		$('#build-a-set__products-grid').find('.ss-set-product').hide();
	 		$('#build-a-set__products-grid').find('.' + $filter_class).show();
	 	});

	 	$(document).on('click','#build-a-set__section .ss-set-product .btn-add-to-set, #build-a-set__section .ss-set-product .plus-qty',function(e){
			e.preventDefault();
			var $variant_id = $(this).data('variantId') || $(this).parents('.ss-set-product').data('variantId');
			add_item_to_set($variant_id, $(this));
		});

		$(document).on('click','#build-a-set__section .ss-set-product .minus-qty',function(e){
			e.preventDefault();
			var $variant_id = $(this).parents('.ss-set-product').data('variantId');
			remove_item_from_set($variant_id, $(this));
		});

		$(document).on('click','.set__item-remove',function(e){
			e.preventDefault();
			var $variant_id = $(this).data('variantId');
			$('#build-a-set__section .ss-set-product[data-variant-id="' + $variant_id + '"] .minus-qty').trigger('click');
		});

		$(document).on('click','.btn-link-to__anchor',function(e){
			e.preventDefault();
			var $target = $(this).data('target');

			if($('#' + $target).length) {
				$('html, body').animate({ scrollTop: $('#' + $target).offset().top - 120 }, 500);
			}
		});

		const form = document.getElementById('set__atc-wrapper');

		if(form) {
			form.addEventListener("submit", async(e) => {
				e.preventDefault();
				form.querySelector('.btn-add-set-to-cart').classList.add('is-adding');

				const bundleId = new Date().getTime();

				if($bucket.length == $bucket_max) {
					$items_array = new Array();

					for($i=0; $i<$bucket.length; $i++) {

						$variant_id = $bucket[$i];
						$element = $('#build-a-set__products-grid').find('.ss-set-product[data-variant-id="' + $variant_id + '"]');
						$product_title = $element.data('productTitle');
						$variant_title = $element.data('variantTitle');
						$item_title = $product_title + '***' + $variant_title;

						$item = { id: $bucket[$i], quantity: 1, properties: { _bundleId: bundleId , _itemProductTitle: $product_title, _itemVariantTitle: $variant_title } }

						if($is_mini) {
							$item.properties['_miniset'] = true;
						}

						$items_array.push($item);
					}
					
				}

				await fetch('/cart/add.js', {
		      		method: 'post',
		      		headers: {
		        		'Content-Type': 'application/json'
		      		},
			      	body: JSON.stringify({
			        	items: $items_array
			      	})
			    }).then(function(){
			    	form.querySelector('.btn-add-set-to-cart').classList.remove('is-adding');

			    	fbq('track', 'AddToCart', {
				        content_name: 'Custom Set', 
				        content_category: 'Sets',
				        content_ids: ['8612869832954'],
				        content_type: 'product',
				        value: $bucket_discounted_price / 100,
				        currency: Shopify.currency.active
			      	});

			    	/* dataLayer.push({ 'ecommerce': null });
			    	dataLayer.push({
			    		'event': 'add_to_cart',
			    		'ecommerce': {
			    			'currency': '{{ shop.currency }}',
			    			'value': $bucket_discounted_price,
			    			'items': [{'item_id': '{{ atc_product.id }}','item_name': 'Custom Set','item_brand': 'Salt&Stone','item_category': 'Sets','quantity': 1,'price': $bucket_discounted_price }] } }); */


			    	reset_interface();
			    });
			});
		}

		function update_price($current_obj, $action) {
			var $variant_price = $current_obj.parents('.ss-set-product').data('price');
			var $variant_discounted_price = $current_obj.parents('.ss-set-product').data('discountedPrice');

			if($action == 'plus') {
				$bucket_actual_price = parseFloat($bucket_actual_price) + parseFloat($variant_price);
				$bucket_discounted_price = parseFloat($bucket_discounted_price) + parseFloat($variant_discounted_price);	
			} else {
				$bucket_actual_price = parseFloat($bucket_actual_price) - parseFloat($variant_price);
				$bucket_discounted_price = parseFloat($bucket_discounted_price) - parseFloat($variant_discounted_price);	
			}
		}

		function update_quantity($current_obj, $action) {
			$current_count = parseInt($current_obj.parents('.ss-set-product').find('input').val());
			
			if($action == 'plus') {
				$current_count = $current_count + 1;	
			} else {
				$current_count = $current_count - 1;
			}
			
			$current_obj.parents('.ss-set-product').find('input').val($current_count);
		}
		

		function add_item_to_set($variant_id, $current_obj) {
			if($bucket.length < $bucket_max) {
				$bucket.push($variant_id);
				$current_obj.parents('.ss-set-product').addClass('is-active');
				update_quantity($current_obj, 'plus');
				update_price($current_obj, 'plus');
				update_set();
			} else {
				alert('You can add a maximum of 3 items to the bundle!');
			}
		}

		function remove_item_from_set($variant_id, $current_obj) {
			if($bucket.length > 0) {
				for($i=$bucket.length - 1;$i>=0;$i--) {
					if($variant_id == $bucket[$i]) {
						$bucket.splice($i,1);
						break;
					}
				}

				update_quantity($current_obj,'minus');
				update_price($current_obj,'minus');

				if($current_obj.parents('.ss-set-product').find('input').val() == 0) {
					$current_obj.parents('.ss-set-product').removeClass('is-active');
				}

				update_set();
			}
		}

		function reset_interface() {
			$bucket.length = 0;
			$bucket_actual_price = 0;
			$bucket_discounted_price = 0;
			$('.ss-set-product').find('input').val('0');
			$('.ss-set-product').removeClass('is-active');
			update_set();
		}


		function update_set() {

			// Update Set Count
			$('#build-a-set__section .set__count .count').text($bucket.length);

			// Enable/Disable Set ATC
			$set_atc = $('#build-a-set__section .btn-add-set-to-cart');

			if($bucket.length == $bucket_max) {

				// Enable SET ATC
				$discounted_money_format = window.cartStrings.cartCurrencySymbol + '{{amount}}';
				$price_money_format = window.cartStrings.cartCurrencySymbol + '{{amount}}';

				if($bucket_discounted_price % 100 == 0) {
					$discounted_money_format = window.cartStrings.cartCurrencySymbol + '{{amount_no_decimals}}';
				}	

				if($bucket_actual_price % 100 == 0) {
					$price_money_format = window.cartStrings.cartCurrencySymbol + '{{amount_no_decimals}}';
				}

				$set_atc.find('span').html('Add to Bag &ndash; <span class="discounted-price">' + theme.Currency.formatMoney($bucket_discounted_price, $discounted_money_format) + '</span><span class="actual-price">' + theme.Currency.formatMoney($bucket_actual_price, $price_money_format));
				$set_atc.removeAttr('disabled');


				// Disable all other buttons and quantity selectors
				$('.ss-set-product').addClass('set-full');
				$('#productModal .btn-add-to-set').addClass('set-full');

				$('#set__atc-wrapper').show();

			} else {
				$remaining_products = $bucket_max - $bucket.length;
				$atc_text =  $bucket.length + '/' + $bucket_max + ' products';

				// if($remaining_products > 1) {
				// 	$atc_text = $atc_text + 's';
				// }

				$set_atc.find('span').html($atc_text);
				$set_atc.attr('disabled',true);
				$('.ss-set-product').removeClass('set-full');
				$('#productModal .btn-add-to-set').removeClass('set-full');

				if($(window).width() < 992) {
					$('#set__atc-wrapper').hide();
				} else {
					$('#set__atc-wrapper').show();
				}

			}


			// Reset Bucket

			$set_items__html = '';

			if($bucket.length > 0) {				

				// Show items in bucket
				for($i=0; $i<$bucket.length; $i++) {
					$variant_id = $bucket[$i];

					$original_element = $('#build-a-set__products-grid').find('.ss-set-product[data-variant-id="' + $variant_id + '"]');
					$target_element = $('#build-a-set__section .set__contents .set__items .set__item:nth-child(' + ($i+1) + ')');

					$variant_image_url = $original_element.data('variantImage');
					$product_title = $original_element.data('productTitle');
					$variant_title = $original_element.data('variantTitle');
					$title_class = 'title';

					if($variant_title) {
						$variant_title = $variant_title.split('/')[0];
						$title_class = 'title-with-variant';
					}

					$discounted_price = parseFloat($original_element.data('discountedPrice'));
					$regular_price = parseFloat($original_element.data('price'));

					$discounted_money_format = window.cartStrings.cartCurrencySymbol + '{{amount}}';
					$price_money_format = window.cartStrings.cartCurrencySymbol + '{{amount}}';

					if($discounted_price % 100 == 0) {
						$discounted_money_format = window.cartStrings.cartCurrencySymbol + '{{amount_no_decimals}}';
					}	

					if($regular_price % 100 == 0) {
						$price_money_format = window.cartStrings.cartCurrencySymbol + '{{amount_no_decimals}}';
					}

					$variant_image_html = '<img src="' + $variant_image_url + '" class="objfit variant-image"><a href="#" class="set__item-remove" data-variant-id="' + $variant_id + '"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#DDDDDD"/><rect width="1.19175" height="12.7539" transform="matrix(0.717016 -0.697056 0.717016 0.697056 7 7.82812)" fill="black"/><rect width="1.19175" height="12.7539" transform="matrix(0.717016 0.697056 -0.717016 0.697056 16.1406 7.27344)" fill="black"/></svg></a>';

					
					$set_items__html += '<li class="set__item">'
					+ '<div class="image-wrapper">'
					+ $variant_image_html
					+ '</div>'
					+ '<div class="text-wrapper">'
					+ '<div class="product__meta">'
					+ '<div class="product__meta-wrapper g-flex">'
					+ '<div class="product__meta-left">'
					+ '<p class="product-title ' + $title_class + '">'
					+ '<span class="variant-product-title">'
					+ $product_title
					+ '</span>'
					+ '<span class="variant-title">'
					+ $variant_title
					+ '</span>'
					+ '</p>'
					+ '</div>'
					+ '<div class="product__meta-right">'
					+ '<div class="product__meta-price">'
					+ '<span class="discounted-price">'
					+ theme.Currency.formatMoney($discounted_price, $discounted_money_format)
					+ '</span>'
					+ '<span class="regular-price">'
					+ theme.Currency.formatMoney($regular_price, $price_money_format)
					+ '</span>'
					+ '</div>'
					+ '</div>'
					+ '</div>'
					+ '</div>'
					+ '</div>'
					+ '</li>';
				}
			}

			$cnt = 1;

			for($i = $bucket_max; $i > $bucket.length; $i--) {
				$set_items__html += '<li class="set__item">'
				+ '<div class="image-wrapper">'
                //+ '<svg class="plus-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8.5H14V7.5H2V8.5Z" fill="#A8A8A8"/><path d="M7.5 2L7.5 14H8.5L8.5 2L7.5 2Z" fill="#A8A8A8"/></svg>'
              	+ '</div>'
              	+ '<div class="text-wrapper">'
                + '<h3 class="set__item-placeholder-title sm-font-caps"><span class="d-none d-lg-block">Select Product</span><span class="d-block d-lg-none">' + $product_label + ' ' + ($bucket.length + $cnt) + '</span></h3>'
          		+ '</div>'
				+ '</li>';
				$cnt++;
			}

			$('#build-a-set__grid .set__items').html($set_items__html);

		}

	});

	// function updateElementPosition() {
	// 	var $div = document.getElementById('build-a-set__grid-left');
	// 	var $right_div = document.getElementById('build-a-set__grid-right');

	// 	if($div) {
	// 		var $rect = $div.getBoundingClientRect();
			
	// 		if($(window).width() < 992) {
	// 			if($rect.top <= 0) {
	// 				$('#build-a-set__section').css('marginTop', $right_div.dataset.height + 'px');
	// 				$right_div.classList.add('stuck');

	// 				setTimeout(function(){
	// 					$right_div.classList.add('shown');
	// 				}, 300);
	// 			} else {
	// 				$right_div.classList.remove('stuck','shown');
	// 				$('#build-a-set__section').css('marginTop', 0);
	// 			}
	// 		} else {
	// 			$right_div.classList.remove('stuck','shown');
	// 		}
	// 	}
	// }

	// Initial check
	// updateElementPosition();

	// Check on scroll
	// window.addEventListener('scroll', updateElementPosition);

	// Optional: Check on resize
	// window.addEventListener('resize', updateElementPosition);

})(jQuery);
(function($){

	$(document).ready(function(){

	 	$(document).on('click','.cart-upsell__action',function(e){
	 		e.preventDefault();
	 		$btn = $(this);
	 		$variant_id = $btn.data('variantId');
	 		$(this).addClass('is-adding');

	 		$.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: {
                    quantity: 1,
                    id: $variant_id
                },
                success: function(data) {
                    $btn.removeClass('is-adding');
                },
                error: function (data) {
                    alert('Something went wrong! Please try again.')
                    $btn.removeClass('is-adding');
                }
            });

	 	});
		
	});

})(jQuery);


document.addEventListener('rebuy:cart.enriched', (event) => { 

  	setTimeout(() => {

		// if(window.Rebuy && ($('body').data('country') == 'US' || $('body').data('country') == 'CA')) {

        if(window.Rebuy && $('body').data('country') == 'US') {

      		const subtotal = parseInt(window.Rebuy.Cart.subtotal() / 100);
      		$cartItems = window.Rebuy.SmartCart.items();

      		let $gift_bag = $cartItems.some(item => item.product.id === 8977976492282);

            if(document.querySelector('.cart-upsell') !== null) {
                
          		if(subtotal >= 50 && !$gift_bag) {
            		document.querySelector('.cart-upsell').classList.remove('hide');
            	} else {
            		document.querySelector('.cart-upsell').classList.add('hide');
          		}
            }
    	}

  	}, 0);
});
(function($){

    $(window).on('load',function(){
      /* if($('body').attr('id') == 'your-shopping-cart') {
        $('.js-drawer-open-button-right').trigger('click');  
      } */

      // alert(window.Rebuy.Cart.itemCount());

    });

    document.addEventListener('rebuy:cart.add', (event) => { 
      $('.btn--add-to-cart, .add-to-cart').removeClass('is-adding');
    });

    document.addEventListener('rebuy:cart.ready', (event) => { 
      updateCartCounter();
    });

    document.addEventListener('rebuy:cart.change', (event) => { 
      updateCartCounter();
    });

    function updateCartCounter() {
      if(window.Rebuy.Cart.itemCount() > 0) {
        $('.cart-counter').fadeIn();
      } else {
        $('.cart-counter').fadeOut();
      }
    }

    $(document).on('click','.site-header__right .cart-counter',function(e){
      Rebuy.SmartCart.show(e);
    });

    $(document).on('click','.btn--add-to-cart, .add-to-cart',function(e){
      $(this).addClass('is-adding');
    });

})(jQuery);
(function($){

  $(document).ready(function(){

    if($('body').hasClass('lock-collection') && !sessionStorage.getItem('lockCollection-' + $('body').data('collectionId')) && !sessionStorage.getItem('lockPDPCollection')) {
      $('#productLockModal').modal('show');
    }

  });

})(jQuery);
const sortSelect = document.querySelector("#sortBy");
const helperElement = document.querySelector(".helper-element");

if(sortSelect && helperElement) {
	document.addEventListener('DOMContentLoaded', initResize);
	sortSelect.addEventListener("change", initResize);
}

function initResize(event) {
	helperElement.innerHTML = event.target.querySelector("option:checked").innerText;
	resize(helperElement.offsetWidth);
}

function resize(width) {
	// const root = document.documentElement;
	const root = document.querySelector('.section-header');
	root.style.setProperty("--dynamic-size", `${width}px`);
	document.querySelector('.filter-dropdown').style.setProperty('opacity', 1);
}

(function($){

	if($('.collection-nav').length) {

		var current = $('.current');

		if($(window).width() < 768) {
			current[0].scrollIntoView({
	           	behavior: 'smooth',
	           	inline: 'center',
	           	block: 'nearest'
         	});	
		}
	}


	/* if($('.collection-nav').length) {

		var marker = $('#marker'), 
		 current = $('.current');
		
		current.addClass('active');

		if($(window).width() < 768) {
			current[0].scrollIntoView({
           	behavior: 'smooth',
           	inline: 'center',
           	block: 'nearest'
         });	
		}

		marker.css({
    		// Place the marker in the middle of the border
    		bottom: -(marker.height() / 2),
    		left: current.position().left,
    		width: current.outerWidth(),
    		display: "block"
		});

		$('li.collection-nav__item').mouseover(function () {
    		var self = $(this),
        	offsetLeft = self.position().left,
        	// Use the element under the pointer OR the current page item
        	width = self.outerWidth() || current.outerWidth(),
        	// Ternary operator, because if using OR when offsetLeft is 0, it is considered a falsy value, thus causing a bug for the first element.
        	left = offsetLeft == 0 ? 0 : offsetLeft || current.position().left;
  			// Play with the active class
    		$('.active').removeClass('active');
    		self.addClass('active');
    		marker.css({
        		left: left,
        		width: width,
    		});
		});

		$('.collection-nav ul.menu').mouseleave(function () {
  			// remove all active classes, add active class to the current page item
    		$('.active').removeClass('active');
    		current.addClass('active');
  			// reset the marker to the current page item position and width
    		marker.css({
        		left: current.position().left,
        		width: current.outerWidth()
    		});
		});
 	} */

})(jQuery);
(function($){

    document.addEventListener('rebuy:cart.enriched', (event) => { 

        setTimeout(() => {

            if($('body').hasClass('enable-freesamples')) {

                // Inject Complimentary Samples Button to Reby Cart

                $rebuy_cart_flyout_element = '.rebuy-cart__flyout-content'; 
                $rebuy_cart_items_element = '.rebuy-cart__flyout-content.has-items .rebuy-cart__flyout-items';
            
                $free_samples_btn_html = $('<div class="rebuy-cart__flyout-samples-action"><a href="#" data-bs-toggle="modal" data-bs-target="#complimentarySamplesModal" class="btn"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="5.0459" y1="2.18557e-08" x2="5.0459" y2="10" stroke="#010101"/><line y1="4.95459" x2="10" y2="4.95459" stroke="#010101"/></svg>Select Complimentary Sample</a></div>');

                $cart_items_json = JSON.stringify(event.detail.cart.items());

                if($($rebuy_cart_flyout_element).find('.rebuy-cart__flyout-samples-action').length == 0 && !$cart_items_json.includes('_ss_sample')) {
                    $free_samples_btn_html.insertAfter($rebuy_cart_items_element);
                }

                if($cart_items_json.includes('_ss_sample')) {
                    $('.rebuy-cart__flyout-content').find('.rebuy-cart__flyout-samples-action').remove();
                }



                // Clear Cart if it only contains samples

                $cart_items = window.Rebuy.SmartCart.items();
                $cart_items_length = $cart_items.length;

                if($cart_items_length > 0) {
                    
                    $samples_count = 0;

                    for(i=0;i<$cart_items_length;i++) {

                        if($cart_items[i].properties._ss_sample !== undefined) {
                            $samples_count++;
                        }
                    }

                    if($samples_count == $cart_items_length) {
                        fetch("/cart/clear.js")
                            .then((response) => response.json())
                            .catch((error) => {
                                console.error("Error fetching cart:", error);
                            })
                    }
                }


                // Remove Sample if it is not added from Modal

                $cart_items = window.Rebuy.SmartCart.items();
                $cart_items_length = $cart_items.length;

                if($cart_items_length > 0) {

                    for(i=0;i<$cart_items_length;i++) {

                        if($cart_items[i].properties._ss_sample !== undefined && $cart_items[i].properties._ss_sample !== 'valid') {

                            window.Rebuy.Cart.removeItem($cart_items[i]);
                        }
                    }
                }

            }


        }, 0);
      
    });

    $(document).ready(function(){

        $('#complimentarySamplesModal').on('show.bs.modal', function(e){
            $cart_items_json = JSON.stringify(window.Rebuy.SmartCart.items());

            $('#complimentarySamplesModal .sample-product').each(function(i, e){
                $sample_product_atc = $(this).find('.btn-sample--add-to-cart');
                $sample_product_variant = $(this).find('.btn-sample--add-to-cart').data('variantId');
                
                if($cart_items_json.includes($sample_product_variant)) {
                    $sample_product_atc.text('Added').addClass('is-added');
                } else {
                    $sample_product_atc.text('Add').removeClass('is-added');
                }
            });
        });


        $('#complimentarySamplesModal').on('hidden.bs.modal', function(e){
            
        });

    });

    $(document).on('click','.btn-sample--add-to-cart',function(e){
    
        var $btn = $(this);
        $btn.addClass('is-adding');

        var $all_btns = $('.sample-products .sample-product .btn-sample--add-to-cart');
        $all_btns.addClass('disabled');

        var $variant_id = $(this).data('variantId');


        fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {

                $add_sample = true;
            
                if (cart && cart.items.length > 0) {

                    $samples_count = 0;

                    for(i=0;i<cart.items.length;i++) {
                        if(cart.items[i].properties._ss_sample !== undefined) {
                            $samples_count++;
                        }
                    }

                    if($samples_count == 1  ) {
                        alert('You cannot add more than 1 sample!');
                        $btn.removeClass('is-adding').text('Error').addClass('is-added');
                        $('.sample-products .sample-product .btn-sample--add-to-cart').addClass('disabled');
                        $all_btns.removeClass('disabled');
                        $add_sample = false;
                    }
                }


                if($add_sample) {
                    $.ajax({
                        url: '/cart/add.js',
                        dataType: 'json',
                        type: 'post',
                        data: {
                            quantity: 1,
                            id: $variant_id,
                            properties: {
                              '_ss_sample': 'valid'
                            }
                        },
                        success: function(data) {
                            $btn.removeClass('is-adding').text('Added').addClass('is-added');
                            $all_btns.removeClass('disabled');

                            bootstrap.Modal.getInstance(document.getElementById('complimentarySamplesModal')).hide();
                        },
                        error: function (data) {
                            alert('Something went wrong! Please try again later.')
                            $btn.removeClass('is-adding').text('Error').addClass('is-added');
                            $all_btns.removeClass('disabled');
                        }
                    });
                }

            })
            .catch((error) => {
                console.error("Error fetching cart:", error);
            })
    });

})(jQuery);


document.addEventListener("DOMContentLoaded",()=>{
	const customMarquees = document.querySelectorAll(".ss-compliments-marquee");
    
  customMarquees.forEach((customMarquee)=>{
    const pauseOnHover = true;
  	const animationDuration = 80;
  	const marqueeWrap = customMarquee.querySelector(".marquee-wrap");
    
    const marqueeContain1 = customMarquee.querySelector(".marquee-container-1");
    const marqueeContain2 = customMarquee.querySelector(".marquee-container-2");
    const marqueeContain3 = customMarquee.querySelector(".marquee-container-3");
    const marqueeContain4 = customMarquee.querySelector(".marquee-container-4");
    
    //marqueeContain.remove();
    //marqueeWrap.append(marqueeContain1,marqueeContain2);
    
    // Store animations for pause/play control
    const animations = [];
    
    [marqueeContain1, marqueeContain2, marqueeContain3, marqueeContain4].forEach((element, index) => {
      // Create keyframes for the animation
      const keyframes = [
        { transform: 'translateX(0%)' },
        { transform: 'translateX(-100%)' }
      ];

      // Animation options
      const options = {
        duration: animationDuration * 1000, // Convert to milliseconds
        iterations: Infinity,
        easing: 'linear'
      };

      // Start the animation and store reference
      const animation = element.animate(keyframes, options);
      animations.push(animation);
    });
    
    // Add hover pause functionality if enabled
    if (pauseOnHover && window.innerWidth > 768) {
      marqueeWrap.addEventListener('mouseenter', () => {
        animations.forEach(animation => animation.pause());
      });

      marqueeWrap.addEventListener('mouseleave', () => {
        animations.forEach(animation => animation.play());
      });
    }

  });
});
(function($){

	$(document).ready(function(){

	 	/* if(!window.Cookies.get('user-country')) {
			$.getJSON('https://ipapi.co/json/', function(data){
				$('body').attr('data-country', data.country_code);
				window.Cookies.set('user-country', data.country_code);
			});
		} else {
			$('body').attr('data-country', window.Cookies.get('user-country'));
		} 

		if($('body').attr('data-country')) {
			$country = 'United States';
			if($('body').attr('data-country') == 'CA') {
				$country = 'Canada';
			}
			$('.user-country').text($country);
		}*/
		
	});

})(jQuery);
(function($){

    $(document).ready(function(){

        $('#crosssellModal').on('show.bs.modal', function(e){
            
        });


        $('#crosssellModal').on('hidden.bs.modal', function(e){
            window.Rebuy.SmartCart.skip_open = false;
            window.Rebuy.SmartCart.show();
        });

    });

})(jQuery);


(function($){

	$(document).ready(function(){

		$(document).on('click','.osano-optout-link',function(e){
			Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
		});
		
	});

})(jQuery);
(function($){

  document.addEventListener('rebuy:cart.change', (event) => { 

    $cart_variant_ids = new Array();

    if(window.Rebuy.SmartCart && window.Rebuy.SmartCart.hasItems()) {
      $items = window.Rebuy.SmartCart.items();
      for(i=0;i<$items.length;i++) {
        $cart_variant_ids.push($items[i].id);
      }
    }

    sessionStorage.setItem('ssCartItems', JSON.stringify($cart_variant_ids));

  });

  document.addEventListener('rebuy:cart.enriched', (event) => {

    

  });

  document.addEventListener('rebuy:cart.add', (event) => {

    if(!sessionStorage.getItem('crosssellShown') && event.detail.item && event.detail.item.selling_plan_allocation == undefined) {

    if(event.detail.item && event.detail.item.properties && event.detail.item.properties._addtocart_source !== undefined && event.detail.item.properties._addtocart_source == 'PDP') {

      $added_variant_id = event.detail.item.id;
      $added_variant_key = event.detail.item.key;
      $added_variant_qty = event.detail.item.quantity;
      $added_variant_product_title = event.detail.item.product_title;
      $added_variant_title = event.detail.item.variant_title.split(" / ")[0];

      if(typeof $crosssell_array !== 'undefined') {

        for(i=0;i<$crosssell_array.length;i++) {

          if($added_variant_id == $crosssell_array[i].id) {

            $crosssell_id = $crosssell_array[i].crosssell_variant_id;
            $crosssell_variant_title = $crosssell_array[i].crosssell_variant_title.split(" / ")[0];
            $crosssell_variant_product_title = $crosssell_array[i].crosssell_variant_product_title;

            if(sessionStorage.getItem('ssCartItems')) {
              $cart_variant_ids = JSON.parse(sessionStorage.getItem('ssCartItems'));

              if($cart_variant_ids.includes($crosssell_id)) {
                break;
              }
            }

            window.Rebuy.SmartCart.skip_open = true;

            $crosssell_modal = $('#crosssellModal');
            $crosssell_modal_body = $crosssell_modal.find('.modal-body__content');

            $crosssell_title = $crosssell_array[i].crosssell_title;
            $crosssell_top_tag = $crosssell_array[i].crosssell_top_tag;
            $crosssell_featured_image = $crosssell_array[i].crosssell_featured_image;
            $crosssell_description = $crosssell_array[i].crosssell_description;
            $crosssell_price = $crosssell_array[i].crosssell_variant_price;
            $show_crosssell_product_variants = $crosssell_array[i].show_crosssell_product_variants;
            $crosssell_product_variants = $crosssell_array[i].crosssell_product_variants;
            $crosssell_current_variant_label = $crosssell_array[i].crosssell_current_variant_label;
            $crosssell_create_virtual_set = $crosssell_array[i].crosssell_create_virtual_set;
            $crosssell_virtual_set_title = $crosssell_array[i].crosssell_virtual_set_title;
            $crosssell_virtual_set_image = $crosssell_array[i].crosssell_virtual_set_image;
            $crosssell_virtual_set_discount_percent = $crosssell_array[i].crosssell_virtual_set_discount_percent;
            $crosssell_swap_variant = $crosssell_array[i].crosssell_swap_variant;

            $crosssell_modal_body.text('');

            if($crosssell_top_tag != '') {
              $product_top_tag_element = '<p class="product-tag">' + $crosssell_top_tag + '</p>';
              $crosssell_modal_body.append($product_top_tag_element);
            }

            if($crosssell_title != '') {
              $product_title_element = '<h2 class="product-title">' + $crosssell_title + '</h2>';
              $crosssell_modal_body.append($product_title_element);
            }

            if($crosssell_featured_image != '') {
              $product_image_element = '<img class="product-image img-fluid" src="' + $crosssell_featured_image + '">';
              $crosssell_modal_body.append($product_image_element);
            }

            if($show_crosssell_product_variants == 'true' && $crosssell_product_variants) {
              $crosssell_modal_body.append('<label class="choose-scent-label">Choose Your Scent</label>');
              $crosssell_modal_body.append($crosssell_product_variants);
              $crosssell_modal_body.append('<div class="variant-title">' + $crosssell_current_variant_label + '</div>');
            }

            if($crosssell_description) {
              $product_description_element = '<div class="product-description">' + $crosssell_description + '</div>';
              $crosssell_modal_body.append($product_description_element);
            }

            $crosssell_modal_body.append('<button class="btn btn-flyout--add-to-cart add-to-cart" data-variant-id="' + $crosssell_id + '" data-variant-title="' + $crosssell_variant_title + '" data-variant-product-title="' + $crosssell_variant_product_title + '" data-added-variant-id="' + $added_variant_id + '" data-added-variant-key="' + $added_variant_key + '" data-added-variant-qty="' + $added_variant_qty + '" data-added-variant-title="' + $added_variant_title +'" data-added-variant-product-title="' + $added_variant_product_title + '" data-virtual-set="' + $crosssell_create_virtual_set + '" data-virtual-set-title="' + $crosssell_virtual_set_title + '" data-virtual-set-image="' + $crosssell_virtual_set_image + '" data-virtual-set-discount-percent=' + $crosssell_virtual_set_discount_percent + ' data-swap-variant="' + $crosssell_swap_variant + '">Add &ndash; ' + $crosssell_price + '</button><div class="text-center"><a href="#" data-bs-dismiss="modal" aria-label="Close" class="skip-link">Skip to Bag</a></div>');
            
            $crosssell_modal.modal('show');
            sessionStorage.setItem('crosssellShown', 1);
            break;
          }
        }
      }
    }

    }
  });

  $(document).on('click','.btn-flyout--add-to-cart',function(e){
    
    var $btn = $(this);
    $btn.addClass('is-adding');

    var $variant_id = $btn.data('variantId');
    var $variant_title = $btn.data('variantTitle');
    var $variant_product_title = $btn.data('variantProductTitle');
    var $is_exitpopup = $btn.hasClass('exitpopup-btn');
    var $virtual_set = $btn.data('virtualSet');
    var $swap_variant = $btn.data('swapVariant');

    if($virtual_set) {
      
      $added_variant_id = $btn.data('addedVariantId');
      $added_variant_qty = $btn.data('addedVariantQty');
      $added_variant_key = $btn.data('addedVariantKey');
      $added_variant_title = $btn.data('addedVariantTitle');
      $added_variant_product_title = $btn.data('addedVariantProductTitle');

      $virtual_set_title = $btn.data('virtualSetTitle');
      $virtual_set_image = $btn.data('virtualSetImage');
      $virtual_set_discount_percent = $btn.data('virtualSetDiscountPercent');

      // Remove Previous Added Variant from Cart

      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: {
          id: $added_variant_key,
          quantity: $added_variant_qty - 1
        },
        success: function(data) {

          // Add Bundle

          const bundleId = new Date().getTime();
          $items_array = new Array();

          $item1 = {
            id: $added_variant_id,
            quantity: 1,
            properties: {
              _bundleId: bundleId,
              _itemProductTitle: $added_variant_product_title,
              _itemVariantTitle: $added_variant_title,
              _virtualset: true,
              _virtualsetDiscount: $virtual_set_discount_percent,
              _setTitle: $virtual_set_title,
              _setImage: $virtual_set_image
            }
          }

          $item2 = {
            id: $variant_id,
            quantity: 1,
            properties: {
              _bundleId: bundleId,
              _itemProductTitle: $variant_product_title,
              _itemVariantTitle: $variant_title,
              _virtualset: true,
              _virtualsetDiscount: $virtual_set_discount_percent,
              _setTitle: $virtual_set_title,
              _setImage: $virtual_set_image,
              _ss_original_variant: $added_variant_id,
              _ss_item_source: 'PDP Popup'
            }
          }

          $items_array.push($item1);
          $items_array.push($item2);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: $items_array }),
          })
          .then(response => response.json())
          .then(data => {
            // Handle the response, e.g., update the cart UI
            $('#crosssellModal').modal('hide');
            $btn.removeClass('is-adding');
          })
          .catch(error => {
            console.error('Error:', error);
            // Handle errors
            alert('Something went wrong! Please try again later.')
            $('#crosssellModal').modal('hide');
            $btn.removeClass('is-adding');
          });

        },
        error: function(data) {
          alert('Something went wrong! Please try again later.')
          $('#crosssellModal').modal('hide');
          $btn.removeClass('is-adding');
        }
      });

    } else if($swap_variant) {
      $added_variant_id = $btn.data('addedVariantId');
      $added_variant_qty = $btn.data('addedVariantQty');
      $added_variant_key = $btn.data('addedVariantKey');

      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: {
          id: $added_variant_key,
          quantity: $added_variant_qty - 1
        },
        success: function(data) {

          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: {
              quantity: 1,
              id: $swap_variant,
              properties: {
                '_ss_original_variant': $added_variant_id,
                '_ss_item_source': 'PDP Popup'
              }
            },
            success: function(data) {
              $('#crosssellModal').modal('hide');
              $btn.removeClass('is-adding');
            },
            error: function (data) {
              alert('Something went wrong! Please try again later.')
              $('#crosssellModal').modal('hide');
              $btn.removeClass('is-adding');
            }
          });

        },
        error: function(data) {
          alert('Something went wrong! Please try again later.')
          $('#crosssellModal').modal('hide');
          $btn.removeClass('is-adding');
        }
      });



    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: {
          quantity: 1,
          id: $variant_id,
          properties: {
            '_ss_item_source': 'PDP Popup'
          }
        },
        success: function(data) {
          if($is_exitpopup) {
            $('.close-exitpopup--trigger').trigger('click');
          } else {
            $('#crosssellModal').modal('hide');
          }
          $btn.removeClass('is-adding');
        },
        error: function (data) {
          alert('Something went wrong! Please try again later.')
          $('#crosssellModal').modal('hide');
          $btn.removeClass('is-adding');
        }
      });
    }
  });

})(jQuery);
(function($){

	$(document).ready(function(){

		/* if("ontouchstart" in window || "ontouch" in window) {
		} else {
			var $nav_sublist = $('.desktop-nav__sublist');
			var $main_nav = $('#desktop-nav');

			if($main_nav.length && $nav_sublist.length) {
				$nav_sublist.css('width', $main_nav.outerWidth() * 2);
			}

		 	var $nav_item = $('.desktop-nav__item');

	      	$nav_item.hover(function(){
		        var $button = $(this).find('.desktop-nav__toggle-btn');
		        var currentlyExpanded = $button.attr('aria-expanded');
		        var toggleState = false;
		        // Updated aria-expanded value based on state pre-click
		        if (currentlyExpanded === 'true') {
		          $button.attr('aria-expanded', 'false');
		        } else {
		          $button.attr('aria-expanded', 'true');
		          toggleState = true;
		        }

		        // Toggle that expands/collapses sublist
		        $button
		          .closest('.desktop-nav__has-sublist')
		          .toggleClass('desktop-nav--expanded', toggleState)
		          .next()
		          .toggle();

		        // Custom
		        $button
		    	  .closest('.desktop-nav__item')
		    	  .siblings()
		    	  .find('.desktop-nav__has-sublist')
		    	  .removeClass('desktop-nav--expanded')
		    	  .find('.desktop-nav__toggle-btn')
		    	  .attr('aria-expanded', 'false')
		    	  .parent()
		    	  .siblings('.desktop-nav__sublist').hide();
	      	});
      	} */	
	});

})(jQuery);
async function copyTextToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
  }
}

(function($){

  $(document).ready(function(){

    const urlParams = new URLSearchParams(window.location.search);
    const showDiscountCode = urlParams.get('discount_code') === 'show';

    if(showDiscountCode) {
      $('body').addClass('discount-modal-active');
      $('#discountModal').modal('show');
    }

    $('#discountModal, #quizDiscountModal').on('hidden.bs.modal', function(e){
      $('body').removeClass('discount-modal-active');
    });

    $(document).on('click','#discountModal .btn-copy-discount',function(e){
      e.preventDefault();
      $btn = $(this);
      $btn.text('Copied!');
      copyTextToClipboard($btn.siblings('input[name="discount_code"]').val());
      setTimeout(function(){
        $('#discountModal').modal('hide');
      }, 1000);
    });


    $(document).on('click','#quizDiscountModal .btn-copy-discount',function(e){
      e.preventDefault();
      $btn = $(this);
      $btn.text('Applied!');
      copyTextToClipboard($btn.siblings('input[name="discount_code"]').val());
      setTimeout(function(){
        $('#quizDiscountModal').modal('hide');
      }, 1000);
    });


  });

})(jQuery);
(function($){

	$(document).ready(function(){

	 	/* var $nav_item = $('.mobile-nav__item');

      	$nav_item.hoverIntent(function(){
	        var $button = $(this).find('.mobile-nav__toggle-btn');
	        var currentlyExpanded = $button.attr('aria-expanded');
	        var toggleState = false;
	        // Updated aria-expanded value based on state pre-click
	        if (currentlyExpanded === 'true') {
	          $button.attr('aria-expanded', 'false');
	        } else {
	          $button.attr('aria-expanded', 'true');
	          toggleState = true;
	        }

	        // Toggle that expands/collapses sublist
	        $button
	          .closest('.mobile-nav__has-sublist')
	          .toggleClass('mobile-nav--expanded', toggleState)
	          .next()
	          .slideToggle();

	        // Custom
	        $button
	    	  .closest('.mobile-nav__item')
	    	  .siblings()
	    	  .find('.mobile-nav__has-sublist')
	    	  .removeClass('mobile-nav--expanded')
	    	  .find('.mobile-nav__toggle-btn')
	    	  .attr('aria-expanded', 'false')
	    	  .parent()
	    	  .siblings('.mobile-nav__sublist').slideUp();
      	}); */
		
	});

})(jQuery);
(function($){

	$(document).ready(function(){

	 	/* $(document).on('click','#addtocart-floating-button',function(e){
	 		e.preventDefault();
	 		if($(this).hasClass('disabled')) { return; }
	 		$('[data-product-form]').trigger('submit');
	 	});

	 	$(window).on('resize scroll',function(){
	 		y = $(window).scrollTop();
	 		$floating_btn = $('#addtocart-floating-button__wrapper');
	 		var elementTop = 0;

	 		if($floating_btn.length) {

	 			if($('body').hasClass('custom-product-bundle')) {
	 				elementTop = $('#ProductBundleForm').offset().top;	
	 			} else {
	 				elementTop = $('.product-single__form').offset().top;	
	 			}

	 			if(y >= elementTop) {
	 				$floating_btn.addClass('push-up');
	 			}

	 			if(y < elementTop) {
					$floating_btn.removeClass('push-up');
				}
	 		}
	 	}); */
		
	});

})(jQuery);
(function($){

	document.addEventListener('DOMContentLoaded', function(){
		const fgcElement = document.querySelector('.free-gift-component');

		if(fgcElement) {
			fgcElement.classList.add('active');
		}
	});

	$(document).on('click','.close-component',function(e){
		e.preventDefault();

		$(this).parent('.free-gift-component').removeClass('active');
	});

})(jQuery);

(function($){

	$(window).on('load', function(){
		setTimeout(function(){
			if($('#geoip-banner').length) {
				$('#geoip-banner').find('.geoip-popup-banner').append('<h2 id="geoip-title">Confirm Store</h2>');

				if($('body').hasClass('has-popup')) {
					$('#geoip-banner').addClass('with-popup');
				}

				$('#geoip-banner .geoip-popup-banner').css('opacity', 1);
			}	
		}, 1200);
		
	});

})(jQuery);
(function($){

	queryMap = {};
	timeout = '';
	searchElement = document.getElementById('Search');
	searchInput = searchElement.querySelector('.Search__Input');
	searchResultsElement = searchElement.querySelector('.Search__Results');

	$(document).ready(function(){

		$(document).on('click','.js-open-search',function(e){
			e.preventDefault();
			$(this).toggleClass('search-open');

			$is_search_open = $(this).hasClass('search-open');

			if($is_search_open) {
				openSearch();
			} else {
				closeSearch();
			}
		});

		$(document).on('click','.js-close-search, #Search__Overlay',function(e){
			e.preventDefault();
			closeSearch();
		});

		var debounce = function (func, wait, immediate) {
		     var timeout;
		     return function() {
		         var context = this, args = arguments;
		         var later = function() {
		                 timeout = null;
		                 if (!immediate) func.apply(context, args);
		         };
		         var callNow = immediate && !timeout;
		         clearTimeout(timeout);
		         timeout = setTimeout(later, wait);
		         if (callNow) func.apply(context, args);
		     };
		};

		$('#Search .Search__Input').keyup(debounce(function(event){

			if (event.keyCode === 13 || $('body').hasClass('template-search')) {
	          	return;
	        }

			lastInputValue = event.target.value;
			
			if (lastInputValue === '') {
	        	clearResults();
	          	return;
	        }

	        var queryOptions = { method: 'GET', credentials: 'same-origin' };

	        var queries = [fetch('/search?view=ajax&q=*' + encodeURIComponent(lastInputValue) + '*&type=product', queryOptions)];

	        queryMap[lastInputValue] = true;

	        Promise.all(queries).then(function (responses) {
	          
	          if (lastInputValue !== event.target.value) {
	            return;
	          }

	          delete queryMap[event.target.value];

	          Promise.all(responses.map(function (response) {
	            return response.text();
	          })).then(function (contents) {
              	searchResultsElement.innerHTML = contents[0];
	           	searchResultsElement.setAttribute('aria-hidden', 'false');
	          });
	        });


		}, 200));


		function openSearch() {
			$('body').addClass('js-search-open js-drawer-open');
			$('#Search').attr('aria-hidden','false');
			setTimeout(function(){
				$('#Search').find('.Search__Input').focus();
			}, 150);
		}

		function closeSearch() {
			$('.js-open-search').removeClass('search-open');
			$('body').removeClass('js-search-open js-drawer-open');
			$('#Search').removeAttr('aria-hidden');

			setTimeout(function(){
				clearResults();
			}, 500);
		}

		function clearResults() {
			searchResultsElement.innerHTML = '';
			searchResultsElement.setAttribute('aria-hidden', 'true');
			searchInput.value = '';
		}

	});

})(jQuery);

(function($){

	$(document).ready(function(){

		var $swiperSelector = $('.images-with-cta__grid-slider .swiper');
		
		$swiperSelector.each(function(index) {
    		var $this = $(this);
    		$this.addClass('swiper-images-with-cta-slider-' + index);
    		$slidesPerView = 'auto';

    		var swiper = new Swiper('.swiper-images-with-cta-slider-' + index, {
      			slidesPerView: $slidesPerView,
      			spaceBetween: 16,
      			slidesOffsetAfter: 16,
      			loop: false,
      			centeredSlides: false,
      			speed: 500,
      			cssMode: false,
      			freeMode: {
      				enabled: false
      			},
      			mousewheel: {
      				enabled: true,
    				sensitivity: 3,
    				forceToAxis: true,
    				thresholdDelta: 250,
    				thresholdTime: 1200
      			},
      			scrollbar: {
      				el: $(this).find('.swiper-scrollbar'),
        			draggable: true,
        			dragSize: 85,
        			enabled: false,
        			snapOnRelease: false
      			},

      			breakpoints: {

      				768: {
      					slidesPerView: $slidesPerView,
      					centeredSlides: false,
      					loop: false,
      					cssMode: false,
      					spaceBetween: 24,
      					slidesOffsetAfter: 24,
      					speed: 2000,
      					scrollbar: {
		        			enabled: true
		      			},
		      			freeMode: {
		      				enabled: true,
		      				sticky: false,
		      				momentum: true,
		      				momentumRatio: 5,
		    				momentumBounce: true
		      			}
      				},

      				992: {
      					slidesPerView: $slidesPerView,
      					centeredSlides: false,
      					loop: false,
      					cssMode: false,
      					spaceBetween: 32,
      					speed: 2000,
      					slidesOffsetAfter: 32,
      					scrollbar: {
		        			enabled: true
		      			},
		      			freeMode: {
		      				enabled: true,
		      				sticky: false,
		      				momentum: true,
		      				momentumRatio: 5,
		    				momentumBounce: true
		      			}
      				}
      			}
      			
   			});
		}); 
		
	});

	

})(jQuery);
(function(a){function d(e){0<e.clientY||(b&&clearTimeout(b),0>=a.exitIntent.settings.sensitivity?a.event.trigger("exitintent"):b=setTimeout(function(){b=null;a.event.trigger("exitintent")},a.exitIntent.settings.sensitivity))}function c(){b&&(clearTimeout(b),b=null)}var b;a.exitIntent=function(b,f){a.exitIntent.settings=a.extend(a.exitIntent.settings,f);if("enable"==b)a(window).mouseleave(d),a(window).mouseenter(c);else if("disable"==b)c(),a(window).unbind("mouseleave",d),a(window).unbind("mouseenter",
c);else throw"Invalid parameter to jQuery.exitIntent -- should be 'enable'/'disable'";};a.exitIntent.settings={sensitivity:300}})(jQuery);
(function($){

	if($('#klaviyo_footer_form').length) {

		KlaviyoSubscribe.attachToForms('#klaviyo_footer_form', {
	        hide_form_on_success: false,
	        success_message: 'Thanks for subscribing!',
	        extra_properties: {
	          $source: 'Website Footer'
	        },
	        success: function ($form) {
	          $form.find('#k_id_email').attr('placeholder','Thank you');
	          $form.find('#k_id_email').attr('readonly', true);
	          $form.find('#k_id_email').addClass('subscribed');
	          $form.find('.klaviyo_submit_button').hide();
	          setup_cookie();
	        }
	    });

   	}

   	if($('#klaviyo_popup_form').length) {

		KlaviyoSubscribe.attachToForms('#klaviyo_popup_form', {
	        hide_form_on_success: false,
	        success_message: 'Thanks for subscribing!',
	        extra_properties: {
	          $source: 'Website Popup'
	        },
	        success: function ($form) {
          		$form.find('#k_id_email').attr('placeholder','Thank you');
	          	$form.find('#k_id_email').attr('readonly', true);
	          	$form.find('#k_id_email').addClass('subscribed');
	          	$form.find('.klaviyo_submit_button').hide();
	          	setup_cookie();
	        }
	    });
   	}

   	if($('#klaviyo_leadgen_form').length) {

		KlaviyoSubscribe.attachToForms('#klaviyo_leadgen_form', {
	        hide_form_on_success: false,
	        success_message: 'Thanks for subscribing!',
	        extra_properties: {
	          $source: 'Website Leadgen'
	        },
	        success: function ($form) {
          		$form.find('#k_id_email').attr('placeholder','Thank you');
	          	$form.find('#k_id_email').attr('readonly', true);
	          	$form.find('#k_id_email').addClass('subscribed');
	          	$form.find('.klaviyo_submit_button').hide();
	          	setup_cookie();
	        }
	    });
   	}

   	if($('#klaviyo_international_form').length) {

		KlaviyoSubscribe.attachToForms('#klaviyo_international_form', {
	        hide_form_on_success: true,
	        success_message: 'Thanks for subscribing!',
	        extra_properties: {
	        	$source: 'International Popup'
	        },
	        success: function ($form) {
	        	$form.parents('#internationalPopup').find('.title').text('Thank you!');
          		$form.find('.select-country__wrapper').hide();
          		$form.siblings('.btn-dismiss').removeClass('hide');
	          	// setup_cookie();
	        }
	    });
   	}

   	if($('#waitlist-newsletter-form').length) {

		KlaviyoSubscribe.attachToForms('#waitlist-newsletter-form', {
	        hide_form_on_success: false,
	        success_message: 'Thanks for subscribing!',
	        extra_properties: {
	          $source: 'Waitlist'
	        },
	        success: function ($form) {
	        	$form.hide();
      			$form.siblings('.thanks-content').fadeIn('fast');
	        }
	    });
   	}

   	$(document).on('click','#ss-popup .popup-close__trigger',function(e){
   		e.preventDefault();
   		setup_cookie();
   		$('#ss-popup').removeClass('slide');
   	});

   	$(document).on('click','.announcement-close__trigger',function(e){
   		e.preventDefault();
   		setup_announcement_cookie();
   		$('#ss-announcement').removeClass('slide');
   	});

   	$(window).on('load',function(e){
		// slide_popup();
		slide_announcement();
	});

	function slide_popup() {

		if(!Cookies.get('ss-newsletter')) {
      		setTimeout(function(){
          		$("#ss-popup").addClass("slide");
          		$('body').addClass('has-popup');
          		setup_cookie();
      		}, 1000);
      	}
	}

	function slide_announcement() {

		if(!sessionStorage.getItem('ss-announcement')) {

			if($('#ss-announcement').length) {
				if($('#ss-announcement').hasClass('with-popup') && !Cookies.get('ss-newsletter')) {
					var announcement_distance = 11;
					var bottom_margin = 16;

					if($(window).width() >= 768 && $(window).width() <= 991) {
						bottom_margin = 24;
					}

					if($(window).width() >= 992) {
						bottom_margin = 32;
					}

					var $popup_height = $('#ss-popup').outerHeight(true) + announcement_distance + bottom_margin;
					$('#ss-announcement').css('bottom', $popup_height + 'px');
				}				
			}

      		setTimeout(function(){
          		$("#ss-announcement").addClass("slide");
          		// setup_announcement_cookie();
      		}, 2000);
      	}
	}

})(jQuery);

function setup_cookie() {
   	if(!Cookies.get('ss-newsletter')) {
		Cookies.set('ss-newsletter', '1', { expires: 45 });
	}
}

function setup_announcement_cookie() {
	if(!sessionStorage.getItem('ss-announcement')) {
		sessionStorage.setItem('ss-announcement', '1');
	}
}
(function($){

	$(document).ready(function(){

		$('a').each(function(){

			var a = new RegExp('/' + window.location.host + '/');

			if(!a.test(this.href) && this.href.indexOf('mailto') != 0 && this.href.indexOf('tel') != 0 && !this.classList.contains('sephora-link') && !this.classList.contains('sephora-continue-btn')) {
				$(this).prop('target','_blank');
			}

		});

	});

})(jQuery);
(function($){

	$(document).ready(function() {

		$(document).on('click','#mobile-menu li a',function(e){
			var $target = $(this).data('target');

			if($target !== undefined) {
				e.preventDefault();
				$('#mobile-menu__wrapper').hide();
				$('#' + $target).addClass('active');	
				$('.mobile-menu__submenu__close').addClass('active');
			}
		});

		$(document).on('click','.mobile-menu__submenu__close',function(e){
			$('.mobile-menu__submenu').removeClass('active');
			$('#mobile-menu__wrapper').fadeIn();
			$('.mobile-menu__submenu__close').removeClass('active');
		});

		$(document).on('click','#MobileDrawer-Overlay',function(e){
			e.preventDefault();
			timber.LeftDrawer.close(e);
		});	

	});

})(jQuery);
const $page_ids = ['quiz','scent-quiz','quiz-scent10','quiz-scent15','quiz-naturalworld'];

(function($){

	$(document).ready(function(){

		if($page_ids.includes($('body').attr('id'))) {

			// Preload Images

			const imageUrls = [
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-scent-floral.jpg?v=1769487285',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-scent-warm.jpg?v=1769487306',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-scent-woody.jpg?v=1770315667',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-scent-citrus.jpg?v=1769487383',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-scent-sweet.jpg?v=1769487385',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-place-forest.jpg?v=1770149301',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-place-balcony.jpg?v=1770149301',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-place-fire.jpg?v=1770149529',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-place-hike.jpg?v=1770149303',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-place-trees.jpg?v=1770149301',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-place-seaside.webp?v=1780526138',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-place-horizon.webp?v=1787685661',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-routine-shower.jpg?v=1769488570',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-routine-post-shower.jpg?v=1769488572',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-routine-home.jpg?v=1769488576',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-routine-go.jpg?v=1769488579',
			  'https://cdn.shopify.com/s/files/1/1916/1271/files/img-routine-everywhere.jpg?v=1769488582',
			];

			imageUrls.forEach(url => {
			  new Image().src = url;
			});


			$(document).on('mouseenter', '.oct-quiz-multiple-choice-options li', function(e){

				$label = $(this).find('div:first-child').text().toLowerCase();
				
				if($label.includes('forest')) {
					$label = 'forest';
				} else if($label.includes('balcony')) {
					$label = 'balcony';
				} else if($label.includes('fire')) {
					$label = 'fire';
				} else if($label.includes('drive')) {
					$label = 'drive';
				} else if($label.includes('trees')) {
					$label = 'trees';
				} else if($label.includes('seaside')) {
					$label = 'seaside';
				} else if($label.includes('post-shower')) {
					$label = 'post-shower';
				} else if($label.includes('shower')) {
					$label = 'shower';
				} else if($label.includes('home')) {
					$label = 'home';
				} else if($label.includes('go')) {
					$label = 'go';
				} else if($label.includes('Everywhere')) {
					$label = 'everywhere';
				} else if($label.includes('horizon')) {
					$label = 'horizon';
				}

				$('.ocg-quiz-wrapper-side__image').attr('data-image', $label);
			});
		}

	});

	$(document).on('click','.btn-octane__add-to-cart',function(e){
 		e.preventDefault();

 		if($(window).width() > 991) {
 			window.Rebuy.SmartCart.skip_open = true;	
 		} else {
 			window.Rebuy.SmartCart.skip_open = false;	
 		}

 		$btn = $(this);
 		$variant_id = $btn.data('variantId');
 		$(this).addClass('is-adding');

 		$.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: {
                quantity: 1,
                id: $variant_id
            },
            success: function(data) {
                $btn.removeClass('is-adding');
            },
            error: function (data) {
                alert('Something went wrong! Please try again.')
                $btn.removeClass('is-adding');
            }
        });

 	});

})(jQuery);

document.addEventListener('rebuy:smartcart.ready', (event) => {
	if($page_ids.includes($('body').attr('id'))) {
  		window.Rebuy.SmartCart.skip_open = true;
  	}
});

document.addEventListener('rebuy:cart.change', (event) => { 
	if($page_ids.includes($('body').attr('id')) && jQuery('.octane__cart').length) {
		octane_getCartContents();
	}
});

function octane_change_cartitem($variant_id, $action = 'remove', $quantity = 0) {
	$('.octane__cart-items').addClass('processing');
	window.Rebuy.SmartCart.skip_open = true;

	if($action == 'update_plus') {
		$quantity = $quantity + 1;
	} else if($action == 'update_minus') {
		$quantity = $quantity - 1;
	}

	$.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: {
            quantity: $quantity,
            id: $variant_id
        },
        success: function(data) {
            
        },
        error: function (data) {
            alert('Something went wrong! Can\'t remove item.');
        },
        complete: function() {
        	$('.octane__cart-items').removeClass('processing');
        }
    });
}

async function octane_getCartContents() {

	try {
		const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');

		if (!cartResponse.ok) {
      		throw new Error(`HTTP error! status: ${cartResponse.status}`);
    	}

    	const cart = await cartResponse.json();

    	if(cart && cart.items.length > 0) {

    		document.querySelector('.octane__cart-contents').classList.remove('empty');

    		const items = cart.items;
    		$cart_items_html = '<div class="octane__cart-items">';

    		$free_items_html = '';
    		$paid_items_html = '';

    		items.forEach((item,index) => {

    			$money_format = window.cartStrings.cartCurrencySymbol + '{{amount}}';
    			$subtotal_money_format = window.cartStrings.cartCurrencySymbol + '{{amount}}';

    			if(item.final_line_price % 100 == 0) {
					$money_format = window.cartStrings.cartCurrencySymbol + '{{amount_no_decimals}}';
				}

				if(cart.total_price % 100 == 0) {
					$subtotal_money_format = window.cartStrings.cartCurrencySymbol + '{{amount_no_decimals}}';
				}

				$final_line_price = item.final_line_price == 0 ? 'FREE' : removeZerosRoundOff(theme.Currency.formatMoney(item.final_line_price, $subtotal_money_format));

				$item_class = $final_line_price == 'FREE' ? 'free-item' : '';

    			$item_html = `<div class="octane__cart-item ` + $item_class + `">
    				<div class="octane__cart-item-media">
    					<img class="objfit" src="` + item.image + `&width=600">`;

    					if($final_line_price !== 'FREE') {
    						$item_html += `<button type="button" alt="Remove ` + item.product_title + `" aria-label="Remove ` + item.product_title + `" class="rebuy-cart__flyout-item-remove" onclick="octane_change_cartitem(` + item.id + `);"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#DDDDDD"></circle> <rect width="1.19175" height="12.7539" transform="matrix(0.717016 -0.697056 0.717016 0.697056 7 7.83203)" fill="black"></rect> <rect width="1.19175" height="12.7539" transform="matrix(0.717016 0.697056 -0.717016 0.697056 16.1445 7.27734)" fill="black"></rect></svg></button>`;	
    					}


    			$item_html += `</div>
    				<div class="octane__cart-item-info">
    					<h4 class="product-title">` + item.product_title + `</h4>
    					<p class="variant-title">` + item.variant_options[0] + `</p>`;

    					if($final_line_price !== 'FREE') {

    					$item_html += `<div class="rebuy-cart__flyout-item-quantity"><div class="rebuy-cart__flyout-item-quantity-widget"><button alt="Decrease quantity of ` + item.product_title + `" aria-label="Decrease quantity of ` + item.product_title + `" type="button" class="rebuy-cart__flyout-item-quantity-widget-button"  onclick="octane_change_cartitem(` + item.id + `,'update_minus',` + item.quantity + `);"><svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.37866L5.24264 5.6213L9.48528 1.37866" stroke="black" stroke-width="1.25"></path></svg></button> <span class="rebuy-cart__flyout-item-quantity-widget-label"><span class="sr-only">Quantity of ` + item.product_title + `</span>` + item.quantity + `</span><button onclick="octane_change_cartitem(` + item.id + `,'update_plus',` + item.quantity + `);" alt="Increase quantity of ` + item.product_title + `" aria-label="Increase quantity of ` + item.product_title + `" type="button" class="rebuy-cart__flyout-item-quantity-widget-button"><svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.97057 5.6213L4.72793 1.37866L0.485291 5.6213" stroke="black" stroke-width="1.25"></path></svg></button></div></div>`;
                		}

    				$item_html += `</div>
    				<div class="octane__cart-item-price">
    					<p class="line-price">`;

    				if(item.discounts.length && $final_line_price !== 'FREE') {
    					$item_html += `<span class="discounted-line-price">` + removeZeros(theme.Currency.formatMoney(item.line_price, $subtotal_money_format)) + `</span>`;
    				} 

    				$item_html += `<span class="final-line-price">` + $final_line_price +`</span></p>
    				</div>
				</div>`;


				if($final_line_price == 'FREE') {
					$free_items_html += $item_html;
				} else {
					$paid_items_html += $item_html;
				}

				});

    		$cart_items_html += $free_items_html;
    		$cart_items_html += $paid_items_html;
				$cart_items_html += `</div>`;

				$cart_items_html += `<div class="octane__cart-subtotal__wrapper">`;

				if(cart.cart_level_discount_applications.length) {
					$cart_items_html += `<div class="octane__cart-discount">
					<p class="discount-label"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style="fill:none;stroke:#989898;margin-right:5px" viewBox="0 0 14 14" focusable="false" aria-hidden="true"><g stroke-linejoin="round" clip-path="url(#discount_svg__a)"><path stroke-linecap="round" d="M10.5 1.5H7.93a2.5 2.5 0 0 0-1.8.766L1.52 7.052a1.5 1.5 0 0 0 .02 2.101l3.48 3.48a1.25 1.25 0 0 0 1.75.016l5.116-4.926a2 2 0 0 0 .613-1.441V3.5a2 2 0 0 0-2-2"></path><circle cx="9.5" cy="4.5" r="0.563" stroke-linecap="round"></circle><path d="M9.49 4.49h.02v.02h-.02z"></path></g><defs><clipPath id="discount_svg__a"><path fill="#fff" d="M0 0h14v14H0z"></path></clipPath></defs></svg>` + cart.cart_level_discount_applications[0].title + `</p>
					<p class="discount-amount">-` + theme.Currency.formatMoney(cart.cart_level_discount_applications[0].total_allocated_amount, window.cartStrings.cartCurrencySymbol + '{{amount}}') + `</p></div>`;	
				}


				$cart_items_html += `<div class="octane__cart-subtotal">
					<p class="subtotal-label">Subtotal</p>
					<p class="subtotal-price">` + theme.Currency.formatMoney(cart.total_price, window.cartStrings.cartCurrencySymbol + '{{amount}}') + `</p>
				</div>`;

				$cart_items_html += `<a href="/checkout" class="btn btn-octane__checkout">Checkout</a>`;

				$cart_items_html += `</div>`;

    		document.querySelector('.octane__cart-contents').innerHTML = $cart_items_html;
    	} else {
    		document.querySelector('.octane__cart-contents').classList.add('empty');
    		document.querySelector('.octane__cart-contents').innerHTML = 'Cart is Empty!';
    	}
        	
    } catch(error) {
        	document.querySelector('.octane__cart-contents').innerHTML = 'Error fetching cart:' + error;
    }
}

document.addEventListener('octane.quiz.completed', function(event){

	$quiz_wrapper = document.getElementById('octane-quiz-outer-wrapper');
	$quiz_wrapper.classList.add('results-loading');

	var $scent_title = 'Default Scent';
	var $scent_description = 'Default Description';
	var $scent_image = '';
	var $scent_image_mobile = '';

	switch(event.detail.state.results_page_id) {

		// Santal
		case 'a50708aacc2586ba314fdd1bf20ffe4665cd7025':
			$scent_title = 'Santal & Vetiver';
			$scent_description = 'Warm, woody, and creamy—like being enveloped in a soft blanket on a crisp, cool day.'; 
			$scent_image = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-santal.jpg?v=1770148158';
			$scent_image_mobile = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-santal-mobile.jpg?v=1770148163';
			break;

		// Bergamot
		case 'f5349e30e7098ad3036f354d5a7dfaab7908ba08':
			$scent_title = 'Bergamot & Hinoki';
			$scent_description = 'Citrus, woody, and sparkling—like a crisp, clear morning.'; 
			$scent_image = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-bergamot.jpg?v=1770147952';
			$scent_image_mobile = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-bergamot-mobile.jpg?v=1770147962';
			break;

		// Black Rose
		case 'f3f1122869252a6555b21ca1e3e600513bd9270a':
			$scent_title = 'Black Rose & Oud';
			$scent_description = 'Dark, floral, and sensual—like bouquets of black roses and lilies blooming.'; 
			$scent_image = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-blackrose.jpg?v=1770147988';
			$scent_image_mobile = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-blackrose-mobile.jpg?v=1770147991';
			break;

		// Saffron
		case 'c3351cee6d4126a32854b2ee3b3c399ddf093109':
			$scent_title = 'Saffron & Cedar';
			$scent_description = 'Sweet, warm, and ambery—like taking a drive up the Pacific Coast where the ocean meets the mountains.'; 
			$scent_image = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-saffron.jpg?v=1770148051';
			$scent_image_mobile = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-saffron-mobile.jpg?v=1770148059';
			break;

		// Neroli
		case '58218cea07961fc7a28a6db57ebefc8c86254d5a':
			$scent_title = 'Neroli & Basil';
			$scent_description = 'Crisp, green, and energizing—like a breath of fresh air flowing through your lungs.'; 
			$scent_image = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-neroli.jpg?v=1770148023';
			$scent_image_mobile = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-neroli-mobile.jpg?v=1770148026';
			break;

		// Lily & Yuzu
		case 'e97594f619e01c1d0183681babb48814195faad9':
		case 'a54dba019cf93106e9c5cd221d7c3f7840e85856':
		case '2bbe535a1e97f45002d4a9650e8575847d2dbdbd':
		case '66ae712d2e154bdb3221dc9cab69fe5ea2bbc108':
		case 'a4a446cafdb559a0821359c1d7624d3082710c39':
			$scent_title = 'Lily & Yuzu';
			$scent_description = 'Fresh, sparkling, and sunlit—like diving into cool waves beneath an endless summer sky.'; 
			$scent_image = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-lily.webp?v=1780527797';
			$scent_image_mobile = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-lily-mobile.webp?v=1780527797';
			break;

		// Ambrette & Pear
		// Taken from custom-quiz-results__header
		case 'a41c15fa61ca4c38783b15c44fa47becc0d23256':
		case '022f1c49c8b42a06bf73d49975dd3bc5a8fccdb3':
		case 'b5835759edbec61b53821e62bd2e40d85424391a':
		case 'c6efe75a45b6abd22565794404acf60a7110696d':
		case 'ab275b07cd6bf362d627251ae0467d04f3e0302a':
			$scent_title = 'Ambrette & Pear';
			$scent_description = 'Clean, warm, and musky—like soft linen sheets brushing against your skin.'; 
			$scent_image = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-ambrette-v2.webp?v=1787850401';
			$scent_image_mobile = 'https://cdn.shopify.com/s/files/1/1916/1271/files/img-result-ambrette-mobile-v2.webp?v=1787850401';
			break;

	}

	if(event.detail.state.headless_results_page_accessed !== undefined) {
		var $routine_products = event.detail.state.headless_results_page_accessed.sections[0].products;
		var $more_you_love_products = event.detail.state.headless_results_page_accessed.sections[1].products;	

	} else {
		var $routine_products = event.detail.sections[0].products;
		var $more_you_love_products = event.detail.sections[1].products;	
	}

	
	
	var $results_html = '';
	var $more_you_love_html = '';

	$results_html = `<div class="custom-quiz-results">
		<div class="custom-quiz-results__left">
			<div class="custom-quiz-results__header result-` + event.detail.state.results_page_id + `">
				<div class="media-container">
					<img src="` + $scent_image + `" class="objfit d-none d-md-block">
					<img src="` + $scent_image_mobile + `" class="objfit d-block d-md-none">
					<div class="content">
						<p class="subtitle">Your Signature Scent</p>
						<h1 class="title">` + $scent_title + `</h1>
						<p class="description">` + $scent_description + `</p>
					</div>
				</div>
			</div>

			<div class="custom-quiz-results__personalized-routine">
				<h2 class="section-title">Your personalized routine</h2>
				<div class="personalized-routine__products">`;

  	let initial_cart_items = [];

	for($product in $routine_products) {

		$product_id = $routine_products[$product].id;
		$product_variant_title = $routine_products[$product].title;
		$product_image_src = $routine_products[$product].image;
		$product_description = $routine_products[$product].description;
		$product_price = $routine_products[$product].price_formatted;

		$titles = $product_variant_title.split(' - ');
		$product_title = $titles[0];
		$variant_title = $titles[1];
		$variant_id = $titles[2]

		$results_html += `<div class="product">
			<div class="product-media"><img src="` + $product_image_src + `" class="objfit">
			</div>
			<div class="product-meta">
				<div class="product-meta__content">
					<h3>` + $product_title + `</h3>
					<p class="variant-title">` + $variant_title + `</p>
					<div class="description">` + $product_description + `</div>
					<div class="product-reviews" data-oke-star-rating data-oke-reviews-product-id="shopify-` + $product_id + `"></div>
					<a href="#" data-variant-id="` + $variant_id + `" class="btn btn-octane__add-to-cart">Add to cart - ` + $product_price.replace('.00','').replace('CA','') + `</a>
				</div>
			</div>
		</div>`;

		const item = {
	        'id': $variant_id,
	        'quantity': 1
	    };

		initial_cart_items.push(item);
	}

	const dataToSend = {
		'items': initial_cart_items
	};

	octane_updateCart(dataToSend);
	
	$results_html += `</div>
			</div>
		</div>
		<div class="custom-quiz-results__right">
			<div class="octane__cart">
				<h3 class="cart-title">Your Bag</h3>
				<div class="octane__cart-contents"></div>
			</div>
		</div>
	</div>		
	`;

	$quiz_wrapper = document.getElementById('octane-quiz-outer-wrapper');
	$quiz_wrapper.insertAdjacentHTML('beforeend', $results_html);

	setTimeout(function(){
		window.okeWidgetApi.initAllWidgets();
	}, 100);

	$more_you_love_html = `<div class="product-recommendations">
		<div class="section-header g-flex">
			<div class="section-header__left">
				<h2 class="section-title">More you’ll love</h2>
			</div>
			<div class="section-header__right">
				<a href="/collections/all" class="cta">Shop All</a>
			</div>
		</div>
		<div class="product-recommendations-slider">
        	<div class="recommendations-swiper">
        		<div class="swiper-wrapper">`;

    for($product in $more_you_love_products) {

		// If we have selected product e.g. Santal Set, Bergamot Set
		if($more_you_love_products[$product].variants !== undefined) {
			$variant_id = $more_you_love_products[$product].variants[0].id;
		}

		$product_variant_title = $more_you_love_products[$product].title;
		$product_image_src = $more_you_love_products[$product].image;
		$product_price = $more_you_love_products[$product].price_formatted.replace('.00','').replace('CA','');

		$titles = $product_variant_title.split(' - ');
		$product_title = $titles[0];
		$variant_title = $titles[1];
		$variant_id = $titles[2]

		$product_save_tag = '';

		if($more_you_love_products[$product].compare_at_price_formatted !== undefined) {

			$compare_at_price = parseInt($more_you_love_products[$product].compare_at_price_formatted.replace('CA$', '').replace('$', '').replace('£', '').replace('.00',''));
			$price = parseInt($more_you_love_products[$product].price_formatted.replace('CA$', '').replace('$', '').replace('£', '').replace('.00',''));
			$save_amount = $compare_at_price - $price;
			$product_save_tag = 'Save ' + window.cartStrings.cartCurrencySymbol + $save_amount.toString();
		}

		if($more_you_love_products[$product].variants !== undefined && $more_you_love_products[$product].variants[0].compare_at_price_formatted !== null) {

			$compare_at_price = $more_you_love_products[$product].variants[0].compare_at_price;
			$price = $more_you_love_products[$product].variants[0].price;
			$save_amount = $compare_at_price - $price;
			$product_save_tag = 'Save ' + window.cartStrings.cartCurrencySymbol + $save_amount.toString();
		}

		$more_you_love_html += `<div class="swiper-slide product-slider__item">
			<div class="ss-product">
				<div class="product__wrapper">
					<div class="product__image-wrapper">
						<img class="objfit ss-product__image" src="` + $product_image_src + `">

						<div class="atc-form">
							<form method="post" action="/cart/add" class="add-to-cart__form" data-product-id="` + $variant_id + `" enctype="multipart/form-data" onsubmit="handleYmalSubmit(event)"><input type="hidden" name="form_type" value="product"><input type="hidden" name="id" value="` + $variant_id + `"><button class="add-to-cart" onclick="window.Rebuy.SmartCart.skip_open = false;"><svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15.5" cy="15.5" r="15" stroke="black"></circle><rect x="0.242188" y="-0.242188" width="0.485541" height="15.0518" transform="matrix(-0.00239811 -0.999997 0.999997 0.00239803 8.21591 15.9664)" fill="black" stroke="black" stroke-width="0.485541"></rect><rect x="0.243352" y="0.243352" width="0.485542" height="15.0518" transform="matrix(0.999997 0.00239803 0.00239811 0.999997 14.9916 7.72696)" fill="black" stroke="black" stroke-width="0.485542"></rect></svg></button>
							</form>
						</div>

          				<div class="product-tag" v-if="productTag(product)" v-html="productTag(product)"></div>`;

          			if($product_save_tag != '') {
          				$more_you_love_html += `<div class="product-save-tag">` + $product_save_tag + `</div>`;
          			}		
              			
              			$more_you_love_html += `<div class="product-top-tag" v-if="productTopTag(product)" v-html="productTopTag(product)"></div>
					</div>

					<div class="product__meta-wrapper">
              			<div class="product__meta-left">
                			<p class="product-title">` + $product_title;

                			if($variant_title !== undefined) {
                				$more_you_love_html += `<span class="variant-title">` + $variant_title + `</span>`;
                			}

                		$more_you_love_html += `</p>
              			</div>
              			<div class="product__meta-right">
                			<div class="product__meta-price">
                				<span class="rebuy-price">` + $product_price + `</span>
                			</div>
              			</div>
              		</div>
				</div>
			</div>
		</div>`;
	}
	
	$more_you_love_html += `</div>
			</div>
		</div>
	</div>`;

	$quiz_rendered_wrapper = document.querySelector('.octane-ai-quiz-rendered');
	$quiz_rendered_wrapper.insertAdjacentHTML('beforeend', $more_you_love_html);


	setTimeout(function(){
		init_recommendations_slider();
	}, 100);


}, false);


async function octane_updateCart(newItems) {
	try {
		const clearResponse = await fetch('/cart/clear.js', {
			method: 'POST'
		});

		if(!clearResponse.ok) {
			throw new Error('Failed to clear the cart.');
		}

		if($('body').attr('id') == 'quiz-scent10' || $('body').attr('id') == 'quiz-scent15' || $('body').attr('id') == 'quiz-naturalworld') {

			const discountResponse = await fetch('https://www.saltandstone.com/discount/SCENT10');

			if($('body').attr('id') == 'quiz-scent15') {
				const discountResponse = await fetch('https://www.saltandstone.com/discount/WELCOME15');
			}

			if($('body').attr('id') == 'quiz-naturalworld') {
				const discountResponse = await fetch('https://www.saltandstone.com/discount/NATURALWORLD');
			}

			if(!discountResponse.ok) {
				throw new Error('Failed to apply discount.');
			}

			$('body').addClass('discount-modal-active');
  			$('#quizDiscountModal').modal('show');

		}

		const addResponse = await fetch('/cart/add.js', {
      		method: 'POST',
      		headers: {
        		'Content-Type': 'application/json'
      		},
      		body: JSON.stringify(newItems) // Assuming newItems is an object/array as required by your endpoint
		});

		if (!addResponse.ok) {
  			throw new Error('Failed to add new items.');
    	}

    	octane_getCartContents();

    	setTimeout(function() {
			$quiz_wrapper.classList.remove('results-loading');
		}, 1000);

    	setTimeout(function() {
			document.querySelector(".custom-quiz-results__personalized-routine").scrollIntoView({
			    block: "start", // Aligns the element's start (top) with the start of the scrollable area
			    behavior: "smooth" // Optional: adds smooth scrolling animation
			});
		}, 3000);

  	} catch (error) {
    	console.error('Error updating cart:', error);
  	}
}


document.addEventListener("octane.quiz.questionLoaded", function (event) {
  
  setTimeout(function(){
  	const listItems = document.querySelectorAll('li.oct-quiz-multiple-choice-options__option');
  
  	listItems.forEach(item => {
  		item.classList.value = '';
  		item.classList.add('oct-quiz-multiple-choice-options__option');
  		item.removeAttribute('data-is-option-selected');
	});

  }, 100);
  

  if(document.getElementById('octane-quiz-wrapper') !== undefined) {
  	document.getElementById('octane-quiz-wrapper').classList.add('question-' + event.detail.question_id);
  }
}, false);
(function($){

	$(document).ready(function(){
		// set_main_content_height();
	});

	$(window).on('resize',function(){
		// set_main_content_height();
	});

})(jQuery);
(function($){

  $(window).on('load',function(e){
    if($('body').hasClass('template-product')) {
      $.exitIntent('enable');
    }

    $(document).bind('exitintent', function() {
       show_exitintent_popup();
    });
  });

  $(document).on('click','.close-exitpopup--trigger',function(e){
    e.preventDefault();
    $('.product-exitpopup__background, #product-exitpopup--scroller').removeClass('active');
    $(this).closest('.product-exitpopup').fadeOut('fast');
  });

  function handleScroll() {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    if (scrollPosition / pageHeight > 0.75 && window.matchMedia("(pointer: coarse)").matches) {
      show_exitintent_popup();
    }
  }

  function show_exitintent_popup() {
    var cartItems = JSON.stringify(Rebuy.Cart.cart.items) || [];
    
    // Show only if Best Sellers Set, Body Care Ritual Set, Body Mist, Signature Scent Duo are not in cart

    if(!cartItems.includes('8139772100858') && !cartItems.includes('8593059873018') && !cartItems.includes('8494751973626') && !cartItems.includes('8222543610106')) {
      $product_exitpopup_div = $('.product-exitpopup');
      $exitpopup_background = $('.product-exitpopup__background');
      $exitpopup_scroller = $('#product-exitpopup--scroller');

      if($product_exitpopup_div.length) { //&& !sessionStorage.getItem('ss-product-exitpopup')) {
        $exitpopup_scroller.addClass('active');
        $exitpopup_background.addClass('active');
        $product_exitpopup_div.fadeIn('fast');
        sessionStorage.setItem('ss-product-exitpopup', '1');

        window.removeEventListener('scroll', handleScroll);
        $(document).unbind('exitintent');
      }
    }
  }

  window.addEventListener('scroll', handleScroll);

  // .btn-flyout--add-to-cart REFER custom-rebuy-product-crosssell.js

})(jQuery);
(function($){

  $(document).ready(function(){

    if($('body').hasClass('lock-product') && !sessionStorage.getItem('lockPDPCollection')) {
      $('.product-single__form').remove();
      $('#productLockModal').modal('show');
    }

    $('#productLockModal').on('shown.bs.modal', function(e){
      $('#productLockModal').find('input[type="password"]').focus();
    });

    $('#productLockModal').on('hidden.bs.modal', function(e){
      if(!sessionStorage.getItem('lockPDPCollection')) {
        var cleanUrl = window.location.href.split('?')[0];

        if(!document.body.classList.contains('template-product')) {
          cleanUrl = window.Shopify.routes.root;
        }

        // if the product url doesnt has variant e.g. cherry products
        if(!window.location.href.includes('?')) {
          cleanUrl = window.Shopify.routes.root;
        }

        window.location.href = cleanUrl;
      }
    });

    $('#product-lock__form input[type="password"]').on('focus keypress', function(e){
      $('#product-lock__form').find('.error').hide();
    });

    $(document).on('click','#productLockModal .btn-lock-product',function(e){
      e.preventDefault();
      $entered_product_key = btoa($(this).siblings('input[name="product_key"]').val().toLowerCase());
      $original_product_key = $('body').data('productKey');
      $object_id = $('body').data('productId');
      $sessionVariable = 'lockProduct-';

      if($('body').hasClass('template-collection')) {
        $sessionVariable = 'lockCollection-';
        $object_id = $('body').data('collectionId');
      }

      if($('body').hasClass('template-page')) {
        $sessionVariable = 'lockPage-';
        $object_id = $('body').data('pageId');
      }

      if($entered_product_key == $original_product_key) {
        sessionStorage.setItem($sessionVariable + $object_id);
        sessionStorage.setItem('lockPDPCollection');
        $('#productLockModal').modal('hide');
        $('body').removeClass('product-lock-active');
        window.location.reload();
      } else {
        $('#product-lock__form').find('input[type="password"]').val('');
        $('#product-lock__form').find('.error').show();
      }

    });


  });

})(jQuery);
(function($){

    $(document).ready(function(){

        $(document).on('click','#productModal .btn-add-to-set',function(e){
            e.preventDefault();
            $variant_id = $(this).attr('data-variant-id');
            $btn_ss_set_product = $('#build-a-set__products-grid .ss-set-product[data-variant-id="' + $variant_id + '"]').find('.btn-add-to-set');
            $btn_ss_set_product.trigger('click');
            $('#productModal').modal('hide');
        });

        $('#productModal').on('show.bs.modal', function(e){
            var $variant_id = e.relatedTarget.dataset.variantId;
            var $product_title = e.relatedTarget.dataset.title;
            
            var $product_scent = e.relatedTarget.dataset.scent;
            var $product_scent_note = e.relatedTarget.dataset.scentNote;
            var $product_scent_color = e.relatedTarget.dataset.scentColor;

            var $product_size = e.relatedTarget.dataset.size;
            var $product_image = e.relatedTarget.dataset.image;
            var $product_description = e.relatedTarget.dataset.description;
            var $product_price = e.relatedTarget.dataset.price;
            var $product_discounted_price = e.relatedTarget.dataset.discountedPrice;
    
            var $target_product_title = $(this).find('.product-title');
            var $target_product_size = $(this).find('.product-size');
            var $target_product_image = $(this).find('.product-media img');
            var $target_product_description = $(this).find('.product-description');
            var $target_product_scent = $(this).find('.product-scent');
            var $target_product_scent_title = $(this).find('.scent-title');
            var $target_product_scent_note = $(this).find('.scent-note');
            var $target_product_scent_color = $(this).find('.scent-color');
            var $target_product_btn = $(this).find('.btn-add-to-set');
            var $target_product_price = $(this).find('.original-price');
            var $target_product_discounted_price = $(this).find('.discounted-price');

            $target_product_title.text($product_title);
            $target_product_size.text($product_size);

            $target_product_image.removeAttr('src');
            $target_product_image.attr('src', $product_image);

            $target_product_description.html($product_description);

            if($product_scent !== undefined) {
                $target_product_scent_title.text($product_scent);
                $target_product_scent_note.text($product_scent_note);
                $target_product_scent_color.css('background', $product_scent_color);
                $target_product_scent.show();
            } else {
                $target_product_scent.hide();
            }

            $target_product_btn.attr('data-variant-id',$variant_id);
            $target_product_price.text($product_price);
            $target_product_discounted_price.text($product_discounted_price);
        });

    });

})(jQuery);


(function($){

	$(document).ready(function(){
		init_recommendations_slider();
	});

	$(window).on('resize',function(){
		init_recommendations_slider();
	});

})(jQuery);

function init_recommendations_slider() {

	var $swiperSelector = $('.recommendations-swiper');
		
		$swiperSelector.each(function(index) {
		var $this = $(this);
		$this.addClass('swiper-slider-' + index);

		var swiper = new Swiper('.swiper-slider-' + index, {
  			slidesPerView: 'auto',
  			spaceBetween: 4,
  			slidesOffsetAfter: 0,
  			loop: false,
  			centeredSlides: false,
  			speed: 500,
  			cssMode: true,
  			freeMode: {
  				enabled: false
  			},
  			mousewheel: {
  				enabled: true,
				sensitivity: 3,
				forceToAxis: true,
				thresholdDelta: 250,
				thresholdTime: 1200
  			},

  			breakpoints: {

  				768: {
  					centeredSlides: false,
  					loop: false,
  					cssMode: false,
  					spaceBetween: 4,
  					slidesOffsetAfter: 0,
  					speed: 2000,
  					scrollbar: {
	        			enabled: true
	      			},
	      			freeMode: {
	      				enabled: true,
	      				sticky: false,
	      				momentum: true,
	      				momentumRatio: 5,
	    				momentumBounce: true
	      			}
  				},

  				992: {
  					centeredSlides: false,
  					loop: false,
  					cssMode: false,
  					spaceBetween: 4,
  					speed: 2000,
  					slidesOffsetAfter: 0,
  					scrollbar: {
	        			enabled: true
	      			},
	      			freeMode: {
	      				enabled: true,
	      				sticky: false,
	      				momentum: true,
	      				momentumRatio: 5,
	    				momentumBounce: true
	      			}
  				}
  			}
  			
			});
	});



 	// $('.product-recommendations-slider').each(function(index){

 	// 	var $prev_item = $(this).siblings('.section-header').find('.slick-prev');
 	// 	var $next_item = $(this).siblings('.section-header').find('.slick-next');

 	// 	if(!$(this).hasClass('slick-initialized')) {
 	// 		$(this).slick({
 	// 			arrows: true,
 	// 			dots: false,
 	// 			infinite: true,
 	// 			autoplay: false,
 	// 			swipe: true,
 	// 			variableWidth: true,
 	// 			prevArrow: $prev_item,
 	// 			nextArrow: $next_item,
 	// 			centerMode: true,
 	// 			mobileFirst: true,

 	// 			responsive: [
 	// 				{
 	// 					breakpoint: 768,
 	// 					settings: "unslick"
 	// 				}
 	// 			]
 	// 		});
 	// 	}

 	// });
}
(function($){

	$(document).ready(function(){

		$(document).on('click','.product__reviews-summary .reviews-summary__left',function(e){
			e.preventDefault();

			if($('.oke-is-clickable').length) {
				$('.oke-is-clickable').trigger('click');
			}
		});
		
	});

})(jQuery);
(function($){

	$(document).ready(function(){

		// To prevent screen jump	
		$(document).on('click','#ProductMediaGroup-product-template .slick-dots a',function(e){
			e.preventDefault();
		});


		var $swiperSelector = $('.product-slider .swiper:not(.mobile-swiper');
		
		$swiperSelector.each(function(index) {
    		var $this = $(this);
    		$this.addClass('swiper-slider-' + index);
    		$slidesPerView = 'auto';

    		if($this.parent().hasClass('grid-layout-mobile-slider')) {
    			$slidesPerView = 4;
    		}

    		var swiper = new Swiper('.swiper-slider-' + index, {
      			slidesPerView: $slidesPerView,
      			spaceBetween: 4,
      			loop: false,
      			centeredSlides: false,
      			speed: 500,
      			cssMode: false,
      			freeMode: {
      				enabled: false
      			},
      			mousewheel: {
      				enabled: true,
    				sensitivity: 3,
    				forceToAxis: true,
    				thresholdDelta: 250,
    				thresholdTime: 1200
      			},
      			scrollbar: {
      				el: $(this).find('.swiper-scrollbar'),
        			draggable: true,
        			dragSize: 85,
        			enabled: false,
        			snapOnRelease: false
      			},

      			breakpoints: {

      				768: {
      					slidesPerView: $slidesPerView,
      					centeredSlides: false,
      					loop: false,
      					cssMode: false,
      					spaceBetween: 4,
      					slidesOffsetAfter: 4,
      					speed: 2000,
      					scrollbar: {
		        			enabled: true
		      			},
		      			freeMode: {
		      				enabled: true,
		      				sticky: false,
		      				momentum: true,
		      				momentumRatio: 5,
		    				momentumBounce: true
		      			}
      				},

      				992: {
      					slidesPerView: $slidesPerView,
      					centeredSlides: false,
      					loop: false,
      					cssMode: false,
      					spaceBetween: 4,
      					speed: 2000,
      					slidesOffsetAfter: 4,
      					scrollbar: {
		        			enabled: true
		      			},
		      			freeMode: {
		      				enabled: true,
		      				sticky: false,
		      				momentum: true,
		      				momentumRatio: 5,
		    				momentumBounce: true
		      			}
      				}
      			}
      			
   			});
		});

		init_mobileswiper();
		

	 	// $('.product-slider').each(function(index){

	 	// 	var $prev_item = $(this).parent().siblings('.product-slider__header').find('.slick-prev');
	 	// 	var $next_item = $(this).parent().siblings('.product-slider__header').find('.slick-next');

	 	// 	if(!$(this).hasClass('slick-initialized')) {

	 	// 		$(this).slick({
	 	// 			arrows: false,
	 	// 			dots: true,
	 	// 			infinite: true,
	 	// 			autoplay: false,
	 	// 			speed: 150,
	 	// 			cssEase: "linear",
	 	// 			swipe: true,
	 	// 			variableWidth: true,
	 	// 			prevArrow: $prev_item,
	 	// 			nextArrow: $next_item,

	 	// 			responsive: [
	 	// 				{
	 	// 					breakpoint: 768,
	 	// 					settings: {
	 	// 						centerMode: true
	 	// 					}
	 	// 				}
	 	// 			]
	 	// 		});

	 	// 		var dots = $(this).find('.slick-dots');
	 	// 		var slides = dots.find('li').length - 1;
	 	// 		var scrollId = "ssb-" + (Math.random() + 1).toString(36).substring(7);
 		// 	 	var scrollWidth = 50;

 		// 	 	var scroll = `
		// 			<div class="slick-scrollbar ${scrollId}"><input type="range" min="0" max="${slides}" step="0.01"value="0" /></div>`;

		// 		$(scroll).insertAfter(dots);
	 	// 	}

	 	// });


	 	// $('body').on('input mouseout change', '.slick-scrollbar', function(){
  		// 	var current = Math.round($(this).find('input').val());
  		// 	$slick = $(this).parent('.product-slider');

  		// 	$slick.slick('slickGoTo', current);
		// });
		
	});

	$(window).on('resize', function() {
		init_mobileswiper();
	});	


	function init_mobileswiper() {

		if($(window).width() < 768) {

			var $mobileswiperSelector = $('.product-slider .swiper.mobile-swiper');
			
			$mobileswiperSelector.each(function(index) {
	    		var $this = $(this);
	    		$this.addClass('mobile-swiper-slider-' + index);

	    		var mobilswiper = new Swiper('.mobile-swiper-slider-' + index, {
	      			slidesPerView: 'auto',
	      			spaceBetween: 4,
	      			loop: false,
	      			centeredSlides: false,
	      			speed: 500,
	      			cssMode: true,
	      			freeMode: {
	      				enabled: false
	      			},
	      			mousewheel: {
	      				enabled: true,
	    				sensitivity: 3,
	    				forceToAxis: true,
	    				thresholdDelta: 250,
	    				thresholdTime: 1200
	      			}
	   			});
			});
		} else {
			mobile_swipers = document.querySelectorAll('.mobile-swiper');

			mobile_swipers.forEach(function(item) {
				if(item.swiper) {
					item.swiper.destroy(true, true);
				}
			});
		}
	}

})(jQuery);
(function($){

	$(window).on('resize orientationchange', function() {
		if($('.product-single__media-group').length && $('.product-single__media-group').hasClass('slick-initialized')) {
	    	$('.product-single__media-group').slick('setPosition');
	    }
	});

	document.addEventListener("DOMContentLoaded", () => {
        const videos = document.querySelectorAll(".lazyvideo");

        const options = {
		  root: null, // use the viewport
		  rootMargin: '0px 0px 300px 0px', // Load 300px before reaching the viewport
		};

        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {

            const video = entry.target;

            if (entry.isIntersecting) {
				video.play();
            } else {
              	video.pause();
            }
          });
        }, options);

        videos.forEach(video => observer.observe(video));


        if($('body').hasClass('template-product')) {

			// Wait for RCA_DATA to be defined
		
			let checkExist = setInterval(function () {
			    const targetElement = document.querySelector('.rc-widget');
			    if (targetElement) {
			        clearInterval(checkExist);
			        rc_widgetCustomText();
			    }
			}, 500);

			// Stop checking for RCA_DATA. It either loaded or clearly is not here.
			setTimeout(clearInterval, 10000, checkExist);


			// Wait for RCA_DATA to be defined
		
			let checkExist_afterpay = setInterval(function () {
				if(document.body.classList.contains('template-product')) {
				    const afterPayShadowRoot = document.querySelector('#product-form__wrapper').querySelector('square-placement').shadowRoot;

				    if(afterPayShadowRoot) {

				    	const afterPayShadowRootParagraph = afterPayShadowRoot.querySelector('.afterpay-paragraph');

				    	if (afterPayShadowRootParagraph) {

							let afterPayCSS = `
					    		.mono-light-jewel-afterpay path {
					    			fill: #aaaaaa !important;
					    		}
					    	`;

					    	apStyleElement = document.createElement('style');
					    	apStyleElement.setAttribute('id','afterpay-custom-css');
					    	apStyleElement.innerHTML = afterPayCSS;

					    	if(afterPayShadowRoot !== null) {
				    			afterPayShadowRoot.appendChild(apStyleElement);	
					    		clearInterval(checkExist_afterpay);
					    	}
					    }
				    }
			   	}

			}, 500);

			// Stop checking for AFTERPAY. It either loaded or clearly is not here.
			setTimeout(clearInterval, 10000, checkExist_afterpay);
		}

  	});

	$(document).ready(function(){
			
		$('.product-form__input.size input[name="Size"]').on('change', function(e){
			setTimeout(function(){
				rc_widgetCustomText();
			}, 100);
		});
		
	});

	$(document).on('click', '.product-single .product-single__media-group-wrapper .slider-arrows .slider-arrows__left', function(e){
		e.preventDefault();
		$('.product-single__media-group').slick('slickPrev');
	});

	$(document).on('click', '.product-single .product-single__media-group-wrapper .slider-arrows .slider-arrows__right', function(e){
		e.preventDefault();
		$('.product-single__media-group').slick('slickNext');
	});

	$('.product-single__media-group').on('afterChange', function(event, slick, currentSlide, nextSlide) {

		$('.product-single__thumbnail-group-wrapper .product-single__thumbnail-img').removeClass('active');
		
		if(currentSlide > 0) {
			$(this).siblings('.product-tags--container').addClass('hide--tags');
		} else {
			$(this).siblings('.product-tags--container').removeClass('hide--tags');
		}

		if(currentSlide < $('.product-single__thumbnail-group-wrapper .product-single__thumbnail-img:visible').length) {
			$('.product-single__thumbnail-group-wrapper .product-single__thumbnail-img:visible').eq(currentSlide).addClass('active');	
		}

	    // Play the video in the current slide

	    $video = $('[data-slick-index="' + currentSlide + '"]').find('video');

	    if($video.length) {
	    	$video_element = $video.get(0);
			$video_element.play();
	    }
	});


	$('.product-single__media-group').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

	    // Pause the video in the current slide

	    $video = $('[data-slick-index="' + currentSlide + '"]').find('video');

	    if($video.length) {
	    	$video_element = $video.get(0);

	    	if(!$video_element.paused) {
	    		$video_element.pause();	
	    	}
	    }
	});



	$(document).on('click','.product-single__thumbnail-group-wrapper .product-single__thumbnail-img', function(e){
		e.preventDefault();
		$current_element = $(this);
		$(this).addClass('active').siblings().removeClass('active');

		var $visible_elements = $('.product-single__thumbnail-group-wrapper .product-single__thumbnail-img:visible');
		var $index = $visible_elements.index($current_element);

		if($('.product-single__media-group').length && $('.product-single__media-group').hasClass('slick-initialized')) {
        	$('.product-single__media-group').slick('slickGoTo', $index, true);
        }
	});

	$(document).on('click', '.product-single .product-single__scents-included li', function(e){
		e.preventDefault();
		$accordion_item = $('.product-accordions .product__description');

		if($accordion_item.length) {
			$accordion_item.find('.accordion-trigger').addClass('open');
			$accordion_item.find('.accordion-content').slideDown();

			$offset_item = $('#product-accordions__desktop');

			if($(window).width() < 992) {
				$offset_item = $('#product-accordions__mobile');
			}

			$('html,body').animate({ scrollTop: $offset_item.offset().top - 160 }, 500);
		}
	});

	$(document).on('change','.rc-radio__input', function(e){
		rc_sellingPlansCustomHTML();
		rc_addRadioGroupClass();
	});


	function rc_widgetCustomText(){

		// one time price remove Zeros
		const original_onetimePriceLabel = document.querySelector('.rc-widget .rc-radio.onetime-radio .price-label');
		const original_onetimePrice = original_onetimePriceLabel.innerHTML;

		new_onetimePrice = original_onetimePrice.replaceAll('.00','');
		original_onetimePriceLabel.innerHTML = new_onetimePrice;

		

		// subscription price remove Zeros
		const original_subscriptionPriceLabel = document.querySelector('.rc-widget .rc-radio.subscription-radio .price-label');

		const original_subsriptionPrice = original_subscriptionPriceLabel.innerHTML;

		new_subsriptionPrice = original_subsriptionPrice.replaceAll('.00','');

		if($('body').hasClass('subscriptionsaleactive')) {
			var currencyCart = window.cartStrings.cartCurrency;
			var currencySymbol = window.cartStrings.cartCurrencySymbol;
			var priceNum = parseFloat(new_subsriptionPrice.substring(1));
			new_subsriptionPrice = parseFloat(priceNum * 0.88).toFixed(2).toString();
			new_subsriptionPrice = currencySymbol + new_subsriptionPrice;

			if(currencyCart !== 'USD') {
				new_subsriptionPrice = new_subsriptionPrice + ' ' + currencyCart;
			}
		}

		original_subscriptionPriceLabel.innerHTML = new_subsriptionPrice;


		// update subscription label to auto-renew
		const subscriptionLabel = document.querySelector('.rc-widget .rc-radio.subscription-radio .discount-label');
		subscriptionLabelText = 'Subscribe & Save';
		subscriptionLabel.innerText = subscriptionLabelText;

		rc_sellingPlansCustomHTML();
		rc_addRadioGroupClass();

		if($('.rc-widget .rc-radio-group__options .marker').length == 0) {
			$('.rc-widget .rc-radio-group__options').append('<div class="marker"></div>');	
		}
		$('.rc-widget').addClass('loaded');
	}


	function rc_sellingPlansCustomHTML() {
		const sellingPlansSelect = document.querySelector('.rc-selling-plans-dropdown__select');
		const sellingPlansCustomHTML = '<ul class="subscription-benefits"><li>15% off every order</li><li>Pause or cancel anytime</li><li>Early access to new launches</li></ul>';

		if(sellingPlansSelect !== null && $('.subscription-benefits').length == 0) {
			sellingPlansSelect.insertAdjacentHTML('beforebegin', sellingPlansCustomHTML);
		}


		setTimeout(function(){
			if($('.rc-radio.subscription-radio').hasClass('rc-radio--active')) {
				$('.rc-selling-plans').addClass('active');
			}	
		});
		
	}

	function rc_addRadioGroupClass() {
		if($('.rc-radio__input:checked').val() == 'onetime') {
			$('.rc-radio-group__options').removeClass('subscription-active');
		} else {
			$('.rc-radio-group__options').addClass('subscription-active');
		}
	}

})(jQuery);
(function($){

	$(document).ready(function(){

		$('fieldset.scent label').hoverIntent(function(){
			var $title = $(this).data('title');
			var $description = $(this).data('description');
			
			$(this).parents('.fieldset-wrapper').find('.current-scent__name').html($title);
			$('.product-accordions').find('.product-variant__description').find('.current-variant__description').html($description);
		});

		$('fieldset.scent').hoverIntent(function(){

		}, function() {

			var $title = $(this).find('input[name="scent"]:checked+label').data('title');
			var $description = $(this).find('input[name="scent"]:checked+label').data('description');

			$(this).parents('.fieldset-wrapper').find('.current-scent__name').html($title);
			$('.product-accordions').find('.product-variant__description').find('.current-variant__description').html($description);
		});

		$('.ss-product product-variant-radios label').hoverIntent(function(){
			var $radio = $('#' + $(this).attr('for'));
			if($radio.length) {
				$radio.trigger('click');
			}
		});
		
	});


	$('.ss-product product-variant-radios input[type="radio"]').on('change',function(e){

		$ss_product = $(this).parents('.ss-product');
		$selected_option = $ss_product.find('product-variant-radios input[type="radio"]:checked');

		// Fetch Current Variant Data
		$is_available = $selected_option.data('available');
		$variant_image = $selected_option.data('image');
		$variant_hovervideo = $selected_option.data('hovervideo');
		$variant_price = $selected_option.data('price');
		$variant_scent = $selected_option.data('scent');
		$variant_url = $selected_option.data('url');
		$variant_top_tag = $selected_option.data('topTag');
		$variant_id = $selected_option.val();

		// Fetch Elements to be updated
		$input_variant_id = $ss_product.find('.add-to-cart__form input[name="id"]');
		$media_wrapper = $ss_product.find('.product__image-wrapper');
		$media = $ss_product.find('.product__image-wrapper .ss-product__image');
		$hovervideo = $ss_product.find('.product__image-wrapper video');
		$price = $ss_product.find('.product__meta-price .sale-price');
		$subscription_price = $ss_product.find('.product__meta-price .subscription-price');
		$scent = $ss_product.find('.product__meta-left .variant-title');
		$anchor = $ss_product.find('.product__image-wrapper .product__image-link');
		$anchor.attr('href', $variant_url);
		$product_form = $ss_product.find('.add-to-cart__form');
		$top_tag = $ss_product.find('.product-top-tag');
		$sold_out = $ss_product.find('.product__meta-right .sold-out');
		$price_element = $ss_product.find('.product-price__wrap');
		

		// Update Image
		$media.attr('src', $variant_image);
		$media.attr('srcset', $variant_image);
		$media.siblings('source').attr('srcset', $variant_image);

		// Update Hover Video 

		if($variant_hovervideo) {
			$hovervideo.find('source').attr('src', $variant_hovervideo);
			$hovervideo.get(0).load();	
		}

		// Update Price
		$price.text($variant_price);

		// Update Scent
		$scent.text($variant_scent);

		// Update Variant ID
		$input_variant_id.val($variant_id);

		// Update Top Tag
		if($variant_top_tag != '') {
			$top_tag_html = '<div class="product-top-tag">' + $variant_top_tag + '</div>';
			$top_tag.remove();
			$ss_product.find('.product__image-wrapper').append($top_tag_html);
		} else {
			$top_tag.remove();
		}


		if($is_available) {
			$sold_out.addClass('hide');
			$price_element.removeClass('hide');
			$product_form.removeClass('hide');
		} else {
			$sold_out.removeClass('hide');
			$price_element.addClass('hide');
			$product_form.addClass('hide');
		}
	});


	$(document).on('change', '#crosssellModal product-variant-radios input[type="radio"]', function(e){
		$crosssellModal = $(this).parents('#crosssellModal');
		$selected_option = $crosssellModal.find('product-variant-radios input[type="radio"]:checked');

		// Fetch Current Variant Data
		$is_available = $selected_option.data('available');
		$variant_image = $selected_option.data('image');
		$variant_scent = $selected_option.data('scent');
		$variant_title = $selected_option.data('variantTitle').split(" / ")[0];
		$product_title = $selected_option.data('productTitle');		
		$variant_id = $selected_option.val();

		// Fetch Elements to be updated
		$btn_add_to_cart = $crosssellModal.find('.btn-flyout--add-to-cart');
		$media = $crosssellModal.find('.product-image');
		$scent = $crosssellModal.find('.variant-title');

		// Update Image
		$media.attr('src', $variant_image);

		// Update Scent
		$scent.text($variant_scent);

		// Update Variant ID & other attributes
		$btn_add_to_cart.attr('data-variant-id', $variant_id);
		$btn_add_to_cart.attr('data-variant-title', $variant_title);
		$btn_add_to_cart.attr('data-variant-product-title', $product_title);

		if($is_available) {
			$btn_add_to_cart.removeAttr('disabled');
		} else {
			$btn_add_to_cart.attr('disabled', true);
		}
	});

})(jQuery);
(function($){

	/* $(document).ready(function(){

	 	$(document).on('onRechargeLoad',function(e){
			alert('recharge loaded');
		});
		
	});

	window.addEventListener('DOMContentLoaded', function(e){
		alert('yes dom loaded');
	});


	$(window).on('load',function(e){
		if($('body').hasClass('template-product') && $('.rc-widget .onetime-radio').length) {
			$onetime_array = $('.rc-widget .onetime-radio').find('.rc-radio__label').text().split(" ");
			$first_part = '<span class="rc-radio__onetime">' + $onetime_array[0] + '</span>';
			$second_part = '<span class="rc-radio__price">' + $onetime_array[1] + '</span>';
				
			$('.rc-widget .onetime-radio').find('.rc-radio__label').html($first_part + $second_part);

			$('.rc-widget .rc-radio.onetime-radio, .rc-widget .rc-radio.subscription-radio').css('display','flex');
	 	} else {
	 		alert($('.rc-widget .onetime-radio').length);
	 		alert('dont know');
	 	}
	}); */

})(jQuery);
(function($){

	$(document).ready(function(){

	 	$(document).on('click','.read-more__link',function(e){
	 		e.preventDefault();

	 		$(this).siblings('.read-more__text').show();
	 		$(this).hide();
	 	});

	 	$(document).on('click','.read-less__link',function(e){
	 		e.preventDefault();

	 		$(this).parent('.read-more__text').hide();
	 		$(this).parent('.read-more__text').siblings('.read-more__link').show();
	 	});
		
	});

})(jQuery);
/* 
  Additional Custom Functions to Support 
  Custom Rebuy Recommended Widget Template
*/

function productTag(product) {
  var product_tag = '';

  if(product.selected_variant.metafields.sas !== undefined) {
    if(product.selected_variant.metafields.sas.variant_custom_tag) {
      product_tag = product.selected_variant.metafields.sas.variant_custom_tag;
    }
  } else {
    if(product.metafields.sas.product_custom_tag) {
      product_tag = product.metafields.sas.product_custom_tag;
    }
  }
  
  return product_tag;
}

function productSaveTag(product) {
  var save_value = 0;
  var product_save_tag = '';

  if(document.body.classList.contains('cyberweekactive')) { return; }

  if(product.selected_variant.compare_at_price && product.selected_variant.compare_at_price > product.selected_variant.price) {
    save_value = product.selected_variant.compare_at_price - product.selected_variant.price;
    product_save_tag = 'Save ' + window.cartStrings.cartCurrencySymbol + save_value;
  }
  
  return product_save_tag;
}

function productTopTag(product) {
  var product_top_tag = '';

  if(product.selected_variant.metafields.sas !== undefined) {
    if(product.selected_variant.metafields.sas.variant_top_tag) {
      product_top_tag = product.selected_variant.metafields.sas.variant_top_tag;
    }
  } else {
    if(product.metafields.sas.product_top_tag) {
      product_top_tag = product.metafields.sas.product_top_tag;
    }
  }
  
  return product_top_tag;
}


function productTitle(product) {
  var product_title = product.title;

  if(product.selected_variant.option2 !== null) {    
    product_title = product_title + '<br/><span class="sm-font-caps variant-title">' + product.selected_variant.option1 + '</span>';
  }

  return product_title;
}

function productHoverVideo(product) {
  var $product_hover_html = '';

  var product_variant_group_id = product.id + '-' + product.selected_variant.id;

  $item_index = window.ymal_products.indexOf(window.ymal_products.find(arr => arr.includes(product_variant_group_id)));

  if($item_index >= 0) {

    $product_hover_html = window.ymal_products[$item_index][1];

  }

  return $product_hover_html;
}

function productAddToCartForm(product) {
  var variant_force_sold_out = false;
  var current_variant = product;
  var $addtocart_html;

  if(product.selected_variant) {
    current_variant = product.selected_variant;
  }

  if(current_variant.metafields.sas !== undefined) {
    if(window.country_iso_code == 'CA' && current_variant.metafields.sas.force_sold_out_ca) {
      variant_force_sold_out = true;
    }

    if(window.country_iso_code == 'US' && current_variant.metafields.sas.force_sold_out_us) {
      variant_force_sold_out = true;
    }

    if(window.country_iso_code == 'GB' && current_variant.metafields.sas.force_sold_out_gb) {
      variant_force_sold_out = true;
    }
  }

  if(variant_force_sold_out) {
    $addtocart_html = '<span class="sold-out">Sold Out</span>';
  } else {
    if(current_variant.inventory_quantity > 0 || current_variant.inventory_policy == 'continue') {
      $addtocart_html = '<form method="post" action="/cart/add" class="add-to-cart__form" data-money-format="' + window.shop_money_format + '" data-product-id="' + product.id + '" enctype="multipart/form-data" onsubmit="handleYmalSubmit(event)">';
      $addtocart_html += '<input type="hidden" name="form_type" value="product">';
      $addtocart_html += '<input type="hidden" name="id" data-productid="' + product.id + '" data-sku="' + current_variant.sku + '" value="' +  current_variant.id + '" />';
      $addtocart_html += '<button class="add-to-cart"><svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15.5" cy="15.5" r="15" stroke="black"/><rect x="0.242188" y="-0.242188" width="0.485541" height="15.0518" transform="matrix(-0.00239811 -0.999997 0.999997 0.00239803 8.21591 15.9664)" fill="black" stroke="black" stroke-width="0.485541"/><rect x="0.243352" y="0.243352" width="0.485542" height="15.0518" transform="matrix(0.999997 0.00239803 0.00239811 0.999997 14.9916 7.72696)" fill="black" stroke="black" stroke-width="0.485542"/></svg></button>';
      $addtocart_html += '</form>';
    } else {
      $addtocart_html = '<span class="sold-out">Sold Out</span>';
    }
  }

  return $addtocart_html;
}

function handleYmalSubmit(event) {
  event.preventDefault();
  var form = event.target;
  var formData = new FormData(form);

  var params = {
    type: 'POST',
    url: ShopifyAPI.cartRoutes.cartAddUrl + '.js',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function(line_item) {
      
    },
    error: function(XMLHttpRequest, textStatus) {
      alert('There was an error adding item! Please try again later.')
    }
  };
  jQuery.ajax(params);
}


function updateWidgetPricing(event) {
  if(event.detail.widget.id == 100439) {    // YMAL WIDGET
    setTimeout(() => {
      const pricing = document.querySelectorAll(`.rebuy-price`);
    
      pricing.forEach((price) => {
        price.textContent = price.textContent.replace('.00', '');
      });
    }, 0);
  }

  if(event.detail.widget.id == 102476 || event.detail.widget.id == 103433) {    // Cart Recommendations WIDGET and Empty Cart Featured
    setTimeout(() => {
      const pricing = document.querySelectorAll(`.rebuy-button-money`);
    
      pricing.forEach((price) => {
        price.textContent = price.textContent.replace('.00', '');
      });
    }, 0);
  }
}

function init_ajaxform(event) {
  if(event.detail.widget.id == 100439) {    // YMAL WIDGET

    setTimeout(() => {
      const ajaxform = document.querySelectorAll(`div[data-rebuy-id="100439"] .add-to-cart__form`);
    
      ajaxform.forEach((form) => {
        ajaxCart.init({
          formSelector: form,
          addToCartSelector: '.add-to-cart',
          moneyFormat: '${{amount}}'
        });
      });
    }, 0);
  }
}

function init_ymal_slider(event) {
  if(event.detail.widget.id == 100439) {    // YMAL WIDGET
    setTimeout(() => {
      init_recommendations_slider();
    }, 0);
  }
}

// document.addEventListener('rebuy.productsChange', updateWidgetPricing);
document.addEventListener('rebuy.productsChange', init_ajaxform);
document.addEventListener('rebuy.productsChange', init_ymal_slider);





function checkItemOption(item) {

}
$shipping_us_threshold = $('input[name="free-shipping-us-threshold"]').val() ? $('input[name="free-shipping-us-threshold"]').val() : '50';
$shipping_uk_threshold = $('input[name="free-shipping-uk-threshold"]').val() ? $('input[name="free-shipping-uk-threshold"]').val() : '50';
$shipping_ca_threshold = $('input[name="free-shipping-canada-threshold"]').val() ? $('input[name="free-shipping-canada-threshold"]').val() : '75';

$free_gift_us_threshold = $('body').data('thresholdUs');
$free_gift_ca_threshold = $('body').data('thresholdCa');
$free_gift_uk_threshold = $('body').data('thresholdUk');

$free_gift_name = $('body').data('freeGiftName') ? $('body').data('freeGiftName') : 'gift';

/* 
  Additional Custom Functions to Support 
  Custom Rebuy Smart Cart
*/

// SHIPSCOUT TEST

document.addEventListener('rebuy:smartcart.ready', (event) => {

  if($('#rebuy-additional-checkout-buttons').length && $('#rebuy-additional-checkout-buttons shopify-apple-pay-button').length) {
      $('.rebuy-cart__flyout-actions').addClass('has-apple-pay');
  }


  /* if(Shopify.country == 'US') {
    window._shipScout = window._shipScout || [];
    _shipScout.push(function (response) {
      var thresholdCents = response.freeShippingThresholdCents;
      Rebuy.SmartCart.settings.progress_bar.bars[0].tiers[0].presentment_currencies['USD'] = thresholdCents;
      // Rebuy.SmartCart.settings.progress_bar.bars[0].tiers[0].minimum = thresholdCents / 100;
    });
  } */
});

// SHIPSCOUT TEST ENDS

function renderEmptyHeader() {
  return '<h2 id="SmartCart_title" class="rebuy-cart__flyout-title">Your bag is empty</h2>';
}

function productVariantTitle(product) {
  var product_variant_title = '';

  if(product.selected_variant.option2 !== null) {    
    product_variant_title = product.selected_variant.option1;
  }

  return product_variant_title;
}

function cartCurrencyReplace(amount) {
  return amount.replace('$', window.cartStrings.cartCurrencySymbol);
}


function updateCartPricing(event) {

  setTimeout(() => {
    // const pricing = document.querySelectorAll(`.rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)`);
    // const shipping_pricing = document.querySelectorAll(`.rebuy-cart__progress-bar-prompt`);

    // const subtotal_amount = document.querySelectorAll(`.rebuy-cart__flyout-subtotal-amount`);
  
    // pricing.forEach((price) => {
    //   price.textContent = price.textContent.replace('.00', '');
    // });

    // shipping_pricing.forEach((price) => {
    //   price.textContent = price.textContent.replace('.00', '').replace('$ ', '$');
    // });

    // subtotal_amount.forEach((price) => {
    //   price.textContent = price.textContent.replace('.00', '').replace('$ ', '$');
    // });

  }, 0);
}

function compareatprice_has_decimals(item) {
  const SmartCart = window.Rebuy.SmartCart;
  if(SmartCart.compareAtPrice(item).toString().endsWith("00")) {
    return false;
  } else {
     return true;  
  }
}

function discounted_price_has_decimals(item) {
  if(item.discounted_price.toString().endsWith("00")) {
     return false;
  } else {
     return true;  
  }
}

function original_price_has_decimals(item) {
  var original_price = item.final_line_price / 0.85; // Discount is 15%

  if(original_price.toString().endsWith("00")) {
     return false;
  } else {
     return true;  
  }
}

function price_has_decimals(item) {
  if(item.final_line_price.toString().endsWith("00")) {
     return false;
  } else {
     return true;  
  }
}

document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  const smartcart = event.detail.smartcart;
  const item = event.detail.item;
  const item_id = item.id;

  if(item.properties['_bundle_unique'] !== undefined) {
    $bundle_unique = item.properties['_bundle_unique'];
    $cart_items = smartcart.cart.items;

    $item_updates_string = '';

    for($item of $cart_items) {
      if($item.properties['_bundle_unique'] !== undefined && $item.key != item.key) {
        if($item.properties['_bundle_unique'] == $bundle_unique) {
          $item_updates_string += 'updates[' + $item.key + ']=0&';
        }
      }
    }

    if($item_updates_string != '') {
      jQuery.post(window.Shopify.routes.root + 'cart/update.js', $item_updates_string);
    }
  }
  
});

// for Reorder Landing Page

function reorder_updateSubscriptionSelect() {
  setTimeout(() => {
    const sselect_option = document.querySelectorAll(`.rebuy-reorder__item-subscription .rebuy-select option`);

    sselect_option.forEach((ss_option) => {
      if((ss_option.innerHTML.indexOf('Months') >= 0 || ss_option.innerHTML.indexOf('Month') >= 0) && ss_option.innerHTML.indexOf('Every') == -1) {
        ss_option.innerHTML = 'Every ' + ss_option.innerHTML;
      }
    });
  }, 0);
}

document.addEventListener('rebuy:cart.enriched', (event) => { 
  setTimeout(() => {
    const sselect_option = document.querySelectorAll(`.rebuy-cart__flyout-item-subscription .rebuy-select option`);

    sselect_option.forEach((ss_option) => {
      if((ss_option.innerHTML.indexOf('Months') >= 0 || ss_option.innerHTML.indexOf('Month') >= 0) && ss_option.innerHTML.indexOf('Every') == -1) {
        ss_option.innerHTML = 'Every ' + ss_option.innerHTML;
      }
    });

    updateCartPricing();

  }, 0);
  reorder_updateSubscriptionSelect();

  setTimeout(() => {

    var $subscription_sets = document.querySelectorAll('.rebuy-cart__flyout-item.product-type-SubscriptionSet');

    $subscription_sets.forEach(function(item) {
      $onetime_group = item.querySelector('.rebuy-cart__flyout-item-subscription optgroup[label="One-Time Purchase"]');
      $frequency_group = item.querySelector('.rebuy-cart__flyout-item-subscription optgroup:nth-child(2)');

      if($onetime_group !== null) {
        item.querySelector('.rebuy-cart__flyout-item-subscription optgroup[label="One-Time Purchase"]').remove();
      }
 
      if($frequency_group !== null) {
        $frequency_group.label = "Select Frequency";
      }
    });
    
    }

  , 100);
  
});

function showItemComponents(item) {
  $bundle_contents_html = '';

  if(item.properties._bundle_contents) {
    $bundle_contents = item.properties._bundle_contents;
    $bundle_items = $bundle_contents.split('---');

    for($i=0; $i<$bundle_items.length; $i++) {
      $item_titles = $bundle_items[$i].split('***');

      $bundle_contents_html += '<div class="bundle-item"><div class="bundle-item__product-title">' + $item_titles[0] + '</div><div class="bundle-item__variant-title">' + $item_titles[1] + '</div></div>';
    }
  }

  return $bundle_contents_html;
}

function isBundle(item) {
  return (item.properties._bundle_handle == undefined) ? false : true;
}

function showBundleDetails(item, items) {
  $bundle_details = '<div class="bundle-product__details">';

  jQuery.each(items, function(index, cartItem) {
    for (var property in cartItem.properties) {
      if(cartItem.properties['_bundle_unique'] == item.properties._bundle_unique) {
        $bundle_details += '<div class="bundle-item" data-line="' + (index + 1) + '" data-line-item-key="' + cartItem.key + '"><span class="item-product-title">' + cartItem.product_title + '&mdash;</span>' + cartItem.variant_options[0] + '</div>';
        break;
      }
    }
  });

  $bundle_details += '</div>';

  return $bundle_details;
}

function itemDiscountedPrice(item) {
  return item.discounted_price;
}

function itemTotalPrice(item) {
  return item.line_price;
}

function itemOriginalPrice(item) {

  if(item.properties._bundle_discount) {

    // Bundle Discount - 8.92857143
    // Bundle Discount / 100 - 0.0892857143
    // 1 - Bundle Discount - 0.910714286
    // Original Price - Discounted Price X Above Calculation (5100 / 100) * 0.910714286
    
    item_original_price = (item.line_price) / (1 - parseFloat(item.properties._bundle_discount / 100));

    return parseInt(item_original_price);
  } else {
    return parseInt(item.line_price / 0.85); // Discount is 15%
  }
}

function itemTotalCompareAtPrice(item) {
  const SmartCart = window.Rebuy.SmartCart;
  var compare_at_price = SmartCart.compareAtPrice(item) * item.quantity;

  if(item.selling_plan_allocation !== undefined) {
    if(item.product_type !== undefined && item.product_type == 'SubscriptionSet') {
      if(SmartCart.compareAtPrice(item).toString().endsWith(".00")) {
        return compare_at_price * 100;
      } else {
        return compare_at_price;  
      }
    } else {
      if(item.product.tags.includes('Sets')) {
        return item.compare_at_price * item.quantity || item.product.variants[0].compare_at_price * 100 * item.quantity;
      } else {
        return item.selling_plan_allocation.compare_at_price * item.quantity;  
      }
    }
  } else {
    if(SmartCart.compareAtPrice(item).toString().endsWith(".00")) {
      return compare_at_price * 100;
    } else {
      return compare_at_price;  
    }
  }
}

function itemBundlePrice(item) {
  return item.properties._bundle_product_price.toString().replace('.00','');
}

function itemBundleCompareAtPrice(item) {
  return item.properties._bundle_product_compare_at_price.toString().replace('.00','');
}

function subtotal_has_decimals() {
  const Cart = window.Rebuy.Cart;
  const cart_subtotal = Cart.subtotal();

  if(cart_subtotal.toString().endsWith("00")) {
     return false;
  } else {
     return true;  
  }
}

function removeZeros(priceString) {
  return priceString.replaceAll('.00','').replaceAll('$ ','$');
}

function removeZerosRoundOff(priceString) {
  amountWithoutSymbol = parseFloat(priceString.replace(window.cartStrings.cartCurrencySymbol,''));
  roundedAmount = Math.ceil(amountWithoutSymbol);

  return window.cartStrings.cartCurrencySymbol + roundedAmount;
}

function cartSubtotal() {
  const Cart = window.Rebuy.Cart;
  return Cart.subtotal();
}

function cyberweek_variantPrice(product, variant) {
  var variant_price = variant.price;
  var variant_compare_at_price = variant.compare_at_price;

  if(Shopify.country == 'CA') {

    if(variant.presentment_prices[0].compare_at_price != null) {
      variant_compare_at_price = variant.presentment_prices[0].compare_at_price['amount'];
    }

    if(variant.presentment_prices[0].price != null) {
      variant_price = variant.presentment_prices[0].price['amount'];
    }
  }

  if(product.tags.indexOf('Sets') !== -1) {
    product_tags = product.tags.split(', ');
    discount_percent = 20;

    for($i=0; $i < product_tags.length; $i++) {
      if(product_tags[$i].indexOf('SESP_') !== -1) {
        discount_percent = product_tags[$i].split('_')[1];
      }
    }

    discount_multiplier = (100 - discount_percent) / 100;

    if(variant_compare_at_price) {
      cyberweek_price = variant_compare_at_price * 100 * discount_multiplier;
    } else {
      cyberweek_price = variant_price * 100 * discount_multiplier;
    }
  } else {
    cyberweek_price = variant_price * 100 * 0.8;
  }

  return Math.round(cyberweek_price / 100) * 100;
}

function cyberweek_variantCompareAtPrice(product, variant) {

  var variant_price = variant.price;
  var variant_compare_at_price = variant.compare_at_price;

  if(Shopify.country == 'CA') {

    if(variant.presentment_prices[0].compare_at_price != null) {
      variant_compare_at_price = variant.presentment_prices[0].compare_at_price['amount'];
    }

    if(variant.presentment_prices[0].price != null) {
      variant_price = variant.presentment_prices[0].price['amount'];
    }
  }
  
  // if(product.tags.indexOf('Sets') !== -1) {
  //   return variant_compare_at_price;
  // } else {
  //   return variant_price;  
  // }

  if(variant_compare_at_price) {
    return variant_compare_at_price * 100;
  } else {
    return variant_price * 100;  
  }
}

function cyberWeek() {
  if($('body').hasClass('cyberweekactive')) {
    return true;
  } else {
    return false;
  }
}


function progressStepLabel(tier) {
  if(tier.type == 'shipping') {
    return 'Free Shipping';
  } else {
    return tier.product_amount_reached_label_text;
  }
  
}

function rebuyCartTotal() {
  return Rebuy.SmartCart.subtotalNumber().toString();
}

function itemIsFreeGift(item) {
  if(item.discounted_price == 0) { 
    return true; 
  } else {
    return false;
  }
}

function shippingThreshold() {

  var shippingThreshold = '$' + $shipping_us_threshold;

  if(Shopify.country == 'CA') {
    shippingThreshold = '$' + $shipping_ca_threshold;
  }  

  if(Shopify.country == 'GB') {
    shippingThreshold = '£' + $shipping_uk_threshold;
  }

  return shippingThreshold;
}

function freeProductThreshold() {
  var freeProductThreshold = '$' + $free_gift_us_threshold;

  if(Shopify.country == 'CA') {
    freeProductThreshold = '$' + $free_gift_ca_threshold;
  }  

  if(Shopify.country == 'GB') {
    freeProductThreshold = '£' + $free_gift_uk_threshold;
  }

  return freeProductThreshold;
}

function shippingMinimumReached() {
  var shippingThreshold = parseInt($shipping_us_threshold) * 100;
  const Cart = window.Rebuy.Cart;

  if(Shopify.country == 'GB') {
    shippingThreshold = parseInt($shipping_uk_threshold) * 100;
  }

  if(Shopify.country == 'CA') {
    shippingThreshold = parseInt($shipping_ca_threshold) * 100;
  }

  if(Cart.subtotal() >= shippingThreshold) {
    return true; 
  } else {
    return false;
  }
}

function showIndicatorMessage() {
  var freeProductThreshold = $free_gift_us_threshold * 100;
  const Cart = window.Rebuy.Cart;

  if(Shopify.country == 'GB') {
    freeProductThreshold =  $free_gift_uk_threshold * 100;
  }

  if(Shopify.country == 'CA') {
    freeProductThreshold =  $free_gift_ca_threshold * 100;
  }

  if(Cart.subtotal() >= freeProductThreshold) {
    return false;
  } else {
    return true;
  }
}

function balanceCalculator() {
  var shippingThreshold = parseInt($shipping_us_threshold) * 100;
  var freeProductThreshold = $free_gift_us_threshold * 100;
  const Cart = window.Rebuy.Cart;

  if(Shopify.country == 'CA') {
    shippingThreshold = parseInt($shipping_ca_threshold) * 100;
    freeProductThreshold = $free_gift_ca_threshold * 100;
  }

  if(Shopify.country == 'GB') {
    shippingThreshold = parseInt($shipping_uk_threshold) * 100;
    freeProductThreshold = $free_gift_uk_threshold * 100;
  }

  if(Cart.subtotal() >= shippingThreshold) {
    return freeProductThreshold - Cart.subtotal(); 
  } else {
    return shippingThreshold - Cart.subtotal();
  }
}

function indicatorMessage() {
  indicator_message = '';

  if(shippingMinimumReached()) {
    indicator_message = 'a free ' + $free_gift_name;
  } else {
    indicator_message = 'free shipping';
  }

  return ' away from ' + indicator_message;
  
}

function isItemBundle(item) {
  return item.properties['_bundle_contents'];
}

function rebuyCountry() {
  return Shopify.country;
}

function isSampleItem(item) {
  return item.properties['_ss_sample'] || item.product_type == 'Sample';
}
(function($){

	$(document).ready(function(){

		$('#search_sortBy').on('change',function(){

			if (!location.search.length) {
		        return {};
	      	}

	      	var params = {};

	      	for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');i < aCouples.length;i++) {
        		aKeyValue = aCouples[i].split('=');
        		if (aKeyValue.length > 1) {
          			params[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        		}
      		}

      		params.sort_by = $(this).val();
      		location.search = decodeURIComponent(jQuery.param(params));

		});

	});

})(jQuery);

(function($){

	$(document).ready(function(e){
		slide_sephora_popup();
	});

   	$(window).on('load',function(e){
		// slide_sephora_popup();
	});

	$(document).on('click','#sephora-popup .popup-close__trigger, #sephora-popup .sephora-continue-btn',function(e){
   		e.preventDefault();
   		setup_sephora_cookie();
   		$('#sephora-popup').removeClass('slide-in');
   		$('body').removeClass('has-sephora-popup');
   		slide_klaviyo_popup();
   	});

   	$(document).on('click','#sephora-popup .btn.sephora-link',function(e){
   		setup_sephora_cookie();
   		$('#sephora-popup').removeClass('slide-in');
   		$('body').removeClass('has-sephora-popup');
   	}); 

	function slide_sephora_popup() {
		$iso_codes = ["AU","NZ","SG","TH","MY","PH","AE","OM","BH","QA","KW","eu","SA","FR","ES","PT","IT","PL","GR","CZ","DK","DE","RO","SE","CH"];

		if(!sessionStorage.getItem('sephora-popup') && ($.inArray($('body').data('country'), $iso_codes) > -1 || $.inArray($('body').data('market'), $iso_codes) > -1)) {
      		setTimeout(function(){
          		$("#sephora-popup").addClass("slide-in");
          		$('body').addClass('has-sephora-popup');
      		}, 0);
      	} else if(!sessionStorage.getItem('international-popup') && $('body').data('market') == 'international') {
      		if(!sessionStorage.getItem('international-popup')) {
      			$('#internationalPopup').modal('show');
      		}
      	} else {
      		// slide_klaviyo_popup();
      	}
	}

   	function setup_sephora_cookie() {
   		if(!sessionStorage.getItem('sephora-popup')) {
			sessionStorage.setItem('sephora-popup', '1');
		}
   	}

   	function slide_klaviyo_popup() {

		if(!Cookies.get('ss-newsletter')) {
      		setTimeout(function(){
          		$("#ss-popup").addClass("slide");
          		$('body').addClass('has-popup');
          		setup_cookie();
      		}, 1000);
      	}
	}

	$('#internationalPopup').on('hidden.bs.modal', function(e){
      setup_international_cookie();
    });
	

   	function setup_international_cookie() {
   		if(!sessionStorage.getItem('international-popup')) {
			sessionStorage.setItem('international-popup', '1');
		}
   	}

})(jQuery);
/* PRODUCT SETS JS */

$bundle_toggle = '.js-utility-nav-toggle';
$bundle_toggleText = '.js-utility-nav-toggle-text';
$bundle_toggleSwatch = '.js-utility-nav-toggle-swatch';
$bundle_dropdown = '.js-utility-nav-dropdown';
$swatch_selector = '.ProductBundleSwatchSelector';
$swatches = '.js-swatch-selection';
$underlay = '.UnderlayTransparent';
$navigation_item = '.ProductBundleSwatchSelector__navigation-item';
$formInput_selector = '.js-variant-input';
$formInputs = '.js-bundle-product-form .js-variant-input';
$bundleUniqueIdInputs = '.js-variant-input-property-bundle-unique';
$alternate_form_selector = '.js-bundle-product-form';
$form_selector = '.js-product-form';
$addtocart_btn = '.ProductForm__AddToCart';
$bundle_toggleLabel = '.ProductBundleSwatchSelector__navigation-label';

$bundle_item = '.ProductBundleSelectorItem';
$bundle_hero_image = '.ProductBundleSelectorItem__hero-image';

$(document).on('ready',function(){
  setUniqueIds();
  // checkForSelections();
});

$(document).on('click', $bundle_toggle, function(e){
  e.preventDefault();
  $(this).attr('aria-expanded', $(this).attr('aria-expanded')=='false' ? 'true' : 'false');
  $(this).parents($swatch_selector).toggleClass('is-expanded');
  $($underlay).toggleClass('UnderlayTransparent--active');
});

$(document).on('click', '.UnderlayTransparent', function(e){
  e.preventDefault();
  $($underlay).removeClass('UnderlayTransparent--active');
  $($swatch_selector).removeClass('is-expanded');
  $($bundle_toggle).attr('aria-expanded','false');
});

$(document).on('click', $swatches, function(e) {
  e.preventDefault();
  $data_swatch_style = $(this).data('swatchStyle');
  $data_color_name = $(this).data('colorName');
  $data_color_description = $(this).data('colorDescription');
  $data_variant_id = $(this).data('variantId');
  $data_variant_image = $(this).data('variantImage');

  $(this).addClass('ProductSwatch__swatch--selected').parents($navigation_item).siblings().find($swatches).removeClass('ProductSwatch__swatch--selected');
  $(this).parents($swatch_selector).addClass('is-selected').removeClass('is-expanded');
  $($underlay).removeClass('UnderlayTransparent--active');
  $(this).parents($swatch_selector).find($bundle_toggleSwatch).attr('style',$data_swatch_style);
  $(this).parents($swatch_selector).find($bundle_toggleText).text($data_color_name);
  $(this).parents($swatch_selector).find($formInput_selector).val($data_variant_id);
  $(this).parents($swatch_selector).find($bundle_toggleLabel).html($data_color_name);
  $(this).parents($bundle_item).find($bundle_hero_image).find('.Media').removeClass('is-loaded');
  $(this).parents($bundle_item).find($bundle_hero_image + '[data-variant-id="' + $data_variant_id + '"]').find('.Media').addClass('is-loaded');
  $('.ProductBundleSelectorItem').find('.ProductBundleSwatchSelector__navigation-label').removeClass('error');


  $total_tobe_selected = $('.ProductBundleSwatchSelector.selectable').length;
  $total_selected = $('.ProductBundleSwatchSelector.selectable.is-selected').length;
  $choose_scents_button = $('.ProductForm__AddToCart.choose-scents');

  if($choose_scents_button) {
    $circles = $choose_scents_button.find('.circle');

    $circles.each(function(i,e){
      if($(this).index() < $total_selected) {
        $(this).addClass('active');
      }
    });

    if($total_tobe_selected == $total_selected) {
      $original_text = $choose_scents_button.data('originalText');
      $choose_scents_button.html($original_text);
      $choose_scents_button.removeClass('choose-scents');
    }
  }

  // alert($total_tobe_selected);
  // alert($total_selected);

});

$(document).on('click','.ProductForm__AddToCart.choose-scents',function(e){
  e.preventDefault();

  if($(window).width() < 992) {
    $('html,body').animate({ scrollTop: $('#product-form__wrapper').offset().top - 100 }, 500 );
  }
});

$(document).on('click', $addtocart_btn, function(e){
  e.preventDefault();
  $curr_btn = $(this);

  if(!getselectedInputs()) {
    $($formInputs).each(function(){
      if($(this).val() == "") { 
        $(this).parents('.ProductBundleSelectorItem').find('.ProductBundleSwatchSelector__navigation-label').addClass('error');
      }
    });

    if($curr_btn.hasClass('sets')) {
      $('html, body').animate({ scrollTop: $('#product-form__wrapper').offset().top }, 500);
    }
    return false;
  }

  $(this).addClass('is-adding');
  var alternateForm = document.querySelector($alternate_form_selector);
  var mainForm = document.querySelector($form_selector);
  // var form = alternateForm || mainForm;
  // var formData = new FormData(form);
  var form = $('.js-bundle-product-form');

  var $items_to_add_array = {};
  var $total_items = form.find(".ProductBundleSelectorItem").length - 1;

  form.find(".ProductBundleSelectorItem").each(function(iin,iiv){
    var item_id_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']id"]';
    var bundle_handle_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_handle]"]';
    var bundle_discount_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_discount]"]';
    var bundle_price_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_price]"]';
    var bundle_unique_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_unique]"]';

    var bundle_product_url_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_product_url]"]';
    var bundle_product_title_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_product_title]"]';
    var bundle_product_image_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_product_image]"]';
    var bundle_product_price_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_product_price]"]';
    var bundle_product_compare_at_price_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_product_compare_at_price]"]';
    var item_unique_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_item_unique]"]';

    var $item_id = $(this).find(item_id_field).val();
    var $bundle_handle = $(this).find(bundle_handle_field).val();
    var $bundle_discount = $(this).find(bundle_discount_field).val();
    var $bundle_price = $(this).find(bundle_price_field).val();
    var $bundle_unique = $(this).find(bundle_unique_field).val();

    var $bundle_product_url = $(this).find(bundle_product_url_field).val();
    var $bundle_product_title = $(this).find(bundle_product_title_field).val();
    var $bundle_product_image = $(this).find(bundle_product_image_field).val();
    var $bundle_product_price = $(this).find(bundle_product_price_field).val();
    var $bundle_product_compare_at_price = $(this).find(bundle_product_compare_at_price_field).val();

    var $item_unique = $(this).find(item_unique_field).val();

    var $item_properties = { '_bundle_handle': $bundle_handle, '_bundle_discount': $bundle_discount, '_bundle_price': $bundle_discount, '_bundle_unique': $bundle_unique, '_bundle_product_url': $bundle_product_url, '_bundle_product_title': $bundle_product_title, '_bundle_product_image': $bundle_product_image, '_bundle_product_price': $bundle_product_price, '_bundle_product_compare_at_price': $bundle_product_compare_at_price, '_item_unique': $item_unique };

    var $item = { 'id': $item_id, 'quantity': 1, 'properties': $item_properties };

    $items_to_add_array[iin] = $item;

    if(iin == $total_items) { 

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          "items": $items_to_add_array
        },
        success: function() {
          setUniqueIds();
          ajaxCart.load();
          $($addtocart_btn).removeClass('is-adding');
        }
      });

    }
  });
  
  /* $.ajax({
    url: '/cart/add',
    method: 'post',
    data: formData,
    processData: false,
    contentType: false,
    cache: false,
    success: function() {
      document.dispatchEvent(new CustomEvent('theme:loading:end')); 
      document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: $('.js-variant-input').length - 1 } }));
      setUniqueIds();
    },
    error: function() { alert('some error occurred'); setUniqueIds(); }
  }); */
});

function getselectedInputs() {
  var $valid = true;
  $($formInputs).each(function(){
    if($(this).val() == "") { $valid = false; }
  });

  return $valid;
}

function setUniqueIds() {
  const $millisecs = Date.now();

  $($bundleUniqueIdInputs).each(function(){
    var $initial_val = $(this).data('initialValue');
    $(this).val($initial_val + '__' + $millisecs);
  });
}

function checkForSelections() {
  if(getselectedInputs()) { 
    $($addtocart_btn).removeAttr('disabled').html($($addtocart_btn).data('originalText'));
  } else { 
    $($addtocart_btn).attr('disabled','disabled').html($($addtocart_btn).data('disabledText'));
  }
}
(function($){

	$(document).ready(function(){
		/* if(!sessionStorage.getItem('spk-popup') && $('body').data('country') == 'GB') {
      		$('#spkPopup').modal('show');
      	} */
	});

   	$('#spkPopup').on('shown.bs.modal', function(e){
      setup_spk_cookie();
    });

   	function setup_spk_cookie() {
   		if(!sessionStorage.getItem('spk-popup')) {
			sessionStorage.setItem('spk-popup', '1');
		}
   	}

})(jQuery);
(function($){

	function getURLParameter(name) {
  		const urlParams = new URLSearchParams(window.location.search);
  		return urlParams.get(name);
	}

	$(document).ready(function(){
		$('body#gift-guide').scrollspy({ target: '#gift-guide-nav', offset: 200 });

		const sectionId = getURLParameter('sectionid');

		if(sectionId !== null) {
			setTimeout(function(){
				move_to_element($('#' + sectionId));	
			}, 500);
			
		}
	});

	$(document).on('click','.ss-giftguide-hero .item-grid .item',function(e){
		$target_element = $('#' + $(this).data('target'));
		move_to_element($target_element);
	});

	$(document).on('click','#gift-guide-nav ul li a', function(e){
		e.preventDefault();
		$target_element = $($(this).attr('href'));
		move_to_element($target_element);
	});

	function move_to_element($element) {
		if($element.length) {

			$distance = 175;

			if($(window).width() < 992) {
				$distance = 160;
			}

			if($(window).width() < 768) {
				$distance = 145;
			}

			$('html, body').animate( { scrollTop: $element.offset().top - $distance }, 1500, 'easeInOutExpo' );
		}
	}


	function showhideGiftGuideHeader() {
		var $div = document.querySelector('.ss-giftguide-hero');
		var $header = document.getElementById('gift-guide__header');

		if($div && $header) {
			var $rect = $div.getBoundingClientRect();
			var $bottom_offset = 125;

			if($rect.bottom <= $bottom_offset) {
				$header.classList.add('active');
			} else {
				$header.classList.remove('active');
			}
		}
	}

	// Initial check
	showhideGiftGuideHeader();

	// Check on scroll
	window.addEventListener('scroll', showhideGiftGuideHeader);

	// Optional: Check on resize
	window.addEventListener('resize', showhideGiftGuideHeader);

})(jQuery);
(function($){

	$(document).ready(function(){

		$(document).on('click','.ss-hero .btn.jump-to-collection, .ss-hero .hero__link.jump-to-collection, .ss-fullbleed-image a.jump-to-collection', function(e){
			e.preventDefault();
			
			if($('#CollectionSection').length) {
				$('html,body').animate({ scrollTop: $('#CollectionSection').offset().top - 120 }, 500);
			}
		});

		$(document).on('click','.btn-818-shopnow, .media-818__link', function(e){
			e.preventDefault();
			
			if($('.ss-product.intro-with-media__meta').length) {
				$('html,body').animate({ scrollTop: $('.ss-product.intro-with-media__meta').offset().top - 150 }, 500);
			}
		});

	});

	$(window).on('load', function(){
		if($('body').attr('id') == 'lily-amp-yuzu') {
			const urlParams = new URLSearchParams(window.location.search);
			const jumptoCollection = urlParams.has('jumptocollection');

			if($('#CollectionSection').length && jumptoCollection) {
				$('html,body').animate({ scrollTop: $('#CollectionSection').offset().top - 120 }, 500);
			}
		}
	});

})(jQuery);

(function($){

	$(document).ready(function(){

	 	/* $('.ss-product .single-option-radio .single-option-selector__radio').on('change',function(e){
	 		e.preventDefault();
	 		
	 		var $radio_group_name = $(this).attr('name');
	 		var $selected_variant = $('input[name="' + $radio_group_name + '"]:checked+label');

	 		var $selected_variant_id = $selected_variant.data('variantId');
	 		var $selected_variant_image = $selected_variant.data('variantImage');
	 		var $selected_variant_video = $selected_variant.data('variantVideo');

	 		$(this).parents('.ss-product').find('.add-to-cart__form').find('input[name="id"]').val($selected_variant_id);
	 		$(this).parents('.ss-product').find('.ss-product__image').attr('src', $selected_variant_image).attr('srcset','');

	 		if("ontouchstart" in window || "ontouch" in window) {
			} else {
				$(this).parents('.ss-product').find('video').find('source').prop('src', $selected_variant_video);
				$(this).parents('.ss-product').find('video').load();
			}
	 	}); */

	 	$('.ss-product .quick-add-radio .quick-add-radio__input').on('change', function(e){
	    	e.preventDefault();

	    	$radio_input = $(this);
	    	$selected_option = $radio_input.val();

	    	$atc_form = $radio_input.closest('.add-to-cart__quick-add-popup').siblings('.add-to-cart__form');
	    	
	    	if($selected_option == 'subscription') {
	    		$selling_plan = $radio_input.siblings('.quick-add-radio__label').find('.variant-selling-plan').val();
	    		$selling_plan_input = '<input type="hidden" name="selling_plan" value="' + $selling_plan + '">';
	    		$atc_form.append($selling_plan_input);
	    	} else {
	    		$atc_form.find('input[name="selling_plan"]').remove();
	    	}
	    });

	    $('.ss-product .quick-add-radio .variant-selling-plan').on('change', function(e){
	    	e.preventDefault();
	    	$select = $(this);
	    	$selected_selling_plan = $select.val();

	    	$atc_form = $select.closest('.add-to-cart__quick-add-popup').siblings('.add-to-cart__form');
	    	$selling_plan = $atc_form.find('input[name="selling_plan"]');

	    	if($selling_plan.length) {
	    		$selling_plan.val($selected_selling_plan);	
	    	} else {
	    		$selling_plan_input = '<input type="hidden" name="selling_plan" value="' + $selected_selling_plan + '">';
	    		$atc_form.append($selling_plan_input);
	    	}
	    	
	    });
		
	});

	var video = $("video.hover-img");

    video.mouseenter(function () {
    	if("ontouchstart" in window || "ontouch" in window) {

		} else {
			$video = $(this);
    		if(!$video.hasClass('is-loaded')) {
	    		$video.hide();
				$video.get(0).load();	
	    		$video.attr('loop', true);
				$video.attr('autoplay', true);
		        
	       	}
       }
    }).mouseleave(function () { 
    	// if($(this).playing) {
        // 	$(this).get(0).pause(); 
        // }
    });

    hover_videos = document.querySelectorAll('video.hover-img');

    hover_videos.forEach(function(item, index) {
    	item.addEventListener('loadeddata', function() {
    		item.classList.add('is-loaded');
    		item.play();
    		item.style.display = 'block';
	    }, false);
    });


    $(document).on('click','.ss-product .add-to-cart__quick-add-trigger',function(e){
    	e.preventDefault();
    	$current_product = $(this).closest('.ss-product');
    	$current_product.addClass('popup-active');
    	$current_product_siblings = $current_product.siblings();
    	$current_product_siblings.removeClass('popup-active').find('.quick-add-radio').removeClass('active');
    	$current_product_siblings.find('.quick-add-radio.onetime-radio').addClass('active');
    	$current_product_siblings.find('input[name="selling_plan"]').remove();

    	

    	$slider_item = $current_product.closest('.product-slider__item');
    	if($slider_item.length) {
    		$slider_item_siblings = $slider_item.siblings('.product-slider__item');
    		$slider_item_siblings.find('.ss-product').removeClass('popup-active').find('.quick-add-radio').removeClass('active');
    		$slider_item_siblings.find('.ss-product').find('.quick-add-radio.onetime-radio').addClass('active');
    		$slider_item_siblings.find('.ss-product').find('input[name="selling_plan"]').remove();
    	}
    });

    $(document).on('click','.ss-product .quick-add-radio',function(e){
    	$(this).addClass('active').siblings().removeClass('active');
    });

    $(document).on('click',function(e){
    	var $target = $(e.target);
    	if(!$target.closest('.ss-product').length && $('body').hasClass('template-collection')) {
    		$('.ss-product').removeClass('popup-active');
    	}
    });


})(jQuery);



(function($){

	$(document).ready(function(){

		var $reviewsSlider = $('.swiper.ss-reviews-slider__slider');
		
		$reviewsSlider.each(function(index) {
    		var $this = $(this);
    		$this.addClass('reviews-swiper-slider-' + index);

    		var swiper = new Swiper('.reviews-swiper-slider-' + index, {
      			slidesPerView: 'auto',
      			spaceBetween: 10,
      			loop: true,
      			centeredSlides: true,
      			speed: 500,
      			freeMode: {
      				enabled: true
      			},
      			mousewheel: {
      				enabled: true,
    				sensitivity: 3,
    				forceToAxis: true,
    				thresholdDelta: 250,
    				thresholdTime: 1200
      			}
   			});
		});
	});

})(jQuery);
(function($){

	const forms = document.querySelectorAll('.product-subscription-form');

	if(forms) {
		forms.forEach((form) => {
			form.addEventListener("submit", async(e) => {
				e.preventDefault();

				$btn = form.querySelector('.btn-subscription__add-to-cart');
				$btn.classList.add('is-adding');
				$btn.setAttribute('aria-disabled', true);

				$variant_id = form.querySelector('[name="id"]').value;
				$variant_selling_plan = form.querySelector('[name="selling_plan"]').value;

				$items_array = new Array();
				$item = { id: $variant_id, quantity: 1, selling_plan: $variant_selling_plan }
				$items_array.push($item);

				await fetch('/cart/add.js', {
		      		method: 'post',
		      		headers: {
		        		'Content-Type': 'application/json'
		      		},
			      	body: JSON.stringify({
			        	items: $items_array
			      	})
			    }).then(function(){
			    	$btn.classList.remove('is-adding');
					$btn.removeAttribute('aria-disabled');
			    });
			});
		});
		
	}

	$(document).ready(function(){
		$('.ss-subscription-product').each(function(i,e){
			update_variant_link($(this));
		});
	});

	$('.ss-subscription-product .variant-selling-plan').on('change',function(e){
		$subscription_product = $(this).parents('.ss-subscription-product');
		update_variant_link($subscription_product);
	});

	$('.ss-subscription-product .product-variants').on('change',function(e){

		$subscription_product = $(this).parents('.ss-subscription-product');
		$selected_option = $(this).find(':selected');

		// Fetch Current Variant Data
		$is_available = $selected_option.data('available');
		$variant_image = $selected_option.data('image');
		$variant_hovervideo = $selected_option.data('hovervideo');
		$variant_price = $selected_option.data('price');
		$variant_subscription_price = $selected_option.data('subscriptionPrice');
		$variant_scent = $selected_option.data('scent');
		$variant_lock = $selected_option.data('variantLock');

		if($variant_lock && !sessionStorage.getItem('lockPDPCollection')) {
			$('#productLockModal').modal('show');
			$(this)[0].selectedIndex = 0;
			return false;
		}

		// Fetch Elements to be updated
		$button = $subscription_product.find('.btn-subscription__add-to-cart');
		$media = $subscription_product.find('.product__image-wrapper .ss-product__image');
		$hovervideo = $subscription_product.find('.product__image-wrapper video');
		$price = $subscription_product.find('.product__meta-price .regular-price');
		$subscription_price = $subscription_product.find('.product__meta-price .subscription-price');
		$scent = $subscription_product.find('.product-subscription-form__left');

		// Update Image
		$media.attr('src', $variant_image);
		$media.attr('srcset', $variant_image);
		$media.siblings('source').attr('srcset', $variant_image);

		// Update Hover Video 
		$hovervideo.find('source').attr('src', $variant_hovervideo);
		$hovervideo.get(0).load();

		// Update Price
		$price.text($variant_price);
		$subscription_price.text($variant_subscription_price);

		// Update Scent
		$scent.attr('data-scent', $variant_scent);

		update_variant_link($subscription_product);


		if($is_available) {
			$button.removeAttr('disabled');
			$button.find('.inner-text').text('Add to Bag');
		} else {
			$button.attr('disabled','disabled');
			$button.find('.inner-text').text('Sold Out');
		}
	});

	function update_variant_link($subscription_product) {
		$variant_url = $subscription_product.find('.product-variants').find(':selected').data('url');

		if($variant_url == undefined) {
			$variant_url = $subscription_product.find('.product-variants').find('option:first-child').data('url');
		}

		$is_set = $subscription_product.find('.product-variants').find(':selected').data('is-set');

		if($is_set) {
			$variant_link = $variant_url;
		} else {
			$variant_selling_plan = $subscription_product.find('.variant-selling-plan').val();
			$variant_link = $variant_url + '&selling_plan=' + $variant_selling_plan;
		}

		// Update Anchor
		$anchor = $subscription_product.find('.product__image-wrapper .product__image-link');
		$anchor.attr('href', $variant_link);
	}

	$(document).on('click','.btn-scroll-to-products', function(e){
		e.preventDefault();
		$target = $('#CollectionSubscription');

		if($target.length) {
			$('html,body').animate( { scrollTop: $target.offset().top - 125 }, 500);
		}
	});

})(jQuery);
document.addEventListener('DOMContentLoaded', () => {
  	const messages = document.querySelectorAll('.ss-announcement__item');
  	let currentMessageIndex = 0;

  	function cycleMessages() {
	    // Get the current active message
	    const currentMessage = messages[currentMessageIndex];

	    // Prepare the current message to fade out
	    currentMessage.classList.add('leaving');
	    currentMessage.classList.remove('active');

	    // Determine the index of the next message
	    currentMessageIndex = (currentMessageIndex + 1) % messages.length;

	    // Get the next message and immediately set it to active
	    const nextMessage = messages[currentMessageIndex];
	    nextMessage.classList.remove('leaving');
	    nextMessage.classList.add('active');
	}

  	// Set the interval for cycling messages (e.g., every 5 seconds)
  	setInterval(cycleMessages, 5000); 
});
(function($){

	$(window).on('load',function(e){
		if($('body').data('market') == 'eu') {
			$('#stockists__filter li[data-region="europe"]').trigger('click');
		}

		/* if($('body').data('market') == 'uk') {
			$('#stockists__filter li[data-region="uk"]').trigger('click');
		} */
	});

	$(document).ready(function(){

	 	$(document).on('click','.stockists__filter-trigger',function(e){
	 		e.preventDefault();
	 		$(this).toggleClass('open');
	 		$('#stockists__filter').slideToggle('fast');
	 	});

	 	$(document).on('click','#stockists__filter li',function(e){
	 		e.preventDefault();
	 		var $filter_region = $(this).data('region');
	 		var $filter_label = $(this).text();

	 		$('#stockists__filter-current-item').find('span').text($filter_label);
	 		$('#stockists__filter li').show();
	 		$('#stockists__filter li[data-region="' + $filter_region + '"]').hide();

	 		if($filter_region == 'all') {
	 			$('#stockists__content .region').show();	
	 			$('#stockists__content .region-title').show();
	 		} else {
	 			$('#stockists__content .region').hide();
	 			$('#stockists__content .region-title').hide();
	 			$('#stockists__content .region.' + $filter_region).show();
	 		}

	 		$('.stockists__filter-trigger').removeClass('open');
	 		$('#stockists__filter').slideUp('fast');
	 	});
		
	});

})(jQuery);
(function($){

	$(document).ready(function(){

		var $swiperSelector = $('.subscription-swiper');
		
		$swiperSelector.each(function(index) {
    		var $this = $(this);
    		$this.addClass('swiper-slider-' + index);

    		if(!$this.hasClass('swiper-initialized')) {

    		var swiper = new Swiper('.swiper-slider-' + index, {
      			slidesPerView: 'auto',
      			spaceBetween: 16,
      			slidesOffsetAfter: 16,
      			loop: false,
      			centeredSlides: false,
      			speed: 500,
      			cssMode: true,
      			freeMode: {
      				enabled: false
      			},
      			mousewheel: {
      				enabled: true,
    				sensitivity: 3,
    				forceToAxis: true,
    				thresholdDelta: 250,
    				thresholdTime: 1200
      			},
      			scrollbar: {
      				el: $(this).find('.swiper-scrollbar'),
        			draggable: true,
        			dragSize: 85,
        			enabled: false,
        			snapOnRelease: false
      			},

      			breakpoints: {

      				992: {
      					centeredSlides: false,
      					loop: false,
      					cssMode: false,
      					spaceBetween: 32,
      					speed: 2000,
      					slidesOffsetAfter: 32,
      					scrollbar: {
		        			enabled: true
		      			},
		      			freeMode: {
		      				enabled: true,
		      				sticky: false,
		      				momentum: true,
		      				momentumRatio: 5,
		    				momentumBounce: true
		      			}
      				}
      			}
      			
   			});

    		}
		});

	 	/* $('.subscription-slider').each(function(index){

	 		var $prev_item = $(this).parent().siblings('.subscription-slider__header').find('.slick-prev');
	 		var $next_item = $(this).parent().siblings('.subscription-slider__header').find('.slick-next');

	 		if(!$(this).hasClass('slick-initialized')) {
	 			$(this).slick({
	 				arrows: true,
	 				dots: false,
	 				infinite: true,
	 				autoplay: false,
	 				swipe: true,
	 				variableWidth: true,
	 				prevArrow: $prev_item,
	 				nextArrow: $next_item
	 			});
	 		}

	 	}); */
		
	});

})(jQuery);
(function($){

	$(document).ready(function(){

		$('a[href*="#"]:not([href="#"])').click(function(e) {
	     	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
		
	      		var hash_target = $('[data-accordion-name=' + this.hash.slice(1) + ']');
	      
		      	if(hash_target.length) {
					hash_target.find('.accordion-trigger').trigger('click');
				}
	    	}
	  	});


		// Coming from different page

		var hash = window.location.hash;

		if ( hash == '' || hash == '#' || hash == undefined || window.location.href.includes('/pages/quiz'))
			return false;

		var hash_target = $('[data-accordion-name=' + hash.slice(1) + ']');

		if(hash_target.length) {
			hash_target.find('.accordion-trigger').trigger('click');
		}
	});

	$(window).on('load', function(){

		setTimeout(function(){

			var hash = window.location.hash;

			if ( hash == '' || hash == '#' || hash == undefined)
				return false;

			$page_hash_target = $('[name=' + hash.slice(1) + ']');
			$page_hash_id_target = $('[id=' + hash.slice(1) + ']');

			if($page_hash_target.length) {
				$('html,body').stop().animate({
					scrollTop: $page_hash_target.offset().top - 100
				}, 'ease-in');
			} else if($page_hash_id_target.length) {
				$('html,body').stop().animate({
					scrollTop: $page_hash_id_target.offset().top - 180
				}, 'ease-in');
			}
		}, 250);
	});

})(jQuery);
(function($){

  $(document).ready(function(){

    enquire.register('screen and (min-width: 768px)', {
      
      match: function() {
        $('.hero__media').each(function(i,v) {
          if($(this).find('video').length) {
            $video_src = $(this).find('video').find('source').data('src');
            $(this).find('video').find('source').prop('src', $video_src);
            $(this).find('video').load();
          }
        });
      }

    });

    enquire.register('screen and (max-width: 767px)', {

      match: function() {
        $('.hero__media:not(.remove-video-on-mobile').each(function(i,v) {
          if($(this).find('video').length) {

            if($(this).find('video').find('source').data('mobileSrc') !== undefined) {
              $video_src = $(this).find('video').find('source').data('mobileSrc');
            } else {
              $video_src = $(this).find('video').find('source').data('src');
            }

            $(this).find('video').find('source').prop('src', $video_src);
            $(this).find('video').load();
          }
        });
      }

    });


  });

  $(window).on('load', function(){

    enquire.register('screen and (max-width: 767px)', {

      match: function() {

        $('.img-switch-on-mobile').each(function(i,v){

          $(this).css('opacity', 0);
          
          $desktop_src = $(this).attr('src');
          $desktop_srcset = $(this).attr('srcset');
          $desktop_width = $(this).attr('width');
          $desktop_height = $(this).attr('height');

          $mobile_src = $(this).data('mobileSrc');
          $mobile_srcset = $(this).data('mobileSrcset');
          $mobile_width = $(this).data('mobileWidth');
          $mobile_height = $(this).data('mobileHeight');

          // Set Desktop Attributes
          $(this).attr('data-desktop-src',$desktop_src);
          $(this).attr('data-desktop-srcset',$desktop_srcset);
          $(this).attr('data-desktop-width',$desktop_width);
          $(this).attr('data-desktop-height',$desktop_height);

          $(this).attr('src',$mobile_src);
          $(this).attr('srcset',$mobile_srcset);
          $(this).attr('width',$mobile_width);
          $(this).attr('height',$mobile_height);

          $(this).css('opacity', 1);

        });

      }
    });

    enquire.register('screen and (min-width: 768px)', {
      
      match: function() {

        $('.img-switch-on-mobile').each(function(i,v){

          $(this).css('opacity', 0);
          
          $desktop_src = $(this).data('desktopSrc');
          $desktop_srcset = $(this).data('desktopSrcset');
          $desktop_width = $(this).data('desktopWidth');
          $desktop_height = $(this).data('desktopHeight');

          $(this).attr('src',$desktop_src);
          $(this).attr('srcset',$desktop_srcset);
          $(this).attr('width',$desktop_width);
          $(this).attr('height',$desktop_height);

          $(this).css('opacity', 1);

        });

      }

    });

  });

})(jQuery);
(function($){

	$(document).on('click','#terms-popup .popup-close__trigger, #terms-popup .terms-shop__btn, #terms-popup--overlay',function(e){
   		e.preventDefault();
   		$('#terms-popup').fadeOut();
   		$('body').removeClass('has-terms-popup');
   	});

   	$(document).on('click','.terms-popup__trigger',function(e){
   		e.preventDefault();
   		$('#terms-popup').fadeIn();
   		$('body').addClass('has-terms-popup');
   	});

})(jQuery);
(function($){

	$(document).ready(function(){

		if("ontouchstart" in window || "ontouch" in window) {

			 /* if($('.ss-hero').length && !$('.ss-hero').hasClass('lululemon-style') && !$('.ss-hero').hasClass('full-width')) {
				$outer_margin = 16

				if($(window).width > 768) {
					$outer_margin = 24;
				}

				$total_height = $('.site-header').outerHeight(true) + $outer_margin;

				if($('.ss-hero').hasClass('announcement-active')) {
					$total_height = $total_height + $('#ss-top-announcement').outerHeight(true);
				}

				if($('#header-nav').length) {
					$total_height = $total_height + $('#header-nav').outerHeight(true);
				}

				$('.ss-hero .hero__inner').css('height', window.innerHeight - $total_height);
			} */

		} else {

			$('.ss-product').on('mouseenter',function(e){
				$prod_video = $(this).find('video');

				if($prod_video.addEventListener) {
					if($prod_video.paused) {
						$prod_video.play();
					}
				}
			});

		}

	});

	$(window).on('load',function() {
		
		if("ontouchstart" in window || "ontouch" in window) {

		} else {
			$('.ss-product').each(function(i,v){
	          if($(this).find('video').length) {
	            // $video_src = $(this).find('video').find('source').data('src');
	            // $(this).find('video').find('source').prop('src', $video_src);
	            // $(this).find('video').load();
	          }
	        });
       	}
	});

})(jQuery);

(function($){

	$(document).ready(function(){

	 	$(window).on('resize scroll',function(){
	 		y = $(window).scrollTop();

 			if($('body').hasClass('transparent-header')) {
	 		
	 			if(y >= 20) {
	 				$('body').addClass('white-header');
	 			}

	 			if(y < 20) {
					$('body').removeClass('white-header');
				}
	 		}
	 	});
		
	});

})(jQuery);
(function($){

	$(document).ready(function(){

		$(document).on('click','.upsell-add-to-cart',function(e){
			$(this).addClass('is-adding');

			var $variant_id = $(this).data('variantId');
			$.ajax({
		      	url: '/cart/add.js',
		      	dataType: 'json',
		      	type: 'post',
		      	data: {
		        	quantity: 1,
		        	id: $variant_id
		      	},
		      	success: function(data) {
		        	ajaxCart.load();
		      	},
		      	error: function (data) {
		      	}
		    });
		});

		$('body').on('ajaxCart.afterCartLoad', function(evt, cart) {

			if(typeof _UpsellConfig !== 'undefined' && typeof _UpsellConfig.products !== 'undefined' && _UpsellConfig.products != '' ) {
				$upsell_products = JSON.parse(_UpsellConfig.products);	

				var $cart_items;

				ShopifyAPI.getCart(function(data){ 
					$cart_items = data.items;
					var $cart_items_ids = [];

					if($cart_items.length > 0) {
						
						for(i = 0; i < $cart_items.length; i++) {
							$cart_items_ids.push($cart_items[i].product_id);
						}

						var upsell_html = '<div id="ss-upsell-product__slider-header" class="g-flex"><div class="header-left"><h2 class="section-title text-upper">You might also like</h2></div><div class="header-right"><div id="ss-upsell-product__slider-navigation"><a class="slick-arrow slick-prev"><svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16.0029" cy="16" r="15.5" transform="rotate(180 16.0029 16)" stroke="black"/><path d="M17.5029 21L12.5029 16L17.5029 11" stroke="black" stroke-width="1.25"/></svg></a><a class="slick-arrow slick-next"><svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16.0029" cy="16" r="15.5" transform="rotate(180 16.0029 16)" stroke="black"/><path d="M17.5029 21L12.5029 16L17.5029 11" stroke="black" stroke-width="1.25"/></svg></a></div></div></div><div id="ss-upsell-product__slider-wrapper"><div id="ss-upsell-product__slider">';

						for(var i=0; i<$upsell_products.length; i++) {
							var $product_obj = $upsell_products[i];

							if(!$cart_items_ids.includes($product_obj.id)) {
								upsell_html += build_upsell_item_html($product_obj);
							}
						}

						upsell_html += '</div></div>';

						$('#ss-upsell-items').html(upsell_html);

						var $prev_item = $('#ss-upsell-product__slider-navigation').find('.slick-prev');
	 					var $next_item = $('#ss-upsell-product__slider-navigation').find('.slick-next');

						$('#ss-upsell-product__slider').slick({
							arrows: true,
	 						dots: false,
	 						infinite: false,
	 						autoplay: false,
	 						swipe: true,
	 						slidesToShow: 1.1,
	 						slidesToScroll: 1,
	 						variableWidth: true,
			 				prevArrow: $prev_item,
			 				nextArrow: $next_item
	 					});
					}
				});
			}
		});

		function build_upsell_item_html($product) {

			var $upsell_item_html = '';
			$upsell_item_html += '<div class="ss-upsell-product">';
			$upsell_item_html += '<div class="product-wrapper g-flex">';
			$upsell_item_html += '<div class="product-wrapper__left">';
			$upsell_item_html += '<div class="product__image-wrapper ss-border-radius">';
			$upsell_item_html += '<a class="product__image-link" href="/products/' + $product.handle + '"><img class="objfit" src="' + $product.featured_image + '"></a>';
			$upsell_item_html += '</div></div>';
			$upsell_item_html += '<div class="product-wrapper__right">';
			$upsell_item_html += '<h2 class="text-upper"><a href="/products/' + $product.handle + '">' + $product.title + '</a></h2><a class="add-to-cart btn btn-black-outline upsell-add-to-cart" data-variant-id="' + $product.variants[0].id + '">Add ' + theme.Currency.formatMoney($product.variants[0].price, theme.strings.moneyFormat) + '</a>';
			$upsell_item_html += '</div></div></div>';


			return $upsell_item_html;
		}

	});

})(jQuery);

(function($){

	$(document).on('click','#waitlist-popup .popup-close__trigger, #waitlist-popup .waitlist-continue-btn, #waitlist-popup--overlay',function(e){
   		e.preventDefault();
   		$('#waitlist-popup').fadeOut(function(){
   			$('#waitlist-newsletter-form').show();
   			$('#waitlist-popup').find('.thanks-content').hide();
   		});
   		$('body').removeClass('has-waitlist-popup');
   	});

   	$(document).on('click','#WAITLIST_trigger',function(e){
   		e.preventDefault();
   		$('#waitlist-popup').fadeIn();
   		$('body').addClass('has-waitlist-popup');
   	});

})(jQuery);